/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { ComboboxItemDto, NameValueDto } from './admin-proxies';
import { BackgroundJobCancellationRequestDto, BackgroundJobExecutionStatus, ImportUploadExceptionOutput, ImportUploadOutput, LogLevel, ScheduleTypeEnum } from './commission-proxies';
import { ContractTypeListDto, MilestoneEditDto, OrderLocationDetailContractEditDto, OrderLocationDetailMilestoneEditDto, OrderStage, OrderStatusEditDto, ProductMilestoneEditDto } from './order-proxies';
import { DropdownDto } from './partner-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { ContractTerm, Quote } from './quote-proxies';
import { ActivityCategory, ActivityType, AdvisorEntitlementDto, BackgroundJobExecutionDto, ContactEditDto, ContactListDto, FileDto, Int64IdNameDto, PartnerSupportEditDto, PartnersDto, ProductCategoryListDto, ProductListDto, SalesCampaignDto, UserListDto, UserListRoleDto } from './shared-models';
import { CreateOrUpdateTicketInput, DocumentType, SurveyDto, TicketPriority } from './ticket-proxies';
import { RoleType } from './user-proxies';

@Injectable()
export class ActionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getActionList(): Observable<ActionDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Action/GetActionList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActionList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActionList(<any>response_);
                        } catch (e) {
                            return <Observable<ActionDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ActionDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActionList(response: HttpResponseBase): Observable<ActionDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ActionDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ActionDropdownDto[]>([]);
    }

    /**
     * @param ticketTypeId (optional)
     * @param statusId (optional)
     * @return Success
     */
    getButtonIds(ticketTypeId: number | undefined, statusId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + '/api/services/app/Action/GetButtonIds?';
        if (ticketTypeId === null) throw new Error("The parameter 'ticketTypeId' cannot be null.");
        else if (ticketTypeId !== undefined) url_ += 'ticketTypeId=' + encodeURIComponent('' + ticketTypeId) + '&';
        if (statusId === null) throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined) url_ += 'statusId=' + encodeURIComponent('' + statusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetButtonIds(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetButtonIds(<any>response_);
                        } catch (e) {
                            return <Observable<number[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetButtonIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number[]>([]);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getAdminActions(filter: string | undefined): Observable<AdminActionListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Action/GetAdminActions?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdminActions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdminActions(<any>response_);
                        } catch (e) {
                            return <Observable<AdminActionListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdminActionListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdminActions(response: HttpResponseBase): Observable<AdminActionListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdminActionListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdminActionListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAction(body: CreateOrUpdateActionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Action/CreateOrUpdateAction';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateAction(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteAction(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Action/DeleteAction?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAction(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getActionForEdit(id: number | undefined): Observable<ActionAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Action/GetActionForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActionForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActionForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<ActionAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ActionAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActionForEdit(response: HttpResponseBase): Observable<ActionAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ActionAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ActionAdminEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getButtonList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Action/GetButtonList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetButtonList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetButtonList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetButtonList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }
}

@Injectable()
export class AdjustmentScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param hasOutstandingBalance (optional)
     * @param hasReachedEndDate (optional)
     * @param advisorId (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param scheduleType (optional)
     * @param actionType (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAdjustmentSchedulesPagedResult(
        hasOutstandingBalance: boolean | undefined,
        hasReachedEndDate: boolean | undefined,
        advisorId: number | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        scheduleType: ScheduleTypeEnum | undefined,
        actionType: AdjustmentScheduleActionType | undefined,
        sorting: string | undefined,
        skipCount: number | undefined,
        maxResultCount: number | undefined
    ): Observable<AdjustmentScheduleDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/GetAdjustmentSchedulesPagedResult?';
        if (hasOutstandingBalance === null) throw new Error("The parameter 'hasOutstandingBalance' cannot be null.");
        else if (hasOutstandingBalance !== undefined)
            url_ += 'hasOutstandingBalance=' + encodeURIComponent('' + hasOutstandingBalance) + '&';
        if (hasReachedEndDate === null) throw new Error("The parameter 'hasReachedEndDate' cannot be null.");
        else if (hasReachedEndDate !== undefined) url_ += 'hasReachedEndDate=' + encodeURIComponent('' + hasReachedEndDate) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (scheduleType === null) throw new Error("The parameter 'scheduleType' cannot be null.");
        else if (scheduleType !== undefined) url_ += 'scheduleType=' + encodeURIComponent('' + scheduleType) + '&';
        if (actionType === null) throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined) url_ += 'actionType=' + encodeURIComponent('' + actionType) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdjustmentSchedulesPagedResult(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdjustmentSchedulesPagedResult(<any>response_);
                        } catch (e) {
                            return <Observable<AdjustmentScheduleDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdjustmentScheduleDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdjustmentSchedulesPagedResult(response: HttpResponseBase): Observable<AdjustmentScheduleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdjustmentScheduleDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdjustmentScheduleDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param reason (optional)
     * @return Success
     */
    endAdjustmentSchedule(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/EndAdjustmentSchedule?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (reason === null) throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined) url_ += 'reason=' + encodeURIComponent('' + reason) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEndAdjustmentSchedule(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEndAdjustmentSchedule(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEndAdjustmentSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteAdjustmentSchedule(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/DeleteAdjustmentSchedule?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAdjustmentSchedule(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAdjustmentSchedule(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAdjustmentSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAdjustmentSchedule(id: number | undefined): Observable<AdjustmentScheduleDto> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/GetAdjustmentSchedule?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdjustmentSchedule(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdjustmentSchedule(<any>response_);
                        } catch (e) {
                            return <Observable<AdjustmentScheduleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdjustmentScheduleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdjustmentSchedule(response: HttpResponseBase): Observable<AdjustmentScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdjustmentScheduleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdjustmentScheduleDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateSchedule(body: AdjustmentScheduleEditDto | undefined): Observable<AdjustmentScheduleDto> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/CreateOrUpdateSchedule';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateSchedule(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateSchedule(<any>response_);
                        } catch (e) {
                            return <Observable<AdjustmentScheduleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdjustmentScheduleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateSchedule(response: HttpResponseBase): Observable<AdjustmentScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdjustmentScheduleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdjustmentScheduleDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    generateScheduledTransactions(month: number | undefined, year: number | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/GenerateScheduledTransactions?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGenerateScheduledTransactions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGenerateScheduledTransactions(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGenerateScheduledTransactions(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getTransactionSummary(month: number | undefined, year: number | undefined): Observable<ScheduleTransactionSummaryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentSchedule/GetTransactionSummary?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTransactionSummary(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTransactionSummary(<any>response_);
                        } catch (e) {
                            return <Observable<ScheduleTransactionSummaryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ScheduleTransactionSummaryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTransactionSummary(response: HttpResponseBase): Observable<ScheduleTransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ScheduleTransactionSummaryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ScheduleTransactionSummaryDto[]>([]);
    }
}

@Injectable()
export class AdjustmentScheduleItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getScheduleItems(): Observable<AdjustmentScheduleItemDto[]> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentScheduleItem/GetScheduleItems';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetScheduleItems(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetScheduleItems(<any>response_);
                        } catch (e) {
                            return <Observable<AdjustmentScheduleItemDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdjustmentScheduleItemDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetScheduleItems(response: HttpResponseBase): Observable<AdjustmentScheduleItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdjustmentScheduleItemDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdjustmentScheduleItemDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateScheduleItem(body: AdjustmentScheduleItemEditDto | undefined): Observable<AdjustmentScheduleItemDto> {
        let url_ = this.baseUrl + '/api/services/app/AdjustmentScheduleItem/CreateOrUpdateScheduleItem';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateScheduleItem(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateScheduleItem(<any>response_);
                        } catch (e) {
                            return <Observable<AdjustmentScheduleItemDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdjustmentScheduleItemDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateScheduleItem(response: HttpResponseBase): Observable<AdjustmentScheduleItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdjustmentScheduleItemDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdjustmentScheduleItemDto>(<any>null);
    }
}

@Injectable()
export class V2ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAdvisor(id: number | undefined): Observable<Advisor> {
        let url_ = this.baseUrl + '/api/services/app/Advisors/v2/GetAdvisor?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdvisor(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdvisor(<any>response_);
                        } catch (e) {
                            return <Observable<Advisor>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Advisor>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdvisor(response: HttpResponseBase): Observable<Advisor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = Advisor.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Advisor>(<any>null);
    }

    /**
     * @return Success
     */
    advisor(id: number): Observable<Advisor> {
        let url_ = this.baseUrl + '/api/services/app/Advisors/v2/advisor/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAdvisor(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAdvisor(<any>response_);
                        } catch (e) {
                            return <Observable<Advisor>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Advisor>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAdvisor(response: HttpResponseBase): Observable<Advisor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = Advisor.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Advisor>(<any>null);
    }

    /**
     * @param name (optional)
     * @param isExactNameMatch (optional)
     * @return Success
     */
    getAdvisors(name: string | undefined, isExactNameMatch: boolean | undefined): Observable<Advisor[]> {
        let url_ = this.baseUrl + '/api/services/app/Advisors/v2/GetAdvisors?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        if (isExactNameMatch === null) throw new Error("The parameter 'isExactNameMatch' cannot be null.");
        else if (isExactNameMatch !== undefined) url_ += 'isExactNameMatch=' + encodeURIComponent('' + isExactNameMatch) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdvisors(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdvisors(<any>response_);
                        } catch (e) {
                            return <Observable<Advisor[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Advisor[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdvisors(response: HttpResponseBase): Observable<Advisor[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Advisor.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Advisor[]>([]);
    }

    /**
     * @param name (optional)
     * @param advisorId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAdvisorSalesReps(
        name: string | undefined,
        advisorId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<AdvisorUsersModelPagedResultModel> {
        let url_ = this.baseUrl + '/api/services/app/Advisors/v2/getAdvisorSalesReps?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdvisorSalesReps(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdvisorSalesReps(<any>response_);
                        } catch (e) {
                            return <Observable<AdvisorUsersModelPagedResultModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdvisorUsersModelPagedResultModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdvisorSalesReps(response: HttpResponseBase): Observable<AdvisorUsersModelPagedResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdvisorUsersModelPagedResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdvisorUsersModelPagedResultModel>(<any>null);
    }

    /**
     * @param textMatch (optional)
     * @param sorting (optional)
     * @return Success
     */
    contractTerms(textMatch: string | undefined, sorting: string | undefined): Observable<ContractTermsResponsePagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/ContractTerms/v2/contract-terms?';
        if (textMatch === null) throw new Error("The parameter 'textMatch' cannot be null.");
        else if (textMatch !== undefined) url_ += 'textMatch=' + encodeURIComponent('' + textMatch) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processContractTerms(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processContractTerms(<any>response_);
                        } catch (e) {
                            return <Observable<ContractTermsResponsePagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContractTermsResponsePagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processContractTerms(response: HttpResponseBase): Observable<ContractTermsResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ContractTermsResponsePagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContractTermsResponsePagedResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param filter (optional)
     * @param name (optional)
     * @param advisorIds (optional)
     * @param accountManagerIds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCustomers(
        id: number | undefined,
        filter: string | undefined,
        name: string | undefined,
        advisorIds: number[] | undefined,
        accountManagerIds: number[] | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustomerModelPagedResultModel> {
        let url_ = this.baseUrl + '/api/services/app/Customers/v2/GetCustomers?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        if (advisorIds === null) throw new Error("The parameter 'advisorIds' cannot be null.");
        else if (advisorIds !== undefined)
            advisorIds &&
                advisorIds.forEach((item) => {
                    url_ += 'advisorIds=' + encodeURIComponent('' + item) + '&';
                });
        if (accountManagerIds === null) throw new Error("The parameter 'accountManagerIds' cannot be null.");
        else if (accountManagerIds !== undefined)
            accountManagerIds &&
                accountManagerIds.forEach((item) => {
                    url_ += 'accountManagerIds=' + encodeURIComponent('' + item) + '&';
                });
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomers(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerModelPagedResultModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerModelPagedResultModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<CustomerModelPagedResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerModelPagedResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerModelPagedResultModel>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCustomer(id: number | undefined): Observable<CustomerModel> {
        let url_ = this.baseUrl + '/api/services/app/Customers/v2/GetCustomer?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerModel>(<any>null);
    }

    /**
     * @param name (optional)
     * @param address (optional)
     * @param address2 (optional)
     * @param city (optional)
     * @param state (optional)
     * @param zipCode (optional)
     * @param country (optional)
     * @param billingAddress (optional)
     * @param billingAddress2 (optional)
     * @param billingState (optional)
     * @param billingCity (optional)
     * @param billingZipcode (optional)
     * @param billingCountry (optional)
     * @param advisorId (optional)
     * @param accountManagerId (optional)
     * @return Success
     */
    createCustomer(
        name: string | undefined,
        address: string | undefined,
        address2: string | undefined,
        city: string | undefined,
        state: string | undefined,
        zipCode: string | undefined,
        country: string | undefined,
        billingAddress: string | undefined,
        billingAddress2: string | undefined,
        billingState: string | undefined,
        billingCity: string | undefined,
        billingZipcode: string | undefined,
        billingCountry: string | undefined,
        advisorId: number | undefined,
        accountManagerId: number | undefined
    ): Observable<CustomerModel> {
        let url_ = this.baseUrl + '/api/services/app/Customers/v2/CreateCustomer?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        if (address === null) throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined) url_ += 'address=' + encodeURIComponent('' + address) + '&';
        if (address2 === null) throw new Error("The parameter 'address2' cannot be null.");
        else if (address2 !== undefined) url_ += 'address2=' + encodeURIComponent('' + address2) + '&';
        if (city === null) throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined) url_ += 'city=' + encodeURIComponent('' + city) + '&';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'state=' + encodeURIComponent('' + state) + '&';
        if (zipCode === null) throw new Error("The parameter 'zipCode' cannot be null.");
        else if (zipCode !== undefined) url_ += 'zipCode=' + encodeURIComponent('' + zipCode) + '&';
        if (country === null) throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined) url_ += 'country=' + encodeURIComponent('' + country) + '&';
        if (billingAddress === null) throw new Error("The parameter 'billingAddress' cannot be null.");
        else if (billingAddress !== undefined) url_ += 'billingAddress=' + encodeURIComponent('' + billingAddress) + '&';
        if (billingAddress2 === null) throw new Error("The parameter 'billingAddress2' cannot be null.");
        else if (billingAddress2 !== undefined) url_ += 'billingAddress2=' + encodeURIComponent('' + billingAddress2) + '&';
        if (billingState === null) throw new Error("The parameter 'billingState' cannot be null.");
        else if (billingState !== undefined) url_ += 'billingState=' + encodeURIComponent('' + billingState) + '&';
        if (billingCity === null) throw new Error("The parameter 'billingCity' cannot be null.");
        else if (billingCity !== undefined) url_ += 'billingCity=' + encodeURIComponent('' + billingCity) + '&';
        if (billingZipcode === null) throw new Error("The parameter 'billingZipcode' cannot be null.");
        else if (billingZipcode !== undefined) url_ += 'billingZipcode=' + encodeURIComponent('' + billingZipcode) + '&';
        if (billingCountry === null) throw new Error("The parameter 'billingCountry' cannot be null.");
        else if (billingCountry !== undefined) url_ += 'billingCountry=' + encodeURIComponent('' + billingCountry) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (accountManagerId === null) throw new Error("The parameter 'accountManagerId' cannot be null.");
        else if (accountManagerId !== undefined) url_ += 'accountManagerId=' + encodeURIComponent('' + accountManagerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateCustomer(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerModel>(<any>null);
    }

    /**
     * @param id (optional)
     * @param name (optional)
     * @param address (optional)
     * @param address2 (optional)
     * @param city (optional)
     * @param state (optional)
     * @param zipCode (optional)
     * @param country (optional)
     * @param billingAddress (optional)
     * @param billingAddress2 (optional)
     * @param billingState (optional)
     * @param billingCity (optional)
     * @param billingZipcode (optional)
     * @param billingCountry (optional)
     * @param advisorId (optional)
     * @param accountManagerId (optional)
     * @return Success
     */
    updateCustomer(
        id: number | undefined,
        name: string | undefined,
        address: string | undefined,
        address2: string | undefined,
        city: string | undefined,
        state: string | undefined,
        zipCode: string | undefined,
        country: string | undefined,
        billingAddress: string | undefined,
        billingAddress2: string | undefined,
        billingState: string | undefined,
        billingCity: string | undefined,
        billingZipcode: string | undefined,
        billingCountry: string | undefined,
        advisorId: number | undefined,
        accountManagerId: number | undefined
    ): Observable<CustomerModel> {
        let url_ = this.baseUrl + '/api/services/app/Customers/v2/UpdateCustomer?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        if (address === null) throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined) url_ += 'address=' + encodeURIComponent('' + address) + '&';
        if (address2 === null) throw new Error("The parameter 'address2' cannot be null.");
        else if (address2 !== undefined) url_ += 'address2=' + encodeURIComponent('' + address2) + '&';
        if (city === null) throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined) url_ += 'city=' + encodeURIComponent('' + city) + '&';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'state=' + encodeURIComponent('' + state) + '&';
        if (zipCode === null) throw new Error("The parameter 'zipCode' cannot be null.");
        else if (zipCode !== undefined) url_ += 'zipCode=' + encodeURIComponent('' + zipCode) + '&';
        if (country === null) throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined) url_ += 'country=' + encodeURIComponent('' + country) + '&';
        if (billingAddress === null) throw new Error("The parameter 'billingAddress' cannot be null.");
        else if (billingAddress !== undefined) url_ += 'billingAddress=' + encodeURIComponent('' + billingAddress) + '&';
        if (billingAddress2 === null) throw new Error("The parameter 'billingAddress2' cannot be null.");
        else if (billingAddress2 !== undefined) url_ += 'billingAddress2=' + encodeURIComponent('' + billingAddress2) + '&';
        if (billingState === null) throw new Error("The parameter 'billingState' cannot be null.");
        else if (billingState !== undefined) url_ += 'billingState=' + encodeURIComponent('' + billingState) + '&';
        if (billingCity === null) throw new Error("The parameter 'billingCity' cannot be null.");
        else if (billingCity !== undefined) url_ += 'billingCity=' + encodeURIComponent('' + billingCity) + '&';
        if (billingZipcode === null) throw new Error("The parameter 'billingZipcode' cannot be null.");
        else if (billingZipcode !== undefined) url_ += 'billingZipcode=' + encodeURIComponent('' + billingZipcode) + '&';
        if (billingCountry === null) throw new Error("The parameter 'billingCountry' cannot be null.");
        else if (billingCountry !== undefined) url_ += 'billingCountry=' + encodeURIComponent('' + billingCountry) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (accountManagerId === null) throw new Error("The parameter 'accountManagerId' cannot be null.");
        else if (accountManagerId !== undefined) url_ += 'accountManagerId=' + encodeURIComponent('' + accountManagerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCustomer(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerModel>(<any>null);
    }

    /**
     * @param customerId (optional)
     * @return Success
     */
    getCustomerTiles(customerId: number | undefined): Observable<CustomerTile> {
        let url_ = this.baseUrl + '/api/services/app/Customers/v2/GetCustomerTiles?';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'customerId=' + encodeURIComponent('' + customerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerTiles(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerTiles(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerTile>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerTile>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerTiles(response: HttpResponseBase): Observable<CustomerTile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerTile.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerTile>(<any>null);
    }

    /**
     * @param textMatch (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    locations(
        id: number,
        textMatch: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustomerLocationResponsePagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Customers/v2/{id}/locations?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (textMatch === null) throw new Error("The parameter 'textMatch' cannot be null.");
        else if (textMatch !== undefined) url_ += 'textMatch=' + encodeURIComponent('' + textMatch) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processLocations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processLocations(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationResponsePagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationResponsePagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processLocations(response: HttpResponseBase): Observable<CustomerLocationResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerLocationResponsePagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationResponsePagedResultDto>(<any>null);
    }

    /**
     * @param orderNumber (optional)
     * @param billingAcountNumber (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param orderStatusTypeIds (optional)
     * @param statusStartDate (optional)
     * @param statusEndDate (optional)
     * @param contractStartDate (optional)
     * @param contractEndDate (optional)
     * @param partnerId (optional)
     * @param customerId (optional)
     * @param customerLocationId (optional)
     * @param providerId (optional)
     * @param productCategoryId (optional)
     * @param productId (optional)
     * @param spmIdList (optional)
     * @param investOwnersIdList (optional)
     * @param provisionerIdList (optional)
     * @param agentIdList (optional)
     * @param orderStatusIdList (optional)
     * @param contractTypeIdList (optional)
     * @param ignoreCache (optional)
     * @param advisorEntitlementId (optional)
     * @param salesCampaignIdList (optional)
     * @param internalSalesAgentIdList (optional)
     * @param accountManagerIdList (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    orders(
        orderNumber: string | undefined,
        billingAcountNumber: string | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        orderStatusTypeIds: string | undefined,
        statusStartDate: moment.Moment | undefined,
        statusEndDate: moment.Moment | undefined,
        contractStartDate: moment.Moment | undefined,
        contractEndDate: moment.Moment | undefined,
        partnerId: string | undefined,
        customerId: string | undefined,
        customerLocationId: string | undefined,
        providerId: string | undefined,
        productCategoryId: string | undefined,
        productId: string | undefined,
        spmIdList: string | undefined,
        investOwnersIdList: string | undefined,
        provisionerIdList: string | undefined,
        agentIdList: string | undefined,
        orderStatusIdList: string | undefined,
        contractTypeIdList: string | undefined,
        ignoreCache: boolean | undefined,
        advisorEntitlementId: number | undefined,
        salesCampaignIdList: string | undefined,
        internalSalesAgentIdList: string | undefined,
        accountManagerIdList: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/v2/orders?';
        if (orderNumber === null) throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined) url_ += 'OrderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (billingAcountNumber === null) throw new Error("The parameter 'billingAcountNumber' cannot be null.");
        else if (billingAcountNumber !== undefined) url_ += 'BillingAcountNumber=' + encodeURIComponent('' + billingAcountNumber) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (orderStatusTypeIds === null) throw new Error("The parameter 'orderStatusTypeIds' cannot be null.");
        else if (orderStatusTypeIds !== undefined) url_ += 'OrderStatusTypeIds=' + encodeURIComponent('' + orderStatusTypeIds) + '&';
        if (statusStartDate === null) throw new Error("The parameter 'statusStartDate' cannot be null.");
        else if (statusStartDate !== undefined)
            url_ += 'StatusStartDate=' + encodeURIComponent(statusStartDate ? '' + statusStartDate.toJSON() : '') + '&';
        if (statusEndDate === null) throw new Error("The parameter 'statusEndDate' cannot be null.");
        else if (statusEndDate !== undefined)
            url_ += 'StatusEndDate=' + encodeURIComponent(statusEndDate ? '' + statusEndDate.toJSON() : '') + '&';
        if (contractStartDate === null) throw new Error("The parameter 'contractStartDate' cannot be null.");
        else if (contractStartDate !== undefined)
            url_ += 'ContractStartDate=' + encodeURIComponent(contractStartDate ? '' + contractStartDate.toJSON() : '') + '&';
        if (contractEndDate === null) throw new Error("The parameter 'contractEndDate' cannot be null.");
        else if (contractEndDate !== undefined)
            url_ += 'ContractEndDate=' + encodeURIComponent(contractEndDate ? '' + contractEndDate.toJSON() : '') + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (customerLocationId === null) throw new Error("The parameter 'customerLocationId' cannot be null.");
        else if (customerLocationId !== undefined) url_ += 'CustomerLocationId=' + encodeURIComponent('' + customerLocationId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (productCategoryId === null) throw new Error("The parameter 'productCategoryId' cannot be null.");
        else if (productCategoryId !== undefined) url_ += 'ProductCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        if (spmIdList === null) throw new Error("The parameter 'spmIdList' cannot be null.");
        else if (spmIdList !== undefined) url_ += 'SpmIdList=' + encodeURIComponent('' + spmIdList) + '&';
        if (investOwnersIdList === null) throw new Error("The parameter 'investOwnersIdList' cannot be null.");
        else if (investOwnersIdList !== undefined) url_ += 'InvestOwnersIdList=' + encodeURIComponent('' + investOwnersIdList) + '&';
        if (provisionerIdList === null) throw new Error("The parameter 'provisionerIdList' cannot be null.");
        else if (provisionerIdList !== undefined) url_ += 'ProvisionerIdList=' + encodeURIComponent('' + provisionerIdList) + '&';
        if (agentIdList === null) throw new Error("The parameter 'agentIdList' cannot be null.");
        else if (agentIdList !== undefined) url_ += 'AgentIdList=' + encodeURIComponent('' + agentIdList) + '&';
        if (orderStatusIdList === null) throw new Error("The parameter 'orderStatusIdList' cannot be null.");
        else if (orderStatusIdList !== undefined) url_ += 'OrderStatusIdList=' + encodeURIComponent('' + orderStatusIdList) + '&';
        if (contractTypeIdList === null) throw new Error("The parameter 'contractTypeIdList' cannot be null.");
        else if (contractTypeIdList !== undefined) url_ += 'ContractTypeIdList=' + encodeURIComponent('' + contractTypeIdList) + '&';
        if (ignoreCache === null) throw new Error("The parameter 'ignoreCache' cannot be null.");
        else if (ignoreCache !== undefined) url_ += 'IgnoreCache=' + encodeURIComponent('' + ignoreCache) + '&';
        if (advisorEntitlementId === null) throw new Error("The parameter 'advisorEntitlementId' cannot be null.");
        else if (advisorEntitlementId !== undefined) url_ += 'AdvisorEntitlementId=' + encodeURIComponent('' + advisorEntitlementId) + '&';
        if (salesCampaignIdList === null) throw new Error("The parameter 'salesCampaignIdList' cannot be null.");
        else if (salesCampaignIdList !== undefined) url_ += 'SalesCampaignIdList=' + encodeURIComponent('' + salesCampaignIdList) + '&';
        if (internalSalesAgentIdList === null) throw new Error("The parameter 'internalSalesAgentIdList' cannot be null.");
        else if (internalSalesAgentIdList !== undefined)
            url_ += 'InternalSalesAgentIdList=' + encodeURIComponent('' + internalSalesAgentIdList) + '&';
        if (accountManagerIdList === null) throw new Error("The parameter 'accountManagerIdList' cannot be null.");
        else if (accountManagerIdList !== undefined) url_ += 'AccountManagerIdList=' + encodeURIComponent('' + accountManagerIdList) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processOrders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processOrders(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processOrders(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param textMatch (optional)
     * @param providerIds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    products(
        textMatch: string | undefined,
        providerIds: number[] | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<ProviderProductProjectionPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Products/v2/products?';
        if (textMatch === null) throw new Error("The parameter 'textMatch' cannot be null.");
        else if (textMatch !== undefined) url_ += 'textMatch=' + encodeURIComponent('' + textMatch) + '&';
        if (providerIds === null) throw new Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined)
            providerIds &&
                providerIds.forEach((item) => {
                    url_ += 'providerIds=' + encodeURIComponent('' + item) + '&';
                });
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProducts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProducts(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderProductProjectionPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderProductProjectionPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProducts(response: HttpResponseBase): Observable<ProviderProductProjectionPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderProductProjectionPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = resultData403 !== undefined ? resultData403 : <any>null;
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderProductProjectionPagedResultDto>(<any>null);
    }

    /**
     * @param textMatch (optional)
     * @param productIds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    providers(
        textMatch: string | undefined,
        productIds: number[] | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<ProviderWithProductsResponsePagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Providers/v2/providers?';
        if (textMatch === null) throw new Error("The parameter 'textMatch' cannot be null.");
        else if (textMatch !== undefined) url_ += 'textMatch=' + encodeURIComponent('' + textMatch) + '&';
        if (productIds === null) throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds &&
                productIds.forEach((item) => {
                    url_ += 'productIds=' + encodeURIComponent('' + item) + '&';
                });
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProviders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProviders(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderWithProductsResponsePagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderWithProductsResponsePagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProviders(response: HttpResponseBase): Observable<ProviderWithProductsResponsePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderWithProductsResponsePagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderWithProductsResponsePagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateOrUpdateTicketInput | undefined): Observable<Ticket> {
        let url_ = this.baseUrl + '/api/services/app/tickets/v2/create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(<any>response_);
                        } catch (e) {
                            return <Observable<Ticket>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Ticket>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<Ticket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = Ticket.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result404: any = null;
                    let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result404 = TicketNotFoundException.fromJS(resultData404);
                    return throwException('Not Found', status, _responseText, _headers, result404);
                })
            );
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result500: any = null;
                    let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result500 = resultData500 !== undefined ? resultData500 : <any>null;
                    return throwException('Server Error', status, _responseText, _headers, result500);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Ticket>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: CreateOrUpdateTicketInput | undefined): Observable<Ticket> {
        let url_ = this.baseUrl + '/api/services/app/tickets/v2/update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(<any>response_);
                        } catch (e) {
                            return <Observable<Ticket>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Ticket>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<Ticket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = Ticket.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result404: any = null;
                    let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result404 = TicketNotFoundException.fromJS(resultData404);
                    return throwException('Not Found', status, _responseText, _headers, result404);
                })
            );
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result500: any = null;
                    let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result500 = resultData500 !== undefined ? resultData500 : <any>null;
                    return throwException('Server Error', status, _responseText, _headers, result500);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Ticket>(<any>null);
    }

    /**
     * @param roleName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUsers(
        roleName: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<UserPagedResultModel> {
        let url_ = this.baseUrl + '/api/services/app/Users/v2/GetUsers?';
        if (roleName === null) throw new Error("The parameter 'roleName' cannot be null.");
        else if (roleName !== undefined) url_ += 'roleName=' + encodeURIComponent('' + roleName) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsers(<any>response_);
                        } catch (e) {
                            return <Observable<UserPagedResultModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserPagedResultModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserPagedResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserPagedResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result403: any = null;
                    let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result403 = ProblemDetails.fromJS(resultData403);
                    return throwException('Forbidden', status, _responseText, _headers, result403);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserPagedResultModel>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUser(id: number | undefined): Observable<UserModel> {
        let url_ = this.baseUrl + '/api/services/app/Users/v2/GetUser?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUser(<any>response_);
                        } catch (e) {
                            return <Observable<UserModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserModel>(<any>null);
    }

    /**
     * @param name (optional)
     * @param roles (optional)
     * @param advisorId (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @return Success
     */
    users(
        name: string | undefined,
        roles: string[] | undefined,
        advisorId: number | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined,
        sorting: string | undefined
    ): Observable<UserModelPagedResultModel> {
        let url_ = this.baseUrl + '/api/services/app/Users/v2/users?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        if (roles === null) throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles &&
                roles.forEach((item) => {
                    url_ += 'roles=' + encodeURIComponent('' + item) + '&';
                });
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUsers(<any>response_);
                        } catch (e) {
                            return <Observable<UserModelPagedResultModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserModelPagedResultModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUsers(response: HttpResponseBase): Observable<UserModelPagedResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserModelPagedResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserModelPagedResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    permissionsWithoutProvisioning(): Observable<{ [key: string]: boolean }> {
        let url_ = this.baseUrl + '/api/services/app/Users/v2/permissions-without-provisioning';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processPermissionsWithoutProvisioning(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processPermissionsWithoutProvisioning(<any>response_);
                        } catch (e) {
                            return <Observable<{ [key: string]: boolean }>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<{ [key: string]: boolean }>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processPermissionsWithoutProvisioning(response: HttpResponseBase): Observable<{ [key: string]: boolean }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (resultData200) {
                        result200 = {} as any;
                        for (let key in resultData200) {
                            if (resultData200.hasOwnProperty(key)) result200[key] = resultData200[key];
                        }
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<{ [key: string]: boolean }>(<any>null);
    }

    /**
     * @return Success
     */
    permissions(): Observable<{ [key: string]: boolean }> {
        let url_ = this.baseUrl + '/api/services/app/Users/v2/permissions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processPermissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processPermissions(<any>response_);
                        } catch (e) {
                            return <Observable<{ [key: string]: boolean }>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<{ [key: string]: boolean }>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processPermissions(response: HttpResponseBase): Observable<{ [key: string]: boolean }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (resultData200) {
                        result200 = {} as any;
                        for (let key in resultData200) {
                            if (resultData200.hasOwnProperty(key)) result200[key] = resultData200[key];
                        }
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<{ [key: string]: boolean }>(<any>null);
    }
}

@Injectable()
export class AdvisorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param supportTypes (optional)
     * @return Success
     */
    supportUsers(id: number, supportTypes: PartnerSupportType[] | undefined): Observable<AdvisorSupportUser[]> {
        let url_ = this.baseUrl + '/api/services/app/Advisors/v2/advisor/{id}/support-users?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (supportTypes === null) throw new Error("The parameter 'supportTypes' cannot be null.");
        else if (supportTypes !== undefined)
            supportTypes &&
                supportTypes.forEach((item) => {
                    url_ += 'supportTypes=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSupportUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSupportUsers(<any>response_);
                        } catch (e) {
                            return <Observable<AdvisorSupportUser[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdvisorSupportUser[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSupportUsers(response: HttpResponseBase): Observable<AdvisorSupportUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdvisorSupportUser.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdvisorSupportUser[]>([]);
    }
}

@Injectable()
export class AgentAccountRateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param billingAccountNumber (optional)
     * @param providerId (optional)
     * @param salesAgentId (optional)
     * @param partnerId (optional)
     * @param partnerSubAgencyId (optional)
     * @param partnerOrderNumber (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionSplitList(
        billingAccountNumber: string | undefined,
        providerId: number | undefined,
        salesAgentId: number | undefined,
        partnerId: number | undefined,
        partnerSubAgencyId: number | undefined,
        partnerOrderNumber: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<AgentAccountRateDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/AgentAccountRate/GetCommissionSplitList?';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (salesAgentId === null) throw new Error("The parameter 'salesAgentId' cannot be null.");
        else if (salesAgentId !== undefined) url_ += 'SalesAgentId=' + encodeURIComponent('' + salesAgentId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (partnerSubAgencyId === null) throw new Error("The parameter 'partnerSubAgencyId' cannot be null.");
        else if (partnerSubAgencyId !== undefined) url_ += 'PartnerSubAgencyId=' + encodeURIComponent('' + partnerSubAgencyId) + '&';
        if (partnerOrderNumber === null) throw new Error("The parameter 'partnerOrderNumber' cannot be null.");
        else if (partnerOrderNumber !== undefined) url_ += 'PartnerOrderNumber=' + encodeURIComponent('' + partnerOrderNumber) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionSplitList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionSplitList(<any>response_);
                        } catch (e) {
                            return <Observable<AgentAccountRateDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AgentAccountRateDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionSplitList(response: HttpResponseBase): Observable<AgentAccountRateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AgentAccountRateDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AgentAccountRateDtoPagedResultDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getCommissionSplitRecord(input: number | undefined): Observable<AgentAccountRateDto> {
        let url_ = this.baseUrl + '/api/services/app/AgentAccountRate/GetCommissionSplitRecord?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionSplitRecord(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionSplitRecord(<any>response_);
                        } catch (e) {
                            return <Observable<AgentAccountRateDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AgentAccountRateDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionSplitRecord(response: HttpResponseBase): Observable<AgentAccountRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AgentAccountRateDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AgentAccountRateDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCommissionSplit(body: AgentAccountRateDto[] | undefined): Observable<AgentAccountRateDto[]> {
        let url_ = this.baseUrl + '/api/services/app/AgentAccountRate/CreateOrUpdateCommissionSplit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCommissionSplit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCommissionSplit(<any>response_);
                        } catch (e) {
                            return <Observable<AgentAccountRateDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AgentAccountRateDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCommissionSplit(response: HttpResponseBase): Observable<AgentAccountRateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AgentAccountRateDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AgentAccountRateDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteCommissionSplit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/AgentAccountRate/DeleteCommissionSplit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCommissionSplit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCommissionSplit(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCommissionSplit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param note (optional)
     * @return Success
     */
    unlinkContractTerm(id: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/AgentAccountRate/UnlinkContractTerm?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (note === null) throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined) url_ += 'note=' + encodeURIComponent('' + note) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUnlinkContractTerm(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUnlinkContractTerm(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUnlinkContractTerm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billingAccountNumber (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAuditHistory(billingAccountNumber: string | undefined, providerId: number | undefined): Observable<AgentAccountRateAuditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/AgentAccountRate/GetAuditHistory?';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'billingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAuditHistory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAuditHistory(<any>response_);
                        } catch (e) {
                            return <Observable<AgentAccountRateAuditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AgentAccountRateAuditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAuditHistory(response: HttpResponseBase): Observable<AgentAccountRateAuditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AgentAccountRateAuditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AgentAccountRateAuditDto[]>([]);
    }
}

@Injectable()
export class ArchiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param activityKey (optional)
     * @param activityType (optional)
     * @return Success
     */
    getActivityArchive(activityKey: number | undefined, activityType: ActivityType | undefined): Observable<ActivityArchiveOutput> {
        let url_ = this.baseUrl + '/api/services/app/Archive/GetActivityArchive?';
        if (activityKey === null) throw new Error("The parameter 'activityKey' cannot be null.");
        else if (activityKey !== undefined) url_ += 'ActivityKey=' + encodeURIComponent('' + activityKey) + '&';
        if (activityType === null) throw new Error("The parameter 'activityType' cannot be null.");
        else if (activityType !== undefined) url_ += 'ActivityType=' + encodeURIComponent('' + activityType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActivityArchive(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActivityArchive(<any>response_);
                        } catch (e) {
                            return <Observable<ActivityArchiveOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ActivityArchiveOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActivityArchive(response: HttpResponseBase): Observable<ActivityArchiveOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ActivityArchiveOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ActivityArchiveOutput>(<any>null);
    }
}

@Injectable()
export class AssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    uploadAssetFile(
        contentType: string | undefined,
        contentDisposition: string | undefined,
        headers: { [key: string]: string[] } | undefined,
        length: number | undefined,
        name: string | undefined,
        fileName: string | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/Asset/UploadAssetFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (contentType === null || contentType === undefined) throw new Error("The parameter 'contentType' cannot be null.");
        else content_.append('ContentType', contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else content_.append('ContentDisposition', contentDisposition.toString());
        if (headers === null || headers === undefined) throw new Error("The parameter 'headers' cannot be null.");
        else content_.append('Headers', JSON.stringify(headers));
        if (length === null || length === undefined) throw new Error("The parameter 'length' cannot be null.");
        else content_.append('Length', length.toString());
        if (name === null || name === undefined) throw new Error("The parameter 'name' cannot be null.");
        else content_.append('Name', name.toString());
        if (fileName === null || fileName === undefined) throw new Error("The parameter 'fileName' cannot be null.");
        else content_.append('FileName', fileName.toString());

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadAssetFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadAssetFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadAssetFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAsset(body: CreateOrUpdateAssetInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Asset/CreateOrUpdateAsset';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateAsset(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateAsset(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCIPropertyTypeList(): Observable<CIPropertyTypeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Asset/GetCIPropertyTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCIPropertyTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCIPropertyTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<CIPropertyTypeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CIPropertyTypeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCIPropertyTypeList(response: HttpResponseBase): Observable<CIPropertyTypeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CIPropertyTypeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CIPropertyTypeListDto[]>([]);
    }

    /**
     * @param cIPropertyTypeId (optional)
     * @return Success
     */
    getPropertyList(cIPropertyTypeId: number | undefined): Observable<CIPropertyListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Asset/GetPropertyList?';
        if (cIPropertyTypeId === null) throw new Error("The parameter 'cIPropertyTypeId' cannot be null.");
        else if (cIPropertyTypeId !== undefined) url_ += 'CIPropertyTypeId=' + encodeURIComponent('' + cIPropertyTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPropertyList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPropertyList(<any>response_);
                        } catch (e) {
                            return <Observable<CIPropertyListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CIPropertyListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPropertyList(response: HttpResponseBase): Observable<CIPropertyListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CIPropertyListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CIPropertyListDto[]>([]);
    }

    /**
     * @param filter (optional)
     * @param customerLocationId (optional)
     * @param orderLocationDetailId (optional)
     * @param productId (optional)
     * @param assetStatusId (optional)
     * @return Success
     */
    getModelAssetList(
        filter: string | undefined,
        customerLocationId: number | undefined,
        orderLocationDetailId: number | undefined,
        productId: number | undefined,
        assetStatusId: number | undefined
    ): Observable<AssetListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Asset/GetModelAssetList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (customerLocationId === null) throw new Error("The parameter 'customerLocationId' cannot be null.");
        else if (customerLocationId !== undefined) url_ += 'CustomerLocationId=' + encodeURIComponent('' + customerLocationId) + '&';
        if (orderLocationDetailId === null) throw new Error("The parameter 'orderLocationDetailId' cannot be null.");
        else if (orderLocationDetailId !== undefined)
            url_ += 'OrderLocationDetailId=' + encodeURIComponent('' + orderLocationDetailId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        if (assetStatusId === null) throw new Error("The parameter 'assetStatusId' cannot be null.");
        else if (assetStatusId !== undefined) url_ += 'AssetStatusId=' + encodeURIComponent('' + assetStatusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetModelAssetList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetModelAssetList(<any>response_);
                        } catch (e) {
                            return <Observable<AssetListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AssetListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetModelAssetList(response: HttpResponseBase): Observable<AssetListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AssetListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AssetListDto[]>([]);
    }

    protected processGetAssetListToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getAssetExcelImportTemplate(input: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Asset/GetAssetExcelImportTemplate?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAssetExcelImportTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAssetExcelImportTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAssetExcelImportTemplate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAssetFile(body: UploadAssetFileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Asset/UpdateAssetFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateAssetFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateAssetFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateAssetFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCIPropertyTypeAssetCI(body: CIPropertyTypeProductInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Asset/CreateOrUpdateCIPropertyTypeAssetCI';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCIPropertyTypeAssetCI(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCIPropertyTypeAssetCI(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCIPropertyTypeAssetCI(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteCIPropertyTypeAssetCI(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Asset/DeleteCIPropertyTypeAssetCI?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCIPropertyTypeAssetCI(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCIPropertyTypeAssetCI(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCIPropertyTypeAssetCI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param customerId (optional)
     * @param assetPropertySearchValue (optional)
     * @return Success
     */
    getInventoryListToExcel(customerId: number | undefined, assetPropertySearchValue: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Asset/GetInventoryListToExcel?';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (assetPropertySearchValue === null) throw new Error("The parameter 'assetPropertySearchValue' cannot be null.");
        else if (assetPropertySearchValue !== undefined)
            url_ += 'assetPropertySearchValue=' + encodeURIComponent('' + assetPropertySearchValue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInventoryListToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInventoryListToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetInventoryListToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AssetListExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    exportToFile(body: AssetsListDto[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/AssetListExcelExporter/ExportToFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExportToFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExportToFile(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processExportToFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param headerList (optional)
     * @return Success
     */
    exportImportTemplate(headerList: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/AssetListExcelExporter/ExportImportTemplate?';
        if (headerList === null) throw new Error("The parameter 'headerList' cannot be null.");
        else if (headerList !== undefined) url_ += 'headerList=' + encodeURIComponent('' + headerList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExportImportTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExportImportTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processExportImportTemplate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AttributeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param attributeTypes (optional)
     * @return Success
     */
    getAttributes(attributeTypes: AttributeType[] | undefined): Observable<AttributeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Attribute/GetAttributes?';
        if (attributeTypes === null) throw new Error("The parameter 'attributeTypes' cannot be null.");
        else if (attributeTypes !== undefined)
            attributeTypes &&
                attributeTypes.forEach((item) => {
                    url_ += 'AttributeTypes=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAttributes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAttributes(<any>response_);
                        } catch (e) {
                            return <Observable<AttributeDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AttributeDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAttributes(response: HttpResponseBase): Observable<AttributeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AttributeDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttributeDto[]>([]);
    }

    /**
     * @param attributeId (optional)
     * @return Success
     */
    getAttribute(attributeId: number | undefined): Observable<AttributeDto> {
        let url_ = this.baseUrl + '/api/services/app/Attribute/GetAttribute?';
        if (attributeId === null) throw new Error("The parameter 'attributeId' cannot be null.");
        else if (attributeId !== undefined) url_ += 'attributeId=' + encodeURIComponent('' + attributeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAttribute(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAttribute(<any>response_);
                        } catch (e) {
                            return <Observable<AttributeDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AttributeDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAttribute(response: HttpResponseBase): Observable<AttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AttributeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttributeDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAttribute(body: AttributeEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Attribute/CreateOrUpdateAttribute';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateAttribute(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateAttribute(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param attributeId (optional)
     * @return Success
     */
    deleteAttribute(attributeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Attribute/DeleteAttribute?';
        if (attributeId === null) throw new Error("The parameter 'attributeId' cannot be null.");
        else if (attributeId !== undefined) url_ += 'attributeId=' + encodeURIComponent('' + attributeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAttribute(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAttribute(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param attributeKey (optional)
     * @param attributeType (optional)
     * @return Success
     */
    getAttributeValues(attributeKey: number | undefined, attributeType: AttributeType | undefined): Observable<AttributeValueEditDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Attribute/GetAttributeValues?';
        if (attributeKey === null) throw new Error("The parameter 'attributeKey' cannot be null.");
        else if (attributeKey !== undefined) url_ += 'attributeKey=' + encodeURIComponent('' + attributeKey) + '&';
        if (attributeType === null) throw new Error("The parameter 'attributeType' cannot be null.");
        else if (attributeType !== undefined) url_ += 'attributeType=' + encodeURIComponent('' + attributeType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAttributeValues(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAttributeValues(<any>response_);
                        } catch (e) {
                            return <Observable<AttributeValueEditDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AttributeValueEditDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAttributeValues(response: HttpResponseBase): Observable<AttributeValueEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AttributeValueEditDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttributeValueEditDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAttributeValues(body: AttributeValueEditDto | undefined): Observable<AttributeValueEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Attribute/CreateOrUpdateAttributeValues';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateAttributeValues(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateAttributeValues(<any>response_);
                        } catch (e) {
                            return <Observable<AttributeValueEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AttributeValueEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateAttributeValues(response: HttpResponseBase): Observable<AttributeValueEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AttributeValueEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttributeValueEditDto>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @return Success
     */
    getAuditLogs(
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        userName: string | undefined,
        serviceName: string | undefined,
        methodName: string | undefined,
        browserInfo: string | undefined,
        hasException: boolean | undefined,
        minExecutionDuration: number | undefined,
        maxExecutionDuration: number | undefined
    ): Observable<AuditLogListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLogs?';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
        if (serviceName === null) throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined) url_ += 'ServiceName=' + encodeURIComponent('' + serviceName) + '&';
        if (methodName === null) throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined) url_ += 'MethodName=' + encodeURIComponent('' + methodName) + '&';
        if (browserInfo === null) throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined) url_ += 'BrowserInfo=' + encodeURIComponent('' + browserInfo) + '&';
        if (hasException === null) throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined) url_ += 'HasException=' + encodeURIComponent('' + hasException) + '&';
        if (minExecutionDuration === null) throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined) url_ += 'MinExecutionDuration=' + encodeURIComponent('' + minExecutionDuration) + '&';
        if (maxExecutionDuration === null) throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined) url_ += 'MaxExecutionDuration=' + encodeURIComponent('' + maxExecutionDuration) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAuditLogs(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAuditLogs(<any>response_);
                        } catch (e) {
                            return <Observable<AuditLogListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AuditLogListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<AuditLogListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AuditLogListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AuditLogListDto[]>([]);
    }

    /**
     * @param logId (optional)
     * @return Success
     */
    getAuditLog(logId: number | undefined): Observable<AuditLogListDto> {
        let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLog?';
        if (logId === null) throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined) url_ += 'logId=' + encodeURIComponent('' + logId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAuditLog(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAuditLog(<any>response_);
                        } catch (e) {
                            return <Observable<AuditLogListDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AuditLogListDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAuditLog(response: HttpResponseBase): Observable<AuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AuditLogListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AuditLogListDto>(<any>null);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @return Success
     */
    getAuditLogsToExcel(
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        userName: string | undefined,
        serviceName: string | undefined,
        methodName: string | undefined,
        browserInfo: string | undefined,
        hasException: boolean | undefined,
        minExecutionDuration: number | undefined,
        maxExecutionDuration: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLogsToExcel?';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
        if (serviceName === null) throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined) url_ += 'ServiceName=' + encodeURIComponent('' + serviceName) + '&';
        if (methodName === null) throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined) url_ += 'MethodName=' + encodeURIComponent('' + methodName) + '&';
        if (browserInfo === null) throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined) url_ += 'BrowserInfo=' + encodeURIComponent('' + browserInfo) + '&';
        if (hasException === null) throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined) url_ += 'HasException=' + encodeURIComponent('' + hasException) + '&';
        if (minExecutionDuration === null) throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined) url_ += 'MinExecutionDuration=' + encodeURIComponent('' + minExecutionDuration) + '&';
        if (maxExecutionDuration === null) throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined) url_ += 'MaxExecutionDuration=' + encodeURIComponent('' + maxExecutionDuration) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAuditLogsToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAuditLogsToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BackgroundJobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param continuationToken (optional)
     * @param pageSize (optional)
     * @param source (optional)
     * @param searchKey (optional)
     * @param metaDataFilters (optional)
     * @return Success
     */
    getCurrentUserJobs(
        continuationToken: string | undefined,
        pageSize: number | undefined,
        source: string | undefined,
        searchKey: string | undefined,
        metaDataFilters: string | undefined
    ): Observable<BackgroundJobExecutionDtoPagedDtoBase> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJob/GetCurrentUserJobs?';
        if (continuationToken === null) throw new Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined) url_ += 'continuationToken=' + encodeURIComponent('' + continuationToken) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (source === null) throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined) url_ += 'Source=' + encodeURIComponent('' + source) + '&';
        if (searchKey === null) throw new Error("The parameter 'searchKey' cannot be null.");
        else if (searchKey !== undefined) url_ += 'SearchKey=' + encodeURIComponent('' + searchKey) + '&';
        if (metaDataFilters === null) throw new Error("The parameter 'metaDataFilters' cannot be null.");
        else if (metaDataFilters !== undefined) url_ += 'MetaDataFilters=' + encodeURIComponent('' + metaDataFilters) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCurrentUserJobs(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCurrentUserJobs(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDtoPagedDtoBase>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDtoPagedDtoBase>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCurrentUserJobs(response: HttpResponseBase): Observable<BackgroundJobExecutionDtoPagedDtoBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDtoPagedDtoBase.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDtoPagedDtoBase>(<any>null);
    }

    /**
     * @param expandCancellationRequests (optional)
     * @return Success
     */
    getCurrentUserJob(expandCancellationRequests: boolean | undefined, uUID: string): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJob/GetCurrentUserJob?';
        if (expandCancellationRequests === null) throw new Error("The parameter 'expandCancellationRequests' cannot be null.");
        else if (expandCancellationRequests !== undefined)
            url_ += 'ExpandCancellationRequests=' + encodeURIComponent('' + expandCancellationRequests) + '&';
        if (uUID === undefined || uUID === null) throw new Error("The parameter 'uUID' must be defined and cannot be null.");
        else url_ += 'UUID=' + encodeURIComponent('' + uUID) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCurrentUserJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCurrentUserJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCurrentUserJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param uuid (optional)
     * @return Success
     */
    requestJobCancellation(uuid: string | undefined): Observable<BackgroundJobCancellationRequestDto> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJob/RequestJobCancellation?';
        if (uuid === null) throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined) url_ += 'uuid=' + encodeURIComponent('' + uuid) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRequestJobCancellation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRequestJobCancellation(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobCancellationRequestDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobCancellationRequestDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processRequestJobCancellation(response: HttpResponseBase): Observable<BackgroundJobCancellationRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobCancellationRequestDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobCancellationRequestDto>(<any>null);
    }
}

@Injectable()
export class BackgroundJobManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getJobSources(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJobManagement/GetJobSources';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetJobSources(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetJobSources(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetJobSources(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param continuationToken (optional)
     * @param pageSize (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param status (optional)
     * @param source (optional)
     * @param searchKey (optional)
     * @param metaDataFilters (optional)
     * @param isUserLookUp (optional)
     * @return Success
     */
    getAllJobs(
        continuationToken: string | undefined,
        pageSize: number | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        status: BackgroundJobExecutionStatus | undefined,
        source: string | undefined,
        searchKey: string | undefined,
        metaDataFilters: string | undefined,
        isUserLookUp: boolean | undefined
    ): Observable<BackgroundJobExecutionDtoPagedDtoBase> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJobManagement/GetAllJobs?';
        if (continuationToken === null) throw new Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined) url_ += 'continuationToken=' + encodeURIComponent('' + continuationToken) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (status === null) throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
        if (source === null) throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined) url_ += 'Source=' + encodeURIComponent('' + source) + '&';
        if (searchKey === null) throw new Error("The parameter 'searchKey' cannot be null.");
        else if (searchKey !== undefined) url_ += 'SearchKey=' + encodeURIComponent('' + searchKey) + '&';
        if (metaDataFilters === null) throw new Error("The parameter 'metaDataFilters' cannot be null.");
        else if (metaDataFilters !== undefined) url_ += 'MetaDataFilters=' + encodeURIComponent('' + metaDataFilters) + '&';
        if (isUserLookUp === null) throw new Error("The parameter 'isUserLookUp' cannot be null.");
        else if (isUserLookUp !== undefined) url_ += 'isUserLookUp=' + encodeURIComponent('' + isUserLookUp) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllJobs(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllJobs(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDtoPagedDtoBase>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDtoPagedDtoBase>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllJobs(response: HttpResponseBase): Observable<BackgroundJobExecutionDtoPagedDtoBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDtoPagedDtoBase.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDtoPagedDtoBase>(<any>null);
    }

    /**
     * @param expandCancellationRequests (optional)
     * @return Success
     */
    getJob(expandCancellationRequests: boolean | undefined, uUID: string): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJobManagement/GetJob?';
        if (expandCancellationRequests === null) throw new Error("The parameter 'expandCancellationRequests' cannot be null.");
        else if (expandCancellationRequests !== undefined)
            url_ += 'ExpandCancellationRequests=' + encodeURIComponent('' + expandCancellationRequests) + '&';
        if (uUID === undefined || uUID === null) throw new Error("The parameter 'uUID' must be defined and cannot be null.");
        else url_ += 'UUID=' + encodeURIComponent('' + uUID) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param uuid (optional)
     * @return Success
     */
    requestJobCancellation(uuid: string | undefined): Observable<BackgroundJobCancellationRequestDto> {
        let url_ = this.baseUrl + '/api/services/app/BackgroundJobManagement/RequestJobCancellation?';
        if (uuid === null) throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined) url_ += 'uuid=' + encodeURIComponent('' + uuid) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRequestJobCancellation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRequestJobCancellation(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobCancellationRequestDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobCancellationRequestDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processRequestJobCancellation(response: HttpResponseBase): Observable<BackgroundJobCancellationRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobCancellationRequestDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobCancellationRequestDto>(<any>null);
    }
}

@Injectable()
export class BillingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getBillingBaseDashboard(partnerId: number | undefined): Observable<BillingBaseDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Billing/GetBillingBaseDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetBillingBaseDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetBillingBaseDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<BillingBaseDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BillingBaseDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetBillingBaseDashboard(response: HttpResponseBase): Observable<BillingBaseDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(BillingBaseDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BillingBaseDashboardOutput[]>([]);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getEditionsForCombobox(): Observable<ComboboxItemDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommonLookup/GetEditionsForCombobox';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEditionsForCombobox(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEditionsForCombobox(<any>response_);
                        } catch (e) {
                            return <Observable<ComboboxItemDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ComboboxItemDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ComboboxItemDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ComboboxItemDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ComboboxItemDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<NameValueDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommonLookup/FindUsers';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processFindUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processFindUsers(<any>response_);
                        } catch (e) {
                            return <Observable<NameValueDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<NameValueDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processFindUsers(response: HttpResponseBase): Observable<NameValueDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = NameValueDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<NameValueDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + '/api/services/app/CommonLookup/GetDefaultEditionName';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDefaultEditionName(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDefaultEditionName(<any>response_);
                        } catch (e) {
                            return <Observable<GetDefaultEditionNameOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetDefaultEditionNameOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getCompanies(): Observable<CompanyOutputDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Company/GetCompanies';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCompanies(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCompanies(<any>response_);
                        } catch (e) {
                            return <Observable<CompanyOutputDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CompanyOutputDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<CompanyOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CompanyOutputDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CompanyOutputDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCompany(body: CompanyInputDto | undefined): Observable<CompanyOutputDto> {
        let url_ = this.baseUrl + '/api/services/app/Company/CreateOrUpdateCompany';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCompany(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCompany(<any>response_);
                        } catch (e) {
                            return <Observable<CompanyOutputDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CompanyOutputDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCompany(response: HttpResponseBase): Observable<CompanyOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CompanyOutputDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CompanyOutputDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteCompany(body: CompanyInputDto | undefined): Observable<CompanyOutputDto> {
        let url_ = this.baseUrl + '/api/services/app/Company/DeleteCompany';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCompany(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCompany(<any>response_);
                        } catch (e) {
                            return <Observable<CompanyOutputDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CompanyOutputDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<CompanyOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CompanyOutputDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CompanyOutputDto>(<any>null);
    }
}

@Injectable()
export class ContractRenewalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param spmId (optional)
     * @param ioId (optional)
     * @param latestContractEndDate (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getContractRenewals(
        providerId: number | undefined,
        partnerId: number | undefined,
        spmId: number | undefined,
        ioId: number | undefined,
        latestContractEndDate: moment.Moment | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<ContractRenewalDtoPagedAndFilteredResultDto> {
        let url_ = this.baseUrl + '/api/services/app/ContractRenewal/GetContractRenewals?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'SpmId=' + encodeURIComponent('' + spmId) + '&';
        if (ioId === null) throw new Error("The parameter 'ioId' cannot be null.");
        else if (ioId !== undefined) url_ += 'IoId=' + encodeURIComponent('' + ioId) + '&';
        if (latestContractEndDate === null) throw new Error("The parameter 'latestContractEndDate' cannot be null.");
        else if (latestContractEndDate !== undefined)
            url_ += 'LatestContractEndDate=' + encodeURIComponent(latestContractEndDate ? '' + latestContractEndDate.toJSON() : '') + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContractRenewals(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContractRenewals(<any>response_);
                        } catch (e) {
                            return <Observable<ContractRenewalDtoPagedAndFilteredResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContractRenewalDtoPagedAndFilteredResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContractRenewals(response: HttpResponseBase): Observable<ContractRenewalDtoPagedAndFilteredResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ContractRenewalDtoPagedAndFilteredResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContractRenewalDtoPagedAndFilteredResultDto>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @param months (optional)
     * @return Success
     */
    getContractRenewalStatistics(partnerId: number | undefined, months: number[] | undefined): Observable<ContractRenewalStatisticDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ContractRenewal/GetContractRenewalStatistics?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (months === null) throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months &&
                months.forEach((item) => {
                    url_ += 'months=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContractRenewalStatistics(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContractRenewalStatistics(<any>response_);
                        } catch (e) {
                            return <Observable<ContractRenewalStatisticDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContractRenewalStatisticDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContractRenewalStatistics(response: HttpResponseBase): Observable<ContractRenewalStatisticDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContractRenewalStatisticDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContractRenewalStatisticDto[]>([]);
    }

    /**
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param spmId (optional)
     * @param ioId (optional)
     * @param latestContractEndDate (optional)
     * @return Success
     */
    exportToExcel(
        providerId: number | undefined,
        partnerId: number | undefined,
        spmId: number | undefined,
        ioId: number | undefined,
        latestContractEndDate: moment.Moment | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/ContractRenewal/ExportToExcel?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        if (ioId === null) throw new Error("The parameter 'ioId' cannot be null.");
        else if (ioId !== undefined) url_ += 'ioId=' + encodeURIComponent('' + ioId) + '&';
        if (latestContractEndDate === null) throw new Error("The parameter 'latestContractEndDate' cannot be null.");
        else if (latestContractEndDate !== undefined)
            url_ += 'latestContractEndDate=' + encodeURIComponent(latestContractEndDate ? '' + latestContractEndDate.toJSON() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExportToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExportToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processExportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class ContractTermServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getContractTermList(): Observable<ContractTermListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ContractTerm/GetContractTermList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContractTermList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContractTermList(<any>response_);
                        } catch (e) {
                            return <Observable<ContractTermListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContractTermListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContractTermList(response: HttpResponseBase): Observable<ContractTermListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContractTermListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContractTermListDto[]>([]);
    }

    /**
     * @return Success
     */
    getContractTypeList(): Observable<ContractTypeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ContractTerm/GetContractTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContractTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContractTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<ContractTypeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContractTypeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContractTypeList(response: HttpResponseBase): Observable<ContractTypeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContractTypeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContractTypeListDto[]>([]);
    }
}

@Injectable()
export class DepartmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getAdminDepartments(filter: string | undefined): Observable<AdminDepartmentListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Department/GetAdminDepartments?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdminDepartments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdminDepartments(<any>response_);
                        } catch (e) {
                            return <Observable<AdminDepartmentListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdminDepartmentListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdminDepartments(response: HttpResponseBase): Observable<AdminDepartmentListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdminDepartmentListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdminDepartmentListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getDepartmentForEdit(id: number | undefined): Observable<DepartmentAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Department/GetDepartmentForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDepartmentForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDepartmentForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<DepartmentAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DepartmentAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDepartmentForEdit(response: HttpResponseBase): Observable<DepartmentAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = DepartmentAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DepartmentAdminEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteDepartment(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Department/DeleteDepartment?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteDepartment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param name (optional)
     * @return Success
     */
    checkDuplicateDepartmentCount(id: number | undefined, name: string | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Department/CheckDuplicateDepartmentCount?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckDuplicateDepartmentCount(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckDuplicateDepartmentCount(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCheckDuplicateDepartmentCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateDepartment(body: CreateOrUpdateDepartmentInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Department/CreateOrUpdateDepartment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateDepartment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getDepartments(): Observable<DepartmentDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Department/GetDepartments';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDepartments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDepartments(<any>response_);
                        } catch (e) {
                            return <Observable<DepartmentDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DepartmentDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDepartments(response: HttpResponseBase): Observable<DepartmentDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DepartmentDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DepartmentDropdownDto[]>([]);
    }

    /**
     * @param departmentId (optional)
     * @param body (optional)
     * @return Success
     */
    addUsersToDepartment(departmentId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Department/AddUsersToDepartment?';
        if (departmentId === null) throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined) url_ += 'departmentId=' + encodeURIComponent('' + departmentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddUsersToDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddUsersToDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddUsersToDepartment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param departmentId (optional)
     * @param body (optional)
     * @return Success
     */
    addRolesToDepartment(departmentId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Department/AddRolesToDepartment?';
        if (departmentId === null) throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined) url_ += 'departmentId=' + encodeURIComponent('' + departmentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddRolesToDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddRolesToDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddRolesToDepartment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getDepartmentIdsByUserId(userId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + '/api/services/app/Department/GetDepartmentIdsByUserId?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDepartmentIdsByUserId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDepartmentIdsByUserId(<any>response_);
                        } catch (e) {
                            return <Observable<number[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDepartmentIdsByUserId(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number[]>([]);
    }

    /**
     * @param departmentId (optional)
     * @return Success
     */
    getDepartmentUsers(departmentId: number | undefined): Observable<DepartmentUserDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Department/GetDepartmentUsers?';
        if (departmentId === null) throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined) url_ += 'departmentId=' + encodeURIComponent('' + departmentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDepartmentUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDepartmentUsers(<any>response_);
                        } catch (e) {
                            return <Observable<DepartmentUserDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DepartmentUserDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDepartmentUsers(response: HttpResponseBase): Observable<DepartmentUserDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DepartmentUserDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DepartmentUserDropdownDto[]>([]);
    }
}

@Injectable()
export class EmailFiltersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllEmailFilterRules(): Observable<EmailFilterRuleDto[]> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/GetAllEmailFilterRules';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllEmailFilterRules(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllEmailFilterRules(<any>response_);
                        } catch (e) {
                            return <Observable<EmailFilterRuleDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EmailFilterRuleDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllEmailFilterRules(response: HttpResponseBase): Observable<EmailFilterRuleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmailFilterRuleDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmailFilterRuleDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getEmailFilterRuleById(id: number | undefined): Observable<EmailFilterRuleDto> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/GetEmailFilterRuleById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmailFilterRuleById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmailFilterRuleById(<any>response_);
                        } catch (e) {
                            return <Observable<EmailFilterRuleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EmailFilterRuleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEmailFilterRuleById(response: HttpResponseBase): Observable<EmailFilterRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EmailFilterRuleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmailFilterRuleDto>(<any>null);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    deleteEmailFilterRules(ids: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/DeleteEmailFilterRules?';
        if (ids === null) throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids &&
                ids.forEach((item) => {
                    url_ += 'ids=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteEmailFilterRules(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteEmailFilterRules(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteEmailFilterRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    processEmailFilterRules(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/ProcessEmailFilterRules';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProcessEmailFilterRules(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProcessEmailFilterRules(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProcessEmailFilterRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateEmailFilterRule(body: EmailFilterRuleEditDto | undefined): Observable<EmailFilterRuleDto> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/CreateOrUpdateEmailFilterRule';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateEmailFilterRule(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateEmailFilterRule(<any>response_);
                        } catch (e) {
                            return <Observable<EmailFilterRuleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EmailFilterRuleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateEmailFilterRule(response: HttpResponseBase): Observable<EmailFilterRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EmailFilterRuleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmailFilterRuleDto>(<any>null);
    }

    /**
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAllFilteredEmails(
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FilteredEmailDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/GetAllFilteredEmails?';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllFilteredEmails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllFilteredEmails(<any>response_);
                        } catch (e) {
                            return <Observable<FilteredEmailDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FilteredEmailDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllFilteredEmails(response: HttpResponseBase): Observable<FilteredEmailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FilteredEmailDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FilteredEmailDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getFilteredEmailById(id: number | undefined): Observable<FilteredEmailDto> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/GetFilteredEmailById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetFilteredEmailById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetFilteredEmailById(<any>response_);
                        } catch (e) {
                            return <Observable<FilteredEmailDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FilteredEmailDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetFilteredEmailById(response: HttpResponseBase): Observable<FilteredEmailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FilteredEmailDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FilteredEmailDto>(<any>null);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    deleteFilteredEmails(ids: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/DeleteFilteredEmails?';
        if (ids === null) throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids &&
                ids.forEach((item) => {
                    url_ += 'ids=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteFilteredEmails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteFilteredEmails(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteFilteredEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    processFilteredEmails(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/ProcessFilteredEmails';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProcessFilteredEmails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProcessFilteredEmails(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProcessFilteredEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendFilteredEmails(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/EmailFilters/SendFilteredEmails';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendFilteredEmails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendFilteredEmails(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendFilteredEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param filter (optional)
     * @param sourceType (optional)
     * @param sourceKeyIds (optional)
     * @return Success
     * @deprecated
     */
    getEventList(
        filter: string | undefined,
        sourceType: number | undefined,
        sourceKeyIds: number[] | undefined
    ): Observable<EventListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Event/GetEventList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (sourceType === null) throw new Error("The parameter 'sourceType' cannot be null.");
        else if (sourceType !== undefined) url_ += 'SourceType=' + encodeURIComponent('' + sourceType) + '&';
        if (sourceKeyIds === null) throw new Error("The parameter 'sourceKeyIds' cannot be null.");
        else if (sourceKeyIds !== undefined)
            sourceKeyIds &&
                sourceKeyIds.forEach((item) => {
                    url_ += 'SourceKeyIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEventList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEventList(<any>response_);
                        } catch (e) {
                            return <Observable<EventListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EventListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEventList(response: HttpResponseBase): Observable<EventListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EventListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EventListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getEventForEdit(id: number | undefined): Observable<EventEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Event/GetEventForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEventForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEventForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<EventEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EventEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEventForEdit(response: HttpResponseBase): Observable<EventEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EventEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EventEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateEvent(body: CreateOrUpdateEventInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Event/CreateOrUpdateEvent';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateEvent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateEvent(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteEvent(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Event/DeleteEvent?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteEvent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteEvent(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     * @deprecated
     */
    getEventTypeList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Event/GetEventTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEventTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEventTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEventTypeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getEventSourceTypeList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Event/GetEventSourceTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEventSourceTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEventSourceTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEventSourceTypeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getEventStatusList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Event/GetEventStatusList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEventStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEventStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEventStatusList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    downloadTempFile(fileName: string, fileType: string, fileToken: string): Observable<void> {
        let url_ = this.baseUrl + '/File/DownloadTempFile?';
        if (fileName === undefined || fileName === null) throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
        if (fileType === undefined || fileType === null) throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else url_ += 'FileType=' + encodeURIComponent('' + fileType) + '&';
        if (fileToken === undefined || fileToken === null) throw new Error("The parameter 'fileToken' must be defined and cannot be null.");
        else url_ += 'FileToken=' + encodeURIComponent('' + fileToken) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDownloadTempFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDownloadTempFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDownloadTempFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param jobUuid (optional)
     * @param fileName (optional)
     * @param contentType (optional)
     * @return Success
     */
    downloadJobFile(jobUuid: string | undefined, fileName: string | undefined, contentType: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/File/DownloadJobFile?';
        if (jobUuid === null) throw new Error("The parameter 'jobUuid' cannot be null.");
        else if (jobUuid !== undefined) url_ += 'jobUuid=' + encodeURIComponent('' + jobUuid) + '&';
        if (fileName === null) throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
        if (contentType === null) throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined) url_ += 'contentType=' + encodeURIComponent('' + contentType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDownloadJobFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDownloadJobFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDownloadJobFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getImportTemplateSampleFile(templateId: number): Observable<FileDto> {
        let url_ = this.baseUrl + '/Import/GetImportTemplateSampleFile?';
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else url_ += 'templateId=' + encodeURIComponent('' + templateId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetImportTemplateSampleFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetImportTemplateSampleFile(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetImportTemplateSampleFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result404: any = null;
                    let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result404 = resultData404 !== undefined ? resultData404 : <any>null;
                    return throwException('Not Found', status, _responseText, _headers, result404);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    uploadFile(
        contentType: string | undefined,
        contentDisposition: string | undefined,
        headers: { [key: string]: string[] } | undefined,
        length: number | undefined,
        name: string | undefined,
        fileName: string | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/Import/UploadFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (contentType === null || contentType === undefined) throw new Error("The parameter 'contentType' cannot be null.");
        else content_.append('ContentType', contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else content_.append('ContentDisposition', contentDisposition.toString());
        if (headers === null || headers === undefined) throw new Error("The parameter 'headers' cannot be null.");
        else content_.append('Headers', JSON.stringify(headers));
        if (length === null || length === undefined) throw new Error("The parameter 'length' cannot be null.");
        else content_.append('Length', length.toString());
        if (name === null || name === undefined) throw new Error("The parameter 'name' cannot be null.");
        else content_.append('Name', name.toString());
        if (fileName === null || fileName === undefined) throw new Error("The parameter 'fileName' cannot be null.");
        else content_.append('FileName', fileName.toString());

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param typeName (optional)
     * @return Success
     */
    getImportTypes(typeName: string | undefined): Observable<ImportTypeSummaryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetImportTypes?';
        if (typeName === null) throw new Error("The parameter 'typeName' cannot be null.");
        else if (typeName !== undefined) url_ += 'typeName=' + encodeURIComponent('' + typeName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetImportTypes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetImportTypes(<any>response_);
                        } catch (e) {
                            return <Observable<ImportTypeSummaryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportTypeSummaryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetImportTypes(response: HttpResponseBase): Observable<ImportTypeSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ImportTypeSummaryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportTypeSummaryDto[]>([]);
    }

    /**
     * @param importTypeId (optional)
     * @return Success
     */
    getImportTypeDetails(importTypeId: number | undefined): Observable<ImportTypeDetailSummaryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetImportTypeDetails?';
        if (importTypeId === null) throw new Error("The parameter 'importTypeId' cannot be null.");
        else if (importTypeId !== undefined) url_ += 'importTypeId=' + encodeURIComponent('' + importTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetImportTypeDetails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetImportTypeDetails(<any>response_);
                        } catch (e) {
                            return <Observable<ImportTypeDetailSummaryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportTypeDetailSummaryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetImportTypeDetails(response: HttpResponseBase): Observable<ImportTypeDetailSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ImportTypeDetailSummaryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportTypeDetailSummaryDto[]>([]);
    }

    /**
     * @param importTypeId (optional)
     * @return Success
     */
    getImportTypeDetailDropdowns(importTypeId: number | undefined): Observable<ImportTypeDetailDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetImportTypeDetailDropdowns?';
        if (importTypeId === null) throw new Error("The parameter 'importTypeId' cannot be null.");
        else if (importTypeId !== undefined) url_ += 'importTypeId=' + encodeURIComponent('' + importTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetImportTypeDetailDropdowns(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetImportTypeDetailDropdowns(<any>response_);
                        } catch (e) {
                            return <Observable<ImportTypeDetailDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportTypeDetailDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetImportTypeDetailDropdowns(response: HttpResponseBase): Observable<ImportTypeDetailDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ImportTypeDetailDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportTypeDetailDropdownDto[]>([]);
    }

    /**
     * @param importTypeId (optional)
     * @param importTemplateImportTypeDetails (optional)
     * @return Success
     */
    getImportTemplates(
        importTypeId: number | undefined,
        importTemplateImportTypeDetails: GetImportTemplateImportTypeDetailInput[] | undefined
    ): Observable<ImportTemplateDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetImportTemplates?';
        if (importTypeId === null) throw new Error("The parameter 'importTypeId' cannot be null.");
        else if (importTypeId !== undefined) url_ += 'ImportTypeId=' + encodeURIComponent('' + importTypeId) + '&';
        if (importTemplateImportTypeDetails === null) throw new Error("The parameter 'importTemplateImportTypeDetails' cannot be null.");
        else if (importTemplateImportTypeDetails !== undefined)
            importTemplateImportTypeDetails &&
                importTemplateImportTypeDetails.forEach((item, index) => {
                    for (let attr in item)
                        if (item.hasOwnProperty(attr)) {
                            url_ +=
                                'ImportTemplateImportTypeDetails[' +
                                index +
                                '].' +
                                attr +
                                '=' +
                                encodeURIComponent('' + (<any>item)[attr]) +
                                '&';
                        }
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetImportTemplates(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetImportTemplates(<any>response_);
                        } catch (e) {
                            return <Observable<ImportTemplateDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportTemplateDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetImportTemplates(response: HttpResponseBase): Observable<ImportTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ImportTemplateDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportTemplateDto[]>([]);
    }

    /**
     * @param importTemplateId (optional)
     * @return Success
     */
    getImportTemplate(importTemplateId: number | undefined): Observable<ImportTemplateEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetImportTemplate?';
        if (importTemplateId === null) throw new Error("The parameter 'importTemplateId' cannot be null.");
        else if (importTemplateId !== undefined) url_ += 'importTemplateId=' + encodeURIComponent('' + importTemplateId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetImportTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetImportTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<ImportTemplateEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportTemplateEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetImportTemplate(response: HttpResponseBase): Observable<ImportTemplateEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ImportTemplateEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportTemplateEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createImportTemplate(body: CreateImportTemplateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Import/CreateImportTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateImportTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateImportTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateImportTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    editImportTemplate(body: EditImportTemplateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Import/EditImportTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEditImportTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEditImportTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEditImportTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param importTemplateId (optional)
     * @return Success
     */
    deleteImportTemplate(importTemplateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Import/DeleteImportTemplate?';
        if (importTemplateId === null) throw new Error("The parameter 'importTemplateId' cannot be null.");
        else if (importTemplateId !== undefined) url_ += 'importTemplateId=' + encodeURIComponent('' + importTemplateId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteImportTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteImportTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteImportTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param importTypeId (optional)
     * @return Success
     */
    getMappableFields(importTypeId: number | undefined): Observable<ImportTemplateMappableFieldDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetMappableFields?';
        if (importTypeId === null) throw new Error("The parameter 'importTypeId' cannot be null.");
        else if (importTypeId !== undefined) url_ += 'importTypeId=' + encodeURIComponent('' + importTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMappableFields(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMappableFields(<any>response_);
                        } catch (e) {
                            return <Observable<ImportTemplateMappableFieldDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportTemplateMappableFieldDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMappableFields(response: HttpResponseBase): Observable<ImportTemplateMappableFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ImportTemplateMappableFieldDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportTemplateMappableFieldDto[]>([]);
    }

    /**
     * @param fileName (optional)
     * @return Success
     */
    getExcelHeaders(fileName: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Import/GetExcelHeaders?';
        if (fileName === null) throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetExcelHeaders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetExcelHeaders(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetExcelHeaders(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }
}

@Injectable()
export class ImportUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    upload(body: ImportUploadInput | undefined): Observable<ImportUploadOutput> {
        let url_ = this.baseUrl + '/api/services/app/ImportUpload/Upload';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpload(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpload(<any>response_);
                        } catch (e) {
                            return <Observable<ImportUploadOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ImportUploadOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpload(response: HttpResponseBase): Observable<ImportUploadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ImportUploadOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ImportUploadOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    uploadJob(body: ImportUploadInput | undefined): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/ImportUpload/UploadJob';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param fileName (optional)
     * @param body (optional)
     * @return Success
     */
    downloadFailedRecords(fileName: string | undefined, body: ImportUploadExceptionOutput[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/ImportUpload/DownloadFailedRecords?';
        if (fileName === null) throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDownloadFailedRecords(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDownloadFailedRecords(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDownloadFailedRecords(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class JobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param jobType (optional)
     * @return Success
     */
    getEnqueuedJobs(jobType: string | undefined): Observable<BackgroundJobExecution[]> {
        let url_ = this.baseUrl + '/api/services/app/Job/GetEnqueuedJobs?';
        if (jobType === null) throw new Error("The parameter 'jobType' cannot be null.");
        else if (jobType !== undefined) url_ += 'jobType=' + encodeURIComponent('' + jobType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEnqueuedJobs(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEnqueuedJobs(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecution[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecution[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEnqueuedJobs(response: HttpResponseBase): Observable<BackgroundJobExecution[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(BackgroundJobExecution.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecution[]>([]);
    }

    /**
     * @param uuid (optional)
     * @return Success
     */
    triggerEnqueuedReprocessJob(uuid: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Job/TriggerEnqueuedReprocessJob?';
        if (uuid === null) throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined) url_ += 'uuid=' + encodeURIComponent('' + uuid) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processTriggerEnqueuedReprocessJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processTriggerEnqueuedReprocessJob(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processTriggerEnqueuedReprocessJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + '/api/services/app/Language/GetLanguages';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLanguages(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLanguages(<any>response_);
                        } catch (e) {
                            return <Observable<GetLanguagesOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetLanguagesOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetLanguagesOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetLanguagesOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Language/GetLanguageForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLanguageForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLanguageForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetLanguageForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetLanguageForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetLanguageForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/CreateOrUpdateLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateLanguage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateLanguage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/DeleteLanguage?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteLanguage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteLanguage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/SetDefaultLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSetDefaultLanguage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSetDefaultLanguage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @param baseLanguageName (optional)
     * @param targetValueFilter (optional)
     * @param filterText (optional)
     * @return Success
     */
    getLanguageTexts(
        maxResultCount: number | undefined,
        skipCount: number | undefined,
        sorting: string | undefined,
        sourceName: string,
        baseLanguageName: string | undefined,
        targetLanguageName: string,
        targetValueFilter: string | undefined,
        filterText: string | undefined
    ): Observable<LanguageTextListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Language/GetLanguageTexts?';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else url_ += 'SourceName=' + encodeURIComponent('' + sourceName) + '&';
        if (baseLanguageName === null) throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined) url_ += 'BaseLanguageName=' + encodeURIComponent('' + baseLanguageName) + '&';
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else url_ += 'TargetLanguageName=' + encodeURIComponent('' + targetLanguageName) + '&';
        if (targetValueFilter === null) throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined) url_ += 'TargetValueFilter=' + encodeURIComponent('' + targetValueFilter) + '&';
        if (filterText === null) throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLanguageTexts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLanguageTexts(<any>response_);
                        } catch (e) {
                            return <Observable<LanguageTextListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<LanguageTextListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<LanguageTextListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = LanguageTextListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<LanguageTextListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/UpdateLanguageText';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateLanguageText(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateLanguageText(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    uploadLocationFile(
        contentType: string | undefined,
        contentDisposition: string | undefined,
        headers: { [key: string]: string[] } | undefined,
        length: number | undefined,
        name: string | undefined,
        fileName: string | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/Location/UploadLocationFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (contentType === null || contentType === undefined) throw new Error("The parameter 'contentType' cannot be null.");
        else content_.append('ContentType', contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else content_.append('ContentDisposition', contentDisposition.toString());
        if (headers === null || headers === undefined) throw new Error("The parameter 'headers' cannot be null.");
        else content_.append('Headers', JSON.stringify(headers));
        if (length === null || length === undefined) throw new Error("The parameter 'length' cannot be null.");
        else content_.append('Length', length.toString());
        if (name === null || name === undefined) throw new Error("The parameter 'name' cannot be null.");
        else content_.append('Name', name.toString());
        if (fileName === null || fileName === undefined) throw new Error("The parameter 'fileName' cannot be null.");
        else content_.append('FileName', fileName.toString());

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadLocationFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadLocationFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadLocationFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MarketplaceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    manageCompany2(body: MarketplaceWebhook | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Marketplace/ManageCompany2';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processManageCompany2(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processManageCompany2(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processManageCompany2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    manageUser2(body: MarketplaceWebhook | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Marketplace/ManageUser2';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processManageUser2(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processManageUser2(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processManageUser2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    manageMembership2(body: MarketplaceWebhook | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Marketplace/ManageMembership2';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processManageMembership2(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processManageMembership2(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processManageMembership2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    manageCompany(body: MarketplaceWebhook | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Marketplace/ManageCompany';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processManageCompany(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processManageCompany(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processManageCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    manageUser(body: MarketplaceWebhook | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Marketplace/ManageUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processManageUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processManageUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processManageUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    manageMembership(body: MarketplaceWebhook | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Marketplace/ManageMembership';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processManageMembership(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processManageMembership(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processManageMembership(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MilestoneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getMilestones(): Observable<MilestoneDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Milestone/GetMilestones';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMilestones(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMilestones(<any>response_);
                        } catch (e) {
                            return <Observable<MilestoneDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<MilestoneDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMilestones(response: HttpResponseBase): Observable<MilestoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MilestoneDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MilestoneDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateMilestone(body: MilestoneEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Milestone/CreateOrUpdateMilestone';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateMilestone(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateMilestone(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateMilestone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param milestoneId (optional)
     * @return Success
     */
    deleteMilestone(milestoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Milestone/DeleteMilestone?';
        if (milestoneId === null) throw new Error("The parameter 'milestoneId' cannot be null.");
        else if (milestoneId !== undefined) url_ += 'milestoneId=' + encodeURIComponent('' + milestoneId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteMilestone(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteMilestone(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteMilestone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OpportunityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param ownerIds (optional)
     * @param partnerIds (optional)
     * @param spmIds (optional)
     * @param salesAgentIds (optional)
     * @param salesEngineerIds (optional)
     * @param productCategoryIds (optional)
     * @param probabilityIds (optional)
     * @param opportunityStageIds (optional)
     * @param contractTypeIds (optional)
     * @param providerIds (optional)
     * @param statusId (optional)
     * @return Success
     * @deprecated
     */
    getOpportunities(
        ownerIds: string | undefined,
        partnerIds: string | undefined,
        spmIds: string | undefined,
        salesAgentIds: string | undefined,
        salesEngineerIds: string | undefined,
        productCategoryIds: string | undefined,
        probabilityIds: string | undefined,
        opportunityStageIds: string | undefined,
        contractTypeIds: string | undefined,
        providerIds: string | undefined,
        statusId: number | undefined
    ): Observable<OpportunityListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunities?';
        if (ownerIds === null) throw new Error("The parameter 'ownerIds' cannot be null.");
        else if (ownerIds !== undefined) url_ += 'OwnerIds=' + encodeURIComponent('' + ownerIds) + '&';
        if (partnerIds === null) throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined) url_ += 'PartnerIds=' + encodeURIComponent('' + partnerIds) + '&';
        if (spmIds === null) throw new Error("The parameter 'spmIds' cannot be null.");
        else if (spmIds !== undefined) url_ += 'SpmIds=' + encodeURIComponent('' + spmIds) + '&';
        if (salesAgentIds === null) throw new Error("The parameter 'salesAgentIds' cannot be null.");
        else if (salesAgentIds !== undefined) url_ += 'SalesAgentIds=' + encodeURIComponent('' + salesAgentIds) + '&';
        if (salesEngineerIds === null) throw new Error("The parameter 'salesEngineerIds' cannot be null.");
        else if (salesEngineerIds !== undefined) url_ += 'SalesEngineerIds=' + encodeURIComponent('' + salesEngineerIds) + '&';
        if (productCategoryIds === null) throw new Error("The parameter 'productCategoryIds' cannot be null.");
        else if (productCategoryIds !== undefined) url_ += 'ProductCategoryIds=' + encodeURIComponent('' + productCategoryIds) + '&';
        if (probabilityIds === null) throw new Error("The parameter 'probabilityIds' cannot be null.");
        else if (probabilityIds !== undefined) url_ += 'ProbabilityIds=' + encodeURIComponent('' + probabilityIds) + '&';
        if (opportunityStageIds === null) throw new Error("The parameter 'opportunityStageIds' cannot be null.");
        else if (opportunityStageIds !== undefined) url_ += 'OpportunityStageIds=' + encodeURIComponent('' + opportunityStageIds) + '&';
        if (contractTypeIds === null) throw new Error("The parameter 'contractTypeIds' cannot be null.");
        else if (contractTypeIds !== undefined) url_ += 'ContractTypeIds=' + encodeURIComponent('' + contractTypeIds) + '&';
        if (providerIds === null) throw new Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined) url_ += 'ProviderIds=' + encodeURIComponent('' + providerIds) + '&';
        if (statusId === null) throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined) url_ += 'StatusId=' + encodeURIComponent('' + statusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunities(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunities(<any>response_);
                        } catch (e) {
                            return <Observable<OpportunityListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpportunityListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunities(response: HttpResponseBase): Observable<OpportunityListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpportunityListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpportunityListDto[]>([]);
    }

    /**
     * @param ownerIds (optional)
     * @param partnerIds (optional)
     * @param spmIds (optional)
     * @param salesAgentIds (optional)
     * @param salesEngineerIds (optional)
     * @param productCategoryIds (optional)
     * @param probabilityIds (optional)
     * @param opportunityStageIds (optional)
     * @param contractTypeIds (optional)
     * @param providerIds (optional)
     * @param statusId (optional)
     * @return Success
     * @deprecated
     */
    getOpportunitiesToExcel(
        ownerIds: string | undefined,
        partnerIds: string | undefined,
        spmIds: string | undefined,
        salesAgentIds: string | undefined,
        salesEngineerIds: string | undefined,
        productCategoryIds: string | undefined,
        probabilityIds: string | undefined,
        opportunityStageIds: string | undefined,
        contractTypeIds: string | undefined,
        providerIds: string | undefined,
        statusId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunitiesToExcel?';
        if (ownerIds === null) throw new Error("The parameter 'ownerIds' cannot be null.");
        else if (ownerIds !== undefined) url_ += 'OwnerIds=' + encodeURIComponent('' + ownerIds) + '&';
        if (partnerIds === null) throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined) url_ += 'PartnerIds=' + encodeURIComponent('' + partnerIds) + '&';
        if (spmIds === null) throw new Error("The parameter 'spmIds' cannot be null.");
        else if (spmIds !== undefined) url_ += 'SpmIds=' + encodeURIComponent('' + spmIds) + '&';
        if (salesAgentIds === null) throw new Error("The parameter 'salesAgentIds' cannot be null.");
        else if (salesAgentIds !== undefined) url_ += 'SalesAgentIds=' + encodeURIComponent('' + salesAgentIds) + '&';
        if (salesEngineerIds === null) throw new Error("The parameter 'salesEngineerIds' cannot be null.");
        else if (salesEngineerIds !== undefined) url_ += 'SalesEngineerIds=' + encodeURIComponent('' + salesEngineerIds) + '&';
        if (productCategoryIds === null) throw new Error("The parameter 'productCategoryIds' cannot be null.");
        else if (productCategoryIds !== undefined) url_ += 'ProductCategoryIds=' + encodeURIComponent('' + productCategoryIds) + '&';
        if (probabilityIds === null) throw new Error("The parameter 'probabilityIds' cannot be null.");
        else if (probabilityIds !== undefined) url_ += 'ProbabilityIds=' + encodeURIComponent('' + probabilityIds) + '&';
        if (opportunityStageIds === null) throw new Error("The parameter 'opportunityStageIds' cannot be null.");
        else if (opportunityStageIds !== undefined) url_ += 'OpportunityStageIds=' + encodeURIComponent('' + opportunityStageIds) + '&';
        if (contractTypeIds === null) throw new Error("The parameter 'contractTypeIds' cannot be null.");
        else if (contractTypeIds !== undefined) url_ += 'ContractTypeIds=' + encodeURIComponent('' + contractTypeIds) + '&';
        if (providerIds === null) throw new Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined) url_ += 'ProviderIds=' + encodeURIComponent('' + providerIds) + '&';
        if (statusId === null) throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined) url_ += 'StatusId=' + encodeURIComponent('' + statusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunitiesToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunitiesToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     * @deprecated
     */
    getOwners(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOwners';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOwners(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOwners(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOwners(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getPartners(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetPartners';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartners(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartners(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartners(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param partnerIds (optional)
     * @return Success
     * @deprecated
     */
    getSalesAgents(partnerIds: number[] | undefined): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetSalesAgents?';
        if (partnerIds === null) throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds &&
                partnerIds.forEach((item) => {
                    url_ += 'partnerIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesAgents(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesAgents(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesAgents(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getSpms(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetSpms';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSpms(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSpms(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSpms(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getProductCategories(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetProductCategories';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductCategories(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductCategories(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductCategories(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getProbabilities(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetProbabilities';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProbabilities(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProbabilities(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProbabilities(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getOpportunityTypes(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityTypes';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityTypes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityTypes(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityTypes(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param opportunityTypeIds (optional)
     * @return Success
     * @deprecated
     */
    getOpportunityStages(opportunityTypeIds: number[] | undefined): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityStages?';
        if (opportunityTypeIds === null) throw new Error("The parameter 'opportunityTypeIds' cannot be null.");
        else if (opportunityTypeIds !== undefined)
            opportunityTypeIds &&
                opportunityTypeIds.forEach((item) => {
                    url_ += 'opportunityTypeIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityStages(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityStages(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityStages(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getContractTypes(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetContractTypes';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContractTypes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContractTypes(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContractTypes(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getProviders(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetProviders';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviders(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviders(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getOpportunityStatuses(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityStatuses';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityStatuses(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityStatuses(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityStatuses(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    updateEstimatedClosedDate(body: UpdateEstimatedClosedDateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/UpdateEstimatedClosedDate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateEstimatedClosedDate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateEstimatedClosedDate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateEstimatedClosedDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param stageTypeIds (optional)
     * @return Success
     * @deprecated
     */
    getOpportunityStageList(filter: string | undefined, stageTypeIds: number[] | undefined): Observable<OpportunityStageListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityStageList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (stageTypeIds === null) throw new Error("The parameter 'stageTypeIds' cannot be null.");
        else if (stageTypeIds !== undefined)
            stageTypeIds &&
                stageTypeIds.forEach((item) => {
                    url_ += 'StageTypeIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityStageList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityStageList(<any>response_);
                        } catch (e) {
                            return <Observable<OpportunityStageListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpportunityStageListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityStageList(response: HttpResponseBase): Observable<OpportunityStageListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpportunityStageListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpportunityStageListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getOpportunityStageForEdit(id: number | undefined): Observable<OpportunityStageEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityStageForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityStageForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityStageForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<OpportunityStageEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpportunityStageEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityStageForEdit(response: HttpResponseBase): Observable<OpportunityStageEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OpportunityStageEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpportunityStageEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteOpportunityStage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/DeleteOpportunityStage?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteOpportunityStage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteOpportunityStage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteOpportunityStage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateOpportunityStage(body: CreateOrUpdateOpportunityStageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/CreateOrUpdateOpportunityStage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateOpportunityStage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateOpportunityStage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateOpportunityStage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param opportunityTypeName (optional)
     * @return Success
     * @deprecated
     */
    createOpportunityType(opportunityTypeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/CreateOpportunityType?';
        if (opportunityTypeName === null) throw new Error("The parameter 'opportunityTypeName' cannot be null.");
        else if (opportunityTypeName !== undefined) url_ += 'opportunityTypeName=' + encodeURIComponent('' + opportunityTypeName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOpportunityType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOpportunityType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOpportunityType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     * @deprecated
     */
    getOpportunityStage(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityStage';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityStage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityStage(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityStage(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param productCategoryId (optional)
     * @return Success
     * @deprecated
     */
    getProduct(productCategoryId: number | undefined): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetProduct?';
        if (productCategoryId === null) throw new Error("The parameter 'productCategoryId' cannot be null.");
        else if (productCategoryId !== undefined) url_ += 'productCategoryId=' + encodeURIComponent('' + productCategoryId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProduct(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProduct(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProduct(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getSalesEngineer(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetSalesEngineer';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesEngineer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesEngineer(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesEngineer(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getOpportunityForEdit(id: number | undefined): Observable<OpportunityEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetOpportunityForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<OpportunityEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpportunityEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityForEdit(response: HttpResponseBase): Observable<OpportunityEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OpportunityEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpportunityEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateOpportunity(body: CreateOrUpdateOpportunityInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/CreateOrUpdateOpportunity';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateOpportunity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateOpportunity(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateOpportunity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteOpportunity(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/DeleteOpportunity?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteOpportunity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteOpportunity(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteOpportunity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     * @deprecated
     */
    getProbabilityToCloseList(filter: string | undefined): Observable<ProbabilityToCloseListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetProbabilityToCloseList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProbabilityToCloseList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProbabilityToCloseList(<any>response_);
                        } catch (e) {
                            return <Observable<ProbabilityToCloseListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProbabilityToCloseListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProbabilityToCloseList(response: HttpResponseBase): Observable<ProbabilityToCloseListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProbabilityToCloseListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProbabilityToCloseListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getProbabilityToCloseForEdit(id: number | undefined): Observable<ProbabilityToCloseEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/GetProbabilityToCloseForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProbabilityToCloseForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProbabilityToCloseForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<ProbabilityToCloseEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProbabilityToCloseEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProbabilityToCloseForEdit(response: HttpResponseBase): Observable<ProbabilityToCloseEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProbabilityToCloseEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProbabilityToCloseEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteProbability(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/DeleteProbability?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProbability(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProbability(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProbability(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateProbabilityToClose(body: CreateOrUpdateProbabilityToCloseInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Opportunity/CreateOrUpdateProbabilityToClose';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProbabilityToClose(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProbabilityToClose(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProbabilityToClose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<OrganizationUnitDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/GetOrganizationUnits';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrganizationUnits(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrganizationUnits(<any>response_);
                        } catch (e) {
                            return <Observable<OrganizationUnitDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrganizationUnitDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<OrganizationUnitDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrganizationUnitDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrganizationUnitDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrganizationUnitUsers(
        id: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<OrganizationUnitUserListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrganizationUnitUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrganizationUnitUsers(<any>response_);
                        } catch (e) {
                            return <Observable<OrganizationUnitUserListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrganizationUnitUserListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<OrganizationUnitUserListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrganizationUnitUserListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrganizationUnitUserListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/CreateOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<OrganizationUnitDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrganizationUnitDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrganizationUnitDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/UpdateOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<OrganizationUnitDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrganizationUnitDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrganizationUnitDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/MoveOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processMoveOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processMoveOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<OrganizationUnitDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OrganizationUnitDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OrganizationUnitDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/DeleteOrganizationUnit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addUserToOrganizationUnit(body: UserToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/AddUserToOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddUserToOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddUserToOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddUserToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (organizationUnitId === null) throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined) url_ += 'OrganizationUnitId=' + encodeURIComponent('' + organizationUnitId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRemoveUserFromOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRemoveUserFromOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    isInOrganizationUnit(body: UserToOrganizationUnitInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/IsInOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processIsInOrganizationUnit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processIsInOrganizationUnit(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processIsInOrganizationUnit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class OutboxServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    produceOrderCreated(id: number): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Outbox/ProduceOrderCreated/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProduceOrderCreated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProduceOrderCreated(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProduceOrderCreated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    produceQuoteCreated(id: number): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Outbox/ProduceQuoteCreated/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProduceQuoteCreated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProduceQuoteCreated(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProduceQuoteCreated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    produceTicketCreated(id: number): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Outbox/ProduceTicketCreated/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProduceTicketCreated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProduceTicketCreated(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProduceTicketCreated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    produceOrderUpdated(id: number): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Outbox/ProduceOrderUpdated/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProduceOrderUpdated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProduceOrderUpdated(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProduceOrderUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    produceQuoteUpdated(id: number): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Outbox/ProduceQuoteUpdated/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProduceQuoteUpdated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProduceQuoteUpdated(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProduceQuoteUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    produceTicketUpdated(id: number): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Outbox/ProduceTicketUpdated/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProduceTicketUpdated(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProduceTicketUpdated(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProduceTicketUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProductTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllProductTypes(): Observable<ProductTypeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ProductType/GetAllProductTypes';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllProductTypes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllProductTypes(<any>response_);
                        } catch (e) {
                            return <Observable<ProductTypeDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductTypeDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllProductTypes(response: HttpResponseBase): Observable<ProductTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductTypeDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductTypeDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProductTypeById(id: number | undefined): Observable<ProductTypeDto> {
        let url_ = this.baseUrl + '/api/services/app/ProductType/GetProductTypeById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductTypeById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductTypeById(<any>response_);
                        } catch (e) {
                            return <Observable<ProductTypeDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductTypeDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductTypeById(response: HttpResponseBase): Observable<ProductTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProductTypeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductTypeDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProductType(body: ProductTypeEditDto | undefined): Observable<ProductTypeDto> {
        let url_ = this.baseUrl + '/api/services/app/ProductType/CreateOrUpdateProductType';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProductType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProductType(<any>response_);
                        } catch (e) {
                            return <Observable<ProductTypeDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductTypeDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProductType(response: HttpResponseBase): Observable<ProductTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProductTypeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductTypeDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProductType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProductType/DeleteProductType?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProductType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProductType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProductType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RequestorServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getRequestor(email: string | undefined): Observable<Requestor> {
        let url_ = this.baseUrl + '/api/services/app/RequestorService/GetRequestor?';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRequestor(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRequestor(<any>response_);
                        } catch (e) {
                            return <Observable<Requestor>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Requestor>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRequestor(response: HttpResponseBase): Observable<Requestor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = Requestor.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Requestor>(<any>null);
    }

    /**
     * @param searchTerm (optional)
     * @return Success
     */
    getRequestorEmails(searchTerm: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/RequestorService/GetRequestorEmails?';
        if (searchTerm === null) throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined) url_ += 'searchTerm=' + encodeURIComponent('' + searchTerm) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRequestorEmails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRequestorEmails(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRequestorEmails(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addRequestors(body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/RequestorService/AddRequestors';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddRequestors(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddRequestors(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddRequestors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    addUserToRequestorByEmail(email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/RequestorService/AddUserToRequestorByEmail?';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddUserToRequestorByEmail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddUserToRequestorByEmail(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddUserToRequestorByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional)
     * @param userId (optional)
     * @return Success
     */
    addRequestor(email: string | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/RequestorService/AddRequestor?';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddRequestor(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddRequestor(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddRequestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional)
     * @param userId (optional)
     * @return Success
     */
    updateRequestorWithUser(email: string | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/RequestorService/UpdateRequestorWithUser?';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateRequestorWithUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateRequestorWithUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateRequestorWithUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StatusAutomationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getStatusAutomations(): Observable<StatusAutomationDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetStatusAutomations';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusAutomations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusAutomations(<any>response_);
                        } catch (e) {
                            return <Observable<StatusAutomationDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<StatusAutomationDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusAutomations(response: HttpResponseBase): Observable<StatusAutomationDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(StatusAutomationDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<StatusAutomationDropdownDto[]>([]);
    }

    /**
     * @param automationTypeId (optional)
     * @return Success
     */
    getStatusAutomationsByAutomationType(automationTypeId: number | undefined): Observable<StatusAutomationDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetStatusAutomationsByAutomationType?';
        if (automationTypeId === null) throw new Error("The parameter 'automationTypeId' cannot be null.");
        else if (automationTypeId !== undefined) url_ += 'automationTypeId=' + encodeURIComponent('' + automationTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusAutomationsByAutomationType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusAutomationsByAutomationType(<any>response_);
                        } catch (e) {
                            return <Observable<StatusAutomationDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<StatusAutomationDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusAutomationsByAutomationType(response: HttpResponseBase): Observable<StatusAutomationDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(StatusAutomationDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<StatusAutomationDropdownDto[]>([]);
    }

    /**
     * @param tenantId (optional)
     * @param appDomain (optional)
     * @param toStatusId (optional)
     * @param toTicketResolutionId (optional)
     * @param isDeleted (optional)
     * @param deleterUserId (optional)
     * @param deletionTime (optional)
     * @param creationTime (optional)
     * @param creatorUserId (optional)
     * @param id (optional)
     * @return Success
     */
    getStatusNameByAutomationType(
        tenantId: number | undefined,
        appDomain: AppDomain | undefined,
        toStatusId: number | undefined,
        toTicketResolutionId: number | undefined,
        isDeleted: boolean | undefined,
        deleterUserId: number | undefined,
        deletionTime: moment.Moment | undefined,
        creationTime: moment.Moment | undefined,
        creatorUserId: number | undefined,
        id: number | undefined
    ): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetStatusNameByAutomationType?';
        if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined) url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
        if (appDomain === null) throw new Error("The parameter 'appDomain' cannot be null.");
        else if (appDomain !== undefined) url_ += 'AppDomain=' + encodeURIComponent('' + appDomain) + '&';
        if (toStatusId === null) throw new Error("The parameter 'toStatusId' cannot be null.");
        else if (toStatusId !== undefined) url_ += 'ToStatusId=' + encodeURIComponent('' + toStatusId) + '&';
        if (toTicketResolutionId === null) throw new Error("The parameter 'toTicketResolutionId' cannot be null.");
        else if (toTicketResolutionId !== undefined) url_ += 'ToTicketResolutionId=' + encodeURIComponent('' + toTicketResolutionId) + '&';
        if (isDeleted === null) throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined) url_ += 'IsDeleted=' + encodeURIComponent('' + isDeleted) + '&';
        if (deleterUserId === null) throw new Error("The parameter 'deleterUserId' cannot be null.");
        else if (deleterUserId !== undefined) url_ += 'DeleterUserId=' + encodeURIComponent('' + deleterUserId) + '&';
        if (deletionTime === null) throw new Error("The parameter 'deletionTime' cannot be null.");
        else if (deletionTime !== undefined)
            url_ += 'DeletionTime=' + encodeURIComponent(deletionTime ? '' + deletionTime.toJSON() : '') + '&';
        if (creationTime === null) throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += 'CreationTime=' + encodeURIComponent(creationTime ? '' + creationTime.toJSON() : '') + '&';
        if (creatorUserId === null) throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined) url_ += 'CreatorUserId=' + encodeURIComponent('' + creatorUserId) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusNameByAutomationType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusNameByAutomationType(<any>response_);
                        } catch (e) {
                            return <Observable<string>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusNameByAutomationType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tenantId (optional)
     * @param appDomain (optional)
     * @param toStatusId (optional)
     * @param toTicketResolutionId (optional)
     * @param isDeleted (optional)
     * @param deleterUserId (optional)
     * @param deletionTime (optional)
     * @param creationTime (optional)
     * @param creatorUserId (optional)
     * @param id (optional)
     * @return Success
     */
    getTicketResolutionNameByAutomationType(
        tenantId: number | undefined,
        appDomain: AppDomain | undefined,
        toStatusId: number | undefined,
        toTicketResolutionId: number | undefined,
        isDeleted: boolean | undefined,
        deleterUserId: number | undefined,
        deletionTime: moment.Moment | undefined,
        creationTime: moment.Moment | undefined,
        creatorUserId: number | undefined,
        id: number | undefined
    ): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetTicketResolutionNameByAutomationType?';
        if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined) url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
        if (appDomain === null) throw new Error("The parameter 'appDomain' cannot be null.");
        else if (appDomain !== undefined) url_ += 'AppDomain=' + encodeURIComponent('' + appDomain) + '&';
        if (toStatusId === null) throw new Error("The parameter 'toStatusId' cannot be null.");
        else if (toStatusId !== undefined) url_ += 'ToStatusId=' + encodeURIComponent('' + toStatusId) + '&';
        if (toTicketResolutionId === null) throw new Error("The parameter 'toTicketResolutionId' cannot be null.");
        else if (toTicketResolutionId !== undefined) url_ += 'ToTicketResolutionId=' + encodeURIComponent('' + toTicketResolutionId) + '&';
        if (isDeleted === null) throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined) url_ += 'IsDeleted=' + encodeURIComponent('' + isDeleted) + '&';
        if (deleterUserId === null) throw new Error("The parameter 'deleterUserId' cannot be null.");
        else if (deleterUserId !== undefined) url_ += 'DeleterUserId=' + encodeURIComponent('' + deleterUserId) + '&';
        if (deletionTime === null) throw new Error("The parameter 'deletionTime' cannot be null.");
        else if (deletionTime !== undefined)
            url_ += 'DeletionTime=' + encodeURIComponent(deletionTime ? '' + deletionTime.toJSON() : '') + '&';
        if (creationTime === null) throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += 'CreationTime=' + encodeURIComponent(creationTime ? '' + creationTime.toJSON() : '') + '&';
        if (creatorUserId === null) throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined) url_ += 'CreatorUserId=' + encodeURIComponent('' + creatorUserId) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketResolutionNameByAutomationType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketResolutionNameByAutomationType(<any>response_);
                        } catch (e) {
                            return <Observable<string>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketResolutionNameByAutomationType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getStatusAutomationTypes(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetStatusAutomationTypes';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusAutomationTypes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusAutomationTypes(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusAutomationTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param automationTypeId (optional)
     * @return Success
     */
    getStatusNamesByAutomationType(automationTypeId: number | undefined): Observable<StatusAutomationToStatusDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetStatusNamesByAutomationType?';
        if (automationTypeId === null) throw new Error("The parameter 'automationTypeId' cannot be null.");
        else if (automationTypeId !== undefined) url_ += 'automationTypeId=' + encodeURIComponent('' + automationTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusNamesByAutomationType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusNamesByAutomationType(<any>response_);
                        } catch (e) {
                            return <Observable<StatusAutomationToStatusDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<StatusAutomationToStatusDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusNamesByAutomationType(response: HttpResponseBase): Observable<StatusAutomationToStatusDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(StatusAutomationToStatusDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<StatusAutomationToStatusDropdownDto[]>([]);
    }

    /**
     * @param departmentId (optional)
     * @return Success
     */
    getToResolutionsByDepartment(departmentId: number | undefined): Observable<StatusAutomationToResolutionDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetToResolutionsByDepartment?';
        if (departmentId === null) throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined) url_ += 'departmentId=' + encodeURIComponent('' + departmentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetToResolutionsByDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetToResolutionsByDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<StatusAutomationToResolutionDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<StatusAutomationToResolutionDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetToResolutionsByDepartment(response: HttpResponseBase): Observable<StatusAutomationToResolutionDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(StatusAutomationToResolutionDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<StatusAutomationToResolutionDropdownDto[]>([]);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getAdminStatusAutomations(filter: string | undefined): Observable<AdminStatusAutomationListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetAdminStatusAutomations?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdminStatusAutomations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdminStatusAutomations(<any>response_);
                        } catch (e) {
                            return <Observable<AdminStatusAutomationListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdminStatusAutomationListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdminStatusAutomations(response: HttpResponseBase): Observable<AdminStatusAutomationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdminStatusAutomationListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdminStatusAutomationListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getStatusAutomationForEdit(id: number | undefined): Observable<StatusAutomationAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/GetStatusAutomationForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusAutomationForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusAutomationForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<StatusAutomationAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<StatusAutomationAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusAutomationForEdit(response: HttpResponseBase): Observable<StatusAutomationAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = StatusAutomationAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<StatusAutomationAdminEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteStatusAutomation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/DeleteStatusAutomation?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteStatusAutomation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteStatusAutomation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteStatusAutomation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateStatusAutomation(body: CreateOrUpdateStatusAutomationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/StatusAutomation/CreateOrUpdateStatusAutomation';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateStatusAutomation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateStatusAutomation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateStatusAutomation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SupervisorTeamServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getSupervisorTeamList(): Observable<SupervisorTeamDto[]> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/GetSupervisorTeamList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSupervisorTeamList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSupervisorTeamList(<any>response_);
                        } catch (e) {
                            return <Observable<SupervisorTeamDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SupervisorTeamDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSupervisorTeamList(response: HttpResponseBase): Observable<SupervisorTeamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SupervisorTeamDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SupervisorTeamDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateSupervisorTeam(body: SupervisorTeamInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/CreateOrUpdateSupervisorTeam';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateSupervisorTeam(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateSupervisorTeam(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateSupervisorTeam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteSupervisorTeam(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/DeleteSupervisorTeam?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteSupervisorTeam(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteSupervisorTeam(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteSupervisorTeam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param supervisorId (optional)
     * @return Success
     */
    getTeamMembersList(supervisorId: number | undefined): Observable<TeamMembersDto[]> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/GetTeamMembersList?';
        if (supervisorId === null) throw new Error("The parameter 'supervisorId' cannot be null.");
        else if (supervisorId !== undefined) url_ += 'supervisorId=' + encodeURIComponent('' + supervisorId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTeamMembersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTeamMembersList(<any>response_);
                        } catch (e) {
                            return <Observable<TeamMembersDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TeamMembersDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTeamMembersList(response: HttpResponseBase): Observable<TeamMembersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TeamMembersDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TeamMembersDto[]>([]);
    }

    /**
     * @param supervisorId (optional)
     * @return Success
     */
    getTeamMemberIds(supervisorId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/GetTeamMemberIds?';
        if (supervisorId === null) throw new Error("The parameter 'supervisorId' cannot be null.");
        else if (supervisorId !== undefined) url_ += 'supervisorId=' + encodeURIComponent('' + supervisorId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTeamMemberIds(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTeamMemberIds(<any>response_);
                        } catch (e) {
                            return <Observable<number[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTeamMemberIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createTeamMember(body: TeamMemberInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/CreateTeamMember';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateTeamMember(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateTeamMember(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateTeamMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTeamMember(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/SupervisorTeam/DeleteTeamMember?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTeamMember(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTeamMember(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTeamMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SurveyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getSurvey(id: number | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + '/api/services/app/Survey/GetSurvey?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSurvey(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSurvey(<any>response_);
                        } catch (e) {
                            return <Observable<SurveyDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SurveyDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SurveyDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SurveyDto>(<any>null);
    }

    /**
     * @param continuationToken (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getAllSurveys(continuationToken: string | undefined, pageSize: number | undefined): Observable<SurveyDtoPagedDtoBase> {
        let url_ = this.baseUrl + '/api/services/app/Survey/GetAllSurveys?';
        if (continuationToken === null) throw new Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined) url_ += 'continuationToken=' + encodeURIComponent('' + continuationToken) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllSurveys(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllSurveys(<any>response_);
                        } catch (e) {
                            return <Observable<SurveyDtoPagedDtoBase>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SurveyDtoPagedDtoBase>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllSurveys(response: HttpResponseBase): Observable<SurveyDtoPagedDtoBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SurveyDtoPagedDtoBase.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SurveyDtoPagedDtoBase>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteSurvey(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Survey/DeleteSurvey?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteSurvey(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteSurvey(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createSurvey(body: SurveyDto | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + '/api/services/app/Survey/CreateSurvey';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateSurvey(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateSurvey(<any>response_);
                        } catch (e) {
                            return <Observable<SurveyDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SurveyDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SurveyDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SurveyDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateSurvey(body: SurveyDto | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + '/api/services/app/Survey/UpdateSurvey';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateSurvey(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateSurvey(<any>response_);
                        } catch (e) {
                            return <Observable<SurveyDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SurveyDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SurveyDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SurveyDto>(<any>null);
    }
}

@Injectable()
export class TerritoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getTerritoryList(): Observable<Territory[]> {
        let url_ = this.baseUrl + '/api/services/app/Territory/GetTerritoryList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTerritoryList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTerritoryList(<any>response_);
                        } catch (e) {
                            return <Observable<Territory[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Territory[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTerritoryList(response: HttpResponseBase): Observable<Territory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Territory.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Territory[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTerritory(id: number | undefined): Observable<Territory> {
        let url_ = this.baseUrl + '/api/services/app/Territory/GetTerritory?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTerritory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTerritory(<any>response_);
                        } catch (e) {
                            return <Observable<Territory>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Territory>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTerritory(response: HttpResponseBase): Observable<Territory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = Territory.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Territory>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTerritory(body: TerritoryInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Territory/CreateOrUpdateTerritory';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTerritory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTerritory(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTerritory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTerritory(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Territory/DeleteTerritory?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTerritory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTerritory(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTerritory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional)
     * @param territoryId (optional)
     * @return Success
     */
    getUserTerritoryList(userId: number | undefined, territoryId: number | undefined): Observable<UserTerritoryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Territory/GetUserTerritoryList?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (territoryId === null) throw new Error("The parameter 'territoryId' cannot be null.");
        else if (territoryId !== undefined) url_ += 'TerritoryId=' + encodeURIComponent('' + territoryId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserTerritoryList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserTerritoryList(<any>response_);
                        } catch (e) {
                            return <Observable<UserTerritoryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserTerritoryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserTerritoryList(response: HttpResponseBase): Observable<UserTerritoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserTerritoryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserTerritoryDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserTerritory(id: number | undefined): Observable<UserTerritory> {
        let url_ = this.baseUrl + '/api/services/app/Territory/GetUserTerritory?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserTerritory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserTerritory(<any>response_);
                        } catch (e) {
                            return <Observable<UserTerritory>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserTerritory>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserTerritory(response: HttpResponseBase): Observable<UserTerritory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserTerritory.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserTerritory>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateUserTerritory(body: UserTerritoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Territory/CreateOrUpdateUserTerritory';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateUserTerritory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateUserTerritory(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateUserTerritory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteUserTerritory(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Territory/DeleteUserTerritory?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteUserTerritory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteUserTerritory(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteUserTerritory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param defaultTimezoneScope (optional)
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<NameValueDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Timing/GetTimezones?';
        if (defaultTimezoneScope === null) throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined) url_ += 'DefaultTimezoneScope=' + encodeURIComponent('' + defaultTimezoneScope) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTimezones(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTimezones(<any>response_);
                        } catch (e) {
                            return <Observable<NameValueDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<NameValueDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<NameValueDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = NameValueDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<NameValueDtoListResultDto>(<any>null);
    }

    /**
     * @param selectedTimezoneId (optional)
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Timing/GetTimezoneComboboxItems?';
        if (selectedTimezoneId === null) throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined) url_ += 'SelectedTimezoneId=' + encodeURIComponent('' + selectedTimezoneId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTimezoneComboboxItems(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTimezoneComboboxItems(<any>response_);
                        } catch (e) {
                            return <Observable<ComboboxItemDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ComboboxItemDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ComboboxItemDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ComboboxItemDto[]>([]);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + '/api/services/app/WebLog/GetLatestWebLogs';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLatestWebLogs(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLatestWebLogs(<any>response_);
                        } catch (e) {
                            return <Observable<GetLatestWebLogsOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetLatestWebLogsOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetLatestWebLogsOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/WebLog/DownloadWebLogs';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDownloadWebLogs(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDownloadWebLogs(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

export class ARCActivityListDto implements IARCActivityListDto {
    activityKey: number;
    activityType: ActivityType;
    detail: string | undefined;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    creatorName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IARCActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityKey = _data['activityKey'];
            this.activityType = _data['activityType'];
            this.detail = _data['detail'];
            this.isPublic = _data['isPublic'];
            this.isComplete = _data['isComplete'];
            this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
            this.creatorName = _data['creatorName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ARCActivityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ARCActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activityKey'] = this.activityKey;
        data['activityType'] = this.activityType;
        data['detail'] = this.detail;
        data['isPublic'] = this.isPublic;
        data['isComplete'] = this.isComplete;
        data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data['creatorName'] = this.creatorName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ARCActivityListDto {
        const json = this.toJSON();
        let result = new ARCActivityListDto();
        result.init(json);
        return result;
    }
}

export interface IARCActivityListDto {
    activityKey: number;
    activityType: ActivityType;
    detail: string | undefined;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    creatorName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ActionAdminEditDto implements IActionAdminEditDto {
    tenantId: number | undefined;
    name: string;
    automationTypeId: number;
    automationId: number;
    buttonId: ActionButtonId;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IActionAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.automationTypeId = _data['automationTypeId'];
            this.automationId = _data['automationId'];
            this.buttonId = _data['buttonId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ActionAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['automationTypeId'] = this.automationTypeId;
        data['automationId'] = this.automationId;
        data['buttonId'] = this.buttonId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ActionAdminEditDto {
        const json = this.toJSON();
        let result = new ActionAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface IActionAdminEditDto {
    tenantId: number | undefined;
    name: string;
    automationTypeId: number;
    automationId: number;
    buttonId: ActionButtonId;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum ActionButtonId {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ActionDropdownDto implements IActionDropdownDto {
    id: number;
    name: string | undefined;

    constructor(data?: IActionDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ActionDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): ActionDropdownDto {
        const json = this.toJSON();
        let result = new ActionDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IActionDropdownDto {
    id: number;
    name: string | undefined;
}

export class Activity implements IActivity {
    tenantId: number | undefined;
    activityKey: number;
    activityType: ActivityType;
    detail: string;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    activityUsers: ActivityUser[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    activityCategory: ActivityCategory;
    completedDate: moment.Moment | undefined;
    creatorUser: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.activityKey = _data['activityKey'];
            this.activityType = _data['activityType'];
            this.detail = _data['detail'];
            this.isPublic = _data['isPublic'];
            this.isComplete = _data['isComplete'];
            this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
            if (Array.isArray(_data['activityUsers'])) {
                this.activityUsers = [] as any;
                for (let item of _data['activityUsers']) this.activityUsers.push(ActivityUser.fromJS(item));
            }
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.activityCategory = _data['activityCategory'];
            this.completedDate = _data['completedDate'] ? moment(_data['completedDate'].toString()) : <any>undefined;
            this.creatorUser = _data['creatorUser'] ? User.fromJS(_data['creatorUser']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['activityKey'] = this.activityKey;
        data['activityType'] = this.activityType;
        data['detail'] = this.detail;
        data['isPublic'] = this.isPublic;
        data['isComplete'] = this.isComplete;
        data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        if (Array.isArray(this.activityUsers)) {
            data['activityUsers'] = [];
            for (let item of this.activityUsers) data['activityUsers'].push(item.toJSON());
        }
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['activityCategory'] = this.activityCategory;
        data['completedDate'] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data['creatorUser'] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Activity {
        const json = this.toJSON();
        let result = new Activity();
        result.init(json);
        return result;
    }
}

export interface IActivity {
    tenantId: number | undefined;
    activityKey: number;
    activityType: ActivityType;
    detail: string;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    activityUsers: ActivityUser[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    activityCategory: ActivityCategory;
    completedDate: moment.Moment | undefined;
    creatorUser: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ActivityArchiveOutput implements IActivityArchiveOutput {
    activityArchiveList: ARCActivityListDto[] | undefined;

    constructor(data?: IActivityArchiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['activityArchiveList'])) {
                this.activityArchiveList = [] as any;
                for (let item of _data['activityArchiveList']) this.activityArchiveList.push(ARCActivityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityArchiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityArchiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityArchiveList)) {
            data['activityArchiveList'] = [];
            for (let item of this.activityArchiveList) data['activityArchiveList'].push(item.toJSON());
        }
        return data;
    }

    clone(): ActivityArchiveOutput {
        const json = this.toJSON();
        let result = new ActivityArchiveOutput();
        result.init(json);
        return result;
    }
}

export interface IActivityArchiveOutput {
    activityArchiveList: ARCActivityListDto[] | undefined;
}

export class ActivityDetailDto implements IActivityDetailDto {
    activityKey: number;
    activityType: ActivityType;
    assignedUserId: number;
    assignedUser: string | undefined;
    detail: string | undefined;
    isPublic: boolean;
    isComplete: boolean;
    completedDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    createdBy: string | undefined;
    activityCategory: ActivityCategory;
    activityCustomer: string | undefined;
    activityProvider: string | undefined;
    activityTitle: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IActivityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityKey = _data['activityKey'];
            this.activityType = _data['activityType'];
            this.assignedUserId = _data['assignedUserId'];
            this.assignedUser = _data['assignedUser'];
            this.detail = _data['detail'];
            this.isPublic = _data['isPublic'];
            this.isComplete = _data['isComplete'];
            this.completedDate = _data['completedDate'] ? moment(_data['completedDate'].toString()) : <any>undefined;
            this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.activityCategory = _data['activityCategory'];
            this.activityCustomer = _data['activityCustomer'];
            this.activityProvider = _data['activityProvider'];
            this.activityTitle = _data['activityTitle'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ActivityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activityKey'] = this.activityKey;
        data['activityType'] = this.activityType;
        data['assignedUserId'] = this.assignedUserId;
        data['assignedUser'] = this.assignedUser;
        data['detail'] = this.detail;
        data['isPublic'] = this.isPublic;
        data['isComplete'] = this.isComplete;
        data['completedDate'] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['activityCategory'] = this.activityCategory;
        data['activityCustomer'] = this.activityCustomer;
        data['activityProvider'] = this.activityProvider;
        data['activityTitle'] = this.activityTitle;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ActivityDetailDto {
        const json = this.toJSON();
        let result = new ActivityDetailDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDetailDto {
    activityKey: number;
    activityType: ActivityType;
    assignedUserId: number;
    assignedUser: string | undefined;
    detail: string | undefined;
    isPublic: boolean;
    isComplete: boolean;
    completedDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    createdBy: string | undefined;
    activityCategory: ActivityCategory;
    activityCustomer: string | undefined;
    activityProvider: string | undefined;
    activityTitle: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ActivityEditDto implements IActivityEditDto {
    detail: string;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    activityKey: number;
    activityType: ActivityType;
    activityCategory: ActivityCategory;
    completedDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IActivityEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data['detail'];
            this.isPublic = _data['isPublic'];
            this.isComplete = _data['isComplete'];
            this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
            this.activityKey = _data['activityKey'];
            this.activityType = _data['activityType'];
            this.activityCategory = _data['activityCategory'];
            this.completedDate = _data['completedDate'] ? moment(_data['completedDate'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ActivityEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['detail'] = this.detail;
        data['isPublic'] = this.isPublic;
        data['isComplete'] = this.isComplete;
        data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data['activityKey'] = this.activityKey;
        data['activityType'] = this.activityType;
        data['activityCategory'] = this.activityCategory;
        data['completedDate'] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): ActivityEditDto {
        const json = this.toJSON();
        let result = new ActivityEditDto();
        result.init(json);
        return result;
    }
}

export interface IActivityEditDto {
    detail: string;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    activityKey: number;
    activityType: ActivityType;
    activityCategory: ActivityCategory;
    completedDate: moment.Moment | undefined;
    id: number;
}

export class ActivityListDto implements IActivityListDto {
    detail: string | undefined;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    createdBy: string | undefined;
    profilePicture: string | undefined;
    activityCategory: ActivityCategory;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data['detail'];
            this.isPublic = _data['isPublic'];
            this.isComplete = _data['isComplete'];
            this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
            this.createdBy = _data['createdBy'];
            this.profilePicture = _data['profilePicture'];
            this.activityCategory = _data['activityCategory'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ActivityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['detail'] = this.detail;
        data['isPublic'] = this.isPublic;
        data['isComplete'] = this.isComplete;
        data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data['createdBy'] = this.createdBy;
        data['profilePicture'] = this.profilePicture;
        data['activityCategory'] = this.activityCategory;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ActivityListDto {
        const json = this.toJSON();
        let result = new ActivityListDto();
        result.init(json);
        return result;
    }
}

export interface IActivityListDto {
    detail: string | undefined;
    isPublic: boolean;
    isComplete: boolean;
    dueDate: moment.Moment | undefined;
    createdBy: string | undefined;
    profilePicture: string | undefined;
    activityCategory: ActivityCategory;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ActivityUser implements IActivityUser {
    tenantId: number | undefined;
    activityId: number;
    activity: Activity;
    userId: number;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IActivityUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.activityId = _data['activityId'];
            this.activity = _data['activity'] ? Activity.fromJS(_data['activity']) : <any>undefined;
            this.userId = _data['userId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ActivityUser {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['activityId'] = this.activityId;
        data['activity'] = this.activity ? this.activity.toJSON() : <any>undefined;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ActivityUser {
        const json = this.toJSON();
        let result = new ActivityUser();
        result.init(json);
        return result;
    }
}

export interface IActivityUser {
    tenantId: number | undefined;
    activityId: number;
    activity: Activity;
    userId: number;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ActivityUserEditDto implements IActivityUserEditDto {
    activityId: number;
    userId: number;
    id: number;

    constructor(data?: IActivityUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data['activityId'];
            this.userId = _data['userId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ActivityUserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activityId'] = this.activityId;
        data['userId'] = this.userId;
        data['id'] = this.id;
        return data;
    }

    clone(): ActivityUserEditDto {
        const json = this.toJSON();
        let result = new ActivityUserEditDto();
        result.init(json);
        return result;
    }
}

export interface IActivityUserEditDto {
    activityId: number;
    userId: number;
    id: number;
}

export class Address implements IAddress {
    street1: string | undefined;
    street2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street1 = _data['street1'];
            this.street2 = _data['street2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['street1'] = this.street1;
        data['street2'] = this.street2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    street1: string | undefined;
    street2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
}

export enum AdjustmentScheduleActionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AdjustmentScheduleDto implements IAdjustmentScheduleDto {
    partnerId: number;
    partnerName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    masterAgencyId: number;
    masterAgencyName: string | undefined;
    description: string | undefined;
    total: number;
    monthlyAmount: number;
    adjustmentScheduleItemId: number;
    adjustmentScheduleItemName: string | undefined;
    endReason: string | undefined;
    commissionWorkbookId: number | undefined;
    balance: number;
    totalTransactions: number;
    adjustmentScheduleType: ScheduleTypeEnum;
    adjustmentScheduleActionType: AdjustmentScheduleActionType;
    adjustmentScheduleTransactions: AdjustmentScheduleTransaction[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAdjustmentScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.masterAgencyId = _data['masterAgencyId'];
            this.masterAgencyName = _data['masterAgencyName'];
            this.description = _data['description'];
            this.total = _data['total'];
            this.monthlyAmount = _data['monthlyAmount'];
            this.adjustmentScheduleItemId = _data['adjustmentScheduleItemId'];
            this.adjustmentScheduleItemName = _data['adjustmentScheduleItemName'];
            this.endReason = _data['endReason'];
            this.commissionWorkbookId = _data['commissionWorkbookId'];
            this.balance = _data['balance'];
            this.totalTransactions = _data['totalTransactions'];
            this.adjustmentScheduleType = _data['adjustmentScheduleType'];
            this.adjustmentScheduleActionType = _data['adjustmentScheduleActionType'];
            if (Array.isArray(_data['adjustmentScheduleTransactions'])) {
                this.adjustmentScheduleTransactions = [] as any;
                for (let item of _data['adjustmentScheduleTransactions'])
                    this.adjustmentScheduleTransactions.push(AdjustmentScheduleTransaction.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AdjustmentScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['masterAgencyId'] = this.masterAgencyId;
        data['masterAgencyName'] = this.masterAgencyName;
        data['description'] = this.description;
        data['total'] = this.total;
        data['monthlyAmount'] = this.monthlyAmount;
        data['adjustmentScheduleItemId'] = this.adjustmentScheduleItemId;
        data['adjustmentScheduleItemName'] = this.adjustmentScheduleItemName;
        data['endReason'] = this.endReason;
        data['commissionWorkbookId'] = this.commissionWorkbookId;
        data['balance'] = this.balance;
        data['totalTransactions'] = this.totalTransactions;
        data['adjustmentScheduleType'] = this.adjustmentScheduleType;
        data['adjustmentScheduleActionType'] = this.adjustmentScheduleActionType;
        if (Array.isArray(this.adjustmentScheduleTransactions)) {
            data['adjustmentScheduleTransactions'] = [];
            for (let item of this.adjustmentScheduleTransactions) data['adjustmentScheduleTransactions'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AdjustmentScheduleDto {
        const json = this.toJSON();
        let result = new AdjustmentScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IAdjustmentScheduleDto {
    partnerId: number;
    partnerName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    masterAgencyId: number;
    masterAgencyName: string | undefined;
    description: string | undefined;
    total: number;
    monthlyAmount: number;
    adjustmentScheduleItemId: number;
    adjustmentScheduleItemName: string | undefined;
    endReason: string | undefined;
    commissionWorkbookId: number | undefined;
    balance: number;
    totalTransactions: number;
    adjustmentScheduleType: ScheduleTypeEnum;
    adjustmentScheduleActionType: AdjustmentScheduleActionType;
    adjustmentScheduleTransactions: AdjustmentScheduleTransaction[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AdjustmentScheduleDtoPagedResultDto implements IAdjustmentScheduleDtoPagedResultDto {
    totalCount: number;
    items: AdjustmentScheduleDto[] | undefined;

    constructor(data?: IAdjustmentScheduleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(AdjustmentScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdjustmentScheduleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentScheduleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): AdjustmentScheduleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdjustmentScheduleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdjustmentScheduleDtoPagedResultDto {
    totalCount: number;
    items: AdjustmentScheduleDto[] | undefined;
}

export class AdjustmentScheduleEditDto implements IAdjustmentScheduleEditDto {
    partnerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    adjustmentScheduleItemId: number;
    masterAgencyId: number;
    description: string | undefined;
    total: number;
    monthlyAmount: number;
    commissionWorkbookDetailId: number | undefined;
    adjustmentScheduleType: ScheduleTypeEnum;
    adjustmentScheduleActionType: AdjustmentScheduleActionType;
    id: number;

    constructor(data?: IAdjustmentScheduleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.adjustmentScheduleItemId = _data['adjustmentScheduleItemId'];
            this.masterAgencyId = _data['masterAgencyId'];
            this.description = _data['description'];
            this.total = _data['total'];
            this.monthlyAmount = _data['monthlyAmount'];
            this.commissionWorkbookDetailId = _data['commissionWorkbookDetailId'];
            this.adjustmentScheduleType = _data['adjustmentScheduleType'];
            this.adjustmentScheduleActionType = _data['adjustmentScheduleActionType'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AdjustmentScheduleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentScheduleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['adjustmentScheduleItemId'] = this.adjustmentScheduleItemId;
        data['masterAgencyId'] = this.masterAgencyId;
        data['description'] = this.description;
        data['total'] = this.total;
        data['monthlyAmount'] = this.monthlyAmount;
        data['commissionWorkbookDetailId'] = this.commissionWorkbookDetailId;
        data['adjustmentScheduleType'] = this.adjustmentScheduleType;
        data['adjustmentScheduleActionType'] = this.adjustmentScheduleActionType;
        data['id'] = this.id;
        return data;
    }

    clone(): AdjustmentScheduleEditDto {
        const json = this.toJSON();
        let result = new AdjustmentScheduleEditDto();
        result.init(json);
        return result;
    }
}

export interface IAdjustmentScheduleEditDto {
    partnerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    adjustmentScheduleItemId: number;
    masterAgencyId: number;
    description: string | undefined;
    total: number;
    monthlyAmount: number;
    commissionWorkbookDetailId: number | undefined;
    adjustmentScheduleType: ScheduleTypeEnum;
    adjustmentScheduleActionType: AdjustmentScheduleActionType;
    id: number;
}

export class AdjustmentScheduleItemDto implements IAdjustmentScheduleItemDto {
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAdjustmentScheduleItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AdjustmentScheduleItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentScheduleItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AdjustmentScheduleItemDto {
        const json = this.toJSON();
        let result = new AdjustmentScheduleItemDto();
        result.init(json);
        return result;
    }
}

export interface IAdjustmentScheduleItemDto {
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AdjustmentScheduleItemEditDto implements IAdjustmentScheduleItemEditDto {
    name: string | undefined;
    id: number;

    constructor(data?: IAdjustmentScheduleItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AdjustmentScheduleItemEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentScheduleItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): AdjustmentScheduleItemEditDto {
        const json = this.toJSON();
        let result = new AdjustmentScheduleItemEditDto();
        result.init(json);
        return result;
    }
}

export interface IAdjustmentScheduleItemEditDto {
    name: string | undefined;
    id: number;
}

export class AdjustmentScheduleTransaction implements IAdjustmentScheduleTransaction {
    id: number;
    adjustmentScheduleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    month: number;
    year: number;
    payAmount: number;
    payoutJobId: string | undefined;
    uuid: string;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    notes: string | undefined;
    adjustmentScheduleAdvisorId: number | undefined;
    adjustmentScheduleAdvisorName: string | undefined;
    adjustmentScheduleDescription: string | undefined;
    balance: number;
    isEndTransaction: boolean;

    constructor(data?: IAdjustmentScheduleTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.adjustmentScheduleId = _data['adjustmentScheduleId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.payAmount = _data['payAmount'];
            this.payoutJobId = _data['payoutJobId'];
            this.uuid = _data['uuid'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.notes = _data['notes'];
            this.adjustmentScheduleAdvisorId = _data['adjustmentScheduleAdvisorId'];
            this.adjustmentScheduleAdvisorName = _data['adjustmentScheduleAdvisorName'];
            this.adjustmentScheduleDescription = _data['adjustmentScheduleDescription'];
            this.balance = _data['balance'];
            this.isEndTransaction = _data['isEndTransaction'];
        }
    }

    static fromJS(data: any): AdjustmentScheduleTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentScheduleTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['adjustmentScheduleId'] = this.adjustmentScheduleId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['payAmount'] = this.payAmount;
        data['payoutJobId'] = this.payoutJobId;
        data['uuid'] = this.uuid;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['notes'] = this.notes;
        data['adjustmentScheduleAdvisorId'] = this.adjustmentScheduleAdvisorId;
        data['adjustmentScheduleAdvisorName'] = this.adjustmentScheduleAdvisorName;
        data['adjustmentScheduleDescription'] = this.adjustmentScheduleDescription;
        data['balance'] = this.balance;
        data['isEndTransaction'] = this.isEndTransaction;
        return data;
    }

    clone(): AdjustmentScheduleTransaction {
        const json = this.toJSON();
        let result = new AdjustmentScheduleTransaction();
        result.init(json);
        return result;
    }
}

export interface IAdjustmentScheduleTransaction {
    id: number;
    adjustmentScheduleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    month: number;
    year: number;
    payAmount: number;
    payoutJobId: string | undefined;
    uuid: string;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    notes: string | undefined;
    adjustmentScheduleAdvisorId: number | undefined;
    adjustmentScheduleAdvisorName: string | undefined;
    adjustmentScheduleDescription: string | undefined;
    balance: number;
    isEndTransaction: boolean;
}

export class AdminActionListDto implements IAdminActionListDto {
    id: number;
    name: string | undefined;
    automation: string | undefined;
    buttonId: string | undefined;

    constructor(data?: IAdminActionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.automation = _data['automation'];
            this.buttonId = _data['buttonId'];
        }
    }

    static fromJS(data: any): AdminActionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminActionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['automation'] = this.automation;
        data['buttonId'] = this.buttonId;
        return data;
    }

    clone(): AdminActionListDto {
        const json = this.toJSON();
        let result = new AdminActionListDto();
        result.init(json);
        return result;
    }
}

export interface IAdminActionListDto {
    id: number;
    name: string | undefined;
    automation: string | undefined;
    buttonId: string | undefined;
}

export class AdminDepartmentListDto implements IAdminDepartmentListDto {
    id: number;
    name: string | undefined;
    senderAddress: string | undefined;
    roles: Role[] | undefined;
    isKafkaEnabled: boolean;

    constructor(data?: IAdminDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.senderAddress = _data['senderAddress'];
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(Role.fromJS(item));
            }
            this.isKafkaEnabled = _data['isKafkaEnabled'];
        }
    }

    static fromJS(data: any): AdminDepartmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['senderAddress'] = this.senderAddress;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        data['isKafkaEnabled'] = this.isKafkaEnabled;
        return data;
    }

    clone(): AdminDepartmentListDto {
        const json = this.toJSON();
        let result = new AdminDepartmentListDto();
        result.init(json);
        return result;
    }
}

export interface IAdminDepartmentListDto {
    id: number;
    name: string | undefined;
    senderAddress: string | undefined;
    roles: Role[] | undefined;
    isKafkaEnabled: boolean;
}

export class AdminEmailCannedResponseListDto implements IAdminEmailCannedResponseListDto {
    id: number;
    userId: number | undefined;
    userFullName: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
    name: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    statusAutomationType: string | undefined;
    statusAutomationId: number | undefined;
    automation: string | undefined;

    constructor(data?: IAdminEmailCannedResponseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userId = _data['userId'];
            this.userFullName = _data['userFullName'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.name = _data['name'];
            this.subject = _data['subject'];
            this.message = _data['message'];
            this.statusAutomationType = _data['statusAutomationType'];
            this.statusAutomationId = _data['statusAutomationId'];
            this.automation = _data['automation'];
        }
    }

    static fromJS(data: any): AdminEmailCannedResponseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminEmailCannedResponseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userId'] = this.userId;
        data['userFullName'] = this.userFullName;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['name'] = this.name;
        data['subject'] = this.subject;
        data['message'] = this.message;
        data['statusAutomationType'] = this.statusAutomationType;
        data['statusAutomationId'] = this.statusAutomationId;
        data['automation'] = this.automation;
        return data;
    }

    clone(): AdminEmailCannedResponseListDto {
        const json = this.toJSON();
        let result = new AdminEmailCannedResponseListDto();
        result.init(json);
        return result;
    }
}

export interface IAdminEmailCannedResponseListDto {
    id: number;
    userId: number | undefined;
    userFullName: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
    name: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    statusAutomationType: string | undefined;
    statusAutomationId: number | undefined;
    automation: string | undefined;
}

export class AdminStatusAutomationListDto implements IAdminStatusAutomationListDto {
    id: number;
    automationType: string | undefined;
    toStatus: string | undefined;
    toTicketResolution: string | undefined;

    constructor(data?: IAdminStatusAutomationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.automationType = _data['automationType'];
            this.toStatus = _data['toStatus'];
            this.toTicketResolution = _data['toTicketResolution'];
        }
    }

    static fromJS(data: any): AdminStatusAutomationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminStatusAutomationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['automationType'] = this.automationType;
        data['toStatus'] = this.toStatus;
        data['toTicketResolution'] = this.toTicketResolution;
        return data;
    }

    clone(): AdminStatusAutomationListDto {
        const json = this.toJSON();
        let result = new AdminStatusAutomationListDto();
        result.init(json);
        return result;
    }
}

export interface IAdminStatusAutomationListDto {
    id: number;
    automationType: string | undefined;
    toStatus: string | undefined;
    toTicketResolution: string | undefined;
}

export class Advisor implements IAdvisor {
    id: string;
    name: string | undefined;
    enabled: boolean;
    status: AdvisorStatus;
    website: string | undefined;
    address: Address;
    partnerAcquisitionId: number | undefined;
    internalId: number | undefined;
    apid: number | undefined;
    advisorEntitlement: AdvisorEntitlementModel;

    constructor(data?: IAdvisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.enabled = _data['enabled'];
            this.status = _data['status'];
            this.website = _data['website'];
            this.address = _data['address'] ? Address.fromJS(_data['address']) : <any>undefined;
            this.partnerAcquisitionId = _data['partnerAcquisitionId'];
            this.internalId = _data['internalId'];
            this.apid = _data['apid'];
            this.advisorEntitlement = _data['advisorEntitlement']
                ? AdvisorEntitlementModel.fromJS(_data['advisorEntitlement'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): Advisor {
        data = typeof data === 'object' ? data : {};
        let result = new Advisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['enabled'] = this.enabled;
        data['status'] = this.status;
        data['website'] = this.website;
        data['address'] = this.address ? this.address.toJSON() : <any>undefined;
        data['partnerAcquisitionId'] = this.partnerAcquisitionId;
        data['internalId'] = this.internalId;
        data['apid'] = this.apid;
        data['advisorEntitlement'] = this.advisorEntitlement ? this.advisorEntitlement.toJSON() : <any>undefined;
        return data;
    }

    clone(): Advisor {
        const json = this.toJSON();
        let result = new Advisor();
        result.init(json);
        return result;
    }
}

export interface IAdvisor {
    id: string;
    name: string | undefined;
    enabled: boolean;
    status: AdvisorStatus;
    website: string | undefined;
    address: Address;
    partnerAcquisitionId: number | undefined;
    internalId: number | undefined;
    apid: number | undefined;
    advisorEntitlement: AdvisorEntitlementModel;
}

export class AdvisorEntitlement implements IAdvisorEntitlement {
    name: string;
    foregroundColor: string;
    backgroundColor: string;
    isEnabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAdvisorEntitlement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.foregroundColor = _data['foregroundColor'];
            this.backgroundColor = _data['backgroundColor'];
            this.isEnabled = _data['isEnabled'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AdvisorEntitlement {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorEntitlement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['foregroundColor'] = this.foregroundColor;
        data['backgroundColor'] = this.backgroundColor;
        data['isEnabled'] = this.isEnabled;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AdvisorEntitlement {
        const json = this.toJSON();
        let result = new AdvisorEntitlement();
        result.init(json);
        return result;
    }
}

export interface IAdvisorEntitlement {
    name: string;
    foregroundColor: string;
    backgroundColor: string;
    isEnabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IAdvisorEntitlementDto {
    name: string;
    foregroundColor: string;
    backgroundColor: string;
    isEnabled: boolean;
    id: number;
}

export class AdvisorEntitlementModel implements IAdvisorEntitlementModel {
    id: number;
    name: string | undefined;
    foregroundColor: string | undefined;
    backgroundColor: string | undefined;
    isEnabled: boolean;

    constructor(data?: IAdvisorEntitlementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.foregroundColor = _data['foregroundColor'];
            this.backgroundColor = _data['backgroundColor'];
            this.isEnabled = _data['isEnabled'];
        }
    }

    static fromJS(data: any): AdvisorEntitlementModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorEntitlementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['foregroundColor'] = this.foregroundColor;
        data['backgroundColor'] = this.backgroundColor;
        data['isEnabled'] = this.isEnabled;
        return data;
    }

    clone(): AdvisorEntitlementModel {
        const json = this.toJSON();
        let result = new AdvisorEntitlementModel();
        result.init(json);
        return result;
    }
}

export interface IAdvisorEntitlementModel {
    id: number;
    name: string | undefined;
    foregroundColor: string | undefined;
    backgroundColor: string | undefined;
    isEnabled: boolean;
}

export enum AdvisorStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AdvisorSupportUser implements IAdvisorSupportUser {
    supportType: PartnerSupportType;
    user: SimpleUserModel;

    constructor(data?: IAdvisorSupportUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportType = _data['supportType'];
            this.user = _data['user'] ? SimpleUserModel.fromJS(_data['user']) : <any>undefined;
        }
    }

    static fromJS(data: any): AdvisorSupportUser {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorSupportUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['supportType'] = this.supportType;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): AdvisorSupportUser {
        const json = this.toJSON();
        let result = new AdvisorSupportUser();
        result.init(json);
        return result;
    }
}

export interface IAdvisorSupportUser {
    supportType: PartnerSupportType;
    user: SimpleUserModel;
}

export class AdvisorUsersModel implements IAdvisorUsersModel {
    advisorId: string;
    advisorInternalId: number;
    advisorName: string | undefined;
    users: SimpleUserModel[] | undefined;

    constructor(data?: IAdvisorUsersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advisorId = _data['advisorId'];
            this.advisorInternalId = _data['advisorInternalId'];
            this.advisorName = _data['advisorName'];
            if (Array.isArray(_data['users'])) {
                this.users = [] as any;
                for (let item of _data['users']) this.users.push(SimpleUserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvisorUsersModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorUsersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['advisorId'] = this.advisorId;
        data['advisorInternalId'] = this.advisorInternalId;
        data['advisorName'] = this.advisorName;
        if (Array.isArray(this.users)) {
            data['users'] = [];
            for (let item of this.users) data['users'].push(item.toJSON());
        }
        return data;
    }

    clone(): AdvisorUsersModel {
        const json = this.toJSON();
        let result = new AdvisorUsersModel();
        result.init(json);
        return result;
    }
}

export interface IAdvisorUsersModel {
    advisorId: string;
    advisorInternalId: number;
    advisorName: string | undefined;
    users: SimpleUserModel[] | undefined;
}

export class AdvisorUsersModelPagedResultModel implements IAdvisorUsersModelPagedResultModel {
    total: number;
    items: AdvisorUsersModel[] | undefined;

    constructor(data?: IAdvisorUsersModelPagedResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data['total'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(AdvisorUsersModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvisorUsersModelPagedResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorUsersModelPagedResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['total'] = this.total;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): AdvisorUsersModelPagedResultModel {
        const json = this.toJSON();
        let result = new AdvisorUsersModelPagedResultModel();
        result.init(json);
        return result;
    }
}

export interface IAdvisorUsersModelPagedResultModel {
    total: number;
    items: AdvisorUsersModel[] | undefined;
}

export class AgentAccountRateAuditDto implements IAgentAccountRateAuditDto {
    action: string | undefined;
    user: string | undefined;
    dateTime: moment.Moment;
    billingAccountNumber: string | undefined;
    providerId: number;
    fieldNames: string | undefined;
    fieldValuesOld: string | undefined;
    fieldValuesNew: string | undefined;
    reason: string | undefined;
    id: number;

    constructor(data?: IAgentAccountRateAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data['action'];
            this.user = _data['user'];
            this.dateTime = _data['dateTime'] ? moment(_data['dateTime'].toString()) : <any>undefined;
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.providerId = _data['providerId'];
            this.fieldNames = _data['fieldNames'];
            this.fieldValuesOld = _data['fieldValuesOld'];
            this.fieldValuesNew = _data['fieldValuesNew'];
            this.reason = _data['reason'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AgentAccountRateAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAccountRateAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['action'] = this.action;
        data['user'] = this.user;
        data['dateTime'] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['providerId'] = this.providerId;
        data['fieldNames'] = this.fieldNames;
        data['fieldValuesOld'] = this.fieldValuesOld;
        data['fieldValuesNew'] = this.fieldValuesNew;
        data['reason'] = this.reason;
        data['id'] = this.id;
        return data;
    }

    clone(): AgentAccountRateAuditDto {
        const json = this.toJSON();
        let result = new AgentAccountRateAuditDto();
        result.init(json);
        return result;
    }
}

export interface IAgentAccountRateAuditDto {
    action: string | undefined;
    user: string | undefined;
    dateTime: moment.Moment;
    billingAccountNumber: string | undefined;
    providerId: number;
    fieldNames: string | undefined;
    fieldValuesOld: string | undefined;
    fieldValuesNew: string | undefined;
    reason: string | undefined;
    id: number;
}

export class AgentAccountRateDto implements IAgentAccountRateDto {
    tenantId: number | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountNumber: string;
    salesAgentId: number;
    salesAgentName: string | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    splitRate: number;
    partnerContractRate: number;
    partnerSubAgencyId: number | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSubAgencyPercent: number | undefined;
    partnerSalesSupportId: number | undefined;
    partnerSalesSupportName: string | undefined;
    partnerAcquisitionId: number | undefined;
    partnerAcquisitionName: string | undefined;
    partnerOrderNumber: string | undefined;
    contractTerm: number | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    billingAccountName: string | undefined;
    originalProviderId: number | undefined;
    partnerContractTermId: number | undefined;
    salesCampaignId: number | undefined;
    usePartnerContractTerm: boolean;
    note: string | undefined;
    effectiveContractDate: moment.Moment;
    isOriginalContractTerm: boolean;
    hasAdditionalRates: boolean;
    commissionTrackingTypeId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAgentAccountRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgentName = _data['salesAgentName'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.splitRate = _data['splitRate'];
            this.partnerContractRate = _data['partnerContractRate'];
            this.partnerSubAgencyId = _data['partnerSubAgencyId'];
            this.partnerSubAgencyName = _data['partnerSubAgencyName'];
            this.partnerSubAgencyPercent = _data['partnerSubAgencyPercent'];
            this.partnerSalesSupportId = _data['partnerSalesSupportId'];
            this.partnerSalesSupportName = _data['partnerSalesSupportName'];
            this.partnerAcquisitionId = _data['partnerAcquisitionId'];
            this.partnerAcquisitionName = _data['partnerAcquisitionName'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.contractTerm = _data['contractTerm'];
            this.contractStartDate = _data['contractStartDate'] ? moment(_data['contractStartDate'].toString()) : <any>undefined;
            this.contractEndDate = _data['contractEndDate'] ? moment(_data['contractEndDate'].toString()) : <any>undefined;
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            this.billingAccountName = _data['billingAccountName'];
            this.originalProviderId = _data['originalProviderId'];
            this.partnerContractTermId = _data['partnerContractTermId'];
            this.salesCampaignId = _data['salesCampaignId'];
            this.usePartnerContractTerm = _data['usePartnerContractTerm'];
            this.note = _data['note'];
            this.effectiveContractDate = _data['effectiveContractDate']
                ? moment(_data['effectiveContractDate'].toString())
                : <any>undefined;
            this.isOriginalContractTerm = _data['isOriginalContractTerm'];
            this.hasAdditionalRates = _data['hasAdditionalRates'];
            this.commissionTrackingTypeId = _data['commissionTrackingTypeId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AgentAccountRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAccountRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgentName'] = this.salesAgentName;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['splitRate'] = this.splitRate;
        data['partnerContractRate'] = this.partnerContractRate;
        data['partnerSubAgencyId'] = this.partnerSubAgencyId;
        data['partnerSubAgencyName'] = this.partnerSubAgencyName;
        data['partnerSubAgencyPercent'] = this.partnerSubAgencyPercent;
        data['partnerSalesSupportId'] = this.partnerSalesSupportId;
        data['partnerSalesSupportName'] = this.partnerSalesSupportName;
        data['partnerAcquisitionId'] = this.partnerAcquisitionId;
        data['partnerAcquisitionName'] = this.partnerAcquisitionName;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['contractTerm'] = this.contractTerm;
        data['contractStartDate'] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data['contractEndDate'] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        data['billingAccountName'] = this.billingAccountName;
        data['originalProviderId'] = this.originalProviderId;
        data['partnerContractTermId'] = this.partnerContractTermId;
        data['salesCampaignId'] = this.salesCampaignId;
        data['usePartnerContractTerm'] = this.usePartnerContractTerm;
        data['note'] = this.note;
        data['effectiveContractDate'] = this.effectiveContractDate ? this.effectiveContractDate.toISOString() : <any>undefined;
        data['isOriginalContractTerm'] = this.isOriginalContractTerm;
        data['hasAdditionalRates'] = this.hasAdditionalRates;
        data['commissionTrackingTypeId'] = this.commissionTrackingTypeId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AgentAccountRateDto {
        const json = this.toJSON();
        let result = new AgentAccountRateDto();
        result.init(json);
        return result;
    }
}

export interface IAgentAccountRateDto {
    tenantId: number | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountNumber: string;
    salesAgentId: number;
    salesAgentName: string | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    splitRate: number;
    partnerContractRate: number;
    partnerSubAgencyId: number | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSubAgencyPercent: number | undefined;
    partnerSalesSupportId: number | undefined;
    partnerSalesSupportName: string | undefined;
    partnerAcquisitionId: number | undefined;
    partnerAcquisitionName: string | undefined;
    partnerOrderNumber: string | undefined;
    contractTerm: number | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    billingAccountName: string | undefined;
    originalProviderId: number | undefined;
    partnerContractTermId: number | undefined;
    salesCampaignId: number | undefined;
    usePartnerContractTerm: boolean;
    note: string | undefined;
    effectiveContractDate: moment.Moment;
    isOriginalContractTerm: boolean;
    hasAdditionalRates: boolean;
    commissionTrackingTypeId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AgentAccountRateDtoPagedResultDto implements IAgentAccountRateDtoPagedResultDto {
    totalCount: number;
    items: AgentAccountRateDto[] | undefined;

    constructor(data?: IAgentAccountRateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(AgentAccountRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentAccountRateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAccountRateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): AgentAccountRateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentAccountRateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentAccountRateDtoPagedResultDto {
    totalCount: number;
    items: AgentAccountRateDto[] | undefined;
}

export class AgentAccountRateTrackingDto implements IAgentAccountRateTrackingDto {
    agentAccountRateId: number;
    commissionTrackingTypeId: number;
    rate: number;
    id: number | undefined;

    constructor(data?: IAgentAccountRateTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentAccountRateId = _data['agentAccountRateId'];
            this.commissionTrackingTypeId = _data['commissionTrackingTypeId'];
            this.rate = _data['rate'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AgentAccountRateTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAccountRateTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['agentAccountRateId'] = this.agentAccountRateId;
        data['commissionTrackingTypeId'] = this.commissionTrackingTypeId;
        data['rate'] = this.rate;
        data['id'] = this.id;
        return data;
    }

    clone(): AgentAccountRateTrackingDto {
        const json = this.toJSON();
        let result = new AgentAccountRateTrackingDto();
        result.init(json);
        return result;
    }
}

export interface IAgentAccountRateTrackingDto {
    agentAccountRateId: number;
    commissionTrackingTypeId: number;
    rate: number;
    id: number | undefined;
}

export enum AppDomain {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.icon = _data['icon'];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['icon'] = this.icon;
        return data;
    }

    clone(): ApplicationLanguageEditDto {
        const json = this.toJSON();
        let result = new ApplicationLanguageEditDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.icon = _data['icon'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['icon'] = this.icon;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ApplicationLanguageListDto {
        const json = this.toJSON();
        let result = new ApplicationLanguageListDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Asset implements IAsset {
    tenantId: number | undefined;
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocation;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: Product;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerInventories: AssetCI[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.assetTag = _data['assetTag'];
            this.description = _data['description'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocation.fromJS(_data['customerLocation']) : <any>undefined;
            this.assetStatusId = _data['assetStatusId'];
            this.assetStatus = _data['assetStatus'] ? AssetStatus.fromJS(_data['assetStatus']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? Product.fromJS(_data['product']) : <any>undefined;
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['customerInventories'])) {
                this.customerInventories = [] as any;
                for (let item of _data['customerInventories']) this.customerInventories.push(AssetCI.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Asset {
        data = typeof data === 'object' ? data : {};
        let result = new Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['assetTag'] = this.assetTag;
        data['description'] = this.description;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['assetStatusId'] = this.assetStatusId;
        data['assetStatus'] = this.assetStatus ? this.assetStatus.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.customerInventories)) {
            data['customerInventories'] = [];
            for (let item of this.customerInventories) data['customerInventories'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Asset {
        const json = this.toJSON();
        let result = new Asset();
        result.init(json);
        return result;
    }
}

export interface IAsset {
    tenantId: number | undefined;
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocation;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: Product;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerInventories: AssetCI[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssetCI implements IAssetCI {
    tenantId: number | undefined;
    assetId: number | undefined;
    asset: Asset;
    ciPropertyTypeAssetCIId: number | undefined;
    ciPropertyTypeAssetCI: CIPropertyTypeAssetCI;
    ciPropertyId: number;
    ciProperty: CIProperty;
    value: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssetCI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.assetId = _data['assetId'];
            this.asset = _data['asset'] ? Asset.fromJS(_data['asset']) : <any>undefined;
            this.ciPropertyTypeAssetCIId = _data['ciPropertyTypeAssetCIId'];
            this.ciPropertyTypeAssetCI = _data['ciPropertyTypeAssetCI']
                ? CIPropertyTypeAssetCI.fromJS(_data['ciPropertyTypeAssetCI'])
                : <any>undefined;
            this.ciPropertyId = _data['ciPropertyId'];
            this.ciProperty = _data['ciProperty'] ? CIProperty.fromJS(_data['ciProperty']) : <any>undefined;
            this.value = _data['value'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AssetCI {
        data = typeof data === 'object' ? data : {};
        let result = new AssetCI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['assetId'] = this.assetId;
        data['asset'] = this.asset ? this.asset.toJSON() : <any>undefined;
        data['ciPropertyTypeAssetCIId'] = this.ciPropertyTypeAssetCIId;
        data['ciPropertyTypeAssetCI'] = this.ciPropertyTypeAssetCI ? this.ciPropertyTypeAssetCI.toJSON() : <any>undefined;
        data['ciPropertyId'] = this.ciPropertyId;
        data['ciProperty'] = this.ciProperty ? this.ciProperty.toJSON() : <any>undefined;
        data['value'] = this.value;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AssetCI {
        const json = this.toJSON();
        let result = new AssetCI();
        result.init(json);
        return result;
    }
}

export interface IAssetCI {
    tenantId: number | undefined;
    assetId: number | undefined;
    asset: Asset;
    ciPropertyTypeAssetCIId: number | undefined;
    ciPropertyTypeAssetCI: CIPropertyTypeAssetCI;
    ciPropertyId: number;
    ciProperty: CIProperty;
    value: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssetCIListDto implements IAssetCIListDto {
    assetId: number;
    ciPropertyId: number;
    ciProperty: CIPropertyListDto;
    ciPropertyTypeAssetCIId: number | undefined;
    value: string | undefined;
    id: number;

    constructor(data?: IAssetCIListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data['assetId'];
            this.ciPropertyId = _data['ciPropertyId'];
            this.ciProperty = _data['ciProperty'] ? CIPropertyListDto.fromJS(_data['ciProperty']) : <any>undefined;
            this.ciPropertyTypeAssetCIId = _data['ciPropertyTypeAssetCIId'];
            this.value = _data['value'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AssetCIListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetCIListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['assetId'] = this.assetId;
        data['ciPropertyId'] = this.ciPropertyId;
        data['ciProperty'] = this.ciProperty ? this.ciProperty.toJSON() : <any>undefined;
        data['ciPropertyTypeAssetCIId'] = this.ciPropertyTypeAssetCIId;
        data['value'] = this.value;
        data['id'] = this.id;
        return data;
    }

    clone(): AssetCIListDto {
        const json = this.toJSON();
        let result = new AssetCIListDto();
        result.init(json);
        return result;
    }
}

export interface IAssetCIListDto {
    assetId: number;
    ciPropertyId: number;
    ciProperty: CIPropertyListDto;
    ciPropertyTypeAssetCIId: number | undefined;
    value: string | undefined;
    id: number;
}

export class AssetEditDto implements IAssetEditDto {
    tenantId: number | undefined;
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: ProductListDto;
    id: number;

    constructor(data?: IAssetEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.assetTag = _data['assetTag'];
            this.description = _data['description'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationDto.fromJS(_data['customerLocation']) : <any>undefined;
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.assetStatusId = _data['assetStatusId'];
            this.assetStatus = _data['assetStatus'] ? AssetStatus.fromJS(_data['assetStatus']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductListDto.fromJS(_data['product']) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AssetEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['assetTag'] = this.assetTag;
        data['description'] = this.description;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['assetStatusId'] = this.assetStatusId;
        data['assetStatus'] = this.assetStatus ? this.assetStatus.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): AssetEditDto {
        const json = this.toJSON();
        let result = new AssetEditDto();
        result.init(json);
        return result;
    }
}

export interface IAssetEditDto {
    tenantId: number | undefined;
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: ProductListDto;
    id: number;
}

export class AssetListDto implements IAssetListDto {
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: ProductListDto;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetailDto;
    orderId: number;
    orderNumber: string | undefined;
    ciPropertyTypeProductList: CIPropertyTypeProductListDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssetListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.assetTag = _data['assetTag'];
            this.description = _data['description'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationDto.fromJS(_data['customerLocation']) : <any>undefined;
            this.assetStatusId = _data['assetStatusId'];
            this.assetStatus = _data['assetStatus'] ? AssetStatus.fromJS(_data['assetStatus']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductListDto.fromJS(_data['product']) : <any>undefined;
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetailDto.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            if (Array.isArray(_data['ciPropertyTypeProductList'])) {
                this.ciPropertyTypeProductList = [] as any;
                for (let item of _data['ciPropertyTypeProductList'])
                    this.ciPropertyTypeProductList.push(CIPropertyTypeProductListDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AssetListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['assetTag'] = this.assetTag;
        data['description'] = this.description;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['assetStatusId'] = this.assetStatusId;
        data['assetStatus'] = this.assetStatus ? this.assetStatus.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        if (Array.isArray(this.ciPropertyTypeProductList)) {
            data['ciPropertyTypeProductList'] = [];
            for (let item of this.ciPropertyTypeProductList) data['ciPropertyTypeProductList'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AssetListDto {
        const json = this.toJSON();
        let result = new AssetListDto();
        result.init(json);
        return result;
    }
}

export interface IAssetListDto {
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: ProductListDto;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetailDto;
    orderId: number;
    orderNumber: string | undefined;
    ciPropertyTypeProductList: CIPropertyTypeProductListDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssetStatus implements IAssetStatus {
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssetStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AssetStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AssetStatus {
        const json = this.toJSON();
        let result = new AssetStatus();
        result.init(json);
        return result;
    }
}

export interface IAssetStatus {
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssetsListDto implements IAssetsListDto {
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: ProductListDto;
    assetCIValue: string[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssetsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.assetTag = _data['assetTag'];
            this.description = _data['description'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationDto.fromJS(_data['customerLocation']) : <any>undefined;
            this.assetStatusId = _data['assetStatusId'];
            this.assetStatus = _data['assetStatus'] ? AssetStatus.fromJS(_data['assetStatus']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductListDto.fromJS(_data['product']) : <any>undefined;
            if (Array.isArray(_data['assetCIValue'])) {
                this.assetCIValue = [] as any;
                for (let item of _data['assetCIValue']) this.assetCIValue.push(item);
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AssetsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['assetTag'] = this.assetTag;
        data['description'] = this.description;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['assetStatusId'] = this.assetStatusId;
        data['assetStatus'] = this.assetStatus ? this.assetStatus.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.assetCIValue)) {
            data['assetCIValue'] = [];
            for (let item of this.assetCIValue) data['assetCIValue'].push(item);
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AssetsListDto {
        const json = this.toJSON();
        let result = new AssetsListDto();
        result.init(json);
        return result;
    }
}

export interface IAssetsListDto {
    name: string | undefined;
    assetTag: string | undefined;
    description: string | undefined;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    assetStatusId: number;
    assetStatus: AssetStatus;
    productId: number;
    product: ProductListDto;
    assetCIValue: string[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AttachmentListDto implements IAttachmentListDto {
    id: number;
    documentType: DocumentType;
    documentKey: number;
    providerId: number | undefined;
    providerName: string | undefined;
    filename: string | undefined;
    attachmentTypeName: string | undefined;
    attachmentTypeId: number;
    filesize: number;
    extension: string | undefined;
    storagepath: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    isPublic: boolean;

    constructor(data?: IAttachmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.documentType = _data['documentType'];
            this.documentKey = _data['documentKey'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.filename = _data['filename'];
            this.attachmentTypeName = _data['attachmentTypeName'];
            this.attachmentTypeId = _data['attachmentTypeId'];
            this.filesize = _data['filesize'];
            this.extension = _data['extension'];
            this.storagepath = _data['storagepath'];
            this.createdBy = _data['createdBy'];
            this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
            this.isPublic = _data['isPublic'];
        }
    }

    static fromJS(data: any): AttachmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['documentType'] = this.documentType;
        data['documentKey'] = this.documentKey;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['filename'] = this.filename;
        data['attachmentTypeName'] = this.attachmentTypeName;
        data['attachmentTypeId'] = this.attachmentTypeId;
        data['filesize'] = this.filesize;
        data['extension'] = this.extension;
        data['storagepath'] = this.storagepath;
        data['createdBy'] = this.createdBy;
        data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['isPublic'] = this.isPublic;
        return data;
    }

    clone(): AttachmentListDto {
        const json = this.toJSON();
        let result = new AttachmentListDto();
        result.init(json);
        return result;
    }
}

export interface IAttachmentListDto {
    id: number;
    documentType: DocumentType;
    documentKey: number;
    providerId: number | undefined;
    providerName: string | undefined;
    filename: string | undefined;
    attachmentTypeName: string | undefined;
    attachmentTypeId: number;
    filesize: number;
    extension: string | undefined;
    storagepath: string | undefined;
    createdBy: string | undefined;
    createdDate: moment.Moment;
    isPublic: boolean;
}

export class AttachmentType implements IAttachmentType {
    tenantId: number | undefined;
    name: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDefault: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAttachmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isDefault = _data['isDefault'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AttachmentType {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isDefault'] = this.isDefault;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AttachmentType {
        const json = this.toJSON();
        let result = new AttachmentType();
        result.init(json);
        return result;
    }
}

export interface IAttachmentType {
    tenantId: number | undefined;
    name: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDefault: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AttachmentTypeDeleteUpdateInput implements IAttachmentTypeDeleteUpdateInput {
    id: number;
    name: string | undefined;

    constructor(data?: IAttachmentTypeDeleteUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): AttachmentTypeDeleteUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentTypeDeleteUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): AttachmentTypeDeleteUpdateInput {
        const json = this.toJSON();
        let result = new AttachmentTypeDeleteUpdateInput();
        result.init(json);
        return result;
    }
}

export interface IAttachmentTypeDeleteUpdateInput {
    id: number;
    name: string | undefined;
}

export class AttributeDto implements IAttributeDto {
    name: string | undefined;
    choices: string | undefined;
    attributeType: AttributeType;
    fieldType: FieldType;
    isRequired: boolean;
    isReadOnly: boolean;
    readonly attributeTypeName: string | undefined;
    readonly fieldTypeName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.attributeType = _data['attributeType'];
            this.fieldType = _data['fieldType'];
            this.isRequired = _data['isRequired'];
            this.isReadOnly = _data['isReadOnly'];
            (<any>this).attributeTypeName = _data['attributeTypeName'];
            (<any>this).fieldTypeName = _data['fieldTypeName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['attributeType'] = this.attributeType;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['isReadOnly'] = this.isReadOnly;
        data['attributeTypeName'] = this.attributeTypeName;
        data['fieldTypeName'] = this.fieldTypeName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AttributeDto {
        const json = this.toJSON();
        let result = new AttributeDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeDto {
    name: string | undefined;
    choices: string | undefined;
    attributeType: AttributeType;
    fieldType: FieldType;
    isRequired: boolean;
    isReadOnly: boolean;
    attributeTypeName: string | undefined;
    fieldTypeName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AttributeEditDto implements IAttributeEditDto {
    name: string | undefined;
    choices: string | undefined;
    attributeType: AttributeType;
    fieldType: FieldType;
    isRequired: boolean;
    isReadOnly: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IAttributeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.attributeType = _data['attributeType'];
            this.fieldType = _data['fieldType'];
            this.isRequired = _data['isRequired'];
            this.isReadOnly = _data['isReadOnly'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AttributeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['attributeType'] = this.attributeType;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['isReadOnly'] = this.isReadOnly;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AttributeEditDto {
        const json = this.toJSON();
        let result = new AttributeEditDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeEditDto {
    name: string | undefined;
    choices: string | undefined;
    attributeType: AttributeType;
    fieldType: FieldType;
    isRequired: boolean;
    isReadOnly: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export enum AttributeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AttributeValueEditDto implements IAttributeValueEditDto {
    attributeKey: number;
    attributeId: number;
    attribute: AttributeDto;
    value: string | undefined;
    readonly attributeName: string | undefined;
    readonly choices: string[] | undefined;
    attributeType: AttributeType;
    fieldType: FieldType;
    readonly isRequired: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IAttributeValueEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeKey = _data['attributeKey'];
            this.attributeId = _data['attributeId'];
            this.attribute = _data['attribute'] ? AttributeDto.fromJS(_data['attribute']) : <any>undefined;
            this.value = _data['value'];
            (<any>this).attributeName = _data['attributeName'];
            if (Array.isArray(_data['choices'])) {
                (<any>this).choices = [] as any;
                for (let item of _data['choices']) (<any>this).choices.push(item);
            }
            this.attributeType = _data['attributeType'];
            this.fieldType = _data['fieldType'];
            (<any>this).isRequired = _data['isRequired'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AttributeValueEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeValueEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['attributeKey'] = this.attributeKey;
        data['attributeId'] = this.attributeId;
        data['attribute'] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data['value'] = this.value;
        data['attributeName'] = this.attributeName;
        if (Array.isArray(this.choices)) {
            data['choices'] = [];
            for (let item of this.choices) data['choices'].push(item);
        }
        data['attributeType'] = this.attributeType;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): AttributeValueEditDto {
        const json = this.toJSON();
        let result = new AttributeValueEditDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeValueEditDto {
    attributeKey: number;
    attributeId: number;
    attribute: AttributeDto;
    value: string | undefined;
    attributeName: string | undefined;
    choices: string[] | undefined;
    attributeType: AttributeType;
    fieldType: FieldType;
    isRequired: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.userName = _data['userName'];
            this.impersonatorTenantId = _data['impersonatorTenantId'];
            this.impersonatorUserId = _data['impersonatorUserId'];
            this.serviceName = _data['serviceName'];
            this.methodName = _data['methodName'];
            this.parameters = _data['parameters'];
            this.executionTime = _data['executionTime'] ? moment(_data['executionTime'].toString()) : <any>undefined;
            this.executionDuration = _data['executionDuration'];
            this.clientIpAddress = _data['clientIpAddress'];
            this.clientName = _data['clientName'];
            this.browserInfo = _data['browserInfo'];
            this.exception = _data['exception'];
            this.customData = _data['customData'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['userName'] = this.userName;
        data['impersonatorTenantId'] = this.impersonatorTenantId;
        data['impersonatorUserId'] = this.impersonatorUserId;
        data['serviceName'] = this.serviceName;
        data['methodName'] = this.methodName;
        data['parameters'] = this.parameters;
        data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data['executionDuration'] = this.executionDuration;
        data['clientIpAddress'] = this.clientIpAddress;
        data['clientName'] = this.clientName;
        data['browserInfo'] = this.browserInfo;
        data['exception'] = this.exception;
        data['customData'] = this.customData;
        data['id'] = this.id;
        return data;
    }

    clone(): AuditLogListDto {
        const json = this.toJSON();
        let result = new AuditLogListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class BackgroundJobCancellationRequest implements IBackgroundJobCancellationRequest {
    id: number;
    createdTime: moment.Moment;

    constructor(data?: IBackgroundJobCancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.createdTime = _data['createdTime'] ? moment(_data['createdTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BackgroundJobCancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobCancellationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['createdTime'] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): BackgroundJobCancellationRequest {
        const json = this.toJSON();
        let result = new BackgroundJobCancellationRequest();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobCancellationRequest {
    id: number;
    createdTime: moment.Moment;
}

export class BackgroundJobExecution implements IBackgroundJobExecution {
    id: number;
    uuid: string;
    creatorUserId: number | undefined;
    jobId: string | undefined;
    tenantId: number | undefined;
    source: string | undefined;
    status: BackgroundJobExecutionStatus;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    failureReason: string | undefined;
    metadata: string | undefined;
    jobResult: string | undefined;
    cancellationRequests: BackgroundJobCancellationRequest[] | undefined;
    output: BackgroundJobOutput;
    creatorFirstName: string | undefined;
    creatorLastName: string | undefined;

    constructor(data?: IBackgroundJobExecution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.uuid = _data['uuid'];
            this.creatorUserId = _data['creatorUserId'];
            this.jobId = _data['jobId'];
            this.tenantId = _data['tenantId'];
            this.source = _data['source'];
            this.status = _data['status'];
            this.startTime = _data['startTime'] ? moment(_data['startTime'].toString()) : <any>undefined;
            this.endTime = _data['endTime'] ? moment(_data['endTime'].toString()) : <any>undefined;
            this.failureReason = _data['failureReason'];
            this.metadata = _data['metadata'];
            this.jobResult = _data['jobResult'];
            if (Array.isArray(_data['cancellationRequests'])) {
                this.cancellationRequests = [] as any;
                for (let item of _data['cancellationRequests'])
                    this.cancellationRequests.push(BackgroundJobCancellationRequest.fromJS(item));
            }
            this.output = _data['output'] ? BackgroundJobOutput.fromJS(_data['output']) : <any>undefined;
            this.creatorFirstName = _data['creatorFirstName'];
            this.creatorLastName = _data['creatorLastName'];
        }
    }

    static fromJS(data: any): BackgroundJobExecution {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobExecution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['uuid'] = this.uuid;
        data['creatorUserId'] = this.creatorUserId;
        data['jobId'] = this.jobId;
        data['tenantId'] = this.tenantId;
        data['source'] = this.source;
        data['status'] = this.status;
        data['startTime'] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data['endTime'] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data['failureReason'] = this.failureReason;
        data['metadata'] = this.metadata;
        data['jobResult'] = this.jobResult;
        if (Array.isArray(this.cancellationRequests)) {
            data['cancellationRequests'] = [];
            for (let item of this.cancellationRequests) data['cancellationRequests'].push(item.toJSON());
        }
        data['output'] = this.output ? this.output.toJSON() : <any>undefined;
        data['creatorFirstName'] = this.creatorFirstName;
        data['creatorLastName'] = this.creatorLastName;
        return data;
    }

    clone(): BackgroundJobExecution {
        const json = this.toJSON();
        let result = new BackgroundJobExecution();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobExecution {
    id: number;
    uuid: string;
    creatorUserId: number | undefined;
    jobId: string | undefined;
    tenantId: number | undefined;
    source: string | undefined;
    status: BackgroundJobExecutionStatus;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    failureReason: string | undefined;
    metadata: string | undefined;
    jobResult: string | undefined;
    cancellationRequests: BackgroundJobCancellationRequest[] | undefined;
    output: BackgroundJobOutput;
    creatorFirstName: string | undefined;
    creatorLastName: string | undefined;
}

export class BackgroundJobExecutionDtoPagedDtoBase implements IBackgroundJobExecutionDtoPagedDtoBase {
    value: BackgroundJobExecutionDto[] | undefined;
    continuationToken: string | undefined;

    constructor(data?: IBackgroundJobExecutionDtoPagedDtoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['value'])) {
                this.value = [] as any;
                for (let item of _data['value']) this.value.push(BackgroundJobExecutionDto.fromJS(item));
            }
            this.continuationToken = _data['continuationToken'];
        }
    }

    static fromJS(data: any): BackgroundJobExecutionDtoPagedDtoBase {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobExecutionDtoPagedDtoBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data['value'] = [];
            for (let item of this.value) data['value'].push(item.toJSON());
        }
        data['continuationToken'] = this.continuationToken;
        return data;
    }

    clone(): BackgroundJobExecutionDtoPagedDtoBase {
        const json = this.toJSON();
        let result = new BackgroundJobExecutionDtoPagedDtoBase();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobExecutionDtoPagedDtoBase {
    value: BackgroundJobExecutionDto[] | undefined;
    continuationToken: string | undefined;
}

export class BackgroundJobFileOutput implements IBackgroundJobFileOutput {
    fileName: string | undefined;
    contentType: string | undefined;
    storagePath: string | undefined;

    constructor(data?: IBackgroundJobFileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.contentType = _data['contentType'];
            this.storagePath = _data['storagePath'];
        }
    }

    static fromJS(data: any): BackgroundJobFileOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobFileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['contentType'] = this.contentType;
        data['storagePath'] = this.storagePath;
        return data;
    }

    clone(): BackgroundJobFileOutput {
        const json = this.toJSON();
        let result = new BackgroundJobFileOutput();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobFileOutput {
    fileName: string | undefined;
    contentType: string | undefined;
    storagePath: string | undefined;
}

export class BackgroundJobLogOutput implements IBackgroundJobLogOutput {
    date: moment.Moment;
    level: LogLevel;
    message: string | undefined;

    constructor(data?: IBackgroundJobLogOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data['date'] ? moment(_data['date'].toString()) : <any>undefined;
            this.level = _data['level'];
            this.message = _data['message'];
        }
    }

    static fromJS(data: any): BackgroundJobLogOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobLogOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['date'] = this.date ? this.date.toISOString() : <any>undefined;
        data['level'] = this.level;
        data['message'] = this.message;
        return data;
    }

    clone(): BackgroundJobLogOutput {
        const json = this.toJSON();
        let result = new BackgroundJobLogOutput();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobLogOutput {
    date: moment.Moment;
    level: LogLevel;
    message: string | undefined;
}

export class BackgroundJobOutput implements IBackgroundJobOutput {
    dynamicOutput: any | undefined;
    files: BackgroundJobFileOutput[] | undefined;
    logs: BackgroundJobLogOutput[] | undefined;

    constructor(data?: IBackgroundJobOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicOutput = _data['dynamicOutput'];
            if (Array.isArray(_data['files'])) {
                this.files = [] as any;
                for (let item of _data['files']) this.files.push(BackgroundJobFileOutput.fromJS(item));
            }
            if (Array.isArray(_data['logs'])) {
                this.logs = [] as any;
                for (let item of _data['logs']) this.logs.push(BackgroundJobLogOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackgroundJobOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['dynamicOutput'] = this.dynamicOutput;
        if (Array.isArray(this.files)) {
            data['files'] = [];
            for (let item of this.files) data['files'].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data['logs'] = [];
            for (let item of this.logs) data['logs'].push(item.toJSON());
        }
        return data;
    }

    clone(): BackgroundJobOutput {
        const json = this.toJSON();
        let result = new BackgroundJobOutput();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobOutput {
    dynamicOutput: any | undefined;
    files: BackgroundJobFileOutput[] | undefined;
    logs: BackgroundJobLogOutput[] | undefined;
}

export class BillingBaseDashboardOutput implements IBillingBaseDashboardOutput {
    date: string | undefined;
    billingAmount: number;

    constructor(data?: IBillingBaseDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data['date'];
            this.billingAmount = _data['billingAmount'];
        }
    }

    static fromJS(data: any): BillingBaseDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BillingBaseDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['date'] = this.date;
        data['billingAmount'] = this.billingAmount;
        return data;
    }

    clone(): BillingBaseDashboardOutput {
        const json = this.toJSON();
        let result = new BillingBaseDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IBillingBaseDashboardOutput {
    date: string | undefined;
    billingAmount: number;
}

export class CIProperty implements ICIProperty {
    tenantId: number | undefined;
    ciPropertyTypeId: number;
    assetCIPropertyType: CIPropertyType;
    name: string;
    choices: string;
    fieldType: FieldType;
    isRequired: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isUsedAsBillingAccountNumber: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICIProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.ciPropertyTypeId = _data['ciPropertyTypeId'];
            this.assetCIPropertyType = _data['assetCIPropertyType'] ? CIPropertyType.fromJS(_data['assetCIPropertyType']) : <any>undefined;
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.fieldType = _data['fieldType'];
            this.isRequired = _data['isRequired'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isUsedAsBillingAccountNumber = _data['isUsedAsBillingAccountNumber'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIProperty {
        data = typeof data === 'object' ? data : {};
        let result = new CIProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['ciPropertyTypeId'] = this.ciPropertyTypeId;
        data['assetCIPropertyType'] = this.assetCIPropertyType ? this.assetCIPropertyType.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isUsedAsBillingAccountNumber'] = this.isUsedAsBillingAccountNumber;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CIProperty {
        const json = this.toJSON();
        let result = new CIProperty();
        result.init(json);
        return result;
    }
}

export interface ICIProperty {
    tenantId: number | undefined;
    ciPropertyTypeId: number;
    assetCIPropertyType: CIPropertyType;
    name: string;
    choices: string;
    fieldType: FieldType;
    isRequired: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isUsedAsBillingAccountNumber: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CIPropertyListDto implements ICIPropertyListDto {
    ciPropertyTypeId: number;
    assetCIPropertyType: CIPropertyType;
    name: string | undefined;
    choices: string | undefined;
    fieldType: FieldType;
    isRequired: boolean;
    id: number;

    constructor(data?: ICIPropertyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ciPropertyTypeId = _data['ciPropertyTypeId'];
            this.assetCIPropertyType = _data['assetCIPropertyType'] ? CIPropertyType.fromJS(_data['assetCIPropertyType']) : <any>undefined;
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.fieldType = _data['fieldType'];
            this.isRequired = _data['isRequired'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIPropertyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ciPropertyTypeId'] = this.ciPropertyTypeId;
        data['assetCIPropertyType'] = this.assetCIPropertyType ? this.assetCIPropertyType.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['id'] = this.id;
        return data;
    }

    clone(): CIPropertyListDto {
        const json = this.toJSON();
        let result = new CIPropertyListDto();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyListDto {
    ciPropertyTypeId: number;
    assetCIPropertyType: CIPropertyType;
    name: string | undefined;
    choices: string | undefined;
    fieldType: FieldType;
    isRequired: boolean;
    id: number;
}

export class CIPropertyType implements ICIPropertyType {
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICIPropertyType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIPropertyType {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CIPropertyType {
        const json = this.toJSON();
        let result = new CIPropertyType();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyType {
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CIPropertyTypeAssetCI implements ICIPropertyTypeAssetCI {
    tenantId: number | undefined;
    ciPropertyTypeId: number;
    ciPropertyType: CIPropertyType;
    assetId: number;
    asset: Asset;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICIPropertyTypeAssetCI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.ciPropertyTypeId = _data['ciPropertyTypeId'];
            this.ciPropertyType = _data['ciPropertyType'] ? CIPropertyType.fromJS(_data['ciPropertyType']) : <any>undefined;
            this.assetId = _data['assetId'];
            this.asset = _data['asset'] ? Asset.fromJS(_data['asset']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIPropertyTypeAssetCI {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyTypeAssetCI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['ciPropertyTypeId'] = this.ciPropertyTypeId;
        data['ciPropertyType'] = this.ciPropertyType ? this.ciPropertyType.toJSON() : <any>undefined;
        data['assetId'] = this.assetId;
        data['asset'] = this.asset ? this.asset.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CIPropertyTypeAssetCI {
        const json = this.toJSON();
        let result = new CIPropertyTypeAssetCI();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyTypeAssetCI {
    tenantId: number | undefined;
    ciPropertyTypeId: number;
    ciPropertyType: CIPropertyType;
    assetId: number;
    asset: Asset;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CIPropertyTypeAssetCIListDto implements ICIPropertyTypeAssetCIListDto {
    ciPropertyTypeId: number;
    ciPropertyType: CIPropertyType;
    assetId: number;
    assetCIList: AssetCIListDto[] | undefined;
    id: number;

    constructor(data?: ICIPropertyTypeAssetCIListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ciPropertyTypeId = _data['ciPropertyTypeId'];
            this.ciPropertyType = _data['ciPropertyType'] ? CIPropertyType.fromJS(_data['ciPropertyType']) : <any>undefined;
            this.assetId = _data['assetId'];
            if (Array.isArray(_data['assetCIList'])) {
                this.assetCIList = [] as any;
                for (let item of _data['assetCIList']) this.assetCIList.push(AssetCIListDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIPropertyTypeAssetCIListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyTypeAssetCIListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ciPropertyTypeId'] = this.ciPropertyTypeId;
        data['ciPropertyType'] = this.ciPropertyType ? this.ciPropertyType.toJSON() : <any>undefined;
        data['assetId'] = this.assetId;
        if (Array.isArray(this.assetCIList)) {
            data['assetCIList'] = [];
            for (let item of this.assetCIList) data['assetCIList'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): CIPropertyTypeAssetCIListDto {
        const json = this.toJSON();
        let result = new CIPropertyTypeAssetCIListDto();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyTypeAssetCIListDto {
    ciPropertyTypeId: number;
    ciPropertyType: CIPropertyType;
    assetId: number;
    assetCIList: AssetCIListDto[] | undefined;
    id: number;
}

export class CIPropertyTypeListDto implements ICIPropertyTypeListDto {
    name: string | undefined;
    id: number;

    constructor(data?: ICIPropertyTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIPropertyTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): CIPropertyTypeListDto {
        const json = this.toJSON();
        let result = new CIPropertyTypeListDto();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyTypeListDto {
    name: string | undefined;
    id: number;
}

export class CIPropertyTypeProductInput implements ICIPropertyTypeProductInput {
    ciPropertyAssetCI: CIPropertyTypeAssetCIListDto;
    assetId: number;
    productId: number;
    orderLocationDetailId: number | undefined;
    customerLocationId: number;

    constructor(data?: ICIPropertyTypeProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ciPropertyAssetCI = _data['ciPropertyAssetCI']
                ? CIPropertyTypeAssetCIListDto.fromJS(_data['ciPropertyAssetCI'])
                : <any>undefined;
            this.assetId = _data['assetId'];
            this.productId = _data['productId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.customerLocationId = _data['customerLocationId'];
        }
    }

    static fromJS(data: any): CIPropertyTypeProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyTypeProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ciPropertyAssetCI'] = this.ciPropertyAssetCI ? this.ciPropertyAssetCI.toJSON() : <any>undefined;
        data['assetId'] = this.assetId;
        data['productId'] = this.productId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['customerLocationId'] = this.customerLocationId;
        return data;
    }

    clone(): CIPropertyTypeProductInput {
        const json = this.toJSON();
        let result = new CIPropertyTypeProductInput();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyTypeProductInput {
    ciPropertyAssetCI: CIPropertyTypeAssetCIListDto;
    assetId: number;
    productId: number;
    orderLocationDetailId: number | undefined;
    customerLocationId: number;
}

export class CIPropertyTypeProductListDto implements ICIPropertyTypeProductListDto {
    productId: number;
    ciPropertyTypeId: number;
    ciPropertyType: CIPropertyType;
    ciPropertyAssetCIList: CIPropertyTypeAssetCIListDto[] | undefined;
    id: number;

    constructor(data?: ICIPropertyTypeProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            this.ciPropertyTypeId = _data['ciPropertyTypeId'];
            this.ciPropertyType = _data['ciPropertyType'] ? CIPropertyType.fromJS(_data['ciPropertyType']) : <any>undefined;
            if (Array.isArray(_data['ciPropertyAssetCIList'])) {
                this.ciPropertyAssetCIList = [] as any;
                for (let item of _data['ciPropertyAssetCIList']) this.ciPropertyAssetCIList.push(CIPropertyTypeAssetCIListDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CIPropertyTypeProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CIPropertyTypeProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        data['ciPropertyTypeId'] = this.ciPropertyTypeId;
        data['ciPropertyType'] = this.ciPropertyType ? this.ciPropertyType.toJSON() : <any>undefined;
        if (Array.isArray(this.ciPropertyAssetCIList)) {
            data['ciPropertyAssetCIList'] = [];
            for (let item of this.ciPropertyAssetCIList) data['ciPropertyAssetCIList'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): CIPropertyTypeProductListDto {
        const json = this.toJSON();
        let result = new CIPropertyTypeProductListDto();
        result.init(json);
        return result;
    }
}

export interface ICIPropertyTypeProductListDto {
    productId: number;
    ciPropertyTypeId: number;
    ciPropertyType: CIPropertyType;
    ciPropertyAssetCIList: CIPropertyTypeAssetCIListDto[] | undefined;
    id: number;
}

export enum CampaignType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ComboboxItemDtoListResultDto implements IComboboxItemDtoListResultDto {
    items: ComboboxItemDto[] | undefined;

    constructor(data?: IComboboxItemDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComboboxItemDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ComboboxItemDtoListResultDto {
        const json = this.toJSON();
        let result = new ComboboxItemDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDtoListResultDto {
    items: ComboboxItemDto[] | undefined;
}

export class CommissionTemplate implements ICommissionTemplate {
    tenantId: number | undefined;
    providerId: number | undefined;
    provider: Provider;
    masterAgencyId: number;
    masterAgency: MasterAgency;
    name: string;
    isActive: boolean;
    startingDate: moment.Moment | undefined;
    dayOfMonth: number | undefined;
    monthlyRecurrence: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    commissionTemplateDetails: CommissionTemplateDetail[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommissionTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? Provider.fromJS(_data['provider']) : <any>undefined;
            this.masterAgencyId = _data['masterAgencyId'];
            this.masterAgency = _data['masterAgency'] ? MasterAgency.fromJS(_data['masterAgency']) : <any>undefined;
            this.name = _data['name'];
            this.isActive = _data['isActive'];
            this.startingDate = _data['startingDate'] ? moment(_data['startingDate'].toString()) : <any>undefined;
            this.dayOfMonth = _data['dayOfMonth'];
            this.monthlyRecurrence = _data['monthlyRecurrence'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['commissionTemplateDetails'])) {
                this.commissionTemplateDetails = [] as any;
                for (let item of _data['commissionTemplateDetails'])
                    this.commissionTemplateDetails.push(CommissionTemplateDetail.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['masterAgencyId'] = this.masterAgencyId;
        data['masterAgency'] = this.masterAgency ? this.masterAgency.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['isActive'] = this.isActive;
        data['startingDate'] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data['dayOfMonth'] = this.dayOfMonth;
        data['monthlyRecurrence'] = this.monthlyRecurrence;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.commissionTemplateDetails)) {
            data['commissionTemplateDetails'] = [];
            for (let item of this.commissionTemplateDetails) data['commissionTemplateDetails'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionTemplate {
        const json = this.toJSON();
        let result = new CommissionTemplate();
        result.init(json);
        return result;
    }
}

export interface ICommissionTemplate {
    tenantId: number | undefined;
    providerId: number | undefined;
    provider: Provider;
    masterAgencyId: number;
    masterAgency: MasterAgency;
    name: string;
    isActive: boolean;
    startingDate: moment.Moment | undefined;
    dayOfMonth: number | undefined;
    monthlyRecurrence: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    commissionTemplateDetails: CommissionTemplateDetail[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommissionTemplateDetail implements ICommissionTemplateDetail {
    tenantId: number | undefined;
    commissionTemplateId: number;
    commissionTemplate: CommissionTemplate;
    commissionField: string;
    providerField: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommissionTemplateDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.commissionTemplate = _data['commissionTemplate'] ? CommissionTemplate.fromJS(_data['commissionTemplate']) : <any>undefined;
            this.commissionField = _data['commissionField'];
            this.providerField = _data['providerField'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionTemplateDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTemplateDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['commissionTemplate'] = this.commissionTemplate ? this.commissionTemplate.toJSON() : <any>undefined;
        data['commissionField'] = this.commissionField;
        data['providerField'] = this.providerField;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionTemplateDetail {
        const json = this.toJSON();
        let result = new CommissionTemplateDetail();
        result.init(json);
        return result;
    }
}

export interface ICommissionTemplateDetail {
    tenantId: number | undefined;
    commissionTemplateId: number;
    commissionTemplate: CommissionTemplate;
    commissionField: string;
    providerField: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommissionTrackingType implements ICommissionTrackingType {
    tenantId: number | undefined;
    name: string;
    isCommissionProcess: boolean;
    hasRate: boolean;
    lookup: string | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    defaultOverride: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommissionTrackingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isCommissionProcess = _data['isCommissionProcess'];
            this.hasRate = _data['hasRate'];
            this.lookup = _data['lookup'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.defaultOverride = _data['defaultOverride'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionTrackingType {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTrackingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isCommissionProcess'] = this.isCommissionProcess;
        data['hasRate'] = this.hasRate;
        data['lookup'] = this.lookup;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['defaultOverride'] = this.defaultOverride;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionTrackingType {
        const json = this.toJSON();
        let result = new CommissionTrackingType();
        result.init(json);
        return result;
    }
}

export interface ICommissionTrackingType {
    tenantId: number | undefined;
    name: string;
    isCommissionProcess: boolean;
    hasRate: boolean;
    lookup: string | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    defaultOverride: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommunicationTypeEditDto implements ICommunicationTypeEditDto {
    name: string;
    description: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommunicationTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.description = _data['description'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommunicationTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['description'] = this.description;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CommunicationTypeEditDto {
        const json = this.toJSON();
        let result = new CommunicationTypeEditDto();
        result.init(json);
        return result;
    }
}

export interface ICommunicationTypeEditDto {
    name: string;
    description: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommunicationTypeListDto implements ICommunicationTypeListDto {
    id: number;
    name: string;
    description: string;

    constructor(data?: ICommunicationTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): CommunicationTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['description'] = this.description;
        return data;
    }

    clone(): CommunicationTypeListDto {
        const json = this.toJSON();
        let result = new CommunicationTypeListDto();
        result.init(json);
        return result;
    }
}

export interface ICommunicationTypeListDto {
    id: number;
    name: string;
    description: string;
}

export class CompanyInputDto implements ICompanyInputDto {
    id: number;
    name: string | undefined;
    uuid: string;
    isInternalCompany: boolean;

    constructor(data?: ICompanyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.uuid = _data['uuid'];
            this.isInternalCompany = _data['isInternalCompany'];
        }
    }

    static fromJS(data: any): CompanyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['uuid'] = this.uuid;
        data['isInternalCompany'] = this.isInternalCompany;
        return data;
    }

    clone(): CompanyInputDto {
        const json = this.toJSON();
        let result = new CompanyInputDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyInputDto {
    id: number;
    name: string | undefined;
    uuid: string;
    isInternalCompany: boolean;
}

export class CompanyOutputDto implements ICompanyOutputDto {
    name: string | undefined;
    uuid: string;
    isInternalCompany: boolean;
    id: number;

    constructor(data?: ICompanyOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.uuid = _data['uuid'];
            this.isInternalCompany = _data['isInternalCompany'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CompanyOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['uuid'] = this.uuid;
        data['isInternalCompany'] = this.isInternalCompany;
        data['id'] = this.id;
        return data;
    }

    clone(): CompanyOutputDto {
        const json = this.toJSON();
        let result = new CompanyOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyOutputDto {
    name: string | undefined;
    uuid: string;
    isInternalCompany: boolean;
    id: number;
}

export enum ContactAccountType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _5 = 5,
    _6 = 6,
}

export class ContactCommunicationTypeDto implements IContactCommunicationTypeDto {
    communicationTypeId: number;
    name: string | undefined;
    description: string | undefined;
    isExist: boolean;
    contactCommunicationId: number;

    constructor(data?: IContactCommunicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationTypeId = _data['communicationTypeId'];
            this.name = _data['name'];
            this.description = _data['description'];
            this.isExist = _data['isExist'];
            this.contactCommunicationId = _data['contactCommunicationId'];
        }
    }

    static fromJS(data: any): ContactCommunicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactCommunicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['communicationTypeId'] = this.communicationTypeId;
        data['name'] = this.name;
        data['description'] = this.description;
        data['isExist'] = this.isExist;
        data['contactCommunicationId'] = this.contactCommunicationId;
        return data;
    }

    clone(): ContactCommunicationTypeDto {
        const json = this.toJSON();
        let result = new ContactCommunicationTypeDto();
        result.init(json);
        return result;
    }
}

export interface IContactCommunicationTypeDto {
    communicationTypeId: number;
    name: string | undefined;
    description: string | undefined;
    isExist: boolean;
    contactCommunicationId: number;
}

export class ContactDropdownDto implements IContactDropdownDto {
    firstName: string | undefined;
    lastName: string | undefined;
    readonly name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContactDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            (<any>this).name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContactDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContactDropdownDto {
        const json = this.toJSON();
        let result = new ContactDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IContactDropdownDto {
    firstName: string | undefined;
    lastName: string | undefined;
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IContactEditDto {
    tenantId: number | undefined;
    title: string | undefined;
    department: string | undefined;
    firstName: string;
    lastName: string;
    email: string | undefined;
    workNumber: string | undefined;
    mobileNumber: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    contactStatus: ContactStatus;
    contactType: ContactAccountType;
    contactAccountKey: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    contactAccountName: string | undefined;
    createdBy: string | undefined;
    creationTime: moment.Moment;
    contactContactGroupIds: number[] | undefined;
    contactRegions: string[] | undefined;
    jobDescription: string | undefined;
    parentId: number | undefined;
    order: number;
    userId: number | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export enum ContactGroupActionType {
    _1 = 1,
    _2 = 2,
}

export class ContactGroupDto implements IContactGroupDto {
    name: string | undefined;
    description: string | undefined;
    contactGroupActionType: ContactGroupActionType;
    order: number;
    type: ContactViewType;
    readonly isRegionView: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContactGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.description = _data['description'];
            this.contactGroupActionType = _data['contactGroupActionType'];
            this.order = _data['order'];
            this.type = _data['type'];
            (<any>this).isRegionView = _data['isRegionView'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContactGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['description'] = this.description;
        data['contactGroupActionType'] = this.contactGroupActionType;
        data['order'] = this.order;
        data['type'] = this.type;
        data['isRegionView'] = this.isRegionView;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContactGroupDto {
        const json = this.toJSON();
        let result = new ContactGroupDto();
        result.init(json);
        return result;
    }
}

export interface IContactGroupDto {
    name: string | undefined;
    description: string | undefined;
    contactGroupActionType: ContactGroupActionType;
    order: number;
    type: ContactViewType;
    isRegionView: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ContactGroupEditDto implements IContactGroupEditDto {
    name: string | undefined;
    description: string | undefined;
    type: ContactViewType;
    contactGroupActionType: ContactGroupActionType;
    order: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContactGroupEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.description = _data['description'];
            this.type = _data['type'];
            this.contactGroupActionType = _data['contactGroupActionType'];
            this.order = _data['order'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContactGroupEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGroupEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['description'] = this.description;
        data['type'] = this.type;
        data['contactGroupActionType'] = this.contactGroupActionType;
        data['order'] = this.order;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContactGroupEditDto {
        const json = this.toJSON();
        let result = new ContactGroupEditDto();
        result.init(json);
        return result;
    }
}

export interface IContactGroupEditDto {
    name: string | undefined;
    description: string | undefined;
    type: ContactViewType;
    contactGroupActionType: ContactGroupActionType;
    order: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ContactGroupListDto implements IContactGroupListDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    order: number;
    type: ContactViewType;
    readonly typeName: string | undefined;
    contactGroupActionType: ContactGroupActionType;
    readonly contactGroupActionTypeName: string | undefined;

    constructor(data?: IContactGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.description = _data['description'];
            this.order = _data['order'];
            this.type = _data['type'];
            (<any>this).typeName = _data['typeName'];
            this.contactGroupActionType = _data['contactGroupActionType'];
            (<any>this).contactGroupActionTypeName = _data['contactGroupActionTypeName'];
        }
    }

    static fromJS(data: any): ContactGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['description'] = this.description;
        data['order'] = this.order;
        data['type'] = this.type;
        data['typeName'] = this.typeName;
        data['contactGroupActionType'] = this.contactGroupActionType;
        data['contactGroupActionTypeName'] = this.contactGroupActionTypeName;
        return data;
    }

    clone(): ContactGroupListDto {
        const json = this.toJSON();
        let result = new ContactGroupListDto();
        result.init(json);
        return result;
    }
}

export interface IContactGroupListDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    order: number;
    type: ContactViewType;
    typeName: string | undefined;
    contactGroupActionType: ContactGroupActionType;
    contactGroupActionTypeName: string | undefined;
}

export interface IContactListDto {
    title: string | undefined;
    department: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    workNumber: string | undefined;
    mobileNumber: string | undefined;
    contactStatus: ContactStatus;
    contactType: ContactAccountType;
    contactAccountKey: number;
    contactAccountName: string | undefined;
    createdBy: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ContactListDtoPagedResultDto implements IContactListDtoPagedResultDto {
    totalCount: number;
    items: ContactListDto[] | undefined;

    constructor(data?: IContactListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ContactListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ContactListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContactListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContactListDtoPagedResultDto {
    totalCount: number;
    items: ContactListDto[] | undefined;
}

export enum ContactStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ContactType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ContactViewOutput implements IContactViewOutput {
    id: number;
    title: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    readonly fullName: string | undefined;
    email: string | undefined;
    workNumber: string | undefined;
    mobileNumber: string | undefined;
    department: string | undefined;
    jobDescription: string | undefined;
    profilePictureId: string | undefined;
    isParent: boolean;
    contactAccountKey: number;
    contactGroup: ContactGroupDto;
    readonly contactGroupId: number;
    readonly contactGroupName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    readonly addressCombined: string | undefined;
    mailingAddress: string | undefined;
    mailingCity: string | undefined;
    mailingState: string | undefined;
    mailingZipcode: string | undefined;
    readonly mailingAddressCombined: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IContactViewOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.title = _data['title'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            (<any>this).fullName = _data['fullName'];
            this.email = _data['email'];
            this.workNumber = _data['workNumber'];
            this.mobileNumber = _data['mobileNumber'];
            this.department = _data['department'];
            this.jobDescription = _data['jobDescription'];
            this.profilePictureId = _data['profilePictureId'];
            this.isParent = _data['isParent'];
            this.contactAccountKey = _data['contactAccountKey'];
            this.contactGroup = _data['contactGroup'] ? ContactGroupDto.fromJS(_data['contactGroup']) : <any>undefined;
            (<any>this).contactGroupId = _data['contactGroupId'];
            (<any>this).contactGroupName = _data['contactGroupName'];
            this.address = _data['address'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            (<any>this).addressCombined = _data['addressCombined'];
            this.mailingAddress = _data['mailingAddress'];
            this.mailingCity = _data['mailingCity'];
            this.mailingState = _data['mailingState'];
            this.mailingZipcode = _data['mailingZipcode'];
            (<any>this).mailingAddressCombined = _data['mailingAddressCombined'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
        }
    }

    static fromJS(data: any): ContactViewOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ContactViewOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['title'] = this.title;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['fullName'] = this.fullName;
        data['email'] = this.email;
        data['workNumber'] = this.workNumber;
        data['mobileNumber'] = this.mobileNumber;
        data['department'] = this.department;
        data['jobDescription'] = this.jobDescription;
        data['profilePictureId'] = this.profilePictureId;
        data['isParent'] = this.isParent;
        data['contactAccountKey'] = this.contactAccountKey;
        data['contactGroup'] = this.contactGroup ? this.contactGroup.toJSON() : <any>undefined;
        data['contactGroupId'] = this.contactGroupId;
        data['contactGroupName'] = this.contactGroupName;
        data['address'] = this.address;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['addressCombined'] = this.addressCombined;
        data['mailingAddress'] = this.mailingAddress;
        data['mailingCity'] = this.mailingCity;
        data['mailingState'] = this.mailingState;
        data['mailingZipcode'] = this.mailingZipcode;
        data['mailingAddressCombined'] = this.mailingAddressCombined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        return data;
    }

    clone(): ContactViewOutput {
        const json = this.toJSON();
        let result = new ContactViewOutput();
        result.init(json);
        return result;
    }
}

export interface IContactViewOutput {
    id: number;
    title: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    email: string | undefined;
    workNumber: string | undefined;
    mobileNumber: string | undefined;
    department: string | undefined;
    jobDescription: string | undefined;
    profilePictureId: string | undefined;
    isParent: boolean;
    contactAccountKey: number;
    contactGroup: ContactGroupDto;
    contactGroupId: number;
    contactGroupName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    addressCombined: string | undefined;
    mailingAddress: string | undefined;
    mailingCity: string | undefined;
    mailingState: string | undefined;
    mailingZipcode: string | undefined;
    mailingAddressCombined: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export enum ContactViewType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ContractRenewalDto implements IContractRenewalDto {
    billingAccountNumber: string | undefined;
    providerId: number;
    providerName: string | undefined;
    productName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    billingAccountName: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment;
    contractTerm: number | undefined;
    providerRevenue: number | undefined;
    agentAmount: number | undefined;
    lastCommissionDate: moment.Moment | undefined;
    spmId: number | undefined;
    spmName: string | undefined;
    ioId: number | undefined;
    ioName: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    orders: OrderIdOrderNumberDto[] | undefined;
    readonly fullAddress: string | undefined;
    id: number;

    constructor(data?: IContractRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.productName = _data['productName'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.billingAccountName = _data['billingAccountName'];
            this.contractStartDate = _data['contractStartDate'] ? moment(_data['contractStartDate'].toString()) : <any>undefined;
            this.contractEndDate = _data['contractEndDate'] ? moment(_data['contractEndDate'].toString()) : <any>undefined;
            this.contractTerm = _data['contractTerm'];
            this.providerRevenue = _data['providerRevenue'];
            this.agentAmount = _data['agentAmount'];
            this.lastCommissionDate = _data['lastCommissionDate'] ? moment(_data['lastCommissionDate'].toString()) : <any>undefined;
            this.spmId = _data['spmId'];
            this.spmName = _data['spmName'];
            this.ioId = _data['ioId'];
            this.ioName = _data['ioName'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders.push(OrderIdOrderNumberDto.fromJS(item));
            }
            (<any>this).fullAddress = _data['fullAddress'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContractRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['productName'] = this.productName;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['billingAccountName'] = this.billingAccountName;
        data['contractStartDate'] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data['contractEndDate'] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data['contractTerm'] = this.contractTerm;
        data['providerRevenue'] = this.providerRevenue;
        data['agentAmount'] = this.agentAmount;
        data['lastCommissionDate'] = this.lastCommissionDate ? this.lastCommissionDate.toISOString() : <any>undefined;
        data['spmId'] = this.spmId;
        data['spmName'] = this.spmName;
        data['ioId'] = this.ioId;
        data['ioName'] = this.ioName;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['fullAddress'] = this.fullAddress;
        data['id'] = this.id;
        return data;
    }

    clone(): ContractRenewalDto {
        const json = this.toJSON();
        let result = new ContractRenewalDto();
        result.init(json);
        return result;
    }
}

export interface IContractRenewalDto {
    billingAccountNumber: string | undefined;
    providerId: number;
    providerName: string | undefined;
    productName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    billingAccountName: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment;
    contractTerm: number | undefined;
    providerRevenue: number | undefined;
    agentAmount: number | undefined;
    lastCommissionDate: moment.Moment | undefined;
    spmId: number | undefined;
    spmName: string | undefined;
    ioId: number | undefined;
    ioName: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    orders: OrderIdOrderNumberDto[] | undefined;
    fullAddress: string | undefined;
    id: number;
}

export class ContractRenewalDtoPagedAndFilteredResultDto implements IContractRenewalDtoPagedAndFilteredResultDto {
    filteredCount: number;
    totalCount: number;
    items: ContractRenewalDto[] | undefined;

    constructor(data?: IContractRenewalDtoPagedAndFilteredResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredCount = _data['filteredCount'];
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ContractRenewalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractRenewalDtoPagedAndFilteredResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRenewalDtoPagedAndFilteredResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['filteredCount'] = this.filteredCount;
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ContractRenewalDtoPagedAndFilteredResultDto {
        const json = this.toJSON();
        let result = new ContractRenewalDtoPagedAndFilteredResultDto();
        result.init(json);
        return result;
    }
}

export interface IContractRenewalDtoPagedAndFilteredResultDto {
    filteredCount: number;
    totalCount: number;
    items: ContractRenewalDto[] | undefined;
}

export class ContractRenewalStatisticDto implements IContractRenewalStatisticDto {
    partnerId: number | undefined;
    renewalInMonths: number;
    numberOfRenewals: number;
    totalOfRenewals: number;
    readonly title: string | undefined;
    readonly totalOfRenewalsAsString: string | undefined;

    constructor(data?: IContractRenewalStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.renewalInMonths = _data['renewalInMonths'];
            this.numberOfRenewals = _data['numberOfRenewals'];
            this.totalOfRenewals = _data['totalOfRenewals'];
            (<any>this).title = _data['title'];
            (<any>this).totalOfRenewalsAsString = _data['totalOfRenewalsAsString'];
        }
    }

    static fromJS(data: any): ContractRenewalStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRenewalStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['renewalInMonths'] = this.renewalInMonths;
        data['numberOfRenewals'] = this.numberOfRenewals;
        data['totalOfRenewals'] = this.totalOfRenewals;
        data['title'] = this.title;
        data['totalOfRenewalsAsString'] = this.totalOfRenewalsAsString;
        return data;
    }

    clone(): ContractRenewalStatisticDto {
        const json = this.toJSON();
        let result = new ContractRenewalStatisticDto();
        result.init(json);
        return result;
    }
}

export interface IContractRenewalStatisticDto {
    partnerId: number | undefined;
    renewalInMonths: number;
    numberOfRenewals: number;
    totalOfRenewals: number;
    title: string | undefined;
    totalOfRenewalsAsString: string | undefined;
}

export class ContractTermListDto implements IContractTermListDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContractTermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContractTermListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContractTermListDto {
        const json = this.toJSON();
        let result = new ContractTermListDto();
        result.init(json);
        return result;
    }
}

export interface IContractTermListDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ContractTermsResponse implements IContractTermsResponse {
    id: number;
    name: string | undefined;
    multiplier: number;

    constructor(data?: IContractTermsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.multiplier = _data['multiplier'];
        }
    }

    static fromJS(data: any): ContractTermsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTermsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['multiplier'] = this.multiplier;
        return data;
    }

    clone(): ContractTermsResponse {
        const json = this.toJSON();
        let result = new ContractTermsResponse();
        result.init(json);
        return result;
    }
}

export interface IContractTermsResponse {
    id: number;
    name: string | undefined;
    multiplier: number;
}

export class ContractTermsResponsePagedResultDto implements IContractTermsResponsePagedResultDto {
    totalCount: number;
    items: ContractTermsResponse[] | undefined;

    constructor(data?: IContractTermsResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ContractTermsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractTermsResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTermsResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ContractTermsResponsePagedResultDto {
        const json = this.toJSON();
        let result = new ContractTermsResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContractTermsResponsePagedResultDto {
    totalCount: number;
    items: ContractTermsResponse[] | undefined;
}

export class ContractType implements IContractType {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContractType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContractType {
        data = typeof data === 'object' ? data : {};
        let result = new ContractType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContractType {
        const json = this.toJSON();
        let result = new ContractType();
        result.init(json);
        return result;
    }
}

export interface IContractType {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateAttachmentInput implements ICreateAttachmentInput {
    documentName: string | undefined;
    providerId: number;
    documentType: DocumentType;
    key: number;
    attachmentTypeId: number;
    isPublic: boolean;
    file: string | undefined;

    constructor(data?: ICreateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data['documentName'];
            this.providerId = _data['providerId'];
            this.documentType = _data['documentType'];
            this.key = _data['key'];
            this.attachmentTypeId = _data['attachmentTypeId'];
            this.isPublic = _data['isPublic'];
            this.file = _data['file'];
        }
    }

    static fromJS(data: any): CreateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['documentName'] = this.documentName;
        data['providerId'] = this.providerId;
        data['documentType'] = this.documentType;
        data['key'] = this.key;
        data['attachmentTypeId'] = this.attachmentTypeId;
        data['isPublic'] = this.isPublic;
        data['file'] = this.file;
        return data;
    }

    clone(): CreateAttachmentInput {
        const json = this.toJSON();
        let result = new CreateAttachmentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateAttachmentInput {
    documentName: string | undefined;
    providerId: number;
    documentType: DocumentType;
    key: number;
    attachmentTypeId: number;
    isPublic: boolean;
    file: string | undefined;
}

export class CreateImportTemplateDetailInput implements ICreateImportTemplateDetailInput {
    importTypeModuleId: number | undefined;
    importTypeModuleFieldId: number | undefined;
    importMapFieldId: number | undefined;
    uploadedField: string | undefined;

    constructor(data?: ICreateImportTemplateDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTypeModuleId = _data['importTypeModuleId'];
            this.importTypeModuleFieldId = _data['importTypeModuleFieldId'];
            this.importMapFieldId = _data['importMapFieldId'];
            this.uploadedField = _data['uploadedField'];
        }
    }

    static fromJS(data: any): CreateImportTemplateDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImportTemplateDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTypeModuleId'] = this.importTypeModuleId;
        data['importTypeModuleFieldId'] = this.importTypeModuleFieldId;
        data['importMapFieldId'] = this.importMapFieldId;
        data['uploadedField'] = this.uploadedField;
        return data;
    }

    clone(): CreateImportTemplateDetailInput {
        const json = this.toJSON();
        let result = new CreateImportTemplateDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateImportTemplateDetailInput {
    importTypeModuleId: number | undefined;
    importTypeModuleFieldId: number | undefined;
    importMapFieldId: number | undefined;
    uploadedField: string | undefined;
}

export class CreateImportTemplateImportTypeDetailInput implements ICreateImportTemplateImportTypeDetailInput {
    importTypeDetailId: number;
    importTypeDetailValue: number;

    constructor(data?: ICreateImportTemplateImportTypeDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTypeDetailId = _data['importTypeDetailId'];
            this.importTypeDetailValue = _data['importTypeDetailValue'];
        }
    }

    static fromJS(data: any): CreateImportTemplateImportTypeDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImportTemplateImportTypeDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTypeDetailId'] = this.importTypeDetailId;
        data['importTypeDetailValue'] = this.importTypeDetailValue;
        return data;
    }

    clone(): CreateImportTemplateImportTypeDetailInput {
        const json = this.toJSON();
        let result = new CreateImportTemplateImportTypeDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateImportTemplateImportTypeDetailInput {
    importTypeDetailId: number;
    importTypeDetailValue: number;
}

export class CreateImportTemplateInput implements ICreateImportTemplateInput {
    importTypeId: number;
    templateName: string | undefined;
    importTemplateDetails: CreateImportTemplateDetailInput[] | undefined;
    importTemplateImportTypeDetails: CreateImportTemplateImportTypeDetailInput[] | undefined;

    constructor(data?: ICreateImportTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTypeId = _data['importTypeId'];
            this.templateName = _data['templateName'];
            if (Array.isArray(_data['importTemplateDetails'])) {
                this.importTemplateDetails = [] as any;
                for (let item of _data['importTemplateDetails'])
                    this.importTemplateDetails.push(CreateImportTemplateDetailInput.fromJS(item));
            }
            if (Array.isArray(_data['importTemplateImportTypeDetails'])) {
                this.importTemplateImportTypeDetails = [] as any;
                for (let item of _data['importTemplateImportTypeDetails'])
                    this.importTemplateImportTypeDetails.push(CreateImportTemplateImportTypeDetailInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateImportTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImportTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTypeId'] = this.importTypeId;
        data['templateName'] = this.templateName;
        if (Array.isArray(this.importTemplateDetails)) {
            data['importTemplateDetails'] = [];
            for (let item of this.importTemplateDetails) data['importTemplateDetails'].push(item.toJSON());
        }
        if (Array.isArray(this.importTemplateImportTypeDetails)) {
            data['importTemplateImportTypeDetails'] = [];
            for (let item of this.importTemplateImportTypeDetails) data['importTemplateImportTypeDetails'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateImportTemplateInput {
        const json = this.toJSON();
        let result = new CreateImportTemplateInput();
        result.init(json);
        return result;
    }
}

export interface ICreateImportTemplateInput {
    importTypeId: number;
    templateName: string | undefined;
    importTemplateDetails: CreateImportTemplateDetailInput[] | undefined;
    importTemplateImportTypeDetails: CreateImportTemplateImportTypeDetailInput[] | undefined;
}

export class CreateOrUpdateActionInput implements ICreateOrUpdateActionInput {
    action: ActionAdminEditDto;

    constructor(data?: ICreateOrUpdateActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.action = new ActionAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data['action'] ? ActionAdminEditDto.fromJS(_data['action']) : new ActionAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateActionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['action'] = this.action ? this.action.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateActionInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateActionInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateActionInput {
    action: ActionAdminEditDto;
}

export interface ICreateOrUpdateActivityInput {
    activity: ActivityEditDto;
    userIdList: number[] | undefined;
    simpleActivityFlag: boolean;
    sendNotification: boolean;
    updateDetailAndDueDate: boolean;
}

export class CreateOrUpdateActivityUserInput implements ICreateOrUpdateActivityUserInput {
    activityUser: ActivityUserEditDto;

    constructor(data?: ICreateOrUpdateActivityUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activityUser = new ActivityUserEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityUser = _data['activityUser'] ? ActivityUserEditDto.fromJS(_data['activityUser']) : new ActivityUserEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateActivityUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateActivityUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activityUser'] = this.activityUser ? this.activityUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateActivityUserInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateActivityUserInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateActivityUserInput {
    activityUser: ActivityUserEditDto;
}

export class CreateOrUpdateAssetInput implements ICreateOrUpdateAssetInput {
    asset: AssetEditDto;

    constructor(data?: ICreateOrUpdateAssetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asset = _data['asset'] ? AssetEditDto.fromJS(_data['asset']) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateAssetInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAssetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['asset'] = this.asset ? this.asset.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAssetInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAssetInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAssetInput {
    asset: AssetEditDto;
}

export class CreateOrUpdateCommunicationTypeInput implements ICreateOrUpdateCommunicationTypeInput {
    communicationType: CommunicationTypeEditDto;

    constructor(data?: ICreateOrUpdateCommunicationTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.communicationType = new CommunicationTypeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationType = _data['communicationType']
                ? CommunicationTypeEditDto.fromJS(_data['communicationType'])
                : new CommunicationTypeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCommunicationTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCommunicationTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['communicationType'] = this.communicationType ? this.communicationType.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCommunicationTypeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCommunicationTypeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCommunicationTypeInput {
    communicationType: CommunicationTypeEditDto;
}

export class CreateOrUpdateContactGroupInput implements ICreateOrUpdateContactGroupInput {
    contactGroup: ContactGroupEditDto;

    constructor(data?: ICreateOrUpdateContactGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contactGroup = new ContactGroupEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactGroup = _data['contactGroup'] ? ContactGroupEditDto.fromJS(_data['contactGroup']) : new ContactGroupEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateContactGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateContactGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['contactGroup'] = this.contactGroup ? this.contactGroup.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateContactGroupInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateContactGroupInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateContactGroupInput {
    contactGroup: ContactGroupEditDto;
}

export class CreateOrUpdateContactInput implements ICreateOrUpdateContactInput {
    contact: ContactEditDto;

    constructor(data?: ICreateOrUpdateContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data['contact'] ? ContactEditDto.fromJS(_data['contact']) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['contact'] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateContactInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateContactInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateContactInput {
    contact: ContactEditDto;
}

export class CreateOrUpdateDepartmentInput implements ICreateOrUpdateDepartmentInput {
    department: DepartmentAdminEditDto;

    constructor(data?: ICreateOrUpdateDepartmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.department = new DepartmentAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data['department'] ? DepartmentAdminEditDto.fromJS(_data['department']) : new DepartmentAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateDepartmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDepartmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['department'] = this.department ? this.department.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateDepartmentInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDepartmentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDepartmentInput {
    department: DepartmentAdminEditDto;
}

export class CreateOrUpdateDocumentStorageInput implements ICreateOrUpdateDocumentStorageInput {
    documentStorage: DocumentStorageEditDto;

    constructor(data?: ICreateOrUpdateDocumentStorageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentStorage = new DocumentStorageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentStorage = _data['documentStorage']
                ? DocumentStorageEditDto.fromJS(_data['documentStorage'])
                : new DocumentStorageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateDocumentStorageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDocumentStorageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['documentStorage'] = this.documentStorage ? this.documentStorage.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateDocumentStorageInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDocumentStorageInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDocumentStorageInput {
    documentStorage: DocumentStorageEditDto;
}

export class CreateOrUpdateEmailCannedResponseInput implements ICreateOrUpdateEmailCannedResponseInput {
    emailCannedResponse: EmailCannedResponseAdminEditDto;

    constructor(data?: ICreateOrUpdateEmailCannedResponseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.emailCannedResponse = new EmailCannedResponseAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailCannedResponse = _data['emailCannedResponse']
                ? EmailCannedResponseAdminEditDto.fromJS(_data['emailCannedResponse'])
                : new EmailCannedResponseAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEmailCannedResponseInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEmailCannedResponseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailCannedResponse'] = this.emailCannedResponse ? this.emailCannedResponse.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateEmailCannedResponseInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateEmailCannedResponseInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEmailCannedResponseInput {
    emailCannedResponse: EmailCannedResponseAdminEditDto;
}

export class CreateOrUpdateEventInput implements ICreateOrUpdateEventInput {
    event: EventEditDto;

    constructor(data?: ICreateOrUpdateEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.event = new EventEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data['event'] ? EventEditDto.fromJS(_data['event']) : new EventEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEventInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEventInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['event'] = this.event ? this.event.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateEventInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateEventInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEventInput {
    event: EventEditDto;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data['language'] ? ApplicationLanguageEditDto.fromJS(_data['language']) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['language'] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateLanguageInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateLanguageInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateOpportunityInput implements ICreateOrUpdateOpportunityInput {
    opportunity: OpportunityEditDto;

    constructor(data?: ICreateOrUpdateOpportunityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.opportunity = new OpportunityEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunity = _data['opportunity'] ? OpportunityEditDto.fromJS(_data['opportunity']) : new OpportunityEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateOpportunityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateOpportunityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['opportunity'] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateOpportunityInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateOpportunityInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateOpportunityInput {
    opportunity: OpportunityEditDto;
}

export class CreateOrUpdateOpportunityStageInput implements ICreateOrUpdateOpportunityStageInput {
    opportunityStage: OpportunityStageEditDto;

    constructor(data?: ICreateOrUpdateOpportunityStageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.opportunityStage = new OpportunityStageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityStage = _data['opportunityStage']
                ? OpportunityStageEditDto.fromJS(_data['opportunityStage'])
                : new OpportunityStageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateOpportunityStageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateOpportunityStageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['opportunityStage'] = this.opportunityStage ? this.opportunityStage.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateOpportunityStageInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateOpportunityStageInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateOpportunityStageInput {
    opportunityStage: OpportunityStageEditDto;
}

export class CreateOrUpdateProbabilityToCloseInput implements ICreateOrUpdateProbabilityToCloseInput {
    probabilityToClose: ProbabilityToCloseEditDto;

    constructor(data?: ICreateOrUpdateProbabilityToCloseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.probabilityToClose = new ProbabilityToCloseEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.probabilityToClose = _data['probabilityToClose']
                ? ProbabilityToCloseEditDto.fromJS(_data['probabilityToClose'])
                : new ProbabilityToCloseEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProbabilityToCloseInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProbabilityToCloseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['probabilityToClose'] = this.probabilityToClose ? this.probabilityToClose.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProbabilityToCloseInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProbabilityToCloseInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProbabilityToCloseInput {
    probabilityToClose: ProbabilityToCloseEditDto;
}

export class CreateOrUpdateProductAttributeInput implements ICreateOrUpdateProductAttributeInput {
    productAttribute: ProductAttributeEditDto;

    constructor(data?: ICreateOrUpdateProductAttributeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productAttribute = new ProductAttributeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productAttribute = _data['productAttribute']
                ? ProductAttributeEditDto.fromJS(_data['productAttribute'])
                : new ProductAttributeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProductAttributeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductAttributeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productAttribute'] = this.productAttribute ? this.productAttribute.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProductAttributeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductAttributeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProductAttributeInput {
    productAttribute: ProductAttributeEditDto;
}

export class CreateOrUpdateProductAttributeTypeInput implements ICreateOrUpdateProductAttributeTypeInput {
    productAttributeType: ProductAttributeTypeEditDto;

    constructor(data?: ICreateOrUpdateProductAttributeTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productAttributeType = new ProductAttributeTypeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productAttributeType = _data['productAttributeType']
                ? ProductAttributeTypeEditDto.fromJS(_data['productAttributeType'])
                : new ProductAttributeTypeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProductAttributeTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductAttributeTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productAttributeType'] = this.productAttributeType ? this.productAttributeType.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProductAttributeTypeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductAttributeTypeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProductAttributeTypeInput {
    productAttributeType: ProductAttributeTypeEditDto;
}

export class CreateOrUpdateProductCategoryInput implements ICreateOrUpdateProductCategoryInput {
    productCategory: ProductCategoryAdminEditDto;

    constructor(data?: ICreateOrUpdateProductCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productCategory = new ProductCategoryAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCategory = _data['productCategory']
                ? ProductCategoryAdminEditDto.fromJS(_data['productCategory'])
                : new ProductCategoryAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProductCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productCategory'] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProductCategoryInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductCategoryInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProductCategoryInput {
    productCategory: ProductCategoryAdminEditDto;
}

export class CreateOrUpdateProductInput implements ICreateOrUpdateProductInput {
    product: ProductEditDto;

    constructor(data?: ICreateOrUpdateProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.product = new ProductEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data['product'] ? ProductEditDto.fromJS(_data['product']) : new ProductEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProductInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProductInput {
    product: ProductEditDto;
}

export class CreateOrUpdateProductMilestoneInput implements ICreateOrUpdateProductMilestoneInput {
    productMilestone: ProductMilestoneEditDto;

    constructor(data?: ICreateOrUpdateProductMilestoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productMilestone = new ProductMilestoneEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productMilestone = _data['productMilestone']
                ? ProductMilestoneEditDto.fromJS(_data['productMilestone'])
                : new ProductMilestoneEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProductMilestoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductMilestoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productMilestone'] = this.productMilestone ? this.productMilestone.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProductMilestoneInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductMilestoneInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProductMilestoneInput {
    productMilestone: ProductMilestoneEditDto;
}

export class CreateOrUpdateStatusAutomationInput implements ICreateOrUpdateStatusAutomationInput {
    statusAutomation: StatusAutomationAdminEditDto;

    constructor(data?: ICreateOrUpdateStatusAutomationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusAutomation = new StatusAutomationAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusAutomation = _data['statusAutomation']
                ? StatusAutomationAdminEditDto.fromJS(_data['statusAutomation'])
                : new StatusAutomationAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateStatusAutomationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateStatusAutomationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['statusAutomation'] = this.statusAutomation ? this.statusAutomation.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateStatusAutomationInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateStatusAutomationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateStatusAutomationInput {
    statusAutomation: StatusAutomationAdminEditDto;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data['parentId'];
            this.displayName = _data['displayName'];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentId'] = this.parentId;
        data['displayName'] = this.displayName;
        return data;
    }

    clone(): CreateOrganizationUnitInput {
        const json = this.toJSON();
        let result = new CreateOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class Customer implements ICustomer {
    tenantId: number | undefined;
    name: string;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    customerLocations: CustomerLocation[] | undefined;
    customerContacts: CustomerContact[] | undefined;
    partnerId: number;
    partner: Partner;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    accountManagerId: number | undefined;
    accountManager: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.billingAddress = _data['billingAddress'];
            this.billingAddress2 = _data['billingAddress2'];
            this.billingCity = _data['billingCity'];
            this.billingState = _data['billingState'];
            this.billingZipcode = _data['billingZipcode'];
            this.billingCountry = _data['billingCountry'];
            if (Array.isArray(_data['customerLocations'])) {
                this.customerLocations = [] as any;
                for (let item of _data['customerLocations']) this.customerLocations.push(CustomerLocation.fromJS(item));
            }
            if (Array.isArray(_data['customerContacts'])) {
                this.customerContacts = [] as any;
                for (let item of _data['customerContacts']) this.customerContacts.push(CustomerContact.fromJS(item));
            }
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.accountManagerId = _data['accountManagerId'];
            this.accountManager = _data['accountManager'] ? User.fromJS(_data['accountManager']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['billingAddress'] = this.billingAddress;
        data['billingAddress2'] = this.billingAddress2;
        data['billingCity'] = this.billingCity;
        data['billingState'] = this.billingState;
        data['billingZipcode'] = this.billingZipcode;
        data['billingCountry'] = this.billingCountry;
        if (Array.isArray(this.customerLocations)) {
            data['customerLocations'] = [];
            for (let item of this.customerLocations) data['customerLocations'].push(item.toJSON());
        }
        if (Array.isArray(this.customerContacts)) {
            data['customerContacts'] = [];
            for (let item of this.customerContacts) data['customerContacts'].push(item.toJSON());
        }
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['accountManagerId'] = this.accountManagerId;
        data['accountManager'] = this.accountManager ? this.accountManager.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    tenantId: number | undefined;
    name: string;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    customerLocations: CustomerLocation[] | undefined;
    customerContacts: CustomerContact[] | undefined;
    partnerId: number;
    partner: Partner;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    accountManagerId: number | undefined;
    accountManager: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerContact implements ICustomerContact {
    customer: Customer;
    customerId: number;
    type: ContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: ICustomerContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data['customer'] ? Customer.fromJS(_data['customer']) : <any>undefined;
            this.customerId = _data['customerId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerContact {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['customerId'] = this.customerId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerContact {
        const json = this.toJSON();
        let result = new CustomerContact();
        result.init(json);
        return result;
    }
}

export interface ICustomerContact {
    customer: Customer;
    customerId: number;
    type: ContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;
}

export class CustomerDto implements ICustomerDto {
    name: string;
    partnerId: number;
    id: number;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.partnerId = _data['partnerId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['partnerId'] = this.partnerId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    name: string;
    partnerId: number;
    id: number;
}

export class CustomerEditDto implements ICustomerEditDto {
    tenantId: number | undefined;
    name: string;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    partnerId: number;
    accountManagerId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.billingAddress = _data['billingAddress'];
            this.billingAddress2 = _data['billingAddress2'];
            this.billingCity = _data['billingCity'];
            this.billingState = _data['billingState'];
            this.billingZipcode = _data['billingZipcode'];
            this.billingCountry = _data['billingCountry'];
            this.partnerId = _data['partnerId'];
            this.accountManagerId = _data['accountManagerId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['billingAddress'] = this.billingAddress;
        data['billingAddress2'] = this.billingAddress2;
        data['billingCity'] = this.billingCity;
        data['billingState'] = this.billingState;
        data['billingZipcode'] = this.billingZipcode;
        data['billingCountry'] = this.billingCountry;
        data['partnerId'] = this.partnerId;
        data['accountManagerId'] = this.accountManagerId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerEditDto {
        const json = this.toJSON();
        let result = new CustomerEditDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerEditDto {
    tenantId: number | undefined;
    name: string;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    partnerId: number;
    accountManagerId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerListDto implements ICustomerListDto {
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    partnerId: number;
    partner: PartnersDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.billingAddress = _data['billingAddress'];
            this.billingAddress2 = _data['billingAddress2'];
            this.billingCity = _data['billingCity'];
            this.billingState = _data['billingState'];
            this.billingZipcode = _data['billingZipcode'];
            this.billingCountry = _data['billingCountry'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnersDto.fromJS(_data['partner']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['billingAddress'] = this.billingAddress;
        data['billingAddress2'] = this.billingAddress2;
        data['billingCity'] = this.billingCity;
        data['billingState'] = this.billingState;
        data['billingZipcode'] = this.billingZipcode;
        data['billingCountry'] = this.billingCountry;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerListDto {
        const json = this.toJSON();
        let result = new CustomerListDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerListDto {
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    partnerId: number;
    partner: PartnersDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerLocation implements ICustomerLocation {
    tenantId: number | undefined;
    customerId: number;
    customer: Customer;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    country: string | undefined;
    dabNo: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerLocationContacts: CustomerLocationContact[] | undefined;
    readonly customerName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? Customer.fromJS(_data['customer']) : <any>undefined;
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.dabNo = _data['dabNo'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['customerLocationContacts'])) {
                this.customerLocationContacts = [] as any;
                for (let item of _data['customerLocationContacts'])
                    this.customerLocationContacts.push(CustomerLocationContact.fromJS(item));
            }
            (<any>this).customerName = _data['customerName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerLocation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['dabNo'] = this.dabNo;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.customerLocationContacts)) {
            data['customerLocationContacts'] = [];
            for (let item of this.customerLocationContacts) data['customerLocationContacts'].push(item.toJSON());
        }
        data['customerName'] = this.customerName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerLocation {
        const json = this.toJSON();
        let result = new CustomerLocation();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocation {
    tenantId: number | undefined;
    customerId: number;
    customer: Customer;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    country: string | undefined;
    dabNo: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerLocationContacts: CustomerLocationContact[] | undefined;
    customerName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerLocationContact implements ICustomerLocationContact {
    customerLocation: CustomerLocation;
    customerLocationId: number;
    type: ContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: ICustomerLocationContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocation = _data['customerLocation'] ? CustomerLocation.fromJS(_data['customerLocation']) : <any>undefined;
            this.customerLocationId = _data['customerLocationId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerLocationContact {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['customerLocationId'] = this.customerLocationId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerLocationContact {
        const json = this.toJSON();
        let result = new CustomerLocationContact();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationContact {
    customerLocation: CustomerLocation;
    customerLocationId: number;
    type: ContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;
}

export class CustomerLocationDto implements ICustomerLocationDto {
    customerId: number;
    customer: CustomerEditDto;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    dabNo: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : <any>undefined;
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.dabNo = _data['dabNo'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['dabNo'] = this.dabNo;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerLocationDto {
        const json = this.toJSON();
        let result = new CustomerLocationDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationDto {
    customerId: number;
    customer: CustomerEditDto;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    dabNo: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerLocationEditDto implements ICustomerLocationEditDto {
    tenantId: number | undefined;
    customerId: number;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    dabNo: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerLocationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.customerId = _data['customerId'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.dabNo = _data['dabNo'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerLocationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['customerId'] = this.customerId;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['dabNo'] = this.dabNo;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerLocationEditDto {
        const json = this.toJSON();
        let result = new CustomerLocationEditDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationEditDto {
    tenantId: number | undefined;
    customerId: number;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    dabNo: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerLocationResponse implements ICustomerLocationResponse {
    id: number;
    customerId: number;
    customerName: string | undefined;
    locationName: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    zipcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(data?: ICustomerLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.locationName = _data['locationName'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.zipcode = _data['zipcode'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.country = _data['country'];
        }
    }

    static fromJS(data: any): CustomerLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['locationName'] = this.locationName;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['zipcode'] = this.zipcode;
        data['city'] = this.city;
        data['state'] = this.state;
        data['country'] = this.country;
        return data;
    }

    clone(): CustomerLocationResponse {
        const json = this.toJSON();
        let result = new CustomerLocationResponse();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationResponse {
    id: number;
    customerId: number;
    customerName: string | undefined;
    locationName: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    zipcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class CustomerLocationResponsePagedResultDto implements ICustomerLocationResponsePagedResultDto {
    totalCount: number;
    items: CustomerLocationResponse[] | undefined;

    constructor(data?: ICustomerLocationResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustomerLocationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerLocationResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerLocationResponsePagedResultDto {
        const json = this.toJSON();
        let result = new CustomerLocationResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationResponsePagedResultDto {
    totalCount: number;
    items: CustomerLocationResponse[] | undefined;
}

export class CustomerModel implements ICustomerModel {
    id: number;
    name: string | undefined;
    tenantId: number | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    accountManagerId: number | undefined;
    accountManagerName: string | undefined;
    accountManagerUuid: string | undefined;
    accountManagerPhoneNumber: string | undefined;
    accountManagerEmailAddress: string | undefined;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.tenantId = _data['tenantId'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.billingAddress = _data['billingAddress'];
            this.billingAddress2 = _data['billingAddress2'];
            this.billingCity = _data['billingCity'];
            this.billingState = _data['billingState'];
            this.billingZipcode = _data['billingZipcode'];
            this.billingCountry = _data['billingCountry'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.accountManagerId = _data['accountManagerId'];
            this.accountManagerName = _data['accountManagerName'];
            this.accountManagerUuid = _data['accountManagerUuid'];
            this.accountManagerPhoneNumber = _data['accountManagerPhoneNumber'];
            this.accountManagerEmailAddress = _data['accountManagerEmailAddress'];
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['tenantId'] = this.tenantId;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['billingAddress'] = this.billingAddress;
        data['billingAddress2'] = this.billingAddress2;
        data['billingCity'] = this.billingCity;
        data['billingState'] = this.billingState;
        data['billingZipcode'] = this.billingZipcode;
        data['billingCountry'] = this.billingCountry;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['accountManagerId'] = this.accountManagerId;
        data['accountManagerName'] = this.accountManagerName;
        data['accountManagerUuid'] = this.accountManagerUuid;
        data['accountManagerPhoneNumber'] = this.accountManagerPhoneNumber;
        data['accountManagerEmailAddress'] = this.accountManagerEmailAddress;
        return data;
    }

    clone(): CustomerModel {
        const json = this.toJSON();
        let result = new CustomerModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerModel {
    id: number;
    name: string | undefined;
    tenantId: number | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingState: string | undefined;
    billingZipcode: string | undefined;
    billingCountry: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    accountManagerId: number | undefined;
    accountManagerName: string | undefined;
    accountManagerUuid: string | undefined;
    accountManagerPhoneNumber: string | undefined;
    accountManagerEmailAddress: string | undefined;
}

export class CustomerModelPagedResultModel implements ICustomerModelPagedResultModel {
    total: number;
    items: CustomerModel[] | undefined;

    constructor(data?: ICustomerModelPagedResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data['total'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustomerModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerModelPagedResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModelPagedResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['total'] = this.total;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerModelPagedResultModel {
        const json = this.toJSON();
        let result = new CustomerModelPagedResultModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerModelPagedResultModel {
    total: number;
    items: CustomerModel[] | undefined;
}

export class CustomerTile implements ICustomerTile {
    activeOrdersCount: number;
    pendingOrdersCount: number;
    pendingQuotesCount: number;

    constructor(data?: ICustomerTile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeOrdersCount = _data['activeOrdersCount'];
            this.pendingOrdersCount = _data['pendingOrdersCount'];
            this.pendingQuotesCount = _data['pendingQuotesCount'];
        }
    }

    static fromJS(data: any): CustomerTile {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activeOrdersCount'] = this.activeOrdersCount;
        data['pendingOrdersCount'] = this.pendingOrdersCount;
        data['pendingQuotesCount'] = this.pendingQuotesCount;
        return data;
    }

    clone(): CustomerTile {
        const json = this.toJSON();
        let result = new CustomerTile();
        result.init(json);
        return result;
    }
}

export interface ICustomerTile {
    activeOrdersCount: number;
    pendingOrdersCount: number;
    pendingQuotesCount: number;
}

export class DepartmentAdminEditDto implements IDepartmentAdminEditDto {
    tenantId: number | undefined;
    name: string | undefined;
    senderAddress: string | undefined;
    isKafkaEnabled: boolean;
    departmentUsers: DepartmentUserAdminListDto[] | undefined;
    departmentRoles: DepartmentRoleDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDepartmentAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.senderAddress = _data['senderAddress'];
            this.isKafkaEnabled = _data['isKafkaEnabled'];
            if (Array.isArray(_data['departmentUsers'])) {
                this.departmentUsers = [] as any;
                for (let item of _data['departmentUsers']) this.departmentUsers.push(DepartmentUserAdminListDto.fromJS(item));
            }
            if (Array.isArray(_data['departmentRoles'])) {
                this.departmentRoles = [] as any;
                for (let item of _data['departmentRoles']) this.departmentRoles.push(DepartmentRoleDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): DepartmentAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['senderAddress'] = this.senderAddress;
        data['isKafkaEnabled'] = this.isKafkaEnabled;
        if (Array.isArray(this.departmentUsers)) {
            data['departmentUsers'] = [];
            for (let item of this.departmentUsers) data['departmentUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.departmentRoles)) {
            data['departmentRoles'] = [];
            for (let item of this.departmentRoles) data['departmentRoles'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): DepartmentAdminEditDto {
        const json = this.toJSON();
        let result = new DepartmentAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentAdminEditDto {
    tenantId: number | undefined;
    name: string | undefined;
    senderAddress: string | undefined;
    isKafkaEnabled: boolean;
    departmentUsers: DepartmentUserAdminListDto[] | undefined;
    departmentRoles: DepartmentRoleDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class DepartmentDropdownDto implements IDepartmentDropdownDto {
    name: string | undefined;
    id: number;
    hasTicketCommissionInquiryAccess: boolean;

    constructor(data?: IDepartmentDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
            this.hasTicketCommissionInquiryAccess = _data['hasTicketCommissionInquiryAccess'];
        }
    }

    static fromJS(data: any): DepartmentDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        data['hasTicketCommissionInquiryAccess'] = this.hasTicketCommissionInquiryAccess;
        return data;
    }

    clone(): DepartmentDropdownDto {
        const json = this.toJSON();
        let result = new DepartmentDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentDropdownDto {
    name: string | undefined;
    id: number;
    hasTicketCommissionInquiryAccess: boolean;
}

export class DepartmentRoleDto implements IDepartmentRoleDto {
    tenantId: number | undefined;
    departmentId: number;
    departmentName: string | undefined;
    roleId: number;
    roleName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDepartmentRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): DepartmentRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): DepartmentRoleDto {
        const json = this.toJSON();
        let result = new DepartmentRoleDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentRoleDto {
    tenantId: number | undefined;
    departmentId: number;
    departmentName: string | undefined;
    roleId: number;
    roleName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class DepartmentUserAdminListDto implements IDepartmentUserAdminListDto {
    id: number;
    name: string | undefined;

    constructor(data?: IDepartmentUserAdminListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): DepartmentUserAdminListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserAdminListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): DepartmentUserAdminListDto {
        const json = this.toJSON();
        let result = new DepartmentUserAdminListDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentUserAdminListDto {
    id: number;
    name: string | undefined;
}

export class DepartmentUserDropdownDto implements IDepartmentUserDropdownDto {
    userId: number;
    userName: string | undefined;

    constructor(data?: IDepartmentUserDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.userName = _data['userName'];
        }
    }

    static fromJS(data: any): DepartmentUserDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['userName'] = this.userName;
        return data;
    }

    clone(): DepartmentUserDropdownDto {
        const json = this.toJSON();
        let result = new DepartmentUserDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentUserDropdownDto {
    userId: number;
    userName: string | undefined;
}

export class DocumentStorageEditDto implements IDocumentStorageEditDto {
    documentName: string | undefined;
    providerId: number;
    documentType: DocumentType;
    key: number;

    constructor(data?: IDocumentStorageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data['documentName'];
            this.providerId = _data['providerId'];
            this.documentType = _data['documentType'];
            this.key = _data['key'];
        }
    }

    static fromJS(data: any): DocumentStorageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentStorageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['documentName'] = this.documentName;
        data['providerId'] = this.providerId;
        data['documentType'] = this.documentType;
        data['key'] = this.key;
        return data;
    }

    clone(): DocumentStorageEditDto {
        const json = this.toJSON();
        let result = new DocumentStorageEditDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentStorageEditDto {
    documentName: string | undefined;
    providerId: number;
    documentType: DocumentType;
    key: number;
}

export class EditImportTemplateDetailInput implements IEditImportTemplateDetailInput {
    importTemplateDetailId: number | undefined;
    importTypeModuleId: number | undefined;
    importTypeModuleFieldId: number | undefined;
    importMapFieldId: number | undefined;
    uploadedField: string | undefined;

    constructor(data?: IEditImportTemplateDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTemplateDetailId = _data['importTemplateDetailId'];
            this.importTypeModuleId = _data['importTypeModuleId'];
            this.importTypeModuleFieldId = _data['importTypeModuleFieldId'];
            this.importMapFieldId = _data['importMapFieldId'];
            this.uploadedField = _data['uploadedField'];
        }
    }

    static fromJS(data: any): EditImportTemplateDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditImportTemplateDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTemplateDetailId'] = this.importTemplateDetailId;
        data['importTypeModuleId'] = this.importTypeModuleId;
        data['importTypeModuleFieldId'] = this.importTypeModuleFieldId;
        data['importMapFieldId'] = this.importMapFieldId;
        data['uploadedField'] = this.uploadedField;
        return data;
    }

    clone(): EditImportTemplateDetailInput {
        const json = this.toJSON();
        let result = new EditImportTemplateDetailInput();
        result.init(json);
        return result;
    }
}

export interface IEditImportTemplateDetailInput {
    importTemplateDetailId: number | undefined;
    importTypeModuleId: number | undefined;
    importTypeModuleFieldId: number | undefined;
    importMapFieldId: number | undefined;
    uploadedField: string | undefined;
}

export class EditImportTemplateImportTypeDetailInput implements IEditImportTemplateImportTypeDetailInput {
    importTemplateImportTypeDetailId: number | undefined;
    importTypeDetailId: number;
    importTypeDetailValue: number;

    constructor(data?: IEditImportTemplateImportTypeDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTemplateImportTypeDetailId = _data['importTemplateImportTypeDetailId'];
            this.importTypeDetailId = _data['importTypeDetailId'];
            this.importTypeDetailValue = _data['importTypeDetailValue'];
        }
    }

    static fromJS(data: any): EditImportTemplateImportTypeDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditImportTemplateImportTypeDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTemplateImportTypeDetailId'] = this.importTemplateImportTypeDetailId;
        data['importTypeDetailId'] = this.importTypeDetailId;
        data['importTypeDetailValue'] = this.importTypeDetailValue;
        return data;
    }

    clone(): EditImportTemplateImportTypeDetailInput {
        const json = this.toJSON();
        let result = new EditImportTemplateImportTypeDetailInput();
        result.init(json);
        return result;
    }
}

export interface IEditImportTemplateImportTypeDetailInput {
    importTemplateImportTypeDetailId: number | undefined;
    importTypeDetailId: number;
    importTypeDetailValue: number;
}

export class EditImportTemplateInput implements IEditImportTemplateInput {
    id: number;
    templateName: string | undefined;
    importTemplateDetails: EditImportTemplateDetailInput[] | undefined;
    importTemplateImportTypeDetails: EditImportTemplateImportTypeDetailInput[] | undefined;

    constructor(data?: IEditImportTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.templateName = _data['templateName'];
            if (Array.isArray(_data['importTemplateDetails'])) {
                this.importTemplateDetails = [] as any;
                for (let item of _data['importTemplateDetails'])
                    this.importTemplateDetails.push(EditImportTemplateDetailInput.fromJS(item));
            }
            if (Array.isArray(_data['importTemplateImportTypeDetails'])) {
                this.importTemplateImportTypeDetails = [] as any;
                for (let item of _data['importTemplateImportTypeDetails'])
                    this.importTemplateImportTypeDetails.push(EditImportTemplateImportTypeDetailInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditImportTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditImportTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['templateName'] = this.templateName;
        if (Array.isArray(this.importTemplateDetails)) {
            data['importTemplateDetails'] = [];
            for (let item of this.importTemplateDetails) data['importTemplateDetails'].push(item.toJSON());
        }
        if (Array.isArray(this.importTemplateImportTypeDetails)) {
            data['importTemplateImportTypeDetails'] = [];
            for (let item of this.importTemplateImportTypeDetails) data['importTemplateImportTypeDetails'].push(item.toJSON());
        }
        return data;
    }

    clone(): EditImportTemplateInput {
        const json = this.toJSON();
        let result = new EditImportTemplateInput();
        result.init(json);
        return result;
    }
}

export interface IEditImportTemplateInput {
    id: number;
    templateName: string | undefined;
    importTemplateDetails: EditImportTemplateDetailInput[] | undefined;
    importTemplateImportTypeDetails: EditImportTemplateImportTypeDetailInput[] | undefined;
}

export class EmailCannedResponseAdminEditDto implements IEmailCannedResponseAdminEditDto {
    tenantId: number | undefined;
    userId: number | undefined;
    departmentId: number | undefined;
    name: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    appDomain: AppDomain;
    statusAutomationId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEmailCannedResponseAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.departmentId = _data['departmentId'];
            this.name = _data['name'];
            this.subject = _data['subject'];
            this.message = _data['message'];
            this.appDomain = _data['appDomain'];
            this.statusAutomationId = _data['statusAutomationId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EmailCannedResponseAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailCannedResponseAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['departmentId'] = this.departmentId;
        data['name'] = this.name;
        data['subject'] = this.subject;
        data['message'] = this.message;
        data['appDomain'] = this.appDomain;
        data['statusAutomationId'] = this.statusAutomationId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): EmailCannedResponseAdminEditDto {
        const json = this.toJSON();
        let result = new EmailCannedResponseAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailCannedResponseAdminEditDto {
    tenantId: number | undefined;
    userId: number | undefined;
    departmentId: number | undefined;
    name: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    appDomain: AppDomain;
    statusAutomationId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EmailCannedResponseDropdownDto implements IEmailCannedResponseDropdownDto {
    id: number;
    name: string | undefined;
    subject: string | undefined;
    message: string | undefined;

    constructor(data?: IEmailCannedResponseDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.subject = _data['subject'];
            this.message = _data['message'];
        }
    }

    static fromJS(data: any): EmailCannedResponseDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailCannedResponseDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['subject'] = this.subject;
        data['message'] = this.message;
        return data;
    }

    clone(): EmailCannedResponseDropdownDto {
        const json = this.toJSON();
        let result = new EmailCannedResponseDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IEmailCannedResponseDropdownDto {
    id: number;
    name: string | undefined;
    subject: string | undefined;
    message: string | undefined;
}

export class EmailFilterRuleDto implements IEmailFilterRuleDto {
    tenantId: number | undefined;
    emailPart: EmailPart;
    filterPermission: FilterPermission;
    value: string | undefined;
    filteredEmailsCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEmailFilterRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.emailPart = _data['emailPart'];
            this.filterPermission = _data['filterPermission'];
            this.value = _data['value'];
            this.filteredEmailsCount = _data['filteredEmailsCount'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EmailFilterRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailFilterRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['emailPart'] = this.emailPart;
        data['filterPermission'] = this.filterPermission;
        data['value'] = this.value;
        data['filteredEmailsCount'] = this.filteredEmailsCount;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): EmailFilterRuleDto {
        const json = this.toJSON();
        let result = new EmailFilterRuleDto();
        result.init(json);
        return result;
    }
}

export interface IEmailFilterRuleDto {
    tenantId: number | undefined;
    emailPart: EmailPart;
    filterPermission: FilterPermission;
    value: string | undefined;
    filteredEmailsCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EmailFilterRuleEditDto implements IEmailFilterRuleEditDto {
    emailPart: EmailPart;
    filterPermission: FilterPermission;
    value: string;
    id: number;

    constructor(data?: IEmailFilterRuleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailPart = _data['emailPart'];
            this.filterPermission = _data['filterPermission'];
            this.value = _data['value'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EmailFilterRuleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailFilterRuleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailPart'] = this.emailPart;
        data['filterPermission'] = this.filterPermission;
        data['value'] = this.value;
        data['id'] = this.id;
        return data;
    }

    clone(): EmailFilterRuleEditDto {
        const json = this.toJSON();
        let result = new EmailFilterRuleEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailFilterRuleEditDto {
    emailPart: EmailPart;
    filterPermission: FilterPermission;
    value: string;
    id: number;
}

export class EmailOrderStatusInputDto implements IEmailOrderStatusInputDto {
    customerName: string | undefined;
    customerLocationName: string | undefined;
    customerAddress: string | undefined;
    customerCity: string | undefined;
    customerState: string | undefined;
    customerZipcode: string | undefined;
    partnerName: string | undefined;
    salesAgent: string | undefined;
    orderNumber: string | undefined;
    orderReceived: string | undefined;
    provider: string | undefined;
    product: string | undefined;
    mrr: number;
    orderStatusOriginal: string | undefined;
    orderStatusNew: string | undefined;
    strategicPartnerManager: string | undefined;
    note: string | undefined;
    emailFrom: string | undefined;
    emailFromName: string | undefined;
    emailTo: string[] | undefined;

    constructor(data?: IEmailOrderStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data['customerName'];
            this.customerLocationName = _data['customerLocationName'];
            this.customerAddress = _data['customerAddress'];
            this.customerCity = _data['customerCity'];
            this.customerState = _data['customerState'];
            this.customerZipcode = _data['customerZipcode'];
            this.partnerName = _data['partnerName'];
            this.salesAgent = _data['salesAgent'];
            this.orderNumber = _data['orderNumber'];
            this.orderReceived = _data['orderReceived'];
            this.provider = _data['provider'];
            this.product = _data['product'];
            this.mrr = _data['mrr'];
            this.orderStatusOriginal = _data['orderStatusOriginal'];
            this.orderStatusNew = _data['orderStatusNew'];
            this.strategicPartnerManager = _data['strategicPartnerManager'];
            this.note = _data['note'];
            this.emailFrom = _data['emailFrom'];
            this.emailFromName = _data['emailFromName'];
            if (Array.isArray(_data['emailTo'])) {
                this.emailTo = [] as any;
                for (let item of _data['emailTo']) this.emailTo.push(item);
            }
        }
    }

    static fromJS(data: any): EmailOrderStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailOrderStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerName'] = this.customerName;
        data['customerLocationName'] = this.customerLocationName;
        data['customerAddress'] = this.customerAddress;
        data['customerCity'] = this.customerCity;
        data['customerState'] = this.customerState;
        data['customerZipcode'] = this.customerZipcode;
        data['partnerName'] = this.partnerName;
        data['salesAgent'] = this.salesAgent;
        data['orderNumber'] = this.orderNumber;
        data['orderReceived'] = this.orderReceived;
        data['provider'] = this.provider;
        data['product'] = this.product;
        data['mrr'] = this.mrr;
        data['orderStatusOriginal'] = this.orderStatusOriginal;
        data['orderStatusNew'] = this.orderStatusNew;
        data['strategicPartnerManager'] = this.strategicPartnerManager;
        data['note'] = this.note;
        data['emailFrom'] = this.emailFrom;
        data['emailFromName'] = this.emailFromName;
        if (Array.isArray(this.emailTo)) {
            data['emailTo'] = [];
            for (let item of this.emailTo) data['emailTo'].push(item);
        }
        return data;
    }

    clone(): EmailOrderStatusInputDto {
        const json = this.toJSON();
        let result = new EmailOrderStatusInputDto();
        result.init(json);
        return result;
    }
}

export interface IEmailOrderStatusInputDto {
    customerName: string | undefined;
    customerLocationName: string | undefined;
    customerAddress: string | undefined;
    customerCity: string | undefined;
    customerState: string | undefined;
    customerZipcode: string | undefined;
    partnerName: string | undefined;
    salesAgent: string | undefined;
    orderNumber: string | undefined;
    orderReceived: string | undefined;
    provider: string | undefined;
    product: string | undefined;
    mrr: number;
    orderStatusOriginal: string | undefined;
    orderStatusNew: string | undefined;
    strategicPartnerManager: string | undefined;
    note: string | undefined;
    emailFrom: string | undefined;
    emailFromName: string | undefined;
    emailTo: string[] | undefined;
}

export enum EmailPart {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class EventEditDto implements IEventEditDto {
    name: string | undefined;
    location: string | undefined;
    address: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    eventType: EventType;
    eventSourceType: EventSourceType;
    eventSourceKey: number;
    eventStatus: EventStatus;
    eventResourceUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEventEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.location = _data['location'];
            this.address = _data['address'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.eventType = _data['eventType'];
            this.eventSourceType = _data['eventSourceType'];
            this.eventSourceKey = _data['eventSourceKey'];
            this.eventStatus = _data['eventStatus'];
            this.eventResourceUrl = _data['eventResourceUrl'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EventEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['location'] = this.location;
        data['address'] = this.address;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['eventType'] = this.eventType;
        data['eventSourceType'] = this.eventSourceType;
        data['eventSourceKey'] = this.eventSourceKey;
        data['eventStatus'] = this.eventStatus;
        data['eventResourceUrl'] = this.eventResourceUrl;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): EventEditDto {
        const json = this.toJSON();
        let result = new EventEditDto();
        result.init(json);
        return result;
    }
}

export interface IEventEditDto {
    name: string | undefined;
    location: string | undefined;
    address: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    eventType: EventType;
    eventSourceType: EventSourceType;
    eventSourceKey: number;
    eventStatus: EventStatus;
    eventResourceUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventListDto implements IEventListDto {
    id: number;
    name: string | undefined;
    location: string | undefined;
    address: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    eventType: string | undefined;
    eventSourceType: string | undefined;
    eventSourceKey: string | undefined;
    eventStatus: string | undefined;

    constructor(data?: IEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.location = _data['location'];
            this.address = _data['address'];
            this.startDate = _data['startDate'];
            this.endDate = _data['endDate'];
            this.eventType = _data['eventType'];
            this.eventSourceType = _data['eventSourceType'];
            this.eventSourceKey = _data['eventSourceKey'];
            this.eventStatus = _data['eventStatus'];
        }
    }

    static fromJS(data: any): EventListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['location'] = this.location;
        data['address'] = this.address;
        data['startDate'] = this.startDate;
        data['endDate'] = this.endDate;
        data['eventType'] = this.eventType;
        data['eventSourceType'] = this.eventSourceType;
        data['eventSourceKey'] = this.eventSourceKey;
        data['eventStatus'] = this.eventStatus;
        return data;
    }

    clone(): EventListDto {
        const json = this.toJSON();
        let result = new EventListDto();
        result.init(json);
        return result;
    }
}

export interface IEventListDto {
    id: number;
    name: string | undefined;
    location: string | undefined;
    address: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    eventType: string | undefined;
    eventSourceType: string | undefined;
    eventSourceKey: string | undefined;
    eventStatus: string | undefined;
}

export enum EventSourceType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EventStatus {
    _1 = 1,
    _2 = 2,
}

export enum EventType {
    _1 = 1,
}

export enum FieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export enum FilterPermission {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class FilteredEmailDto implements IFilteredEmailDto {
    tenantId: number | undefined;
    subject: string | undefined;
    sender: string | undefined;
    emailAsJson: string | undefined;
    emailType: string | undefined;
    emailFilterRules: EmailFilterRuleDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFilteredEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.subject = _data['subject'];
            this.sender = _data['sender'];
            this.emailAsJson = _data['emailAsJson'];
            this.emailType = _data['emailType'];
            if (Array.isArray(_data['emailFilterRules'])) {
                this.emailFilterRules = [] as any;
                for (let item of _data['emailFilterRules']) this.emailFilterRules.push(EmailFilterRuleDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): FilteredEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['subject'] = this.subject;
        data['sender'] = this.sender;
        data['emailAsJson'] = this.emailAsJson;
        data['emailType'] = this.emailType;
        if (Array.isArray(this.emailFilterRules)) {
            data['emailFilterRules'] = [];
            for (let item of this.emailFilterRules) data['emailFilterRules'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): FilteredEmailDto {
        const json = this.toJSON();
        let result = new FilteredEmailDto();
        result.init(json);
        return result;
    }
}

export interface IFilteredEmailDto {
    tenantId: number | undefined;
    subject: string | undefined;
    sender: string | undefined;
    emailAsJson: string | undefined;
    emailType: string | undefined;
    emailFilterRules: EmailFilterRuleDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class FilteredEmailDtoPagedResultDto implements IFilteredEmailDtoPagedResultDto {
    totalCount: number;
    items: FilteredEmailDto[] | undefined;

    constructor(data?: IFilteredEmailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(FilteredEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilteredEmailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredEmailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): FilteredEmailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FilteredEmailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFilteredEmailDtoPagedResultDto {
    totalCount: number;
    items: FilteredEmailDto[] | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.maxResultCount = _data['maxResultCount'];
            this.skipCount = _data['skipCount'];
            this.filter = _data['filter'];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['maxResultCount'] = this.maxResultCount;
        data['skipCount'] = this.skipCount;
        data['filter'] = this.filter;
        return data;
    }

    clone(): FindUsersInput {
        const json = this.toJSON();
        let result = new FindUsersInput();
        result.init(json);
        return result;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class GetActivitiesOutput implements IGetActivitiesOutput {
    activities: ActivityDetailDto[] | undefined;

    constructor(data?: IGetActivitiesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['activities'])) {
                this.activities = [] as any;
                for (let item of _data['activities']) this.activities.push(ActivityDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivitiesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data['activities'] = [];
            for (let item of this.activities) data['activities'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetActivitiesOutput {
        const json = this.toJSON();
        let result = new GetActivitiesOutput();
        result.init(json);
        return result;
    }
}

export interface IGetActivitiesOutput {
    activities: ActivityDetailDto[] | undefined;
}

export class GetAllActivitiesOutput implements IGetAllActivitiesOutput {
    todayList: ActivityListDto[] | undefined;
    pastList: ActivityListDto[] | undefined;
    upcomingList: ActivityListDto[] | undefined;
    otherList: ActivityListDto[] | undefined;
    allList: ActivityListDto[] | undefined;

    constructor(data?: IGetAllActivitiesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['todayList'])) {
                this.todayList = [] as any;
                for (let item of _data['todayList']) this.todayList.push(ActivityListDto.fromJS(item));
            }
            if (Array.isArray(_data['pastList'])) {
                this.pastList = [] as any;
                for (let item of _data['pastList']) this.pastList.push(ActivityListDto.fromJS(item));
            }
            if (Array.isArray(_data['upcomingList'])) {
                this.upcomingList = [] as any;
                for (let item of _data['upcomingList']) this.upcomingList.push(ActivityListDto.fromJS(item));
            }
            if (Array.isArray(_data['otherList'])) {
                this.otherList = [] as any;
                for (let item of _data['otherList']) this.otherList.push(ActivityListDto.fromJS(item));
            }
            if (Array.isArray(_data['allList'])) {
                this.allList = [] as any;
                for (let item of _data['allList']) this.allList.push(ActivityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllActivitiesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActivitiesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todayList)) {
            data['todayList'] = [];
            for (let item of this.todayList) data['todayList'].push(item.toJSON());
        }
        if (Array.isArray(this.pastList)) {
            data['pastList'] = [];
            for (let item of this.pastList) data['pastList'].push(item.toJSON());
        }
        if (Array.isArray(this.upcomingList)) {
            data['upcomingList'] = [];
            for (let item of this.upcomingList) data['upcomingList'].push(item.toJSON());
        }
        if (Array.isArray(this.otherList)) {
            data['otherList'] = [];
            for (let item of this.otherList) data['otherList'].push(item.toJSON());
        }
        if (Array.isArray(this.allList)) {
            data['allList'] = [];
            for (let item of this.allList) data['allList'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllActivitiesOutput {
        const json = this.toJSON();
        let result = new GetAllActivitiesOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllActivitiesOutput {
    todayList: ActivityListDto[] | undefined;
    pastList: ActivityListDto[] | undefined;
    upcomingList: ActivityListDto[] | undefined;
    otherList: ActivityListDto[] | undefined;
    allList: ActivityListDto[] | undefined;
}

export class GetContactForEditOutput implements IGetContactForEditOutput {
    contact: ContactEditDto;

    constructor(data?: IGetContactForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data['contact'] ? ContactEditDto.fromJS(_data['contact']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContactForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['contact'] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetContactForEditOutput {
        const json = this.toJSON();
        let result = new GetContactForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetContactForEditOutput {
    contact: ContactEditDto;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }

    clone(): GetDefaultEditionNameOutput {
        const json = this.toJSON();
        let result = new GetDefaultEditionNameOutput();
        result.init(json);
        return result;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetDocumentNameListDto implements IGetDocumentNameListDto {
    filename: string | undefined;
    providerId: number;
    id: number;
    uuid: string | undefined;

    constructor(data?: IGetDocumentNameListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data['filename'];
            this.providerId = _data['providerId'];
            this.id = _data['id'];
            this.uuid = _data['uuid'];
        }
    }

    static fromJS(data: any): GetDocumentNameListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentNameListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['filename'] = this.filename;
        data['providerId'] = this.providerId;
        data['id'] = this.id;
        data['uuid'] = this.uuid;
        return data;
    }

    clone(): GetDocumentNameListDto {
        const json = this.toJSON();
        let result = new GetDocumentNameListDto();
        result.init(json);
        return result;
    }
}

export interface IGetDocumentNameListDto {
    filename: string | undefined;
    providerId: number;
}

export class GetImportTemplateImportTypeDetailInput implements IGetImportTemplateImportTypeDetailInput {
    importTypeDetailId: number;
    importTypeDetailValue: number;

    constructor(data?: IGetImportTemplateImportTypeDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTypeDetailId = _data['importTypeDetailId'];
            this.importTypeDetailValue = _data['importTypeDetailValue'];
        }
    }

    static fromJS(data: any): GetImportTemplateImportTypeDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportTemplateImportTypeDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTypeDetailId'] = this.importTypeDetailId;
        data['importTypeDetailValue'] = this.importTypeDetailValue;
        return data;
    }

    clone(): GetImportTemplateImportTypeDetailInput {
        const json = this.toJSON();
        let result = new GetImportTemplateImportTypeDetailInput();
        result.init(json);
        return result;
    }
}

export interface IGetImportTemplateImportTypeDetailInput {
    importTypeDetailId: number;
    importTypeDetailValue: number;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data['language'] ? ApplicationLanguageEditDto.fromJS(_data['language']) : <any>undefined;
            if (Array.isArray(_data['languageNames'])) {
                this.languageNames = [] as any;
                for (let item of _data['languageNames']) this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data['flags'])) {
                this.flags = [] as any;
                for (let item of _data['flags']) this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['language'] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data['languageNames'] = [];
            for (let item of this.languageNames) data['languageNames'].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data['flags'] = [];
            for (let item of this.flags) data['flags'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLanguageForEditOutput {
        const json = this.toJSON();
        let result = new GetLanguageForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data['defaultLanguageName'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['defaultLanguageName'] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLanguagesOutput {
        const json = this.toJSON();
        let result = new GetLanguagesOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latesWebLogLines: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['latesWebLogLines'])) {
                this.latesWebLogLines = [] as any;
                for (let item of _data['latesWebLogLines']) this.latesWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latesWebLogLines)) {
            data['latesWebLogLines'] = [];
            for (let item of this.latesWebLogLines) data['latesWebLogLines'].push(item);
        }
        return data;
    }

    clone(): GetLatestWebLogsOutput {
        const json = this.toJSON();
        let result = new GetLatestWebLogsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLatestWebLogsOutput {
    latesWebLogLines: string[] | undefined;
}

export class GetMyActivitiesOutput implements IGetMyActivitiesOutput {
    todayList: ActivityDetailDto[] | undefined;
    pastList: ActivityDetailDto[] | undefined;
    upcomingList: ActivityDetailDto[] | undefined;

    constructor(data?: IGetMyActivitiesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['todayList'])) {
                this.todayList = [] as any;
                for (let item of _data['todayList']) this.todayList.push(ActivityDetailDto.fromJS(item));
            }
            if (Array.isArray(_data['pastList'])) {
                this.pastList = [] as any;
                for (let item of _data['pastList']) this.pastList.push(ActivityDetailDto.fromJS(item));
            }
            if (Array.isArray(_data['upcomingList'])) {
                this.upcomingList = [] as any;
                for (let item of _data['upcomingList']) this.upcomingList.push(ActivityDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyActivitiesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyActivitiesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todayList)) {
            data['todayList'] = [];
            for (let item of this.todayList) data['todayList'].push(item.toJSON());
        }
        if (Array.isArray(this.pastList)) {
            data['pastList'] = [];
            for (let item of this.pastList) data['pastList'].push(item.toJSON());
        }
        if (Array.isArray(this.upcomingList)) {
            data['upcomingList'] = [];
            for (let item of this.upcomingList) data['upcomingList'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetMyActivitiesOutput {
        const json = this.toJSON();
        let result = new GetMyActivitiesOutput();
        result.init(json);
        return result;
    }
}

export interface IGetMyActivitiesOutput {
    todayList: ActivityDetailDto[] | undefined;
    pastList: ActivityDetailDto[] | undefined;
    upcomingList: ActivityDetailDto[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data['receiveNotifications'];
            if (Array.isArray(_data['notifications'])) {
                this.notifications = [] as any;
                for (let item of _data['notifications']) this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['receiveNotifications'] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data['notifications'] = [];
            for (let item of this.notifications) data['notifications'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetNotificationSettingsOutput {
        const json = this.toJSON();
        let result = new GetNotificationSettingsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotificationWithCreator[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data['unreadCount'];
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserNotificationWithCreator.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['unreadCount'] = this.unreadCount;
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetNotificationsOutput {
        const json = this.toJSON();
        let result = new GetNotificationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotificationWithCreator[] | undefined;
}

export class GetOrdersWithoutFollowUpOutput implements IGetOrdersWithoutFollowUpOutput {
    orderId: number;
    orderNumber: string | undefined;
    orderLocationId: number;
    customerLocation: CustomerLocation;
    productName: string | undefined;
    providerName: string | undefined;
    orderStatus: string | undefined;
    customerName: string | undefined;

    constructor(data?: IGetOrdersWithoutFollowUpOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.orderLocationId = _data['orderLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocation.fromJS(_data['customerLocation']) : <any>undefined;
            this.productName = _data['productName'];
            this.providerName = _data['providerName'];
            this.orderStatus = _data['orderStatus'];
            this.customerName = _data['customerName'];
        }
    }

    static fromJS(data: any): GetOrdersWithoutFollowUpOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersWithoutFollowUpOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['orderLocationId'] = this.orderLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['productName'] = this.productName;
        data['providerName'] = this.providerName;
        data['orderStatus'] = this.orderStatus;
        data['customerName'] = this.customerName;
        return data;
    }

    clone(): GetOrdersWithoutFollowUpOutput {
        const json = this.toJSON();
        let result = new GetOrdersWithoutFollowUpOutput();
        result.init(json);
        return result;
    }
}

export interface IGetOrdersWithoutFollowUpOutput {
    orderId: number;
    orderNumber: string | undefined;
    orderLocationId: number;
    customerLocation: CustomerLocation;
    productName: string | undefined;
    providerName: string | undefined;
    orderStatus: string | undefined;
    customerName: string | undefined;
}

export class GetProductAttributeTypeSortedByIsAssignedOutput implements IGetProductAttributeTypeSortedByIsAssignedOutput {
    productAttributeTypeList: ProductAttributeTypeListDto;
    isAssigned: boolean;

    constructor(data?: IGetProductAttributeTypeSortedByIsAssignedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productAttributeTypeList = new ProductAttributeTypeListDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productAttributeTypeList = _data['productAttributeTypeList']
                ? ProductAttributeTypeListDto.fromJS(_data['productAttributeTypeList'])
                : new ProductAttributeTypeListDto();
            this.isAssigned = _data['isAssigned'];
        }
    }

    static fromJS(data: any): GetProductAttributeTypeSortedByIsAssignedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductAttributeTypeSortedByIsAssignedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productAttributeTypeList'] = this.productAttributeTypeList ? this.productAttributeTypeList.toJSON() : <any>undefined;
        data['isAssigned'] = this.isAssigned;
        return data;
    }

    clone(): GetProductAttributeTypeSortedByIsAssignedOutput {
        const json = this.toJSON();
        let result = new GetProductAttributeTypeSortedByIsAssignedOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProductAttributeTypeSortedByIsAssignedOutput {
    productAttributeTypeList: ProductAttributeTypeListDto;
    isAssigned: boolean;
}

export class GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto
    implements IGetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto
{
    totalCount: number;
    items: GetProductAttributeTypeSortedByIsAssignedOutput[] | undefined;

    constructor(data?: IGetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(GetProductAttributeTypeSortedByIsAssignedOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto {
        const json = this.toJSON();
        let result = new GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto {
    totalCount: number;
    items: GetProductAttributeTypeSortedByIsAssignedOutput[] | undefined;
}

export class GetProductAttributeTypesForEditOutput implements IGetProductAttributeTypesForEditOutput {
    productAttributeType: ProductAttributeTypeEditDto;

    constructor(data?: IGetProductAttributeTypesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productAttributeType = _data['productAttributeType']
                ? ProductAttributeTypeEditDto.fromJS(_data['productAttributeType'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductAttributeTypesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductAttributeTypesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productAttributeType'] = this.productAttributeType ? this.productAttributeType.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProductAttributeTypesForEditOutput {
        const json = this.toJSON();
        let result = new GetProductAttributeTypesForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProductAttributeTypesForEditOutput {
    productAttributeType: ProductAttributeTypeEditDto;
}

export class GetProductForEditOutput implements IGetProductForEditOutput {
    product: ProductEditDto;

    constructor(data?: IGetProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data['product'] ? ProductEditDto.fromJS(_data['product']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProductForEditOutput {
        const json = this.toJSON();
        let result = new GetProductForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProductForEditOutput {
    product: ProductEditDto;
}

export class GetProductMilestoneListDto implements IGetProductMilestoneListDto {
    productId: number;
    product: ProductListForProductMilestoneDto;
    milestoneId: number;
    milestone: MilestoneListForProductMilestoneDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;

    constructor(data?: IGetProductMilestoneListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductListForProductMilestoneDto.fromJS(_data['product']) : <any>undefined;
            this.milestoneId = _data['milestoneId'];
            this.milestone = _data['milestone'] ? MilestoneListForProductMilestoneDto.fromJS(_data['milestone']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductMilestoneListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMilestoneListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['milestoneId'] = this.milestoneId;
        data['milestone'] = this.milestone ? this.milestone.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetProductMilestoneListDto {
        const json = this.toJSON();
        let result = new GetProductMilestoneListDto();
        result.init(json);
        return result;
    }
}

export interface IGetProductMilestoneListDto {
    productId: number;
    product: ProductListForProductMilestoneDto;
    milestoneId: number;
    milestone: MilestoneListForProductMilestoneDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
}

export class GetProductMilestoneListDtoPagedResultDto implements IGetProductMilestoneListDtoPagedResultDto {
    totalCount: number;
    items: GetProductMilestoneListDto[] | undefined;

    constructor(data?: IGetProductMilestoneListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(GetProductMilestoneListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductMilestoneListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMilestoneListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProductMilestoneListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GetProductMilestoneListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetProductMilestoneListDtoPagedResultDto {
    totalCount: number;
    items: GetProductMilestoneListDto[] | undefined;
}

export class GetProductMilestoneSortedByIsAssignedOutput implements IGetProductMilestoneSortedByIsAssignedOutput {
    milestoneList: MilestoneListDto;
    isAssigned: boolean;

    constructor(data?: IGetProductMilestoneSortedByIsAssignedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.milestoneList = new MilestoneListDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.milestoneList = _data['milestoneList'] ? MilestoneListDto.fromJS(_data['milestoneList']) : new MilestoneListDto();
            this.isAssigned = _data['isAssigned'];
        }
    }

    static fromJS(data: any): GetProductMilestoneSortedByIsAssignedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMilestoneSortedByIsAssignedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['milestoneList'] = this.milestoneList ? this.milestoneList.toJSON() : <any>undefined;
        data['isAssigned'] = this.isAssigned;
        return data;
    }

    clone(): GetProductMilestoneSortedByIsAssignedOutput {
        const json = this.toJSON();
        let result = new GetProductMilestoneSortedByIsAssignedOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProductMilestoneSortedByIsAssignedOutput {
    milestoneList: MilestoneListDto;
    isAssigned: boolean;
}

export class GetProductMilestoneSortedByIsAssignedOutputPagedResultDto
    implements IGetProductMilestoneSortedByIsAssignedOutputPagedResultDto
{
    totalCount: number;
    items: GetProductMilestoneSortedByIsAssignedOutput[] | undefined;

    constructor(data?: IGetProductMilestoneSortedByIsAssignedOutputPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(GetProductMilestoneSortedByIsAssignedOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductMilestoneSortedByIsAssignedOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMilestoneSortedByIsAssignedOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProductMilestoneSortedByIsAssignedOutputPagedResultDto {
        const json = this.toJSON();
        let result = new GetProductMilestoneSortedByIsAssignedOutputPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetProductMilestoneSortedByIsAssignedOutputPagedResultDto {
    totalCount: number;
    items: GetProductMilestoneSortedByIsAssignedOutput[] | undefined;
}

export class GetQuotesOrdersTicketsCountOutput implements IGetQuotesOrdersTicketsCountOutput {
    quotes: number;
    orders: number;
    tickets: number;

    constructor(data?: IGetQuotesOrdersTicketsCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotes = _data['quotes'];
            this.orders = _data['orders'];
            this.tickets = _data['tickets'];
        }
    }

    static fromJS(data: any): GetQuotesOrdersTicketsCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesOrdersTicketsCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quotes'] = this.quotes;
        data['orders'] = this.orders;
        data['tickets'] = this.tickets;
        return data;
    }

    clone(): GetQuotesOrdersTicketsCountOutput {
        const json = this.toJSON();
        let result = new GetQuotesOrdersTicketsCountOutput();
        result.init(json);
        return result;
    }
}

export interface IGetQuotesOrdersTicketsCountOutput {
    quotes: number;
    orders: number;
    tickets: number;
}

export class GetQuotesWithoutFollowUpOutput implements IGetQuotesWithoutFollowUpOutput {
    quoteId: number;
    quoteNumber: string | undefined;
    quoteStage: string | undefined;

    constructor(data?: IGetQuotesWithoutFollowUpOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.quoteNumber = _data['quoteNumber'];
            this.quoteStage = _data['quoteStage'];
        }
    }

    static fromJS(data: any): GetQuotesWithoutFollowUpOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesWithoutFollowUpOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['quoteNumber'] = this.quoteNumber;
        data['quoteStage'] = this.quoteStage;
        return data;
    }

    clone(): GetQuotesWithoutFollowUpOutput {
        const json = this.toJSON();
        let result = new GetQuotesWithoutFollowUpOutput();
        result.init(json);
        return result;
    }
}

export interface IGetQuotesWithoutFollowUpOutput {
    quoteId: number;
    quoteNumber: string | undefined;
    quoteStage: string | undefined;
}

export class GetTicketsWithoutFollowUpOutput implements IGetTicketsWithoutFollowUpOutput {
    id: number;
    ticketNumber: string | undefined;
    ticketStatus: string | undefined;

    constructor(data?: IGetTicketsWithoutFollowUpOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.ticketNumber = _data['ticketNumber'];
            this.ticketStatus = _data['ticketStatus'];
        }
    }

    static fromJS(data: any): GetTicketsWithoutFollowUpOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketsWithoutFollowUpOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['ticketNumber'] = this.ticketNumber;
        data['ticketStatus'] = this.ticketStatus;
        return data;
    }

    clone(): GetTicketsWithoutFollowUpOutput {
        const json = this.toJSON();
        let result = new GetTicketsWithoutFollowUpOutput();
        result.init(json);
        return result;
    }
}

export interface IGetTicketsWithoutFollowUpOutput {
    id: number;
    ticketNumber: string | undefined;
    ticketStatus: string | undefined;
}

export class GetUserListForActivityOutput implements IGetUserListForActivityOutput {
    id: number;
    name: string | undefined;
    surname: string | undefined;

    constructor(data?: IGetUserListForActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
        }
    }

    static fromJS(data: any): GetUserListForActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListForActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        return data;
    }

    clone(): GetUserListForActivityOutput {
        const json = this.toJSON();
        let result = new GetUserListForActivityOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserListForActivityOutput {
    id: number;
    name: string | undefined;
    surname: string | undefined;
}

export interface IGuidEntityDto {
    id: string;
}

export class ImportTemplateDto implements IImportTemplateDto {
    name: string | undefined;
    importTypeId: number;
    importTypeName: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IImportTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.importTypeId = _data['importTypeId'];
            this.importTypeName = _data['importTypeName'];
            this.description = _data['description'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ImportTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['importTypeId'] = this.importTypeId;
        data['importTypeName'] = this.importTypeName;
        data['description'] = this.description;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ImportTemplateDto {
        const json = this.toJSON();
        let result = new ImportTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IImportTemplateDto {
    name: string | undefined;
    importTypeId: number;
    importTypeName: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ImportTemplateEditDto implements IImportTemplateEditDto {
    importTemplateMappableFieldDetails: ImportTemplateMappableEditFieldDto[] | undefined;
    importTypeDetailDropdowns: ImportTypeDetailDropdownDto[] | undefined;
    name: string | undefined;
    importTypeId: number;
    importTypeName: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IImportTemplateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['importTemplateMappableFieldDetails'])) {
                this.importTemplateMappableFieldDetails = [] as any;
                for (let item of _data['importTemplateMappableFieldDetails'])
                    this.importTemplateMappableFieldDetails.push(ImportTemplateMappableEditFieldDto.fromJS(item));
            }
            if (Array.isArray(_data['importTypeDetailDropdowns'])) {
                this.importTypeDetailDropdowns = [] as any;
                for (let item of _data['importTypeDetailDropdowns'])
                    this.importTypeDetailDropdowns.push(ImportTypeDetailDropdownDto.fromJS(item));
            }
            this.name = _data['name'];
            this.importTypeId = _data['importTypeId'];
            this.importTypeName = _data['importTypeName'];
            this.description = _data['description'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ImportTemplateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTemplateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importTemplateMappableFieldDetails)) {
            data['importTemplateMappableFieldDetails'] = [];
            for (let item of this.importTemplateMappableFieldDetails) data['importTemplateMappableFieldDetails'].push(item.toJSON());
        }
        if (Array.isArray(this.importTypeDetailDropdowns)) {
            data['importTypeDetailDropdowns'] = [];
            for (let item of this.importTypeDetailDropdowns) data['importTypeDetailDropdowns'].push(item.toJSON());
        }
        data['name'] = this.name;
        data['importTypeId'] = this.importTypeId;
        data['importTypeName'] = this.importTypeName;
        data['description'] = this.description;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ImportTemplateEditDto {
        const json = this.toJSON();
        let result = new ImportTemplateEditDto();
        result.init(json);
        return result;
    }
}

export interface IImportTemplateEditDto {
    importTemplateMappableFieldDetails: ImportTemplateMappableEditFieldDto[] | undefined;
    importTypeDetailDropdowns: ImportTypeDetailDropdownDto[] | undefined;
    name: string | undefined;
    importTypeId: number;
    importTypeName: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ImportTemplateMappableEditFieldDto implements IImportTemplateMappableEditFieldDto {
    readonly importTemplateDetailId: number | undefined;
    readonly importTypeModuleId: number | undefined;
    readonly importTypeModuleName: string | undefined;
    readonly importTypeModuleFieldId: number | undefined;
    readonly importTypeModuleFieldName: string | undefined;
    readonly importMapFieldId: number | undefined;
    readonly importMapFieldTableName: string | undefined;
    readonly importMapFieldName: string | undefined;
    readonly isKey: boolean;
    readonly isRequired: boolean;
    readonly currentUploadedField: string | undefined;
    uploadedField: string | undefined;
    description: string | undefined;
    readonly table: string | undefined;
    readonly field: string | undefined;

    constructor(data?: IImportTemplateMappableEditFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).importTemplateDetailId = _data['importTemplateDetailId'];
            (<any>this).importTypeModuleId = _data['importTypeModuleId'];
            (<any>this).importTypeModuleName = _data['importTypeModuleName'];
            (<any>this).importTypeModuleFieldId = _data['importTypeModuleFieldId'];
            (<any>this).importTypeModuleFieldName = _data['importTypeModuleFieldName'];
            (<any>this).importMapFieldId = _data['importMapFieldId'];
            (<any>this).importMapFieldTableName = _data['importMapFieldTableName'];
            (<any>this).importMapFieldName = _data['importMapFieldName'];
            (<any>this).isKey = _data['isKey'];
            (<any>this).isRequired = _data['isRequired'];
            (<any>this).currentUploadedField = _data['currentUploadedField'];
            this.uploadedField = _data['uploadedField'];
            this.description = _data['description'];
            (<any>this).table = _data['table'];
            (<any>this).field = _data['field'];
        }
    }

    static fromJS(data: any): ImportTemplateMappableEditFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTemplateMappableEditFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTemplateDetailId'] = this.importTemplateDetailId;
        data['importTypeModuleId'] = this.importTypeModuleId;
        data['importTypeModuleName'] = this.importTypeModuleName;
        data['importTypeModuleFieldId'] = this.importTypeModuleFieldId;
        data['importTypeModuleFieldName'] = this.importTypeModuleFieldName;
        data['importMapFieldId'] = this.importMapFieldId;
        data['importMapFieldTableName'] = this.importMapFieldTableName;
        data['importMapFieldName'] = this.importMapFieldName;
        data['isKey'] = this.isKey;
        data['isRequired'] = this.isRequired;
        data['currentUploadedField'] = this.currentUploadedField;
        data['uploadedField'] = this.uploadedField;
        data['description'] = this.description;
        data['table'] = this.table;
        data['field'] = this.field;
        return data;
    }

    clone(): ImportTemplateMappableEditFieldDto {
        const json = this.toJSON();
        let result = new ImportTemplateMappableEditFieldDto();
        result.init(json);
        return result;
    }
}

export interface IImportTemplateMappableEditFieldDto {
    importTemplateDetailId: number | undefined;
    importTypeModuleId: number | undefined;
    importTypeModuleName: string | undefined;
    importTypeModuleFieldId: number | undefined;
    importTypeModuleFieldName: string | undefined;
    importMapFieldId: number | undefined;
    importMapFieldTableName: string | undefined;
    importMapFieldName: string | undefined;
    isKey: boolean;
    isRequired: boolean;
    currentUploadedField: string | undefined;
    uploadedField: string | undefined;
    description: string | undefined;
    table: string | undefined;
    field: string | undefined;
}

export class ImportTemplateMappableFieldDto implements IImportTemplateMappableFieldDto {
    readonly importTemplateDetailId: number | undefined;
    readonly importTypeModuleId: number | undefined;
    readonly importTypeModuleName: string | undefined;
    readonly importTypeModuleFieldId: number | undefined;
    readonly importTypeModuleFieldName: string | undefined;
    readonly importMapFieldId: number | undefined;
    readonly importMapFieldTableName: string | undefined;
    readonly importMapFieldName: string | undefined;
    readonly isKey: boolean;
    readonly isRequired: boolean;
    readonly currentUploadedField: string | undefined;
    uploadedField: string | undefined;
    description: string | undefined;
    readonly table: string | undefined;
    readonly field: string | undefined;

    constructor(data?: IImportTemplateMappableFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).importTemplateDetailId = _data['importTemplateDetailId'];
            (<any>this).importTypeModuleId = _data['importTypeModuleId'];
            (<any>this).importTypeModuleName = _data['importTypeModuleName'];
            (<any>this).importTypeModuleFieldId = _data['importTypeModuleFieldId'];
            (<any>this).importTypeModuleFieldName = _data['importTypeModuleFieldName'];
            (<any>this).importMapFieldId = _data['importMapFieldId'];
            (<any>this).importMapFieldTableName = _data['importMapFieldTableName'];
            (<any>this).importMapFieldName = _data['importMapFieldName'];
            (<any>this).isKey = _data['isKey'];
            (<any>this).isRequired = _data['isRequired'];
            (<any>this).currentUploadedField = _data['currentUploadedField'];
            this.uploadedField = _data['uploadedField'];
            this.description = _data['description'];
            (<any>this).table = _data['table'];
            (<any>this).field = _data['field'];
        }
    }

    static fromJS(data: any): ImportTemplateMappableFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTemplateMappableFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTemplateDetailId'] = this.importTemplateDetailId;
        data['importTypeModuleId'] = this.importTypeModuleId;
        data['importTypeModuleName'] = this.importTypeModuleName;
        data['importTypeModuleFieldId'] = this.importTypeModuleFieldId;
        data['importTypeModuleFieldName'] = this.importTypeModuleFieldName;
        data['importMapFieldId'] = this.importMapFieldId;
        data['importMapFieldTableName'] = this.importMapFieldTableName;
        data['importMapFieldName'] = this.importMapFieldName;
        data['isKey'] = this.isKey;
        data['isRequired'] = this.isRequired;
        data['currentUploadedField'] = this.currentUploadedField;
        data['uploadedField'] = this.uploadedField;
        data['description'] = this.description;
        data['table'] = this.table;
        data['field'] = this.field;
        return data;
    }

    clone(): ImportTemplateMappableFieldDto {
        const json = this.toJSON();
        let result = new ImportTemplateMappableFieldDto();
        result.init(json);
        return result;
    }
}

export interface IImportTemplateMappableFieldDto {
    importTemplateDetailId: number | undefined;
    importTypeModuleId: number | undefined;
    importTypeModuleName: string | undefined;
    importTypeModuleFieldId: number | undefined;
    importTypeModuleFieldName: string | undefined;
    importMapFieldId: number | undefined;
    importMapFieldTableName: string | undefined;
    importMapFieldName: string | undefined;
    isKey: boolean;
    isRequired: boolean;
    currentUploadedField: string | undefined;
    uploadedField: string | undefined;
    description: string | undefined;
    table: string | undefined;
    field: string | undefined;
}

export class ImportTypeDetailDropdownDto implements IImportTypeDetailDropdownDto {
    title: string | undefined;
    data: Int64IdNameDto[] | undefined;
    importTemplateImportTypeDetailId: number | undefined;
    importTypeDetailId: number;
    importTypeDetailValue: number | undefined;

    constructor(data?: IImportTypeDetailDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data['title'];
            if (Array.isArray(_data['data'])) {
                this.data = [] as any;
                for (let item of _data['data']) this.data.push(Int64IdNameDto.fromJS(item));
            }
            this.importTemplateImportTypeDetailId = _data['importTemplateImportTypeDetailId'];
            this.importTypeDetailId = _data['importTypeDetailId'];
            this.importTypeDetailValue = _data['importTypeDetailValue'];
        }
    }

    static fromJS(data: any): ImportTypeDetailDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTypeDetailDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['title'] = this.title;
        if (Array.isArray(this.data)) {
            data['data'] = [];
            for (let item of this.data) data['data'].push(item.toJSON());
        }
        data['importTemplateImportTypeDetailId'] = this.importTemplateImportTypeDetailId;
        data['importTypeDetailId'] = this.importTypeDetailId;
        data['importTypeDetailValue'] = this.importTypeDetailValue;
        return data;
    }

    clone(): ImportTypeDetailDropdownDto {
        const json = this.toJSON();
        let result = new ImportTypeDetailDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IImportTypeDetailDropdownDto {
    title: string | undefined;
    data: Int64IdNameDto[] | undefined;
    importTemplateImportTypeDetailId: number | undefined;
    importTypeDetailId: number;
    importTypeDetailValue: number | undefined;
}

export class ImportTypeDetailSummaryDto implements IImportTypeDetailSummaryDto {
    importTypeId: number;
    key: string | undefined;
    id: number;

    constructor(data?: IImportTypeDetailSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTypeId = _data['importTypeId'];
            this.key = _data['key'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ImportTypeDetailSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTypeDetailSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTypeId'] = this.importTypeId;
        data['key'] = this.key;
        data['id'] = this.id;
        return data;
    }

    clone(): ImportTypeDetailSummaryDto {
        const json = this.toJSON();
        let result = new ImportTypeDetailSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IImportTypeDetailSummaryDto {
    importTypeId: number;
    key: string | undefined;
    id: number;
}

export class ImportTypeSummaryDto implements IImportTypeSummaryDto {
    name: string | undefined;
    canSee: boolean;
    id: number;

    constructor(data?: IImportTypeSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.canSee = _data['canSee'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ImportTypeSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTypeSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['canSee'] = this.canSee;
        data['id'] = this.id;
        return data;
    }

    clone(): ImportTypeSummaryDto {
        const json = this.toJSON();
        let result = new ImportTypeSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IImportTypeSummaryDto {
    name: string | undefined;
    canSee: boolean;
    id: number;
}

export class ImportUploadInput implements IImportUploadInput {
    importTypeId: number;
    importTemplateId: number;
    uploadedFileName: string | undefined;
    importTemplateImportTypeDetails: EditImportTemplateImportTypeDetailInput[] | undefined;

    constructor(data?: IImportUploadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importTypeId = _data['importTypeId'];
            this.importTemplateId = _data['importTemplateId'];
            this.uploadedFileName = _data['uploadedFileName'];
            if (Array.isArray(_data['importTemplateImportTypeDetails'])) {
                this.importTemplateImportTypeDetails = [] as any;
                for (let item of _data['importTemplateImportTypeDetails'])
                    this.importTemplateImportTypeDetails.push(EditImportTemplateImportTypeDetailInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportUploadInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportUploadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['importTypeId'] = this.importTypeId;
        data['importTemplateId'] = this.importTemplateId;
        data['uploadedFileName'] = this.uploadedFileName;
        if (Array.isArray(this.importTemplateImportTypeDetails)) {
            data['importTemplateImportTypeDetails'] = [];
            for (let item of this.importTemplateImportTypeDetails) data['importTemplateImportTypeDetails'].push(item.toJSON());
        }
        return data;
    }

    clone(): ImportUploadInput {
        const json = this.toJSON();
        let result = new ImportUploadInput();
        result.init(json);
        return result;
    }
}

export interface IImportUploadInput {
    importTypeId: number;
    importTemplateId: number;
    uploadedFileName: string | undefined;
    importTemplateImportTypeDetails: EditImportTemplateImportTypeDetailInput[] | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data['key'];
            this.baseValue = _data['baseValue'];
            this.targetValue = _data['targetValue'];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['key'] = this.key;
        data['baseValue'] = this.baseValue;
        data['targetValue'] = this.targetValue;
        return data;
    }

    clone(): LanguageTextListDto {
        const json = this.toJSON();
        let result = new LanguageTextListDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LanguageTextListDtoPagedResultDto implements ILanguageTextListDtoPagedResultDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;

    constructor(data?: ILanguageTextListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageTextListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): LanguageTextListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LanguageTextListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageTextListDtoPagedResultDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class MarketplaceWebhook implements IMarketplaceWebhook {
    uuid: string | undefined;
    timestamp: number;
    resource: MarketplaceWebhookResource;
    resourceAction: MarketplaceWebhookResourceAction;

    constructor(data?: IMarketplaceWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resource = new MarketplaceWebhookResource();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data['uuid'];
            this.timestamp = _data['timestamp'];
            this.resource = _data['resource'] ? MarketplaceWebhookResource.fromJS(_data['resource']) : new MarketplaceWebhookResource();
            this.resourceAction = _data['resourceAction'];
        }
    }

    static fromJS(data: any): MarketplaceWebhook {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceWebhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['uuid'] = this.uuid;
        data['timestamp'] = this.timestamp;
        data['resource'] = this.resource ? this.resource.toJSON() : <any>undefined;
        data['resourceAction'] = this.resourceAction;
        return data;
    }

    clone(): MarketplaceWebhook {
        const json = this.toJSON();
        let result = new MarketplaceWebhook();
        result.init(json);
        return result;
    }
}

export interface IMarketplaceWebhook {
    uuid: string | undefined;
    timestamp: number;
    resource: MarketplaceWebhookResource;
    resourceAction: MarketplaceWebhookResourceAction;
}

export class MarketplaceWebhookResource implements IMarketplaceWebhookResource {
    type: MarketplaceWebhookResourceType;
    uuid: string | undefined;

    constructor(data?: IMarketplaceWebhookResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data['type'];
            this.uuid = _data['uuid'];
        }
    }

    static fromJS(data: any): MarketplaceWebhookResource {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceWebhookResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['type'] = this.type;
        data['uuid'] = this.uuid;
        return data;
    }

    clone(): MarketplaceWebhookResource {
        const json = this.toJSON();
        let result = new MarketplaceWebhookResource();
        result.init(json);
        return result;
    }
}

export interface IMarketplaceWebhookResource {
    type: MarketplaceWebhookResourceType;
    uuid: string | undefined;
}

export enum MarketplaceWebhookResourceAction {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum MarketplaceWebhookResourceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class MasterAgency implements IMasterAgency {
    tenantId: number | undefined;
    name: string;
    isMCRevenue: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMasterAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isMCRevenue = _data['isMCRevenue'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): MasterAgency {
        data = typeof data === 'object' ? data : {};
        let result = new MasterAgency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isMCRevenue'] = this.isMCRevenue;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): MasterAgency {
        const json = this.toJSON();
        let result = new MasterAgency();
        result.init(json);
        return result;
    }
}

export interface IMasterAgency {
    tenantId: number | undefined;
    name: string;
    isMCRevenue: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MasterAgencyListDto implements IMasterAgencyListDto {
    tenantId: number | undefined;
    name: string | undefined;
    isMCRevenue: boolean;
    id: number;

    constructor(data?: IMasterAgencyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isMCRevenue = _data['isMCRevenue'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): MasterAgencyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterAgencyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isMCRevenue'] = this.isMCRevenue;
        data['id'] = this.id;
        return data;
    }

    clone(): MasterAgencyListDto {
        const json = this.toJSON();
        let result = new MasterAgencyListDto();
        result.init(json);
        return result;
    }
}

export interface IMasterAgencyListDto {
    tenantId: number | undefined;
    name: string | undefined;
    isMCRevenue: boolean;
    id: number;
}

export class Milestone implements IMilestone {
    tenantId: number | undefined;
    name: string;
    isRequired: boolean;
    order: number;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    requiresNotification: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMilestone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isRequired = _data['isRequired'];
            this.order = _data['order'];
            this.notifyFrom = _data['notifyFrom'];
            this.notifySubject = _data['notifySubject'];
            this.notifyTemplate = _data['notifyTemplate'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.requiresNotification = _data['requiresNotification'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Milestone {
        data = typeof data === 'object' ? data : {};
        let result = new Milestone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isRequired'] = this.isRequired;
        data['order'] = this.order;
        data['notifyFrom'] = this.notifyFrom;
        data['notifySubject'] = this.notifySubject;
        data['notifyTemplate'] = this.notifyTemplate;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['requiresNotification'] = this.requiresNotification;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Milestone {
        const json = this.toJSON();
        let result = new Milestone();
        result.init(json);
        return result;
    }
}

export interface IMilestone {
    tenantId: number | undefined;
    name: string;
    isRequired: boolean;
    order: number;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    requiresNotification: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MilestoneDto implements IMilestoneDto {
    name: string | undefined;
    isRequired: boolean;
    requiresNotification: boolean;
    order: number;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    notifyOnUpdate: boolean;
    survey: SurveyDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMilestoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isRequired = _data['isRequired'];
            this.requiresNotification = _data['requiresNotification'];
            this.order = _data['order'];
            this.notifyFrom = _data['notifyFrom'];
            this.notifySubject = _data['notifySubject'];
            this.notifyTemplate = _data['notifyTemplate'];
            this.notifyOnUpdate = _data['notifyOnUpdate'];
            this.survey = _data['survey'] ? SurveyDto.fromJS(_data['survey']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): MilestoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isRequired'] = this.isRequired;
        data['requiresNotification'] = this.requiresNotification;
        data['order'] = this.order;
        data['notifyFrom'] = this.notifyFrom;
        data['notifySubject'] = this.notifySubject;
        data['notifyTemplate'] = this.notifyTemplate;
        data['notifyOnUpdate'] = this.notifyOnUpdate;
        data['survey'] = this.survey ? this.survey.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): MilestoneDto {
        const json = this.toJSON();
        let result = new MilestoneDto();
        result.init(json);
        return result;
    }
}

export interface IMilestoneDto {
    name: string | undefined;
    isRequired: boolean;
    requiresNotification: boolean;
    order: number;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    notifyOnUpdate: boolean;
    survey: SurveyDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MilestoneListDto implements IMilestoneListDto {
    name: string;
    isRequired: boolean;
    order: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    requiresNotification: boolean;
    id: number;

    constructor(data?: IMilestoneListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isRequired = _data['isRequired'];
            this.order = _data['order'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.requiresNotification = _data['requiresNotification'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): MilestoneListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isRequired'] = this.isRequired;
        data['order'] = this.order;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['requiresNotification'] = this.requiresNotification;
        data['id'] = this.id;
        return data;
    }

    clone(): MilestoneListDto {
        const json = this.toJSON();
        let result = new MilestoneListDto();
        result.init(json);
        return result;
    }
}

export interface IMilestoneListDto {
    name: string;
    isRequired: boolean;
    order: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    requiresNotification: boolean;
    id: number;
}

export class MilestoneListForProductMilestoneDto implements IMilestoneListForProductMilestoneDto {
    name: string;
    id: number;

    constructor(data?: IMilestoneListForProductMilestoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): MilestoneListForProductMilestoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneListForProductMilestoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): MilestoneListForProductMilestoneDto {
        const json = this.toJSON();
        let result = new MilestoneListForProductMilestoneDto();
        result.init(json);
        return result;
    }
}

export interface IMilestoneListForProductMilestoneDto {
    name: string;
    id: number;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.newParentId = _data['newParentId'];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['newParentId'] = this.newParentId;
        return data;
    }

    clone(): MoveOrganizationUnitInput {
        const json = this.toJSON();
        let result = new MoveOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class NameValueDtoListResultDto implements INameValueDtoListResultDto {
    items: NameValueDto[] | undefined;

    constructor(data?: INameValueDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NameValueDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): NameValueDtoListResultDto {
        const json = this.toJSON();
        let result = new NameValueDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface INameValueDtoListResultDto {
    items: NameValueDto[] | undefined;
}

export class NameValueDtoPagedResultDto implements INameValueDtoPagedResultDto {
    totalCount: number;
    items: NameValueDto[] | undefined;

    constructor(data?: INameValueDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NameValueDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): NameValueDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NameValueDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INameValueDtoPagedResultDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class NewProviderListNotificationInput implements INewProviderListNotificationInput {
    assignedUserId: number;
    providers: string | undefined;
    quoteNumber: number;
    quoteId: number;

    constructor(data?: INewProviderListNotificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUserId = _data['assignedUserId'];
            this.providers = _data['providers'];
            this.quoteNumber = _data['quoteNumber'];
            this.quoteId = _data['quoteId'];
        }
    }

    static fromJS(data: any): NewProviderListNotificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new NewProviderListNotificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['assignedUserId'] = this.assignedUserId;
        data['providers'] = this.providers;
        data['quoteNumber'] = this.quoteNumber;
        data['quoteId'] = this.quoteId;
        return data;
    }

    clone(): NewProviderListNotificationInput {
        const json = this.toJSON();
        let result = new NewProviderListNotificationInput();
        result.init(json);
        return result;
    }
}

export interface INewProviderListNotificationInput {
    assignedUserId: number;
    providers: string | undefined;
    quoteNumber: number;
    quoteId: number;
}

export class NotificationData implements INotificationData {
    readonly type: string | undefined;
    properties: { [key: string]: any } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data['type'];
            if (_data['properties']) {
                this.properties = {} as any;
                for (let key in _data['properties']) {
                    if (_data['properties'].hasOwnProperty(key)) this.properties[key] = _data['properties'][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['type'] = this.type;
        if (this.properties) {
            data['properties'] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key)) data['properties'][key] = this.properties[key];
            }
        }
        return data;
    }

    clone(): NotificationData {
        const json = this.toJSON();
        let result = new NotificationData();
        result.init(json);
        return result;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any } | undefined;
}

export enum NotificationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isSubscribed = _data['isSubscribed'];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isSubscribed'] = this.isSubscribed;
        return data;
    }

    clone(): NotificationSubscriptionDto {
        const json = this.toJSON();
        let result = new NotificationSubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.name = _data['name'];
            this.isSubscribed = _data['isSubscribed'];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['name'] = this.name;
        data['isSubscribed'] = this.isSubscribed;
        return data;
    }

    clone(): NotificationSubscriptionWithDisplayNameDto {
        const json = this.toJSON();
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export enum OpportunityContractType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OpportunityEditDto implements IOpportunityEditDto {
    name: string | undefined;
    ownerId: number;
    partnerId: number;
    salesAgentId: number | undefined;
    salesEngineerId: number | undefined;
    estimatedClosedDate: moment.Moment;
    probabilityToCloseId: number;
    status: OpportunityStatus;
    opportunityTypeId: number | undefined;
    opportunityStageId: number | undefined;
    contractType: OpportunityContractType;
    commissionSplit: number | undefined;
    contractTerm: number | undefined;
    providerCommissionRate: number | undefined;
    providerIds: number[] | undefined;
    productCategoryId: number | undefined;
    productId: number | undefined;
    mrr: number;
    nrc: number;
    notes: string | undefined;
    projectFee: number;
    readonly tcv: number | undefined;
    readonly margin: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOpportunityEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.ownerId = _data['ownerId'];
            this.partnerId = _data['partnerId'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesEngineerId = _data['salesEngineerId'];
            this.estimatedClosedDate = _data['estimatedClosedDate'] ? moment(_data['estimatedClosedDate'].toString()) : <any>undefined;
            this.probabilityToCloseId = _data['probabilityToCloseId'];
            this.status = _data['status'];
            this.opportunityTypeId = _data['opportunityTypeId'];
            this.opportunityStageId = _data['opportunityStageId'];
            this.contractType = _data['contractType'];
            this.commissionSplit = _data['commissionSplit'];
            this.contractTerm = _data['contractTerm'];
            this.providerCommissionRate = _data['providerCommissionRate'];
            if (Array.isArray(_data['providerIds'])) {
                this.providerIds = [] as any;
                for (let item of _data['providerIds']) this.providerIds.push(item);
            }
            this.productCategoryId = _data['productCategoryId'];
            this.productId = _data['productId'];
            this.mrr = _data['mrr'];
            this.nrc = _data['nrc'];
            this.notes = _data['notes'];
            this.projectFee = _data['projectFee'];
            (<any>this).tcv = _data['tcv'];
            (<any>this).margin = _data['margin'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OpportunityEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['ownerId'] = this.ownerId;
        data['partnerId'] = this.partnerId;
        data['salesAgentId'] = this.salesAgentId;
        data['salesEngineerId'] = this.salesEngineerId;
        data['estimatedClosedDate'] = this.estimatedClosedDate ? this.estimatedClosedDate.toISOString() : <any>undefined;
        data['probabilityToCloseId'] = this.probabilityToCloseId;
        data['status'] = this.status;
        data['opportunityTypeId'] = this.opportunityTypeId;
        data['opportunityStageId'] = this.opportunityStageId;
        data['contractType'] = this.contractType;
        data['commissionSplit'] = this.commissionSplit;
        data['contractTerm'] = this.contractTerm;
        data['providerCommissionRate'] = this.providerCommissionRate;
        if (Array.isArray(this.providerIds)) {
            data['providerIds'] = [];
            for (let item of this.providerIds) data['providerIds'].push(item);
        }
        data['productCategoryId'] = this.productCategoryId;
        data['productId'] = this.productId;
        data['mrr'] = this.mrr;
        data['nrc'] = this.nrc;
        data['notes'] = this.notes;
        data['projectFee'] = this.projectFee;
        data['tcv'] = this.tcv;
        data['margin'] = this.margin;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OpportunityEditDto {
        const json = this.toJSON();
        let result = new OpportunityEditDto();
        result.init(json);
        return result;
    }
}

export interface IOpportunityEditDto {
    name: string | undefined;
    ownerId: number;
    partnerId: number;
    salesAgentId: number | undefined;
    salesEngineerId: number | undefined;
    estimatedClosedDate: moment.Moment;
    probabilityToCloseId: number;
    status: OpportunityStatus;
    opportunityTypeId: number | undefined;
    opportunityStageId: number | undefined;
    contractType: OpportunityContractType;
    commissionSplit: number | undefined;
    contractTerm: number | undefined;
    providerCommissionRate: number | undefined;
    providerIds: number[] | undefined;
    productCategoryId: number | undefined;
    productId: number | undefined;
    mrr: number;
    nrc: number;
    notes: string | undefined;
    projectFee: number;
    tcv: number | undefined;
    margin: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OpportunityListDto implements IOpportunityListDto {
    name: string | undefined;
    ownerId: number;
    owner: string | undefined;
    spm: string | undefined;
    salesAgent: string | undefined;
    partnerId: number;
    partner: string | undefined;
    estimatedCloseDate: moment.Moment;
    readonly estimatedClosedDateReport: string | undefined;
    probabilityToClose: string | undefined;
    readonly probabilityToCloseString: string | undefined;
    readonly probabilityToCloseReport: string | undefined;
    status: OpportunityStatus;
    readonly statusString: string | undefined;
    opportunityType: string | undefined;
    opportunityStage: string | undefined;
    contractType: OpportunityContractType;
    readonly contractTypeString: string | undefined;
    providers: string | undefined;
    productCategoryId: number | undefined;
    productCategory: string | undefined;
    productId: number | undefined;
    product: string | undefined;
    mrr: number;
    readonly mrrReport: string | undefined;
    nrc: number;
    commissionSplit: number | undefined;
    contractTerm: number | undefined;
    providerCommissionRate: number | undefined;
    projectFee: number;
    readonly tcv: number | undefined;
    readonly margin: number | undefined;
    creationTime: moment.Moment;
    readonly creationTimeAsString: string | undefined;
    daysOld: number;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOpportunityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.ownerId = _data['ownerId'];
            this.owner = _data['owner'];
            this.spm = _data['spm'];
            this.salesAgent = _data['salesAgent'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            this.estimatedCloseDate = _data['estimatedCloseDate'] ? moment(_data['estimatedCloseDate'].toString()) : <any>undefined;
            (<any>this).estimatedClosedDateReport = _data['estimatedClosedDateReport'];
            this.probabilityToClose = _data['probabilityToClose'];
            (<any>this).probabilityToCloseString = _data['probabilityToCloseString'];
            (<any>this).probabilityToCloseReport = _data['probabilityToCloseReport'];
            this.status = _data['status'];
            (<any>this).statusString = _data['statusString'];
            this.opportunityType = _data['opportunityType'];
            this.opportunityStage = _data['opportunityStage'];
            this.contractType = _data['contractType'];
            (<any>this).contractTypeString = _data['contractTypeString'];
            this.providers = _data['providers'];
            this.productCategoryId = _data['productCategoryId'];
            this.productCategory = _data['productCategory'];
            this.productId = _data['productId'];
            this.product = _data['product'];
            this.mrr = _data['mrr'];
            (<any>this).mrrReport = _data['mrrReport'];
            this.nrc = _data['nrc'];
            this.commissionSplit = _data['commissionSplit'];
            this.contractTerm = _data['contractTerm'];
            this.providerCommissionRate = _data['providerCommissionRate'];
            this.projectFee = _data['projectFee'];
            (<any>this).tcv = _data['tcv'];
            (<any>this).margin = _data['margin'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            (<any>this).creationTimeAsString = _data['creationTimeAsString'];
            this.daysOld = _data['daysOld'];
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OpportunityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['ownerId'] = this.ownerId;
        data['owner'] = this.owner;
        data['spm'] = this.spm;
        data['salesAgent'] = this.salesAgent;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        data['estimatedCloseDate'] = this.estimatedCloseDate ? this.estimatedCloseDate.toISOString() : <any>undefined;
        data['estimatedClosedDateReport'] = this.estimatedClosedDateReport;
        data['probabilityToClose'] = this.probabilityToClose;
        data['probabilityToCloseString'] = this.probabilityToCloseString;
        data['probabilityToCloseReport'] = this.probabilityToCloseReport;
        data['status'] = this.status;
        data['statusString'] = this.statusString;
        data['opportunityType'] = this.opportunityType;
        data['opportunityStage'] = this.opportunityStage;
        data['contractType'] = this.contractType;
        data['contractTypeString'] = this.contractTypeString;
        data['providers'] = this.providers;
        data['productCategoryId'] = this.productCategoryId;
        data['productCategory'] = this.productCategory;
        data['productId'] = this.productId;
        data['product'] = this.product;
        data['mrr'] = this.mrr;
        data['mrrReport'] = this.mrrReport;
        data['nrc'] = this.nrc;
        data['commissionSplit'] = this.commissionSplit;
        data['contractTerm'] = this.contractTerm;
        data['providerCommissionRate'] = this.providerCommissionRate;
        data['projectFee'] = this.projectFee;
        data['tcv'] = this.tcv;
        data['margin'] = this.margin;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creationTimeAsString'] = this.creationTimeAsString;
        data['daysOld'] = this.daysOld;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OpportunityListDto {
        const json = this.toJSON();
        let result = new OpportunityListDto();
        result.init(json);
        return result;
    }
}

export interface IOpportunityListDto {
    name: string | undefined;
    ownerId: number;
    owner: string | undefined;
    spm: string | undefined;
    salesAgent: string | undefined;
    partnerId: number;
    partner: string | undefined;
    estimatedCloseDate: moment.Moment;
    estimatedClosedDateReport: string | undefined;
    probabilityToClose: string | undefined;
    probabilityToCloseString: string | undefined;
    probabilityToCloseReport: string | undefined;
    status: OpportunityStatus;
    statusString: string | undefined;
    opportunityType: string | undefined;
    opportunityStage: string | undefined;
    contractType: OpportunityContractType;
    contractTypeString: string | undefined;
    providers: string | undefined;
    productCategoryId: number | undefined;
    productCategory: string | undefined;
    productId: number | undefined;
    product: string | undefined;
    mrr: number;
    mrrReport: string | undefined;
    nrc: number;
    commissionSplit: number | undefined;
    contractTerm: number | undefined;
    providerCommissionRate: number | undefined;
    projectFee: number;
    tcv: number | undefined;
    margin: number | undefined;
    creationTime: moment.Moment;
    creationTimeAsString: string | undefined;
    daysOld: number;
    creatorUserId: number | undefined;
    id: number;
}

export class OpportunityStageEditDto implements IOpportunityStageEditDto {
    name: string | undefined;
    order: number;
    opportunityTypeId: number;
    opportunityType: OpportunityType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOpportunityStageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.order = _data['order'];
            this.opportunityTypeId = _data['opportunityTypeId'];
            this.opportunityType = _data['opportunityType'] ? OpportunityType.fromJS(_data['opportunityType']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OpportunityStageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityStageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['order'] = this.order;
        data['opportunityTypeId'] = this.opportunityTypeId;
        data['opportunityType'] = this.opportunityType ? this.opportunityType.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OpportunityStageEditDto {
        const json = this.toJSON();
        let result = new OpportunityStageEditDto();
        result.init(json);
        return result;
    }
}

export interface IOpportunityStageEditDto {
    name: string | undefined;
    order: number;
    opportunityTypeId: number;
    opportunityType: OpportunityType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OpportunityStageListDto implements IOpportunityStageListDto {
    name: string | undefined;
    order: number;
    opportunityTypeId: number;
    opportunityType: OpportunityType;
    readonly opportunityTypeName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOpportunityStageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.order = _data['order'];
            this.opportunityTypeId = _data['opportunityTypeId'];
            this.opportunityType = _data['opportunityType'] ? OpportunityType.fromJS(_data['opportunityType']) : <any>undefined;
            (<any>this).opportunityTypeName = _data['opportunityTypeName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OpportunityStageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityStageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['order'] = this.order;
        data['opportunityTypeId'] = this.opportunityTypeId;
        data['opportunityType'] = this.opportunityType ? this.opportunityType.toJSON() : <any>undefined;
        data['opportunityTypeName'] = this.opportunityTypeName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OpportunityStageListDto {
        const json = this.toJSON();
        let result = new OpportunityStageListDto();
        result.init(json);
        return result;
    }
}

export interface IOpportunityStageListDto {
    name: string | undefined;
    order: number;
    opportunityTypeId: number;
    opportunityType: OpportunityType;
    opportunityTypeName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum OpportunityStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OpportunityType implements IOpportunityType {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOpportunityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OpportunityType {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OpportunityType {
        const json = this.toJSON();
        let result = new OpportunityType();
        result.init(json);
        return result;
    }
}

export interface IOpportunityType {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Order implements IOrder {
    tenantId: number | undefined;
    orderNumber: string;
    customerId: number;
    customer: Customer;
    partnerId: number;
    partner: Partner;
    salesAgentId: number;
    salesAgent: User;
    salesEngineerId: number | undefined;
    salesEngineer: User;
    createAttribJson: string | undefined;
    orderStage: OrderStage;
    quoteId: number | undefined;
    quoteDetail: Quote;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    specialRateStatus: SpecialRateStatus;
    specialRateLockedDate: moment.Moment | undefined;
    salesCampaignId: number | undefined;
    salesCampaign: SalesCampaignEntity;
    internalSalesAgentId: number | undefined;
    internalSalesAgent: User;
    orderUsers: OrderUser[] | undefined;
    orderLocations: OrderLocation[] | undefined;
    orderDocuments: OrderDocument[] | undefined;
    orderActivities: OrderActivity[] | undefined;
    orderSalesAgents: OrderSalesAgent[] | undefined;
    readonly customerName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderNumber = _data['orderNumber'];
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? Customer.fromJS(_data['customer']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? User.fromJS(_data['salesAgent']) : <any>undefined;
            this.salesEngineerId = _data['salesEngineerId'];
            this.salesEngineer = _data['salesEngineer'] ? User.fromJS(_data['salesEngineer']) : <any>undefined;
            this.createAttribJson = _data['createAttribJson'];
            this.orderStage = _data['orderStage'];
            this.quoteId = _data['quoteId'];
            this.quoteDetail = _data['quoteDetail'] ? Quote.fromJS(_data['quoteDetail']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.specialRateStatus = _data['specialRateStatus'];
            this.specialRateLockedDate = _data['specialRateLockedDate']
                ? moment(_data['specialRateLockedDate'].toString())
                : <any>undefined;
            this.salesCampaignId = _data['salesCampaignId'];
            this.salesCampaign = _data['salesCampaign'] ? SalesCampaignEntity.fromJS(_data['salesCampaign']) : <any>undefined;
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            this.internalSalesAgent = _data['internalSalesAgent'] ? User.fromJS(_data['internalSalesAgent']) : <any>undefined;
            if (Array.isArray(_data['orderUsers'])) {
                this.orderUsers = [] as any;
                for (let item of _data['orderUsers']) this.orderUsers.push(OrderUser.fromJS(item));
            }
            if (Array.isArray(_data['orderLocations'])) {
                this.orderLocations = [] as any;
                for (let item of _data['orderLocations']) this.orderLocations.push(OrderLocation.fromJS(item));
            }
            if (Array.isArray(_data['orderDocuments'])) {
                this.orderDocuments = [] as any;
                for (let item of _data['orderDocuments']) this.orderDocuments.push(OrderDocument.fromJS(item));
            }
            if (Array.isArray(_data['orderActivities'])) {
                this.orderActivities = [] as any;
                for (let item of _data['orderActivities']) this.orderActivities.push(OrderActivity.fromJS(item));
            }
            if (Array.isArray(_data['orderSalesAgents'])) {
                this.orderSalesAgents = [] as any;
                for (let item of _data['orderSalesAgents']) this.orderSalesAgents.push(OrderSalesAgent.fromJS(item));
            }
            (<any>this).customerName = _data['customerName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderNumber'] = this.orderNumber;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        data['salesEngineerId'] = this.salesEngineerId;
        data['salesEngineer'] = this.salesEngineer ? this.salesEngineer.toJSON() : <any>undefined;
        data['createAttribJson'] = this.createAttribJson;
        data['orderStage'] = this.orderStage;
        data['quoteId'] = this.quoteId;
        data['quoteDetail'] = this.quoteDetail ? this.quoteDetail.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['specialRateStatus'] = this.specialRateStatus;
        data['specialRateLockedDate'] = this.specialRateLockedDate ? this.specialRateLockedDate.toISOString() : <any>undefined;
        data['salesCampaignId'] = this.salesCampaignId;
        data['salesCampaign'] = this.salesCampaign ? this.salesCampaign.toJSON() : <any>undefined;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        data['internalSalesAgent'] = this.internalSalesAgent ? this.internalSalesAgent.toJSON() : <any>undefined;
        if (Array.isArray(this.orderUsers)) {
            data['orderUsers'] = [];
            for (let item of this.orderUsers) data['orderUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocations)) {
            data['orderLocations'] = [];
            for (let item of this.orderLocations) data['orderLocations'].push(item.toJSON());
        }
        if (Array.isArray(this.orderDocuments)) {
            data['orderDocuments'] = [];
            for (let item of this.orderDocuments) data['orderDocuments'].push(item.toJSON());
        }
        if (Array.isArray(this.orderActivities)) {
            data['orderActivities'] = [];
            for (let item of this.orderActivities) data['orderActivities'].push(item.toJSON());
        }
        if (Array.isArray(this.orderSalesAgents)) {
            data['orderSalesAgents'] = [];
            for (let item of this.orderSalesAgents) data['orderSalesAgents'].push(item.toJSON());
        }
        data['customerName'] = this.customerName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    tenantId: number | undefined;
    orderNumber: string;
    customerId: number;
    customer: Customer;
    partnerId: number;
    partner: Partner;
    salesAgentId: number;
    salesAgent: User;
    salesEngineerId: number | undefined;
    salesEngineer: User;
    createAttribJson: string | undefined;
    orderStage: OrderStage;
    quoteId: number | undefined;
    quoteDetail: Quote;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    specialRateStatus: SpecialRateStatus;
    specialRateLockedDate: moment.Moment | undefined;
    salesCampaignId: number | undefined;
    salesCampaign: SalesCampaignEntity;
    internalSalesAgentId: number | undefined;
    internalSalesAgent: User;
    orderUsers: OrderUser[] | undefined;
    orderLocations: OrderLocation[] | undefined;
    orderDocuments: OrderDocument[] | undefined;
    orderActivities: OrderActivity[] | undefined;
    orderSalesAgents: OrderSalesAgent[] | undefined;
    customerName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderActivity implements IOrderActivity {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    activityId: number;
    activity: Activity;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? Order.fromJS(_data['order']) : <any>undefined;
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.activityId = _data['activityId'];
            this.activity = _data['activity'] ? Activity.fromJS(_data['activity']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderActivity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['activityId'] = this.activityId;
        data['activity'] = this.activity ? this.activity.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderActivity {
        const json = this.toJSON();
        let result = new OrderActivity();
        result.init(json);
        return result;
    }
}

export interface IOrderActivity {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    activityId: number;
    activity: Activity;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderDocument implements IOrderDocument {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    name: string;
    documentId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? Order.fromJS(_data['order']) : <any>undefined;
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.name = _data['name'];
            this.documentId = _data['documentId'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderDocument {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['documentId'] = this.documentId;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderDocument {
        const json = this.toJSON();
        let result = new OrderDocument();
        result.init(json);
        return result;
    }
}

export interface IOrderDocument {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    orderLocationDetailId: number | undefined;
    orderLocationDetail: OrderLocationDetail;
    name: string;
    documentId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderIdOrderNumberDto implements IOrderIdOrderNumberDto {
    orderId: number;
    orderNumber: string | undefined;

    constructor(data?: IOrderIdOrderNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
        }
    }

    static fromJS(data: any): OrderIdOrderNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderIdOrderNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        return data;
    }

    clone(): OrderIdOrderNumberDto {
        const json = this.toJSON();
        let result = new OrderIdOrderNumberDto();
        result.init(json);
        return result;
    }
}

export interface IOrderIdOrderNumberDto {
    orderId: number;
    orderNumber: string | undefined;
}

export class OrderLocation implements IOrderLocation {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    customerLocationId: number;
    customerLocation: CustomerLocation;
    orderLocationDetails: OrderLocationDetail[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? Order.fromJS(_data['order']) : <any>undefined;
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocation.fromJS(_data['customerLocation']) : <any>undefined;
            if (Array.isArray(_data['orderLocationDetails'])) {
                this.orderLocationDetails = [] as any;
                for (let item of _data['orderLocationDetails']) this.orderLocationDetails.push(OrderLocationDetail.fromJS(item));
            }
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocation {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLocationDetails)) {
            data['orderLocationDetails'] = [];
            for (let item of this.orderLocationDetails) data['orderLocationDetails'].push(item.toJSON());
        }
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocation {
        const json = this.toJSON();
        let result = new OrderLocation();
        result.init(json);
        return result;
    }
}

export interface IOrderLocation {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    customerLocationId: number;
    customerLocation: CustomerLocation;
    orderLocationDetails: OrderLocationDetail[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetail implements IOrderLocationDetail {
    tenantId: number | undefined;
    orderLocationId: number;
    orderLocation: OrderLocation;
    productId: number;
    product: Product;
    providerId: number;
    provider: Provider;
    orderStatusId: number;
    orderStatus: OrderStatus;
    currentOrderLocationDetailContractId: number | undefined;
    currentOrderLocationDetailContract: OrderLocationDetailContract;
    currentOrderLocationDetailMilestoneReceivedId: number | undefined;
    currentOrderLocationDetailMilestoneReceived: OrderLocationDetailMilestone;
    requestedProvisionDate: moment.Moment | undefined;
    orderStatusDate: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    corporateAccountNumber: string | undefined;
    providerOrderNumber: string | undefined;
    orderLocationDetailStatuses: OrderLocationDetailStatus[] | undefined;
    orderLocationDetailMilestones: OrderLocationDetailMilestone[] | undefined;
    orderLocationDetailProductAttributes: OrderLocationDetailProductAttribute[] | undefined;
    orderLocationDetailContracts: OrderLocationDetailContract[] | undefined;
    orderLocationDetailAssets: Asset[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    partnerOrderNumber: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationId = _data['orderLocationId'];
            this.orderLocation = _data['orderLocation'] ? OrderLocation.fromJS(_data['orderLocation']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? Product.fromJS(_data['product']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? Provider.fromJS(_data['provider']) : <any>undefined;
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatus = _data['orderStatus'] ? OrderStatus.fromJS(_data['orderStatus']) : <any>undefined;
            this.currentOrderLocationDetailContractId = _data['currentOrderLocationDetailContractId'];
            this.currentOrderLocationDetailContract = _data['currentOrderLocationDetailContract']
                ? OrderLocationDetailContract.fromJS(_data['currentOrderLocationDetailContract'])
                : <any>undefined;
            this.currentOrderLocationDetailMilestoneReceivedId = _data['currentOrderLocationDetailMilestoneReceivedId'];
            this.currentOrderLocationDetailMilestoneReceived = _data['currentOrderLocationDetailMilestoneReceived']
                ? OrderLocationDetailMilestone.fromJS(_data['currentOrderLocationDetailMilestoneReceived'])
                : <any>undefined;
            this.requestedProvisionDate = _data['requestedProvisionDate']
                ? moment(_data['requestedProvisionDate'].toString())
                : <any>undefined;
            this.orderStatusDate = _data['orderStatusDate'] ? moment(_data['orderStatusDate'].toString()) : <any>undefined;
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.corporateAccountNumber = _data['corporateAccountNumber'];
            this.providerOrderNumber = _data['providerOrderNumber'];
            if (Array.isArray(_data['orderLocationDetailStatuses'])) {
                this.orderLocationDetailStatuses = [] as any;
                for (let item of _data['orderLocationDetailStatuses'])
                    this.orderLocationDetailStatuses.push(OrderLocationDetailStatus.fromJS(item));
            }
            if (Array.isArray(_data['orderLocationDetailMilestones'])) {
                this.orderLocationDetailMilestones = [] as any;
                for (let item of _data['orderLocationDetailMilestones'])
                    this.orderLocationDetailMilestones.push(OrderLocationDetailMilestone.fromJS(item));
            }
            if (Array.isArray(_data['orderLocationDetailProductAttributes'])) {
                this.orderLocationDetailProductAttributes = [] as any;
                for (let item of _data['orderLocationDetailProductAttributes'])
                    this.orderLocationDetailProductAttributes.push(OrderLocationDetailProductAttribute.fromJS(item));
            }
            if (Array.isArray(_data['orderLocationDetailContracts'])) {
                this.orderLocationDetailContracts = [] as any;
                for (let item of _data['orderLocationDetailContracts'])
                    this.orderLocationDetailContracts.push(OrderLocationDetailContract.fromJS(item));
            }
            if (Array.isArray(_data['orderLocationDetailAssets'])) {
                this.orderLocationDetailAssets = [] as any;
                for (let item of _data['orderLocationDetailAssets']) this.orderLocationDetailAssets.push(Asset.fromJS(item));
            }
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationId'] = this.orderLocationId;
        data['orderLocation'] = this.orderLocation ? this.orderLocation.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatus'] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data['currentOrderLocationDetailContractId'] = this.currentOrderLocationDetailContractId;
        data['currentOrderLocationDetailContract'] = this.currentOrderLocationDetailContract
            ? this.currentOrderLocationDetailContract.toJSON()
            : <any>undefined;
        data['currentOrderLocationDetailMilestoneReceivedId'] = this.currentOrderLocationDetailMilestoneReceivedId;
        data['currentOrderLocationDetailMilestoneReceived'] = this.currentOrderLocationDetailMilestoneReceived
            ? this.currentOrderLocationDetailMilestoneReceived.toJSON()
            : <any>undefined;
        data['requestedProvisionDate'] = this.requestedProvisionDate ? this.requestedProvisionDate.toISOString() : <any>undefined;
        data['orderStatusDate'] = this.orderStatusDate ? this.orderStatusDate.toISOString() : <any>undefined;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['corporateAccountNumber'] = this.corporateAccountNumber;
        data['providerOrderNumber'] = this.providerOrderNumber;
        if (Array.isArray(this.orderLocationDetailStatuses)) {
            data['orderLocationDetailStatuses'] = [];
            for (let item of this.orderLocationDetailStatuses) data['orderLocationDetailStatuses'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocationDetailMilestones)) {
            data['orderLocationDetailMilestones'] = [];
            for (let item of this.orderLocationDetailMilestones) data['orderLocationDetailMilestones'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocationDetailProductAttributes)) {
            data['orderLocationDetailProductAttributes'] = [];
            for (let item of this.orderLocationDetailProductAttributes) data['orderLocationDetailProductAttributes'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocationDetailContracts)) {
            data['orderLocationDetailContracts'] = [];
            for (let item of this.orderLocationDetailContracts) data['orderLocationDetailContracts'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocationDetailAssets)) {
            data['orderLocationDetailAssets'] = [];
            for (let item of this.orderLocationDetailAssets) data['orderLocationDetailAssets'].push(item.toJSON());
        }
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetail {
        const json = this.toJSON();
        let result = new OrderLocationDetail();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetail {
    tenantId: number | undefined;
    orderLocationId: number;
    orderLocation: OrderLocation;
    productId: number;
    product: Product;
    providerId: number;
    provider: Provider;
    orderStatusId: number;
    orderStatus: OrderStatus;
    currentOrderLocationDetailContractId: number | undefined;
    currentOrderLocationDetailContract: OrderLocationDetailContract;
    currentOrderLocationDetailMilestoneReceivedId: number | undefined;
    currentOrderLocationDetailMilestoneReceived: OrderLocationDetailMilestone;
    requestedProvisionDate: moment.Moment | undefined;
    orderStatusDate: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    corporateAccountNumber: string | undefined;
    providerOrderNumber: string | undefined;
    orderLocationDetailStatuses: OrderLocationDetailStatus[] | undefined;
    orderLocationDetailMilestones: OrderLocationDetailMilestone[] | undefined;
    orderLocationDetailProductAttributes: OrderLocationDetailProductAttribute[] | undefined;
    orderLocationDetailContracts: OrderLocationDetailContract[] | undefined;
    orderLocationDetailAssets: Asset[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    partnerOrderNumber: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailContract implements IOrderLocationDetailContract {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    contractTermId: number;
    contractTerm: ContractTerm;
    contractTypeId: number;
    contractType: ContractType;
    contractSigned: moment.Moment | undefined;
    contractStart: moment.Moment | undefined;
    contractEnd: moment.Moment | undefined;
    mrr: number | undefined;
    nrr: number | undefined;
    salesCommissionAdj: number | undefined;
    productCode: string | undefined;
    providerQuoteNumber: string | undefined;
    providerContractNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.contractTermId = _data['contractTermId'];
            this.contractTerm = _data['contractTerm'] ? ContractTerm.fromJS(_data['contractTerm']) : <any>undefined;
            this.contractTypeId = _data['contractTypeId'];
            this.contractType = _data['contractType'] ? ContractType.fromJS(_data['contractType']) : <any>undefined;
            this.contractSigned = _data['contractSigned'] ? moment(_data['contractSigned'].toString()) : <any>undefined;
            this.contractStart = _data['contractStart'] ? moment(_data['contractStart'].toString()) : <any>undefined;
            this.contractEnd = _data['contractEnd'] ? moment(_data['contractEnd'].toString()) : <any>undefined;
            this.mrr = _data['mrr'];
            this.nrr = _data['nrr'];
            this.salesCommissionAdj = _data['salesCommissionAdj'];
            this.productCode = _data['productCode'];
            this.providerQuoteNumber = _data['providerQuoteNumber'];
            this.providerContractNumber = _data['providerContractNumber'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailContract {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['contractTermId'] = this.contractTermId;
        data['contractTerm'] = this.contractTerm ? this.contractTerm.toJSON() : <any>undefined;
        data['contractTypeId'] = this.contractTypeId;
        data['contractType'] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data['contractSigned'] = this.contractSigned ? this.contractSigned.toISOString() : <any>undefined;
        data['contractStart'] = this.contractStart ? this.contractStart.toISOString() : <any>undefined;
        data['contractEnd'] = this.contractEnd ? this.contractEnd.toISOString() : <any>undefined;
        data['mrr'] = this.mrr;
        data['nrr'] = this.nrr;
        data['salesCommissionAdj'] = this.salesCommissionAdj;
        data['productCode'] = this.productCode;
        data['providerQuoteNumber'] = this.providerQuoteNumber;
        data['providerContractNumber'] = this.providerContractNumber;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailContract {
        const json = this.toJSON();
        let result = new OrderLocationDetailContract();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailContract {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    contractTermId: number;
    contractTerm: ContractTerm;
    contractTypeId: number;
    contractType: ContractType;
    contractSigned: moment.Moment | undefined;
    contractStart: moment.Moment | undefined;
    contractEnd: moment.Moment | undefined;
    mrr: number | undefined;
    nrr: number | undefined;
    salesCommissionAdj: number | undefined;
    productCode: string | undefined;
    providerQuoteNumber: string | undefined;
    providerContractNumber: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailDto implements IOrderLocationDetailDto {
    tenantId: number | undefined;
    orderLocationId: number;
    productId: number;
    product: ProductEditDto;
    providerId: number;
    provider: ProviderEditDto;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    requestedProvisionDate: moment.Moment | undefined;
    orderStatusDate: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    corporateAccountNumber: string | undefined;
    providerOrderNumber: string | undefined;
    orderLocationDetailMilestones: OrderLocationDetailMilestoneEditDto[] | undefined;
    orderLocationDetailContracts: OrderLocationDetailContractEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationId = _data['orderLocationId'];
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductEditDto.fromJS(_data['product']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatus = _data['orderStatus'] ? OrderStatusEditDto.fromJS(_data['orderStatus']) : <any>undefined;
            this.requestedProvisionDate = _data['requestedProvisionDate']
                ? moment(_data['requestedProvisionDate'].toString())
                : <any>undefined;
            this.orderStatusDate = _data['orderStatusDate'] ? moment(_data['orderStatusDate'].toString()) : <any>undefined;
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.corporateAccountNumber = _data['corporateAccountNumber'];
            this.providerOrderNumber = _data['providerOrderNumber'];
            if (Array.isArray(_data['orderLocationDetailMilestones'])) {
                this.orderLocationDetailMilestones = [] as any;
                for (let item of _data['orderLocationDetailMilestones'])
                    this.orderLocationDetailMilestones.push(OrderLocationDetailMilestoneEditDto.fromJS(item));
            }
            if (Array.isArray(_data['orderLocationDetailContracts'])) {
                this.orderLocationDetailContracts = [] as any;
                for (let item of _data['orderLocationDetailContracts'])
                    this.orderLocationDetailContracts.push(OrderLocationDetailContractEditDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationId'] = this.orderLocationId;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatus'] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data['requestedProvisionDate'] = this.requestedProvisionDate ? this.requestedProvisionDate.toISOString() : <any>undefined;
        data['orderStatusDate'] = this.orderStatusDate ? this.orderStatusDate.toISOString() : <any>undefined;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['corporateAccountNumber'] = this.corporateAccountNumber;
        data['providerOrderNumber'] = this.providerOrderNumber;
        if (Array.isArray(this.orderLocationDetailMilestones)) {
            data['orderLocationDetailMilestones'] = [];
            for (let item of this.orderLocationDetailMilestones) data['orderLocationDetailMilestones'].push(item.toJSON());
        }
        if (Array.isArray(this.orderLocationDetailContracts)) {
            data['orderLocationDetailContracts'] = [];
            for (let item of this.orderLocationDetailContracts) data['orderLocationDetailContracts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailDto {
        const json = this.toJSON();
        let result = new OrderLocationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailDto {
    tenantId: number | undefined;
    orderLocationId: number;
    productId: number;
    product: ProductEditDto;
    providerId: number;
    provider: ProviderEditDto;
    orderStatusId: number;
    orderStatus: OrderStatusEditDto;
    requestedProvisionDate: moment.Moment | undefined;
    orderStatusDate: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    corporateAccountNumber: string | undefined;
    providerOrderNumber: string | undefined;
    orderLocationDetailMilestones: OrderLocationDetailMilestoneEditDto[] | undefined;
    orderLocationDetailContracts: OrderLocationDetailContractEditDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailMilestone implements IOrderLocationDetailMilestone {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    productMilestoneId: number;
    productMilestone: ProductMilestone;
    value: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailMilestone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.productMilestoneId = _data['productMilestoneId'];
            this.productMilestone = _data['productMilestone'] ? ProductMilestone.fromJS(_data['productMilestone']) : <any>undefined;
            this.value = _data['value'] ? moment(_data['value'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailMilestone {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailMilestone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['productMilestoneId'] = this.productMilestoneId;
        data['productMilestone'] = this.productMilestone ? this.productMilestone.toJSON() : <any>undefined;
        data['value'] = this.value ? this.value.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailMilestone {
        const json = this.toJSON();
        let result = new OrderLocationDetailMilestone();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailMilestone {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    productMilestoneId: number;
    productMilestone: ProductMilestone;
    value: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailProductAttribute implements IOrderLocationDetailProductAttribute {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    productAttributeTypeId: number;
    productAttributeType: ProductAttributeType;
    value: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailProductAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.productAttributeTypeId = _data['productAttributeTypeId'];
            this.productAttributeType = _data['productAttributeType']
                ? ProductAttributeType.fromJS(_data['productAttributeType'])
                : <any>undefined;
            this.value = _data['value'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailProductAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailProductAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['productAttributeTypeId'] = this.productAttributeTypeId;
        data['productAttributeType'] = this.productAttributeType ? this.productAttributeType.toJSON() : <any>undefined;
        data['value'] = this.value;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailProductAttribute {
        const json = this.toJSON();
        let result = new OrderLocationDetailProductAttribute();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailProductAttribute {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    productAttributeTypeId: number;
    productAttributeType: ProductAttributeType;
    value: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLocationDetailStatus implements IOrderLocationDetailStatus {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    orderStatusId: number;
    orderStatus: OrderStatus;
    startDate: moment.Moment;
    endDate: moment.Moment;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLocationDetailStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
            this.orderLocationDetail = _data['orderLocationDetail']
                ? OrderLocationDetail.fromJS(_data['orderLocationDetail'])
                : <any>undefined;
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatus = _data['orderStatus'] ? OrderStatus.fromJS(_data['orderStatus']) : <any>undefined;
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderLocationDetailStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLocationDetailStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        data['orderLocationDetail'] = this.orderLocationDetail ? this.orderLocationDetail.toJSON() : <any>undefined;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatus'] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderLocationDetailStatus {
        const json = this.toJSON();
        let result = new OrderLocationDetailStatus();
        result.init(json);
        return result;
    }
}

export interface IOrderLocationDetailStatus {
    tenantId: number | undefined;
    orderLocationDetailId: number;
    orderLocationDetail: OrderLocationDetail;
    orderStatusId: number;
    orderStatus: OrderStatus;
    startDate: moment.Moment;
    endDate: moment.Moment;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderSalesAgent implements IOrderSalesAgent {
    orderId: number;
    order: Order;
    partnerId: number;
    partner: Partner;
    salesAgentId: number;
    salesAgent: User;
    splitRate: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly partnerName: string | undefined;
    readonly salesAgentName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderSalesAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? Order.fromJS(_data['order']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? User.fromJS(_data['salesAgent']) : <any>undefined;
            this.splitRate = _data['splitRate'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            (<any>this).partnerName = _data['partnerName'];
            (<any>this).salesAgentName = _data['salesAgentName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderSalesAgent {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSalesAgent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        data['splitRate'] = this.splitRate;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['partnerName'] = this.partnerName;
        data['salesAgentName'] = this.salesAgentName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderSalesAgent {
        const json = this.toJSON();
        let result = new OrderSalesAgent();
        result.init(json);
        return result;
    }
}

export interface IOrderSalesAgent {
    orderId: number;
    order: Order;
    partnerId: number;
    partner: Partner;
    salesAgentId: number;
    salesAgent: User;
    splitRate: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    partnerName: string | undefined;
    salesAgentName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderStatus implements IOrderStatus {
    tenantId: number | undefined;
    name: string | undefined;
    type: OrderStatusType;
    isActivityView: boolean;
    order: number;
    requiresNotification: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.type = _data['type'];
            this.isActivityView = _data['isActivityView'];
            this.order = _data['order'];
            this.requiresNotification = _data['requiresNotification'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['type'] = this.type;
        data['isActivityView'] = this.isActivityView;
        data['order'] = this.order;
        data['requiresNotification'] = this.requiresNotification;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderStatus {
        const json = this.toJSON();
        let result = new OrderStatus();
        result.init(json);
        return result;
    }
}

export interface IOrderStatus {
    tenantId: number | undefined;
    name: string | undefined;
    type: OrderStatusType;
    isActivityView: boolean;
    order: number;
    requiresNotification: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum OrderStatusType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OrderUser implements IOrderUser {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    userId: number;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.orderId = _data['orderId'];
            this.order = _data['order'] ? Order.fromJS(_data['order']) : <any>undefined;
            this.userId = _data['userId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrderUser {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['orderId'] = this.orderId;
        data['order'] = this.order ? this.order.toJSON() : <any>undefined;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrderUser {
        const json = this.toJSON();
        let result = new OrderUser();
        result.init(json);
        return result;
    }
}

export interface IOrderUser {
    tenantId: number | undefined;
    orderId: number;
    order: Order;
    userId: number;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data['parentId'];
            this.code = _data['code'];
            this.displayName = _data['displayName'];
            this.memberCount = _data['memberCount'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentId'] = this.parentId;
        data['code'] = this.code;
        data['displayName'] = this.displayName;
        data['memberCount'] = this.memberCount;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): OrganizationUnitDto {
        const json = this.toJSON();
        let result = new OrganizationUnitDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitDtoListResultDto implements IOrganizationUnitDtoListResultDto {
    items: OrganizationUnitDto[] | undefined;

    constructor(data?: IOrganizationUnitDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): OrganizationUnitDtoListResultDto {
        const json = this.toJSON();
        let result = new OrganizationUnitDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitDtoListResultDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
    id: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.profilePictureId = _data['profilePictureId'];
            this.addedTime = _data['addedTime'] ? moment(_data['addedTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['profilePictureId'] = this.profilePictureId;
        data['addedTime'] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): OrganizationUnitUserListDto {
        const json = this.toJSON();
        let result = new OrganizationUnitUserListDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class OrganizationUnitUserListDtoPagedResultDto implements IOrganizationUnitUserListDtoPagedResultDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IOrganizationUnitUserListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): OrganizationUnitUserListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrganizationUnitUserListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitUserListDtoPagedResultDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class Partner implements IPartner {
    tenantId: number | undefined;
    name: string;
    website: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    taxId: string | undefined;
    commissionRate: number;
    isApproved: boolean;
    approveTime: moment.Moment | undefined;
    contractTypeId: number | undefined;
    externalId: string | undefined;
    apid: number | undefined;
    uuid: string;
    isMatrixEnabled: boolean;
    contractType: PartnerContractType;
    partnerStatus: PartnerStatus;
    users: User[] | undefined;
    partnerSources: PartnerSource[] | undefined;
    partnerContacts: PartnerContact[] | undefined;
    partnerSupports: PartnerSupport[] | undefined;
    partnerDocuments: PartnerDocument[] | undefined;
    partnerContractTerms: PartnerContractTermEntity[] | undefined;
    partnerAcquisitionId: number;
    partnerAcquisition: PartnerAcquisition;
    isDirectDeposit: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    readonly nameExtended: string | undefined;
    advisorEntitlementId: number | undefined;
    advisorEntitlement: AdvisorEntitlement;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.website = _data['website'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.taxId = _data['taxId'];
            this.commissionRate = _data['commissionRate'];
            this.isApproved = _data['isApproved'];
            this.approveTime = _data['approveTime'] ? moment(_data['approveTime'].toString()) : <any>undefined;
            this.contractTypeId = _data['contractTypeId'];
            this.externalId = _data['externalId'];
            this.apid = _data['apid'];
            this.uuid = _data['uuid'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            this.contractType = _data['contractType'] ? PartnerContractType.fromJS(_data['contractType']) : <any>undefined;
            this.partnerStatus = _data['partnerStatus'];
            if (Array.isArray(_data['users'])) {
                this.users = [] as any;
                for (let item of _data['users']) this.users.push(User.fromJS(item));
            }
            if (Array.isArray(_data['partnerSources'])) {
                this.partnerSources = [] as any;
                for (let item of _data['partnerSources']) this.partnerSources.push(PartnerSource.fromJS(item));
            }
            if (Array.isArray(_data['partnerContacts'])) {
                this.partnerContacts = [] as any;
                for (let item of _data['partnerContacts']) this.partnerContacts.push(PartnerContact.fromJS(item));
            }
            if (Array.isArray(_data['partnerSupports'])) {
                this.partnerSupports = [] as any;
                for (let item of _data['partnerSupports']) this.partnerSupports.push(PartnerSupport.fromJS(item));
            }
            if (Array.isArray(_data['partnerDocuments'])) {
                this.partnerDocuments = [] as any;
                for (let item of _data['partnerDocuments']) this.partnerDocuments.push(PartnerDocument.fromJS(item));
            }
            if (Array.isArray(_data['partnerContractTerms'])) {
                this.partnerContractTerms = [] as any;
                for (let item of _data['partnerContractTerms']) this.partnerContractTerms.push(PartnerContractTermEntity.fromJS(item));
            }
            this.partnerAcquisitionId = _data['partnerAcquisitionId'];
            this.partnerAcquisition = _data['partnerAcquisition'] ? PartnerAcquisition.fromJS(_data['partnerAcquisition']) : <any>undefined;
            this.isDirectDeposit = _data['isDirectDeposit'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            (<any>this).nameExtended = _data['nameExtended'];
            this.advisorEntitlementId = _data['advisorEntitlementId'];
            this.advisorEntitlement = _data['advisorEntitlement'] ? AdvisorEntitlement.fromJS(_data['advisorEntitlement']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['website'] = this.website;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['taxId'] = this.taxId;
        data['commissionRate'] = this.commissionRate;
        data['isApproved'] = this.isApproved;
        data['approveTime'] = this.approveTime ? this.approveTime.toISOString() : <any>undefined;
        data['contractTypeId'] = this.contractTypeId;
        data['externalId'] = this.externalId;
        data['apid'] = this.apid;
        data['uuid'] = this.uuid;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['contractType'] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data['partnerStatus'] = this.partnerStatus;
        if (Array.isArray(this.users)) {
            data['users'] = [];
            for (let item of this.users) data['users'].push(item.toJSON());
        }
        if (Array.isArray(this.partnerSources)) {
            data['partnerSources'] = [];
            for (let item of this.partnerSources) data['partnerSources'].push(item.toJSON());
        }
        if (Array.isArray(this.partnerContacts)) {
            data['partnerContacts'] = [];
            for (let item of this.partnerContacts) data['partnerContacts'].push(item.toJSON());
        }
        if (Array.isArray(this.partnerSupports)) {
            data['partnerSupports'] = [];
            for (let item of this.partnerSupports) data['partnerSupports'].push(item.toJSON());
        }
        if (Array.isArray(this.partnerDocuments)) {
            data['partnerDocuments'] = [];
            for (let item of this.partnerDocuments) data['partnerDocuments'].push(item.toJSON());
        }
        if (Array.isArray(this.partnerContractTerms)) {
            data['partnerContractTerms'] = [];
            for (let item of this.partnerContractTerms) data['partnerContractTerms'].push(item.toJSON());
        }
        data['partnerAcquisitionId'] = this.partnerAcquisitionId;
        data['partnerAcquisition'] = this.partnerAcquisition ? this.partnerAcquisition.toJSON() : <any>undefined;
        data['isDirectDeposit'] = this.isDirectDeposit;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['nameExtended'] = this.nameExtended;
        data['advisorEntitlementId'] = this.advisorEntitlementId;
        data['advisorEntitlement'] = this.advisorEntitlement ? this.advisorEntitlement.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Partner {
        const json = this.toJSON();
        let result = new Partner();
        result.init(json);
        return result;
    }
}

export interface IPartner {
    tenantId: number | undefined;
    name: string;
    website: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    taxId: string | undefined;
    commissionRate: number;
    isApproved: boolean;
    approveTime: moment.Moment | undefined;
    contractTypeId: number | undefined;
    externalId: string | undefined;
    apid: number | undefined;
    uuid: string;
    isMatrixEnabled: boolean;
    contractType: PartnerContractType;
    partnerStatus: PartnerStatus;
    users: User[] | undefined;
    partnerSources: PartnerSource[] | undefined;
    partnerContacts: PartnerContact[] | undefined;
    partnerSupports: PartnerSupport[] | undefined;
    partnerDocuments: PartnerDocument[] | undefined;
    partnerContractTerms: PartnerContractTermEntity[] | undefined;
    partnerAcquisitionId: number;
    partnerAcquisition: PartnerAcquisition;
    isDirectDeposit: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nameExtended: string | undefined;
    advisorEntitlementId: number | undefined;
    advisorEntitlement: AdvisorEntitlement;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerAcquisition implements IPartnerAcquisition {
    tenantId: number | undefined;
    name: string | undefined;
    isMatrixEnabled: boolean;
    isDefault: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerAcquisition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            this.isDefault = _data['isDefault'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerAcquisition {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAcquisition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['isDefault'] = this.isDefault;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerAcquisition {
        const json = this.toJSON();
        let result = new PartnerAcquisition();
        result.init(json);
        return result;
    }
}

export interface IPartnerAcquisition {
    tenantId: number | undefined;
    name: string | undefined;
    isMatrixEnabled: boolean;
    isDefault: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerAcquisitionListDto implements IPartnerAcquisitionListDto {
    name: string | undefined;
    isMatrixEnabled: boolean;
    id: number;

    constructor(data?: IPartnerAcquisitionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerAcquisitionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAcquisitionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerAcquisitionListDto {
        const json = this.toJSON();
        let result = new PartnerAcquisitionListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerAcquisitionListDto {
    name: string | undefined;
    isMatrixEnabled: boolean;
    id: number;
}

export class PartnerContact implements IPartnerContact {
    partner: Partner;
    partnerId: number;
    type: PartnerContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IPartnerContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContact {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContact {
        const json = this.toJSON();
        let result = new PartnerContact();
        result.init(json);
        return result;
    }
}

export interface IPartnerContact {
    partner: Partner;
    partnerId: number;
    type: PartnerContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;
}

export enum PartnerContactType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PartnerContractTermEntity implements IPartnerContractTermEntity {
    tenantId: number | undefined;
    partnerId: number;
    partner: Partner;
    startDate: moment.Moment;
    endDate: moment.Moment;
    commissionTrackingTypeId: number;
    commissionTrackingType: CommissionTrackingType;
    rate: number;
    providerId: number | undefined;
    provider: Provider;
    customerId: number | undefined;
    customer: Customer;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    notes: string | undefined;
    parentOwnerId: number | undefined;
    parentOwner: PartnerAcquisition;
    splits: PartnerContractTermSplitEntity[] | undefined;
    salesCampaignId: number | undefined;
    salesCampaign: SalesCampaignEntity;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerContractTermEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.commissionTrackingTypeId = _data['commissionTrackingTypeId'];
            this.commissionTrackingType = _data['commissionTrackingType']
                ? CommissionTrackingType.fromJS(_data['commissionTrackingType'])
                : <any>undefined;
            this.rate = _data['rate'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? Provider.fromJS(_data['provider']) : <any>undefined;
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? Customer.fromJS(_data['customer']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.notes = _data['notes'];
            this.parentOwnerId = _data['parentOwnerId'];
            this.parentOwner = _data['parentOwner'] ? PartnerAcquisition.fromJS(_data['parentOwner']) : <any>undefined;
            if (Array.isArray(_data['splits'])) {
                this.splits = [] as any;
                for (let item of _data['splits']) this.splits.push(PartnerContractTermSplitEntity.fromJS(item));
            }
            this.salesCampaignId = _data['salesCampaignId'];
            this.salesCampaign = _data['salesCampaign'] ? SalesCampaignEntity.fromJS(_data['salesCampaign']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContractTermEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTermEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['commissionTrackingTypeId'] = this.commissionTrackingTypeId;
        data['commissionTrackingType'] = this.commissionTrackingType ? this.commissionTrackingType.toJSON() : <any>undefined;
        data['rate'] = this.rate;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['notes'] = this.notes;
        data['parentOwnerId'] = this.parentOwnerId;
        data['parentOwner'] = this.parentOwner ? this.parentOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.splits)) {
            data['splits'] = [];
            for (let item of this.splits) data['splits'].push(item.toJSON());
        }
        data['salesCampaignId'] = this.salesCampaignId;
        data['salesCampaign'] = this.salesCampaign ? this.salesCampaign.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContractTermEntity {
        const json = this.toJSON();
        let result = new PartnerContractTermEntity();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTermEntity {
    tenantId: number | undefined;
    partnerId: number;
    partner: Partner;
    startDate: moment.Moment;
    endDate: moment.Moment;
    commissionTrackingTypeId: number;
    commissionTrackingType: CommissionTrackingType;
    rate: number;
    providerId: number | undefined;
    provider: Provider;
    customerId: number | undefined;
    customer: Customer;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    notes: string | undefined;
    parentOwnerId: number | undefined;
    parentOwner: PartnerAcquisition;
    splits: PartnerContractTermSplitEntity[] | undefined;
    salesCampaignId: number | undefined;
    salesCampaign: SalesCampaignEntity;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerContractTermSplitEntity implements IPartnerContractTermSplitEntity {
    partnerContractTermId: number;
    partnerContractTerm: PartnerContractTermEntity;
    type: SplitType;
    salesRepresentativeId: number;
    salesRepresentative: User;
    tenantId: number | undefined;
    deleterUserId: number | undefined;
    rate: number;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerContractTermSplitEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerContractTermId = _data['partnerContractTermId'];
            this.partnerContractTerm = _data['partnerContractTerm']
                ? PartnerContractTermEntity.fromJS(_data['partnerContractTerm'])
                : <any>undefined;
            this.type = _data['type'];
            this.salesRepresentativeId = _data['salesRepresentativeId'];
            this.salesRepresentative = _data['salesRepresentative'] ? User.fromJS(_data['salesRepresentative']) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.deleterUserId = _data['deleterUserId'];
            this.rate = _data['rate'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContractTermSplitEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTermSplitEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerContractTermId'] = this.partnerContractTermId;
        data['partnerContractTerm'] = this.partnerContractTerm ? this.partnerContractTerm.toJSON() : <any>undefined;
        data['type'] = this.type;
        data['salesRepresentativeId'] = this.salesRepresentativeId;
        data['salesRepresentative'] = this.salesRepresentative ? this.salesRepresentative.toJSON() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['deleterUserId'] = this.deleterUserId;
        data['rate'] = this.rate;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContractTermSplitEntity {
        const json = this.toJSON();
        let result = new PartnerContractTermSplitEntity();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTermSplitEntity {
    partnerContractTermId: number;
    partnerContractTerm: PartnerContractTermEntity;
    type: SplitType;
    salesRepresentativeId: number;
    salesRepresentative: User;
    tenantId: number | undefined;
    deleterUserId: number | undefined;
    rate: number;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerContractType implements IPartnerContractType {
    name: string;
    isEnabled: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IPartnerContractType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isEnabled = _data['isEnabled'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContractType {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isEnabled'] = this.isEnabled;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContractType {
        const json = this.toJSON();
        let result = new PartnerContractType();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractType {
    name: string;
    isEnabled: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class PartnerDocument implements IPartnerDocument {
    tenantId: number | undefined;
    partnerId: number;
    partner: Partner;
    name: string;
    documentId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.name = _data['name'];
            this.documentId = _data['documentId'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerDocument {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['documentId'] = this.documentId;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerDocument {
        const json = this.toJSON();
        let result = new PartnerDocument();
        result.init(json);
        return result;
    }
}

export interface IPartnerDocument {
    tenantId: number | undefined;
    partnerId: number;
    partner: Partner;
    name: string;
    documentId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IPartnerEditDto {
    tenantId: number | undefined;
    name: string;
    website: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    taxId: string | undefined;
    commissionRate: number;
    isApproved: boolean;
    isDirectDeposit: boolean;
    approveTime: moment.Moment | undefined;
    contractTypeId: number;
    advisorEntitlementId: number | undefined;
    advisorEntitlement: AdvisorEntitlementDto;
    partnerStatus: PartnerStatus;
    partnerSupports: PartnerSupportEditDto[] | undefined;
    partnerAcquisitionId: number;
    partnerAcquisition: PartnerAcquisitionListDto;
    fullAddress: string | undefined;
    apid: number | undefined;
    uuid: string;
    externalId: string | undefined;
    isMatrixEnabled: boolean;
    canSeeCommissionMatrix: boolean;
    id: number;
}

export class PartnerSource implements IPartnerSource {
    partner: Partner;
    partnerId: number;
    type: PartnerSourceType;
    name: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IPartnerSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.type = _data['type'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSource {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['type'] = this.type;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSource {
        const json = this.toJSON();
        let result = new PartnerSource();
        result.init(json);
        return result;
    }
}

export interface IPartnerSource {
    partner: Partner;
    partnerId: number;
    type: PartnerSourceType;
    name: string;
    creationTime: moment.Moment;
    id: number;
}

export enum PartnerSourceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum PartnerStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PartnerSupport implements IPartnerSupport {
    partner: Partner;
    partnerId: number;
    user: User;
    userId: number;
    type: PartnerSupportType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerSupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.partnerId = _data['partnerId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.userId = _data['userId'];
            this.type = _data['type'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSupport {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSupport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['partnerId'] = this.partnerId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['userId'] = this.userId;
        data['type'] = this.type;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSupport {
        const json = this.toJSON();
        let result = new PartnerSupport();
        result.init(json);
        return result;
    }
}

export interface IPartnerSupport {
    partner: Partner;
    partnerId: number;
    user: User;
    userId: number;
    type: PartnerSupportType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IPartnerSupportEditDto {
    partnerId: number;
    userId: number | undefined;
    user: UserListDto;
    type: PartnerSupportType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum PartnerSupportType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface IPartnersDto {
    name: string;
    nameExtended: string | undefined;
    isMatrixEnabled: boolean;
    id: number;
}

export class ProbabilityToCloseEditDto implements IProbabilityToCloseEditDto {
    name: string;
    order: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProbabilityToCloseEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.order = _data['order'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProbabilityToCloseEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProbabilityToCloseEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['order'] = this.order;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProbabilityToCloseEditDto {
        const json = this.toJSON();
        let result = new ProbabilityToCloseEditDto();
        result.init(json);
        return result;
    }
}

export interface IProbabilityToCloseEditDto {
    name: string;
    order: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProbabilityToCloseListDto implements IProbabilityToCloseListDto {
    id: number;
    name: string;
    order: number;

    constructor(data?: IProbabilityToCloseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.order = _data['order'];
        }
    }

    static fromJS(data: any): ProbabilityToCloseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProbabilityToCloseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['order'] = this.order;
        return data;
    }

    clone(): ProbabilityToCloseListDto {
        const json = this.toJSON();
        let result = new ProbabilityToCloseListDto();
        result.init(json);
        return result;
    }
}

export interface IProbabilityToCloseListDto {
    id: number;
    name: string;
    order: number;
}

export class ProblemDetails implements IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data['type'];
            this.title = _data['title'];
            this.status = _data['status'];
            this.detail = _data['detail'];
            this.instance = _data['instance'];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['type'] = this.type;
        data['title'] = this.title;
        data['status'] = this.status;
        data['detail'] = this.detail;
        data['instance'] = this.instance;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export class Product implements IProduct {
    tenantId: number | undefined;
    productCategoryId: number;
    productCategory: ProductCategory;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    externalId: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.productCategoryId = _data['productCategoryId'];
            this.productCategory = _data['productCategory'] ? ProductCategory.fromJS(_data['productCategory']) : <any>undefined;
            this.name = _data['name'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.externalId = _data['externalId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['productCategoryId'] = this.productCategoryId;
        data['productCategory'] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['externalId'] = this.externalId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    tenantId: number | undefined;
    productCategoryId: number;
    productCategory: ProductCategory;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    externalId: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductAttributeEditDto implements IProductAttributeEditDto {
    id: number | undefined;
    productId: number;
    productAttributeTypeId: number;

    constructor(data?: IProductAttributeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.productId = _data['productId'];
            this.productAttributeTypeId = _data['productAttributeTypeId'];
        }
    }

    static fromJS(data: any): ProductAttributeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['productId'] = this.productId;
        data['productAttributeTypeId'] = this.productAttributeTypeId;
        return data;
    }

    clone(): ProductAttributeEditDto {
        const json = this.toJSON();
        let result = new ProductAttributeEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeEditDto {
    id: number | undefined;
    productId: number;
    productAttributeTypeId: number;
}

export class ProductAttributeListDto implements IProductAttributeListDto {
    id: number | undefined;
    productId: number;
    productAttributeTypeId: number;

    constructor(data?: IProductAttributeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.productId = _data['productId'];
            this.productAttributeTypeId = _data['productAttributeTypeId'];
        }
    }

    static fromJS(data: any): ProductAttributeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['productId'] = this.productId;
        data['productAttributeTypeId'] = this.productAttributeTypeId;
        return data;
    }

    clone(): ProductAttributeListDto {
        const json = this.toJSON();
        let result = new ProductAttributeListDto();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeListDto {
    id: number | undefined;
    productId: number;
    productAttributeTypeId: number;
}

export class ProductAttributeType implements IProductAttributeType {
    tenantId: number | undefined;
    name: string;
    choices: string;
    fieldType: FieldType;
    isRequired: boolean;
    isQuote: boolean;
    isOrder: boolean;
    displayTemplateQuote: boolean;
    displayTemplateOrder: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductAttributeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.fieldType = _data['fieldType'];
            this.isRequired = _data['isRequired'];
            this.isQuote = _data['isQuote'];
            this.isOrder = _data['isOrder'];
            this.displayTemplateQuote = _data['displayTemplateQuote'];
            this.displayTemplateOrder = _data['displayTemplateOrder'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductAttributeType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['isQuote'] = this.isQuote;
        data['isOrder'] = this.isOrder;
        data['displayTemplateQuote'] = this.displayTemplateQuote;
        data['displayTemplateOrder'] = this.displayTemplateOrder;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductAttributeType {
        const json = this.toJSON();
        let result = new ProductAttributeType();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeType {
    tenantId: number | undefined;
    name: string;
    choices: string;
    fieldType: FieldType;
    isRequired: boolean;
    isQuote: boolean;
    isOrder: boolean;
    displayTemplateQuote: boolean;
    displayTemplateOrder: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductAttributeTypeEditDto implements IProductAttributeTypeEditDto {
    name: string;
    choices: string;
    fieldType: FieldType;
    isRequired: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductAttributeTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.fieldType = _data['fieldType'];
            this.isRequired = _data['isRequired'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductAttributeTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['fieldType'] = this.fieldType;
        data['isRequired'] = this.isRequired;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductAttributeTypeEditDto {
        const json = this.toJSON();
        let result = new ProductAttributeTypeEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeTypeEditDto {
    name: string;
    choices: string;
    fieldType: FieldType;
    isRequired: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductAttributeTypeListDto implements IProductAttributeTypeListDto {
    id: number | undefined;
    name: string;
    choices: string;
    fieldType: FieldType;
    readonly fieldTypeName: string | undefined;
    isRequired: boolean;

    constructor(data?: IProductAttributeTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.choices = _data['choices'];
            this.fieldType = _data['fieldType'];
            (<any>this).fieldTypeName = _data['fieldTypeName'];
            this.isRequired = _data['isRequired'];
        }
    }

    static fromJS(data: any): ProductAttributeTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['choices'] = this.choices;
        data['fieldType'] = this.fieldType;
        data['fieldTypeName'] = this.fieldTypeName;
        data['isRequired'] = this.isRequired;
        return data;
    }

    clone(): ProductAttributeTypeListDto {
        const json = this.toJSON();
        let result = new ProductAttributeTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeTypeListDto {
    id: number | undefined;
    name: string;
    choices: string;
    fieldType: FieldType;
    fieldTypeName: string | undefined;
    isRequired: boolean;
}

export class ProductCategory implements IProductCategory {
    tenantId: number | undefined;
    name: string;
    cssClass: string | undefined;
    products: Product[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.cssClass = _data['cssClass'];
            if (Array.isArray(_data['products'])) {
                this.products = [] as any;
                for (let item of _data['products']) this.products.push(Product.fromJS(item));
            }
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['cssClass'] = this.cssClass;
        if (Array.isArray(this.products)) {
            data['products'] = [];
            for (let item of this.products) data['products'].push(item.toJSON());
        }
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductCategory {
        const json = this.toJSON();
        let result = new ProductCategory();
        result.init(json);
        return result;
    }
}

export interface IProductCategory {
    tenantId: number | undefined;
    name: string;
    cssClass: string | undefined;
    products: Product[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductCategoryAdminEditDto implements IProductCategoryAdminEditDto {
    tenantId: number | undefined;
    name: string;
    cssClass: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductCategoryAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.cssClass = _data['cssClass'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductCategoryAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['cssClass'] = this.cssClass;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductCategoryAdminEditDto {
        const json = this.toJSON();
        let result = new ProductCategoryAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductCategoryAdminEditDto {
    tenantId: number | undefined;
    name: string;
    cssClass: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductCategoryAdminListDto implements IProductCategoryAdminListDto {
    id: number;
    name: string;
    cssClass: string | undefined;
    products: Product[] | undefined;
    isDeletable: boolean;

    constructor(data?: IProductCategoryAdminListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.cssClass = _data['cssClass'];
            if (Array.isArray(_data['products'])) {
                this.products = [] as any;
                for (let item of _data['products']) this.products.push(Product.fromJS(item));
            }
            this.isDeletable = _data['isDeletable'];
        }
    }

    static fromJS(data: any): ProductCategoryAdminListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryAdminListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['cssClass'] = this.cssClass;
        if (Array.isArray(this.products)) {
            data['products'] = [];
            for (let item of this.products) data['products'].push(item.toJSON());
        }
        data['isDeletable'] = this.isDeletable;
        return data;
    }

    clone(): ProductCategoryAdminListDto {
        const json = this.toJSON();
        let result = new ProductCategoryAdminListDto();
        result.init(json);
        return result;
    }
}

export interface IProductCategoryAdminListDto {
    id: number;
    name: string;
    cssClass: string | undefined;
    products: Product[] | undefined;
    isDeletable: boolean;
}

export class ProductCategoryEditDto implements IProductCategoryEditDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductCategoryEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductCategoryEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductCategoryEditDto {
        const json = this.toJSON();
        let result = new ProductCategoryEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductCategoryEditDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IProductCategoryListDto {
    id: number | undefined;
    name: string;
}

export class ProductEditDto implements IProductEditDto {
    tenantId: number | undefined;
    productCategoryId: number;
    productCategory: ProductCategoryEditDto;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.productCategoryId = _data['productCategoryId'];
            this.productCategory = _data['productCategory'] ? ProductCategoryEditDto.fromJS(_data['productCategory']) : <any>undefined;
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['productCategoryId'] = this.productCategoryId;
        data['productCategory'] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductEditDto {
        const json = this.toJSON();
        let result = new ProductEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductEditDto {
    tenantId: number | undefined;
    productCategoryId: number;
    productCategory: ProductCategoryEditDto;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IProductListDto {
    id: number | undefined;
    productCategory: ProductCategoryListDto;
    name: string;
}

export class ProductListForProductMilestoneDto implements IProductListForProductMilestoneDto {
    name: string;
    id: number;

    constructor(data?: IProductListForProductMilestoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductListForProductMilestoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListForProductMilestoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductListForProductMilestoneDto {
        const json = this.toJSON();
        let result = new ProductListForProductMilestoneDto();
        result.init(json);
        return result;
    }
}

export interface IProductListForProductMilestoneDto {
    name: string;
    id: number;
}

export class ProductMilestone implements IProductMilestone {
    tenantId: number | undefined;
    productId: number;
    product: Product;
    milestoneId: number;
    milestone: Milestone;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductMilestone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.productId = _data['productId'];
            this.product = _data['product'] ? Product.fromJS(_data['product']) : <any>undefined;
            this.milestoneId = _data['milestoneId'];
            this.milestone = _data['milestone'] ? Milestone.fromJS(_data['milestone']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductMilestone {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMilestone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['milestoneId'] = this.milestoneId;
        data['milestone'] = this.milestone ? this.milestone.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductMilestone {
        const json = this.toJSON();
        let result = new ProductMilestone();
        result.init(json);
        return result;
    }
}

export interface IProductMilestone {
    tenantId: number | undefined;
    productId: number;
    product: Product;
    milestoneId: number;
    milestone: Milestone;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductResponse implements IProductResponse {
    id: number;
    name: string | undefined;

    constructor(data?: IProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): ProductResponse {
        const json = this.toJSON();
        let result = new ProductResponse();
        result.init(json);
        return result;
    }
}

export interface IProductResponse {
    id: number;
    name: string | undefined;
}

export class ProductType implements IProductType {
    tenantId: number | undefined;
    name: string | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    providers: Provider[] | undefined;
    readonly providerCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            if (Array.isArray(_data['providers'])) {
                this.providers = [] as any;
                for (let item of _data['providers']) this.providers.push(Provider.fromJS(item));
            }
            (<any>this).providerCount = _data['providerCount'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        if (Array.isArray(this.providers)) {
            data['providers'] = [];
            for (let item of this.providers) data['providers'].push(item.toJSON());
        }
        data['providerCount'] = this.providerCount;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductType {
        const json = this.toJSON();
        let result = new ProductType();
        result.init(json);
        return result;
    }
}

export interface IProductType {
    tenantId: number | undefined;
    name: string | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    providers: Provider[] | undefined;
    providerCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductTypeDto implements IProductTypeDto {
    name: string | undefined;
    providerCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.providerCount = _data['providerCount'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['providerCount'] = this.providerCount;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductTypeDto {
        const json = this.toJSON();
        let result = new ProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface IProductTypeDto {
    name: string | undefined;
    providerCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductTypeEditDto implements IProductTypeEditDto {
    name: string;
    id: number;

    constructor(data?: IProductTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProductTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): ProductTypeEditDto {
        const json = this.toJSON();
        let result = new ProductTypeEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductTypeEditDto {
    name: string;
    id: number;
}

export class Provider implements IProvider {
    tenantId: number | undefined;
    name: string;
    qbName: string;
    isCommissionEnabled: boolean;
    renewalPolicy: string | undefined;
    isAutoRenew: boolean;
    carrierWeighting: number;
    isActive: boolean;
    commissionManagerId: number | undefined;
    commissionManager: User;
    imageSourceUrl: string | undefined;
    externalId: string | undefined;
    provider_Id: number | undefined;
    uuid: string;
    users: User[] | undefined;
    products: ProviderProduct[] | undefined;
    compensationNotes: string | undefined;
    nameMatch: string | undefined;
    displayCompMatrix: boolean;
    providerCommissionTermId: number | undefined;
    providerCommissionTerm: ProviderCommissionTerm;
    commissionArrears: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    providerManagerId: number | undefined;
    providerManager: ProviderManagerEntity;
    previousNames: string | undefined;
    productTypeId: number | undefined;
    productType: ProductType;
    readonly providerCommissionTermName: string | undefined;
    readonly productTypeName: string | undefined;
    commissionTemplates: CommissionTemplate[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.qbName = _data['qbName'];
            this.isCommissionEnabled = _data['isCommissionEnabled'];
            this.renewalPolicy = _data['renewalPolicy'];
            this.isAutoRenew = _data['isAutoRenew'];
            this.carrierWeighting = _data['carrierWeighting'];
            this.isActive = _data['isActive'];
            this.commissionManagerId = _data['commissionManagerId'];
            this.commissionManager = _data['commissionManager'] ? User.fromJS(_data['commissionManager']) : <any>undefined;
            this.imageSourceUrl = _data['imageSourceUrl'];
            this.externalId = _data['externalId'];
            this.provider_Id = _data['provider_Id'];
            this.uuid = _data['uuid'];
            if (Array.isArray(_data['users'])) {
                this.users = [] as any;
                for (let item of _data['users']) this.users.push(User.fromJS(item));
            }
            if (Array.isArray(_data['products'])) {
                this.products = [] as any;
                for (let item of _data['products']) this.products.push(ProviderProduct.fromJS(item));
            }
            this.compensationNotes = _data['compensationNotes'];
            this.nameMatch = _data['nameMatch'];
            this.displayCompMatrix = _data['displayCompMatrix'];
            this.providerCommissionTermId = _data['providerCommissionTermId'];
            this.providerCommissionTerm = _data['providerCommissionTerm']
                ? ProviderCommissionTerm.fromJS(_data['providerCommissionTerm'])
                : <any>undefined;
            this.commissionArrears = _data['commissionArrears'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.providerManagerId = _data['providerManagerId'];
            this.providerManager = _data['providerManager'] ? ProviderManagerEntity.fromJS(_data['providerManager']) : <any>undefined;
            this.previousNames = _data['previousNames'];
            this.productTypeId = _data['productTypeId'];
            this.productType = _data['productType'] ? ProductType.fromJS(_data['productType']) : <any>undefined;
            (<any>this).providerCommissionTermName = _data['providerCommissionTermName'];
            (<any>this).productTypeName = _data['productTypeName'];
            if (Array.isArray(_data['commissionTemplates'])) {
                this.commissionTemplates = [] as any;
                for (let item of _data['commissionTemplates']) this.commissionTemplates.push(CommissionTemplate.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Provider {
        data = typeof data === 'object' ? data : {};
        let result = new Provider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['qbName'] = this.qbName;
        data['isCommissionEnabled'] = this.isCommissionEnabled;
        data['renewalPolicy'] = this.renewalPolicy;
        data['isAutoRenew'] = this.isAutoRenew;
        data['carrierWeighting'] = this.carrierWeighting;
        data['isActive'] = this.isActive;
        data['commissionManagerId'] = this.commissionManagerId;
        data['commissionManager'] = this.commissionManager ? this.commissionManager.toJSON() : <any>undefined;
        data['imageSourceUrl'] = this.imageSourceUrl;
        data['externalId'] = this.externalId;
        data['provider_Id'] = this.provider_Id;
        data['uuid'] = this.uuid;
        if (Array.isArray(this.users)) {
            data['users'] = [];
            for (let item of this.users) data['users'].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data['products'] = [];
            for (let item of this.products) data['products'].push(item.toJSON());
        }
        data['compensationNotes'] = this.compensationNotes;
        data['nameMatch'] = this.nameMatch;
        data['displayCompMatrix'] = this.displayCompMatrix;
        data['providerCommissionTermId'] = this.providerCommissionTermId;
        data['providerCommissionTerm'] = this.providerCommissionTerm ? this.providerCommissionTerm.toJSON() : <any>undefined;
        data['commissionArrears'] = this.commissionArrears;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['providerManagerId'] = this.providerManagerId;
        data['providerManager'] = this.providerManager ? this.providerManager.toJSON() : <any>undefined;
        data['previousNames'] = this.previousNames;
        data['productTypeId'] = this.productTypeId;
        data['productType'] = this.productType ? this.productType.toJSON() : <any>undefined;
        data['providerCommissionTermName'] = this.providerCommissionTermName;
        data['productTypeName'] = this.productTypeName;
        if (Array.isArray(this.commissionTemplates)) {
            data['commissionTemplates'] = [];
            for (let item of this.commissionTemplates) data['commissionTemplates'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Provider {
        const json = this.toJSON();
        let result = new Provider();
        result.init(json);
        return result;
    }
}

export interface IProvider {
    tenantId: number | undefined;
    name: string;
    qbName: string;
    isCommissionEnabled: boolean;
    renewalPolicy: string | undefined;
    isAutoRenew: boolean;
    carrierWeighting: number;
    isActive: boolean;
    commissionManagerId: number | undefined;
    commissionManager: User;
    imageSourceUrl: string | undefined;
    externalId: string | undefined;
    provider_Id: number | undefined;
    uuid: string;
    users: User[] | undefined;
    products: ProviderProduct[] | undefined;
    compensationNotes: string | undefined;
    nameMatch: string | undefined;
    displayCompMatrix: boolean;
    providerCommissionTermId: number | undefined;
    providerCommissionTerm: ProviderCommissionTerm;
    commissionArrears: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    providerManagerId: number | undefined;
    providerManager: ProviderManagerEntity;
    previousNames: string | undefined;
    productTypeId: number | undefined;
    productType: ProductType;
    providerCommissionTermName: string | undefined;
    productTypeName: string | undefined;
    commissionTemplates: CommissionTemplate[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderCommissionTerm implements IProviderCommissionTerm {
    tenantId: number | undefined;
    name: string;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderCommissionTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderCommissionTerm {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderCommissionTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderCommissionTerm {
        const json = this.toJSON();
        let result = new ProviderCommissionTerm();
        result.init(json);
        return result;
    }
}

export interface IProviderCommissionTerm {
    tenantId: number | undefined;
    name: string;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderEditDto implements IProviderEditDto {
    tenantId: number | undefined;
    name: string;
    qbName: string;
    isCommissionEnabled: boolean;
    renewalPolicy: string | undefined;
    isAutoRenew: boolean;
    carrierWeighting: number;
    isActive: boolean;
    commissionManagerId: number | undefined;
    imageSourceUrl: string | undefined;
    compensationNotes: string | undefined;
    displayCompMatrix: boolean;
    providerCommissionTermId: number | undefined;
    providerCommissionTermName: string | undefined;
    commissionArrears: number | undefined;
    externalId: string | undefined;
    provider_Id: number | undefined;
    uuid: string;
    previousNames: string[] | undefined;
    providerManagerId: number | undefined;
    productTypeId: number | undefined;
    productTypeName: string | undefined;
    providerCategoryId: number | undefined;
    providerCategoryName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.qbName = _data['qbName'];
            this.isCommissionEnabled = _data['isCommissionEnabled'];
            this.renewalPolicy = _data['renewalPolicy'];
            this.isAutoRenew = _data['isAutoRenew'];
            this.carrierWeighting = _data['carrierWeighting'];
            this.isActive = _data['isActive'];
            this.commissionManagerId = _data['commissionManagerId'];
            this.imageSourceUrl = _data['imageSourceUrl'];
            this.compensationNotes = _data['compensationNotes'];
            this.displayCompMatrix = _data['displayCompMatrix'];
            this.providerCommissionTermId = _data['providerCommissionTermId'];
            this.providerCommissionTermName = _data['providerCommissionTermName'];
            this.commissionArrears = _data['commissionArrears'];
            this.externalId = _data['externalId'];
            this.provider_Id = _data['provider_Id'];
            this.uuid = _data['uuid'];
            if (Array.isArray(_data['previousNames'])) {
                this.previousNames = [] as any;
                for (let item of _data['previousNames']) this.previousNames.push(item);
            }
            this.providerManagerId = _data['providerManagerId'];
            this.productTypeId = _data['productTypeId'];
            this.productTypeName = _data['productTypeName'];
            this.providerCategoryId = _data['providerCategoryId'];
            this.providerCategoryName = _data['providerCategoryName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['qbName'] = this.qbName;
        data['isCommissionEnabled'] = this.isCommissionEnabled;
        data['renewalPolicy'] = this.renewalPolicy;
        data['isAutoRenew'] = this.isAutoRenew;
        data['carrierWeighting'] = this.carrierWeighting;
        data['isActive'] = this.isActive;
        data['commissionManagerId'] = this.commissionManagerId;
        data['imageSourceUrl'] = this.imageSourceUrl;
        data['compensationNotes'] = this.compensationNotes;
        data['displayCompMatrix'] = this.displayCompMatrix;
        data['providerCommissionTermId'] = this.providerCommissionTermId;
        data['providerCommissionTermName'] = this.providerCommissionTermName;
        data['commissionArrears'] = this.commissionArrears;
        data['externalId'] = this.externalId;
        data['provider_Id'] = this.provider_Id;
        data['uuid'] = this.uuid;
        if (Array.isArray(this.previousNames)) {
            data['previousNames'] = [];
            for (let item of this.previousNames) data['previousNames'].push(item);
        }
        data['providerManagerId'] = this.providerManagerId;
        data['productTypeId'] = this.productTypeId;
        data['productTypeName'] = this.productTypeName;
        data['providerCategoryId'] = this.providerCategoryId;
        data['providerCategoryName'] = this.providerCategoryName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderEditDto {
        const json = this.toJSON();
        let result = new ProviderEditDto();
        result.init(json);
        return result;
    }
}

export interface IProviderEditDto {
    tenantId: number | undefined;
    name: string;
    qbName: string;
    isCommissionEnabled: boolean;
    renewalPolicy: string | undefined;
    isAutoRenew: boolean;
    carrierWeighting: number;
    isActive: boolean;
    commissionManagerId: number | undefined;
    imageSourceUrl: string | undefined;
    compensationNotes: string | undefined;
    displayCompMatrix: boolean;
    providerCommissionTermId: number | undefined;
    providerCommissionTermName: string | undefined;
    commissionArrears: number | undefined;
    externalId: string | undefined;
    provider_Id: number | undefined;
    uuid: string;
    previousNames: string[] | undefined;
    providerManagerId: number | undefined;
    productTypeId: number | undefined;
    productTypeName: string | undefined;
    providerCategoryId: number | undefined;
    providerCategoryName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderListDto implements IProviderListDto {
    id: number | undefined;
    name: string;
    isCommissionEnabled: boolean;
    renewalPolicy: string | undefined;
    isAutoRenew: boolean;
    carrierWeighting: number;
    isActive: boolean;
    imageSourceUrl: string | undefined;

    constructor(data?: IProviderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.isCommissionEnabled = _data['isCommissionEnabled'];
            this.renewalPolicy = _data['renewalPolicy'];
            this.isAutoRenew = _data['isAutoRenew'];
            this.carrierWeighting = _data['carrierWeighting'];
            this.isActive = _data['isActive'];
            this.imageSourceUrl = _data['imageSourceUrl'];
        }
    }

    static fromJS(data: any): ProviderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['isCommissionEnabled'] = this.isCommissionEnabled;
        data['renewalPolicy'] = this.renewalPolicy;
        data['isAutoRenew'] = this.isAutoRenew;
        data['carrierWeighting'] = this.carrierWeighting;
        data['isActive'] = this.isActive;
        data['imageSourceUrl'] = this.imageSourceUrl;
        return data;
    }

    clone(): ProviderListDto {
        const json = this.toJSON();
        let result = new ProviderListDto();
        result.init(json);
        return result;
    }
}

export interface IProviderListDto {
    id: number | undefined;
    name: string;
    isCommissionEnabled: boolean;
    renewalPolicy: string | undefined;
    isAutoRenew: boolean;
    carrierWeighting: number;
    isActive: boolean;
    imageSourceUrl: string | undefined;
}

export class ProviderManagerEntity implements IProviderManagerEntity {
    userId: number | undefined;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderManagerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderManagerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderManagerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderManagerEntity {
        const json = this.toJSON();
        let result = new ProviderManagerEntity();
        result.init(json);
        return result;
    }
}

export interface IProviderManagerEntity {
    userId: number | undefined;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderModel implements IProviderModel {
    id: number;
    name: string | undefined;

    constructor(data?: IProviderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ProviderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): ProviderModel {
        const json = this.toJSON();
        let result = new ProviderModel();
        result.init(json);
        return result;
    }
}

export interface IProviderModel {
    id: number;
    name: string | undefined;
}

export class ProviderProduct implements IProviderProduct {
    tenantId: number | undefined;
    providerId: number;
    provider: Provider;
    productId: number;
    product: Product;
    nameMatch: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? Provider.fromJS(_data['provider']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? Product.fromJS(_data['product']) : <any>undefined;
            this.nameMatch = _data['nameMatch'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['nameMatch'] = this.nameMatch;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderProduct {
        const json = this.toJSON();
        let result = new ProviderProduct();
        result.init(json);
        return result;
    }
}

export interface IProviderProduct {
    tenantId: number | undefined;
    providerId: number;
    provider: Provider;
    productId: number;
    product: Product;
    nameMatch: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderProductProjection implements IProviderProductProjection {
    id: number;
    name: string | undefined;
    providers: ProviderModel[] | undefined;

    constructor(data?: IProviderProductProjection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            if (Array.isArray(_data['providers'])) {
                this.providers = [] as any;
                for (let item of _data['providers']) this.providers.push(ProviderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderProductProjection {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderProductProjection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        if (Array.isArray(this.providers)) {
            data['providers'] = [];
            for (let item of this.providers) data['providers'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderProductProjection {
        const json = this.toJSON();
        let result = new ProviderProductProjection();
        result.init(json);
        return result;
    }
}

export interface IProviderProductProjection {
    id: number;
    name: string | undefined;
    providers: ProviderModel[] | undefined;
}

export class ProviderProductProjectionPagedResultDto implements IProviderProductProjectionPagedResultDto {
    totalCount: number;
    items: ProviderProductProjection[] | undefined;

    constructor(data?: IProviderProductProjectionPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ProviderProductProjection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderProductProjectionPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderProductProjectionPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderProductProjectionPagedResultDto {
        const json = this.toJSON();
        let result = new ProviderProductProjectionPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProviderProductProjectionPagedResultDto {
    totalCount: number;
    items: ProviderProductProjection[] | undefined;
}

export class ProviderWithProductsResponse implements IProviderWithProductsResponse {
    id: number;
    name: string | undefined;
    products: ProductResponse[] | undefined;

    constructor(data?: IProviderWithProductsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            if (Array.isArray(_data['products'])) {
                this.products = [] as any;
                for (let item of _data['products']) this.products.push(ProductResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderWithProductsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderWithProductsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        if (Array.isArray(this.products)) {
            data['products'] = [];
            for (let item of this.products) data['products'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderWithProductsResponse {
        const json = this.toJSON();
        let result = new ProviderWithProductsResponse();
        result.init(json);
        return result;
    }
}

export interface IProviderWithProductsResponse {
    id: number;
    name: string | undefined;
    products: ProductResponse[] | undefined;
}

export class ProviderWithProductsResponsePagedResultDto implements IProviderWithProductsResponsePagedResultDto {
    totalCount: number;
    items: ProviderWithProductsResponse[] | undefined;

    constructor(data?: IProviderWithProductsResponsePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ProviderWithProductsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderWithProductsResponsePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderWithProductsResponsePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderWithProductsResponsePagedResultDto {
        const json = this.toJSON();
        let result = new ProviderWithProductsResponsePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProviderWithProductsResponsePagedResultDto {
    totalCount: number;
    items: ProviderWithProductsResponse[] | undefined;
}

export class Requestor implements IRequestor {
    tenantId: number | undefined;
    userId: number | undefined;
    user: User;
    emailAddress: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRequestor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.emailAddress = _data['emailAddress'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Requestor {
        data = typeof data === 'object' ? data : {};
        let result = new Requestor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['emailAddress'] = this.emailAddress;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Requestor {
        const json = this.toJSON();
        let result = new Requestor();
        result.init(json);
        return result;
    }
}

export interface IRequestor {
    tenantId: number | undefined;
    userId: number | undefined;
    user: User;
    emailAddress: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Role implements IRole {
    roleType: RoleType;
    description: string | undefined;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    normalizedName: string;
    claims: RoleClaim[] | undefined;
    concurrencyStamp: string | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    tenantId: number | undefined;
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    permissions: RolePermissionSetting[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleType = _data['roleType'];
            this.description = _data['description'];
            this.isInternalDefault = _data['isInternalDefault'];
            this.isAdvisorDefault = _data['isAdvisorDefault'];
            this.normalizedName = _data['normalizedName'];
            if (Array.isArray(_data['claims'])) {
                this.claims = [] as any;
                for (let item of _data['claims']) this.claims.push(RoleClaim.fromJS(item));
            }
            this.concurrencyStamp = _data['concurrencyStamp'];
            this.deleterUser = _data['deleterUser'] ? User.fromJS(_data['deleterUser']) : <any>undefined;
            this.creatorUser = _data['creatorUser'] ? User.fromJS(_data['creatorUser']) : <any>undefined;
            this.lastModifierUser = _data['lastModifierUser'] ? User.fromJS(_data['lastModifierUser']) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.isStatic = _data['isStatic'];
            this.isDefault = _data['isDefault'];
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(RolePermissionSetting.fromJS(item));
            }
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleType'] = this.roleType;
        data['description'] = this.description;
        data['isInternalDefault'] = this.isInternalDefault;
        data['isAdvisorDefault'] = this.isAdvisorDefault;
        data['normalizedName'] = this.normalizedName;
        if (Array.isArray(this.claims)) {
            data['claims'] = [];
            for (let item of this.claims) data['claims'].push(item.toJSON());
        }
        data['concurrencyStamp'] = this.concurrencyStamp;
        data['deleterUser'] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data['creatorUser'] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data['lastModifierUser'] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['isStatic'] = this.isStatic;
        data['isDefault'] = this.isDefault;
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole {
    roleType: RoleType;
    description: string | undefined;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    normalizedName: string;
    claims: RoleClaim[] | undefined;
    concurrencyStamp: string | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    tenantId: number | undefined;
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    permissions: RolePermissionSetting[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RoleClaim implements IRoleClaim {
    tenantId: number | undefined;
    roleId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.roleId = _data['roleId'];
            this.claimType = _data['claimType'];
            this.claimValue = _data['claimValue'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['roleId'] = this.roleId;
        data['claimType'] = this.claimType;
        data['claimValue'] = this.claimValue;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): RoleClaim {
        const json = this.toJSON();
        let result = new RoleClaim();
        result.init(json);
        return result;
    }
}

export interface IRoleClaim {
    tenantId: number | undefined;
    roleId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RolePermissionSetting implements IRolePermissionSetting {
    roleId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRolePermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isGranted = _data['isGranted'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isGranted'] = this.isGranted;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): RolePermissionSetting {
        const json = this.toJSON();
        let result = new RolePermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IRolePermissionSetting {
    roleId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SalesCampaignCreateEditInput implements ISalesCampaignCreateEditInput {
    id: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    name: string | undefined;
    partnerId: number;
    campaignType: CampaignType;

    constructor(data?: ISalesCampaignCreateEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.name = _data['name'];
            this.partnerId = _data['partnerId'];
            this.campaignType = _data['campaignType'];
        }
    }

    static fromJS(data: any): SalesCampaignCreateEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCampaignCreateEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['name'] = this.name;
        data['partnerId'] = this.partnerId;
        data['campaignType'] = this.campaignType;
        return data;
    }

    clone(): SalesCampaignCreateEditInput {
        const json = this.toJSON();
        let result = new SalesCampaignCreateEditInput();
        result.init(json);
        return result;
    }
}

export interface ISalesCampaignCreateEditInput {
    id: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    name: string | undefined;
    partnerId: number;
    campaignType: CampaignType;
}

export interface ISalesCampaignDto {
    id: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    name: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    campaignType: CampaignType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class SalesCampaignDtoPagedResultModel implements ISalesCampaignDtoPagedResultModel {
    total: number;
    items: SalesCampaignDto[] | undefined;

    constructor(data?: ISalesCampaignDtoPagedResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data['total'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(SalesCampaignDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesCampaignDtoPagedResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCampaignDtoPagedResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['total'] = this.total;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): SalesCampaignDtoPagedResultModel {
        const json = this.toJSON();
        let result = new SalesCampaignDtoPagedResultModel();
        result.init(json);
        return result;
    }
}

export interface ISalesCampaignDtoPagedResultModel {
    total: number;
    items: SalesCampaignDto[] | undefined;
}

export class SalesCampaignEntity implements ISalesCampaignEntity {
    tenantId: number | undefined;
    name: string;
    campaignType: CampaignType;
    partnerId: number;
    partner: Partner;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISalesCampaignEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.campaignType = _data['campaignType'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.deleterUserId = _data['deleterUserId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): SalesCampaignEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCampaignEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['campaignType'] = this.campaignType;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['deleterUserId'] = this.deleterUserId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): SalesCampaignEntity {
        const json = this.toJSON();
        let result = new SalesCampaignEntity();
        result.init(json);
        return result;
    }
}

export interface ISalesCampaignEntity {
    tenantId: number | undefined;
    name: string;
    campaignType: CampaignType;
    partnerId: number;
    partner: Partner;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ScheduleTransactionSummaryDto implements IScheduleTransactionSummaryDto {
    scheduleId: number;
    scheduleTransactionId: number;
    partnerId: number;
    partnerName: string | undefined;
    month: number;
    year: number;
    scheduleDescription: string | undefined;
    amount: number;
    balance: number;

    constructor(data?: IScheduleTransactionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data['scheduleId'];
            this.scheduleTransactionId = _data['scheduleTransactionId'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.scheduleDescription = _data['scheduleDescription'];
            this.amount = _data['amount'];
            this.balance = _data['balance'];
        }
    }

    static fromJS(data: any): ScheduleTransactionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTransactionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['scheduleId'] = this.scheduleId;
        data['scheduleTransactionId'] = this.scheduleTransactionId;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['month'] = this.month;
        data['year'] = this.year;
        data['scheduleDescription'] = this.scheduleDescription;
        data['amount'] = this.amount;
        data['balance'] = this.balance;
        return data;
    }

    clone(): ScheduleTransactionSummaryDto {
        const json = this.toJSON();
        let result = new ScheduleTransactionSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleTransactionSummaryDto {
    scheduleId: number;
    scheduleTransactionId: number;
    partnerId: number;
    partnerName: string | undefined;
    month: number;
    year: number;
    scheduleDescription: string | undefined;
    amount: number;
    balance: number;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }

    clone(): SetDefaultLanguageInput {
        const json = this.toJSON();
        let result = new SetDefaultLanguageInput();
        result.init(json);
        return result;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.name = _data['name'];
            this.value = _data['value'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['name'] = this.name;
        data['value'] = this.value;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum SettingScopes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7,
}

export class SimpleUserModel implements ISimpleUserModel {
    id: string;
    internalId: number | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: ISimpleUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.internalId = _data['internalId'];
            this.email = _data['email'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.phoneNumber = _data['phoneNumber'];
        }
    }

    static fromJS(data: any): SimpleUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['internalId'] = this.internalId;
        data['email'] = this.email;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['phoneNumber'] = this.phoneNumber;
        return data;
    }

    clone(): SimpleUserModel {
        const json = this.toJSON();
        let result = new SimpleUserModel();
        result.init(json);
        return result;
    }
}

export interface ISimpleUserModel {
    id: string;
    internalId: number | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
}

export enum SpecialRateStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum SplitType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class StatusAutomationAdminEditDto implements IStatusAutomationAdminEditDto {
    tenantId: number | undefined;
    appDomain: AppDomain;
    deparmentId: number | undefined;
    toStatusId: number;
    toTicketResolutionId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IStatusAutomationAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.appDomain = _data['appDomain'];
            this.deparmentId = _data['deparmentId'];
            this.toStatusId = _data['toStatusId'];
            this.toTicketResolutionId = _data['toTicketResolutionId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): StatusAutomationAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusAutomationAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['appDomain'] = this.appDomain;
        data['deparmentId'] = this.deparmentId;
        data['toStatusId'] = this.toStatusId;
        data['toTicketResolutionId'] = this.toTicketResolutionId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): StatusAutomationAdminEditDto {
        const json = this.toJSON();
        let result = new StatusAutomationAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface IStatusAutomationAdminEditDto {
    tenantId: number | undefined;
    appDomain: AppDomain;
    deparmentId: number | undefined;
    toStatusId: number;
    toTicketResolutionId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class StatusAutomationDropdownDto implements IStatusAutomationDropdownDto {
    id: number;
    toStatus: string | undefined;

    constructor(data?: IStatusAutomationDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.toStatus = _data['toStatus'];
        }
    }

    static fromJS(data: any): StatusAutomationDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusAutomationDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['toStatus'] = this.toStatus;
        return data;
    }

    clone(): StatusAutomationDropdownDto {
        const json = this.toJSON();
        let result = new StatusAutomationDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IStatusAutomationDropdownDto {
    id: number;
    toStatus: string | undefined;
}

export class StatusAutomationToResolutionDropdownDto implements IStatusAutomationToResolutionDropdownDto {
    id: number;
    name: string | undefined;

    constructor(data?: IStatusAutomationToResolutionDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): StatusAutomationToResolutionDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusAutomationToResolutionDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): StatusAutomationToResolutionDropdownDto {
        const json = this.toJSON();
        let result = new StatusAutomationToResolutionDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IStatusAutomationToResolutionDropdownDto {
    id: number;
    name: string | undefined;
}

export class StatusAutomationToStatusDropdownDto implements IStatusAutomationToStatusDropdownDto {
    id: number;
    name: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;

    constructor(data?: IStatusAutomationToStatusDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
        }
    }

    static fromJS(data: any): StatusAutomationToStatusDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusAutomationToStatusDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        return data;
    }

    clone(): StatusAutomationToStatusDropdownDto {
        const json = this.toJSON();
        let result = new StatusAutomationToStatusDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IStatusAutomationToStatusDropdownDto {
    id: number;
    name: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
}

export class SupervisorTeamDto implements ISupervisorTeamDto {
    supervisorId: number;
    supervisor: UserListDto;
    departmentId: number;
    department: DepartmentDropdownDto;
    teamMembers: TeamMembersDto[] | undefined;
    id: number;

    constructor(data?: ISupervisorTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supervisorId = _data['supervisorId'];
            this.supervisor = _data['supervisor'] ? UserListDto.fromJS(_data['supervisor']) : <any>undefined;
            this.departmentId = _data['departmentId'];
            this.department = _data['department'] ? DepartmentDropdownDto.fromJS(_data['department']) : <any>undefined;
            if (Array.isArray(_data['teamMembers'])) {
                this.teamMembers = [] as any;
                for (let item of _data['teamMembers']) this.teamMembers.push(TeamMembersDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): SupervisorTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupervisorTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['supervisorId'] = this.supervisorId;
        data['supervisor'] = this.supervisor ? this.supervisor.toJSON() : <any>undefined;
        data['departmentId'] = this.departmentId;
        data['department'] = this.department ? this.department.toJSON() : <any>undefined;
        if (Array.isArray(this.teamMembers)) {
            data['teamMembers'] = [];
            for (let item of this.teamMembers) data['teamMembers'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): SupervisorTeamDto {
        const json = this.toJSON();
        let result = new SupervisorTeamDto();
        result.init(json);
        return result;
    }
}

export interface ISupervisorTeamDto {
    supervisorId: number;
    supervisor: UserListDto;
    departmentId: number;
    department: DepartmentDropdownDto;
    teamMembers: TeamMembersDto[] | undefined;
    id: number;
}

export class SupervisorTeamInputDto implements ISupervisorTeamInputDto {
    id: number | undefined;
    supervisorId: number;
    departmentId: number;

    constructor(data?: ISupervisorTeamInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.supervisorId = _data['supervisorId'];
            this.departmentId = _data['departmentId'];
        }
    }

    static fromJS(data: any): SupervisorTeamInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupervisorTeamInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['supervisorId'] = this.supervisorId;
        data['departmentId'] = this.departmentId;
        return data;
    }

    clone(): SupervisorTeamInputDto {
        const json = this.toJSON();
        let result = new SupervisorTeamInputDto();
        result.init(json);
        return result;
    }
}

export interface ISupervisorTeamInputDto {
    id: number | undefined;
    supervisorId: number;
    departmentId: number;
}

export class SurveyDtoPagedDtoBase implements ISurveyDtoPagedDtoBase {
    value: SurveyDto[] | undefined;
    continuationToken: string | undefined;

    constructor(data?: ISurveyDtoPagedDtoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['value'])) {
                this.value = [] as any;
                for (let item of _data['value']) this.value.push(SurveyDto.fromJS(item));
            }
            this.continuationToken = _data['continuationToken'];
        }
    }

    static fromJS(data: any): SurveyDtoPagedDtoBase {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDtoPagedDtoBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data['value'] = [];
            for (let item of this.value) data['value'].push(item.toJSON());
        }
        data['continuationToken'] = this.continuationToken;
        return data;
    }

    clone(): SurveyDtoPagedDtoBase {
        const json = this.toJSON();
        let result = new SurveyDtoPagedDtoBase();
        result.init(json);
        return result;
    }
}

export interface ISurveyDtoPagedDtoBase {
    value: SurveyDto[] | undefined;
    continuationToken: string | undefined;
}

export class TeamMemberInputDto implements ITeamMemberInputDto {
    id: number | undefined;
    supervisorTeamId: number;
    memberUserId: number;

    constructor(data?: ITeamMemberInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.supervisorTeamId = _data['supervisorTeamId'];
            this.memberUserId = _data['memberUserId'];
        }
    }

    static fromJS(data: any): TeamMemberInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['supervisorTeamId'] = this.supervisorTeamId;
        data['memberUserId'] = this.memberUserId;
        return data;
    }

    clone(): TeamMemberInputDto {
        const json = this.toJSON();
        let result = new TeamMemberInputDto();
        result.init(json);
        return result;
    }
}

export interface ITeamMemberInputDto {
    id: number | undefined;
    supervisorTeamId: number;
    memberUserId: number;
}

export class TeamMembersDto implements ITeamMembersDto {
    supervisorTeamId: number;
    supervisorFullname: string | undefined;
    supervisorTeamName: string | undefined;
    memberUserId: number;
    memberUserFullname: string | undefined;
    id: number;

    constructor(data?: ITeamMembersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supervisorTeamId = _data['supervisorTeamId'];
            this.supervisorFullname = _data['supervisorFullname'];
            this.supervisorTeamName = _data['supervisorTeamName'];
            this.memberUserId = _data['memberUserId'];
            this.memberUserFullname = _data['memberUserFullname'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TeamMembersDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMembersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['supervisorTeamId'] = this.supervisorTeamId;
        data['supervisorFullname'] = this.supervisorFullname;
        data['supervisorTeamName'] = this.supervisorTeamName;
        data['memberUserId'] = this.memberUserId;
        data['memberUserFullname'] = this.memberUserFullname;
        data['id'] = this.id;
        return data;
    }

    clone(): TeamMembersDto {
        const json = this.toJSON();
        let result = new TeamMembersDto();
        result.init(json);
        return result;
    }
}

export interface ITeamMembersDto {
    supervisorTeamId: number;
    supervisorFullname: string | undefined;
    supervisorTeamName: string | undefined;
    memberUserId: number;
    memberUserFullname: string | undefined;
    id: number;
}

export class TenantNotification implements ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.notificationName = _data['notificationName'];
            this.data = _data['data'] ? NotificationData.fromJS(_data['data']) : <any>undefined;
            this.entityType = _data['entityType'];
            this.entityTypeName = _data['entityTypeName'];
            this.entityId = _data['entityId'];
            this.severity = _data['severity'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['notificationName'] = this.notificationName;
        data['data'] = this.data ? this.data.toJSON() : <any>undefined;
        data['entityType'] = this.entityType;
        data['entityTypeName'] = this.entityTypeName;
        data['entityId'] = this.entityId;
        data['severity'] = this.severity;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): TenantNotification {
        const json = this.toJSON();
        let result = new TenantNotification();
        result.init(json);
        return result;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class Territory implements ITerritory {
    tenantId: number | undefined;
    country: string | undefined;
    stateProvince: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITerritory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.country = _data['country'];
            this.stateProvince = _data['stateProvince'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Territory {
        data = typeof data === 'object' ? data : {};
        let result = new Territory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['country'] = this.country;
        data['stateProvince'] = this.stateProvince;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Territory {
        const json = this.toJSON();
        let result = new Territory();
        result.init(json);
        return result;
    }
}

export interface ITerritory {
    tenantId: number | undefined;
    country: string | undefined;
    stateProvince: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TerritoryInput implements ITerritoryInput {
    id: number | undefined;
    tenantId: number | undefined;
    country: string | undefined;
    stateProvince: string | undefined;

    constructor(data?: ITerritoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.country = _data['country'];
            this.stateProvince = _data['stateProvince'];
        }
    }

    static fromJS(data: any): TerritoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new TerritoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['country'] = this.country;
        data['stateProvince'] = this.stateProvince;
        return data;
    }

    clone(): TerritoryInput {
        const json = this.toJSON();
        let result = new TerritoryInput();
        result.init(json);
        return result;
    }
}

export interface ITerritoryInput {
    id: number | undefined;
    tenantId: number | undefined;
    country: string | undefined;
    stateProvince: string | undefined;
}

export class Ticket implements ITicket {
    id: number;
    tenantId: number | undefined;
    ticketNumber: string | undefined;
    ticketStatusId: number | undefined;
    requestorId: number | undefined;
    assignedUserId: number | undefined;
    providerTicketNumber: string | undefined;
    description: string | undefined;
    ticketPriority: TicketPriority;
    ticketTypeId: number | undefined;
    departmentId: number | undefined;
    subject: string | undefined;
    ticketSourceId: number;
    messageId: string | undefined;

    constructor(data?: ITicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.ticketNumber = _data['ticketNumber'];
            this.ticketStatusId = _data['ticketStatusId'];
            this.requestorId = _data['requestorId'];
            this.assignedUserId = _data['assignedUserId'];
            this.providerTicketNumber = _data['providerTicketNumber'];
            this.description = _data['description'];
            this.ticketPriority = _data['ticketPriority'];
            this.ticketTypeId = _data['ticketTypeId'];
            this.departmentId = _data['departmentId'];
            this.subject = _data['subject'];
            this.ticketSourceId = _data['ticketSourceId'];
            this.messageId = _data['messageId'];
        }
    }

    static fromJS(data: any): Ticket {
        data = typeof data === 'object' ? data : {};
        let result = new Ticket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['ticketNumber'] = this.ticketNumber;
        data['ticketStatusId'] = this.ticketStatusId;
        data['requestorId'] = this.requestorId;
        data['assignedUserId'] = this.assignedUserId;
        data['providerTicketNumber'] = this.providerTicketNumber;
        data['description'] = this.description;
        data['ticketPriority'] = this.ticketPriority;
        data['ticketTypeId'] = this.ticketTypeId;
        data['departmentId'] = this.departmentId;
        data['subject'] = this.subject;
        data['ticketSourceId'] = this.ticketSourceId;
        data['messageId'] = this.messageId;
        return data;
    }

    clone(): Ticket {
        const json = this.toJSON();
        let result = new Ticket();
        result.init(json);
        return result;
    }
}

export interface ITicket {
    id: number;
    tenantId: number | undefined;
    ticketNumber: string | undefined;
    ticketStatusId: number | undefined;
    requestorId: number | undefined;
    assignedUserId: number | undefined;
    providerTicketNumber: string | undefined;
    description: string | undefined;
    ticketPriority: TicketPriority;
    ticketTypeId: number | undefined;
    departmentId: number | undefined;
    subject: string | undefined;
    ticketSourceId: number;
    messageId: string | undefined;
}

export class TicketNotFoundException implements ITicketNotFoundException {
    message: string | undefined;
    readonly data: { [key: string]: any } | undefined;
    innerException: any | undefined;
    helpLink: string | undefined;
    source: string | undefined;
    hResult: number;
    readonly stackTrace: string | undefined;

    constructor(data?: ITicketNotFoundException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data['message'];
            if (_data['data']) {
                (<any>this).data = {} as any;
                for (let key in _data['data']) {
                    if (_data['data'].hasOwnProperty(key)) (<any>this).data[key] = _data['data'][key];
                }
            }
            this.innerException = _data['innerException'];
            this.helpLink = _data['helpLink'];
            this.source = _data['source'];
            this.hResult = _data['hResult'];
            (<any>this).stackTrace = _data['stackTrace'];
        }
    }

    static fromJS(data: any): TicketNotFoundException {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNotFoundException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['message'] = this.message;
        if (this.data) {
            data['data'] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key)) data['data'][key] = this.data[key];
            }
        }
        data['innerException'] = this.innerException;
        data['helpLink'] = this.helpLink;
        data['source'] = this.source;
        data['hResult'] = this.hResult;
        data['stackTrace'] = this.stackTrace;
        return data;
    }

    clone(): TicketNotFoundException {
        const json = this.toJSON();
        let result = new TicketNotFoundException();
        result.init(json);
        return result;
    }
}

export interface ITicketNotFoundException {
    message: string | undefined;
    data: { [key: string]: any } | undefined;
    innerException: any | undefined;
    helpLink: string | undefined;
    source: string | undefined;
    hResult: number;
    stackTrace: string | undefined;
}

export class TicketNumberDto implements ITicketNumberDto {
    ticketId: number;
    ticketNumber: string | undefined;

    constructor(data?: ITicketNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketNumber = _data['ticketNumber'];
        }
    }

    static fromJS(data: any): TicketNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketNumber'] = this.ticketNumber;
        return data;
    }

    clone(): TicketNumberDto {
        const json = this.toJSON();
        let result = new TicketNumberDto();
        result.init(json);
        return result;
    }
}

export interface ITicketNumberDto {
    ticketId: number;
    ticketNumber: string | undefined;
}

export class UpdateEstimatedClosedDateInput implements IUpdateEstimatedClosedDateInput {
    opportunityId: number;
    estimatedClosedDate: moment.Moment;

    constructor(data?: IUpdateEstimatedClosedDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data['opportunityId'];
            this.estimatedClosedDate = _data['estimatedClosedDate'] ? moment(_data['estimatedClosedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateEstimatedClosedDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEstimatedClosedDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['opportunityId'] = this.opportunityId;
        data['estimatedClosedDate'] = this.estimatedClosedDate ? this.estimatedClosedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateEstimatedClosedDateInput {
        const json = this.toJSON();
        let result = new UpdateEstimatedClosedDateInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateEstimatedClosedDateInput {
    opportunityId: number;
    estimatedClosedDate: moment.Moment;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data['languageName'];
            this.sourceName = _data['sourceName'];
            this.key = _data['key'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['languageName'] = this.languageName;
        data['sourceName'] = this.sourceName;
        data['key'] = this.key;
        data['value'] = this.value;
        return data;
    }

    clone(): UpdateLanguageTextInput {
        const json = this.toJSON();
        let result = new UpdateLanguageTextInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data['receiveNotifications'];
            if (Array.isArray(_data['notifications'])) {
                this.notifications = [] as any;
                for (let item of _data['notifications']) this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['receiveNotifications'] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data['notifications'] = [];
            for (let item of this.notifications) data['notifications'].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateNotificationSettingsInput {
        const json = this.toJSON();
        let result = new UpdateNotificationSettingsInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        return data;
    }

    clone(): UpdateOrganizationUnitInput {
        const json = this.toJSON();
        let result = new UpdateOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UploadAssetFileInput implements IUploadAssetFileInput {
    fileName: string;
    assetId: number;
    ciTypeId: number;
    productId: number;
    customerLocationId: number;
    orderLocationDetailId: number;

    constructor(data?: IUploadAssetFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.assetId = _data['assetId'];
            this.ciTypeId = _data['ciTypeId'];
            this.productId = _data['productId'];
            this.customerLocationId = _data['customerLocationId'];
            this.orderLocationDetailId = _data['orderLocationDetailId'];
        }
    }

    static fromJS(data: any): UploadAssetFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadAssetFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['assetId'] = this.assetId;
        data['ciTypeId'] = this.ciTypeId;
        data['productId'] = this.productId;
        data['customerLocationId'] = this.customerLocationId;
        data['orderLocationDetailId'] = this.orderLocationDetailId;
        return data;
    }

    clone(): UploadAssetFileInput {
        const json = this.toJSON();
        let result = new UploadAssetFileInput();
        result.init(json);
        return result;
    }
}

export interface IUploadAssetFileInput {
    fileName: string;
    assetId: number;
    ciTypeId: number;
    productId: number;
    customerLocationId: number;
    orderLocationDetailId: number;
}

export class User implements IUser {
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    title: string | undefined;
    officeAddress: string | undefined;
    officeAddress2: string | undefined;
    officeCity: string | undefined;
    officeState: string | undefined;
    officeZipcode: string | undefined;
    officeCountry: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingZipcode: string | undefined;
    shippingCountry: string | undefined;
    partnerId: number | undefined;
    partner: Partner;
    providerId: number | undefined;
    provider: Provider;
    uuid: string | undefined;
    normalizedUserName: string | undefined;
    readonly company: string | undefined;
    token: string | undefined;
    plainTextPassword: string | undefined;
    userContacts: UserContact[] | undefined;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    tenantId: number | undefined;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data['profilePictureId'];
            this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
            this.userName = _data['userName'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.emailAddress = _data['emailAddress'];
            this.title = _data['title'];
            this.officeAddress = _data['officeAddress'];
            this.officeAddress2 = _data['officeAddress2'];
            this.officeCity = _data['officeCity'];
            this.officeState = _data['officeState'];
            this.officeZipcode = _data['officeZipcode'];
            this.officeCountry = _data['officeCountry'];
            this.shippingAddress = _data['shippingAddress'];
            this.shippingAddress2 = _data['shippingAddress2'];
            this.shippingCity = _data['shippingCity'];
            this.shippingState = _data['shippingState'];
            this.shippingZipcode = _data['shippingZipcode'];
            this.shippingCountry = _data['shippingCountry'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? Provider.fromJS(_data['provider']) : <any>undefined;
            this.uuid = _data['uuid'];
            this.normalizedUserName = _data['normalizedUserName'];
            (<any>this).company = _data['company'];
            this.token = _data['token'];
            this.plainTextPassword = _data['plainTextPassword'];
            if (Array.isArray(_data['userContacts'])) {
                this.userContacts = [] as any;
                for (let item of _data['userContacts']) this.userContacts.push(UserContact.fromJS(item));
            }
            this.normalizedEmailAddress = _data['normalizedEmailAddress'];
            this.concurrencyStamp = _data['concurrencyStamp'];
            if (Array.isArray(_data['tokens'])) {
                this.tokens = [] as any;
                for (let item of _data['tokens']) this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data['deleterUser'] ? User.fromJS(_data['deleterUser']) : <any>undefined;
            this.creatorUser = _data['creatorUser'] ? User.fromJS(_data['creatorUser']) : <any>undefined;
            this.lastModifierUser = _data['lastModifierUser'] ? User.fromJS(_data['lastModifierUser']) : <any>undefined;
            this.authenticationSource = _data['authenticationSource'];
            this.tenantId = _data['tenantId'];
            (<any>this).fullName = _data['fullName'];
            this.password = _data['password'];
            this.emailConfirmationCode = _data['emailConfirmationCode'];
            this.passwordResetCode = _data['passwordResetCode'];
            this.lockoutEndDateUtc = _data['lockoutEndDateUtc'] ? moment(_data['lockoutEndDateUtc'].toString()) : <any>undefined;
            this.accessFailedCount = _data['accessFailedCount'];
            this.isLockoutEnabled = _data['isLockoutEnabled'];
            this.phoneNumber = _data['phoneNumber'];
            this.isPhoneNumberConfirmed = _data['isPhoneNumberConfirmed'];
            this.securityStamp = _data['securityStamp'];
            this.isTwoFactorEnabled = _data['isTwoFactorEnabled'];
            if (Array.isArray(_data['logins'])) {
                this.logins = [] as any;
                for (let item of _data['logins']) this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data['claims'])) {
                this.claims = [] as any;
                for (let item of _data['claims']) this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data['settings'])) {
                this.settings = [] as any;
                for (let item of _data['settings']) this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data['isEmailConfirmed'];
            this.isActive = _data['isActive'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['profilePictureId'] = this.profilePictureId;
        data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
        data['userName'] = this.userName;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['emailAddress'] = this.emailAddress;
        data['title'] = this.title;
        data['officeAddress'] = this.officeAddress;
        data['officeAddress2'] = this.officeAddress2;
        data['officeCity'] = this.officeCity;
        data['officeState'] = this.officeState;
        data['officeZipcode'] = this.officeZipcode;
        data['officeCountry'] = this.officeCountry;
        data['shippingAddress'] = this.shippingAddress;
        data['shippingAddress2'] = this.shippingAddress2;
        data['shippingCity'] = this.shippingCity;
        data['shippingState'] = this.shippingState;
        data['shippingZipcode'] = this.shippingZipcode;
        data['shippingCountry'] = this.shippingCountry;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['uuid'] = this.uuid;
        data['normalizedUserName'] = this.normalizedUserName;
        data['company'] = this.company;
        data['token'] = this.token;
        data['plainTextPassword'] = this.plainTextPassword;
        if (Array.isArray(this.userContacts)) {
            data['userContacts'] = [];
            for (let item of this.userContacts) data['userContacts'].push(item.toJSON());
        }
        data['normalizedEmailAddress'] = this.normalizedEmailAddress;
        data['concurrencyStamp'] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data['tokens'] = [];
            for (let item of this.tokens) data['tokens'].push(item.toJSON());
        }
        data['deleterUser'] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data['creatorUser'] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data['lastModifierUser'] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data['authenticationSource'] = this.authenticationSource;
        data['tenantId'] = this.tenantId;
        data['fullName'] = this.fullName;
        data['password'] = this.password;
        data['emailConfirmationCode'] = this.emailConfirmationCode;
        data['passwordResetCode'] = this.passwordResetCode;
        data['lockoutEndDateUtc'] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data['accessFailedCount'] = this.accessFailedCount;
        data['isLockoutEnabled'] = this.isLockoutEnabled;
        data['phoneNumber'] = this.phoneNumber;
        data['isPhoneNumberConfirmed'] = this.isPhoneNumberConfirmed;
        data['securityStamp'] = this.securityStamp;
        data['isTwoFactorEnabled'] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data['logins'] = [];
            for (let item of this.logins) data['logins'].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data['claims'] = [];
            for (let item of this.claims) data['claims'].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data['settings'] = [];
            for (let item of this.settings) data['settings'].push(item.toJSON());
        }
        data['isEmailConfirmed'] = this.isEmailConfirmed;
        data['isActive'] = this.isActive;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    title: string | undefined;
    officeAddress: string | undefined;
    officeAddress2: string | undefined;
    officeCity: string | undefined;
    officeState: string | undefined;
    officeZipcode: string | undefined;
    officeCountry: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingZipcode: string | undefined;
    shippingCountry: string | undefined;
    partnerId: number | undefined;
    partner: Partner;
    providerId: number | undefined;
    provider: Provider;
    uuid: string | undefined;
    normalizedUserName: string | undefined;
    company: string | undefined;
    token: string | undefined;
    plainTextPassword: string | undefined;
    userContacts: UserContact[] | undefined;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    tenantId: number | undefined;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.claimType = _data['claimType'];
            this.claimValue = _data['claimValue'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['claimType'] = this.claimType;
        data['claimValue'] = this.claimValue;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserContact implements IUserContact {
    user: User;
    userId: number;
    type: UserContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IUserContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.userId = _data['userId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserContact {
        data = typeof data === 'object' ? data : {};
        let result = new UserContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['userId'] = this.userId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): UserContact {
        const json = this.toJSON();
        let result = new UserContact();
        result.init(json);
        return result;
    }
}

export interface IUserContact {
    user: User;
    userId: number;
    type: UserContactType;
    number: string;
    creationTime: moment.Moment;
    id: number;
}

export enum UserContactType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    title: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    company: string | undefined;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    officeCity: string | undefined;
    id: number;
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
    description: string | undefined;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.loginProvider = _data['loginProvider'];
            this.providerKey = _data['providerKey'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['loginProvider'] = this.loginProvider;
        data['providerKey'] = this.providerKey;
        data['id'] = this.id;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserModel implements IUserModel {
    id: string;
    internalId: number | undefined;
    email: string;
    username: string;
    firstName: string;
    lastName: string;
    title: string | undefined;
    isActive: boolean;
    roles: string[] | undefined;
    advisorUuid: string;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.internalId = _data['internalId'];
            this.email = _data['email'];
            this.username = _data['username'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.title = _data['title'];
            this.isActive = _data['isActive'];
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(item);
            }
            this.advisorUuid = _data['advisorUuid'];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['internalId'] = this.internalId;
        data['email'] = this.email;
        data['username'] = this.username;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['title'] = this.title;
        data['isActive'] = this.isActive;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item);
        }
        data['advisorUuid'] = this.advisorUuid;
        return data;
    }

    clone(): UserModel {
        const json = this.toJSON();
        let result = new UserModel();
        result.init(json);
        return result;
    }
}

export interface IUserModel {
    id: string;
    internalId: number | undefined;
    email: string;
    username: string;
    firstName: string;
    lastName: string;
    title: string | undefined;
    isActive: boolean;
    roles: string[] | undefined;
    advisorUuid: string;
}

export class UserModelPagedResultModel implements IUserModelPagedResultModel {
    total: number;
    items: UserModel[] | undefined;

    constructor(data?: IUserModelPagedResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data['total'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModelPagedResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModelPagedResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['total'] = this.total;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): UserModelPagedResultModel {
        const json = this.toJSON();
        let result = new UserModelPagedResultModel();
        result.init(json);
        return result;
    }
}

export interface IUserModelPagedResultModel {
    total: number;
    items: UserModel[] | undefined;
}

export class UserNotification implements IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    readonly targetNotifiersList: string[] | undefined;
    id: string;
    // start of new fields
    // 0. base
    category: string;
    message: string;
    url: string;
    data: Record<string, object>[];
    // 1.Activity
    activityType: number | undefined;
    activityKey: number | undefined;
    // 2. Job
    jobUuid: string | undefined;
    // 3. Order Detail
    orderId: number | undefined;
    orderNumber: string | undefined;
    orderDetailId: number | undefined;
    // end of new fields

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data['category'];
            this.message = _data['message'];
            this.url = _data['url'];
            this.data = _data['data'];
            this.activityType = _data['activityType']
            this.activityKey = _data['activityKey'];
            this.jobUuid = _data['jobUuid'];
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.orderDetailId = _data['orderDetailId'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.state = _data['state'];
            this.notification = _data['notification'] ? TenantNotification.fromJS(_data['notification']) : <any>undefined;
            this.targetNotifiers = _data['targetNotifiers'];
            if (Array.isArray(_data['targetNotifiersList'])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data['targetNotifiersList']) (<any>this).targetNotifiersList.push(item);
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['category'] = this.category;
        data['message'] = this.message;
        data['url'] = this.url;
        data['data'] = this.data;
        data['activityType'] = this.activityType;
        data['activityKey'] = this.activityKey;
        data['jobUuid'] = this.jobUuid;
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['orderDetailId'] = this.orderDetailId;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['state'] = this.state;
        data['notification'] = this.notification ? this.notification.toJSON() : <any>undefined;
        data['targetNotifiers'] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data['targetNotifiersList'] = [];
            for (let item of this.targetNotifiersList) data['targetNotifiersList'].push(item);
        }
        data['id'] = this.id;
        return data;
    }

    clone(): UserNotification {
        const json = this.toJSON();
        let result = new UserNotification();
        result.init(json);
        return result;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export class UserNotificationWithCreator implements IUserNotificationWithCreator {
    creatorUser: string | undefined;
    // start of new fields
    // 0. base
    category: string;
    message: string;
    tenantId: number | undefined;
    url: string;
    data: Record<string, object>[];
    // 1.Activity
    activityType: number | undefined;
    activityKey: number | undefined;
    // 2. Job
    jobUuid: string | undefined;
    // 3. Order Detail
    orderId: number | undefined;
    orderNumber: string | undefined;
    orderDetailId: number | undefined;
    // end of new fields
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    readonly targetNotifiersList: string[] | undefined;
    id: string;

    constructor(data?: IUserNotificationWithCreator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data['category'];
            this.message = _data['message'];
            this.url = _data['url'];
            this.data = _data['data'];
            this.activityType = _data['activityType']
            this.activityKey = _data['activityKey'];
            this.jobUuid = _data['jobUuid'];
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.orderDetailId = _data['orderDetailId'];
            this.creatorUser = _data['creatorUser'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.state = _data['state'];
            this.notification = _data['notification'] ? TenantNotification.fromJS(_data['notification']) : <any>undefined;
            this.targetNotifiers = _data['targetNotifiers'];
            if (Array.isArray(_data['targetNotifiersList'])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data['targetNotifiersList']) (<any>this).targetNotifiersList.push(item);
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserNotificationWithCreator {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationWithCreator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['category'] = this.category;
        data['message'] = this.message;
        data['url'] = this.url;
        data['data'] = this.data;
        data['activityType'] = this.activityType;
        data['activityKey'] = this.activityKey;
        data['jobUuid'] = this.jobUuid;
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['orderDetailId'] = this.orderDetailId;
        data['creatorUser'] = this.creatorUser;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['state'] = this.state;
        data['notification'] = this.notification ? this.notification.toJSON() : <any>undefined;
        data['targetNotifiers'] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data['targetNotifiersList'] = [];
            for (let item of this.targetNotifiersList) data['targetNotifiersList'].push(item);
        }
        data['id'] = this.id;
        return data;
    }

    clone(): UserNotificationWithCreator {
        const json = this.toJSON();
        let result = new UserNotificationWithCreator();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationWithCreator {
    creatorUser: string | undefined;
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
    // 0. base
    category: string;
    message: string;
    url: string;
    data: Record<string, object>[];
    // 1.Activity
    activityType: number | undefined;
    activityKey: number | undefined;
    // 2. Job
    jobUuid: string | undefined;
    // 3. Order Detail
    orderId: number | undefined;
    orderNumber: string | undefined;
    orderDetailId: number | undefined;
}

export class UserPagedResultModel implements IUserPagedResultModel {
    total: number;
    items: User[] | undefined;

    constructor(data?: IUserPagedResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data['total'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPagedResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPagedResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['total'] = this.total;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): UserPagedResultModel {
        const json = this.toJSON();
        let result = new UserPagedResultModel();
        result.init(json);
        return result;
    }
}

export interface IUserPagedResultModel {
    total: number;
    items: User[] | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isGranted = _data['isGranted'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isGranted'] = this.isGranted;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.roleId = _data['roleId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['roleId'] = this.roleId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserTerritory implements IUserTerritory {
    tenantId: number | undefined;
    csmid: number;
    csm: User;
    territoryId: number;
    territory: Territory;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserTerritory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.csmid = _data['csmid'];
            this.csm = _data['csm'] ? User.fromJS(_data['csm']) : <any>undefined;
            this.territoryId = _data['territoryId'];
            this.territory = _data['territory'] ? Territory.fromJS(_data['territory']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserTerritory {
        data = typeof data === 'object' ? data : {};
        let result = new UserTerritory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['csmid'] = this.csmid;
        data['csm'] = this.csm ? this.csm.toJSON() : <any>undefined;
        data['territoryId'] = this.territoryId;
        data['territory'] = this.territory ? this.territory.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): UserTerritory {
        const json = this.toJSON();
        let result = new UserTerritory();
        result.init(json);
        return result;
    }
}

export interface IUserTerritory {
    tenantId: number | undefined;
    csmid: number;
    csm: User;
    territoryId: number;
    territory: Territory;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserTerritoryDto implements IUserTerritoryDto {
    id: number | undefined;
    csmid: number;
    csmName: string | undefined;
    territoryId: number;
    country: string | undefined;
    stateProvince: string | undefined;

    constructor(data?: IUserTerritoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.csmid = _data['csmid'];
            this.csmName = _data['csmName'];
            this.territoryId = _data['territoryId'];
            this.country = _data['country'];
            this.stateProvince = _data['stateProvince'];
        }
    }

    static fromJS(data: any): UserTerritoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTerritoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['csmid'] = this.csmid;
        data['csmName'] = this.csmName;
        data['territoryId'] = this.territoryId;
        data['country'] = this.country;
        data['stateProvince'] = this.stateProvince;
        return data;
    }

    clone(): UserTerritoryDto {
        const json = this.toJSON();
        let result = new UserTerritoryDto();
        result.init(json);
        return result;
    }
}

export interface IUserTerritoryDto {
    id: number | undefined;
    csmid: number;
    csmName: string | undefined;
    territoryId: number;
    country: string | undefined;
    stateProvince: string | undefined;
}

export class UserToOrganizationUnitInput implements IUserToOrganizationUnitInput {
    userId: number;
    organizationUnitId: number;

    constructor(data?: IUserToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.organizationUnitId = _data['organizationUnitId'];
        }
    }

    static fromJS(data: any): UserToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['organizationUnitId'] = this.organizationUnitId;
        return data;
    }

    clone(): UserToOrganizationUnitInput {
        const json = this.toJSON();
        let result = new UserToOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IUserToOrganizationUnitInput {
    userId: number;
    organizationUnitId: number;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.loginProvider = _data['loginProvider'];
            this.name = _data['name'];
            this.value = _data['value'];
            this.expireDate = _data['expireDate'] ? moment(_data['expireDate'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['loginProvider'] = this.loginProvider;
        data['name'] = this.name;
        data['value'] = this.value;
        data['expireDate'] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}
